/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053e4ecc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_053e4ecc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"d4e045ab-e3aa-4142-9843-f738a65c774e","title":"Žinios apie spausdintuvą","link":"finding-information-about-printer-topic.html","desc":"Informacijos apie spausdintuvą paieška Ištekliai","descFull":"Informacijos apie spausdintuvą paieška Ištekliai ir kur juos rasti Ko ieškote? Ieškoti čia Pradinės sąrankos instrukcijos Žr. sąrankos dokumentaciją, kurią gavote kartu su spausdintuvu. Spausdintuvo programinė įranga Spausdinimo arba fakso tvarkyklė Spausdintuvo programinė aparatinė įranga Paslaugų programa Eikite į  www.lexmark.com/downloads , suraskite savo spausdintuvo modelį ir meniu „Tipas“ pasirinkite reikiamą tvarkyklę, programinę aparatinę įrangą ar paslaugų programą. Popieriaus ir specialiųjų laikmenų pasirinkimas ir laikymas Popieriaus įdėjimas Spausdintuvo nustatymų konfigūravimas Dokumentų ir nuotraukų peržiūra ir spausdinimas Spausdintuvo konfigūravimas tinkle Spausdintuvo priežiūra Trikčių šalinimas ir problemų sprendimas Informacijos centras. Eikite adresu  https://infoserve.lexmark.com . Mokomieji vaizdo įrašai. Eikite adresu  https://infoserve.lexmark.com/idv/ . Jutiklinio ekrano vadovas . Eikite adresu  http://support.lexmark.com . Spausdintuvo prieinamumo funkcijų diegimas ir konfigūravimas „Lexmark“ prieinamumo vadovas . Eikite adresu  http://support.lexmark.com . Žinyno informacija spausdintuvo programinei įrangai naudoti. Žinynas „Microsoft Windows“ arba „Macintosh“ operacinėms sistemoms. Atidarykite spausdintuvo programą ir spustelėkite  Žinynas . Norėdami peržiūrėti kontekstinę informaciją, spustelėkite  . Žinynas automatiškai įdiegiamas su spausdintuvo programine įranga. Priklausomai nuo operacinės sistemos spausdintuvo programinė įranga būna arba spausdintuvo programų aplanke, arba darbalaukyje. Dokumentai Pagalba tiesioginio pokalbio metu Pagalba el. paštu Pagalba balso paštu Eikite adresu  http://support.lexmark.com . Pasirinkite šalį arba regioną, tada pasirinkite savo gaminį, kad galėtumėte peržiūrėti atitinkamą palaikymo svetainę. Svetainėje arba spausdintoje garantijoje, kuri pridedama prie spausdintuvo, galima rasti kontaktinę palaikymo informaciją jūsų šalyje arba regione. Susisiekdami su pagalbos klientams skyriumi būkite pasiruošę šią informaciją: pirkimo vietą ir datą; įrenginio tipą ir serijos numerį. Norėdami gauti daugiau informacijos, žr.  . Saugos informacija Teisinio reglamentavimo informacija Informacija apie garantiją Aplinkos apsaugos informacija Informacija apie garantiją skiriasi priklausomai nuo šalies arba regiono: JAV – žr. prie spausdintuvo pridedamą Pareiškimą dėl ribotos garantijos arba eikite adresu  http://support.lexmark.com . Kitose šalyse ir regionuose . Žr. prie spausdintuvo pridedamą spausdintą garantiją. Informacijos apie gaminį vadovas . Žr. dokumentaciją, kurią gavote kartu su spausdintuvu, arba eikite adresu  http://support.lexmark.com . Informacija apie „Lexmark“ skaitmeninį pasą Eikite adresu  https://csr.lexmark.com/digital-passport.php . informacija apie spausdintuvą paieška spausdintuvo informacijos paieška"},{"UUID":"badfbdfb-9746-4a9a-9824-4465254449a7","title":"Žinios apie spausdintuvą","link":"finding-printer-serial-number-topic.html","desc":"Spausdintuvo serijos numerio paieška Atidarykite","descFull":"Spausdintuvo serijos numerio paieška Atidarykite priekines dureles. Raskite serijos numerį kairiajame spausdintuvo šone. spausdintuvo serijos numerio paieška serijos numeris, spausdintuvas paieška"},{"UUID":"c7c11764-9a3e-40e4-8e71-fdc67c890b84","title":"Žinios apie spausdintuvą","link":"printer-configurations-topic.html","desc":"Spausdintuvo konfigūracijos Įsitikinkite, kad spausdintuvas","descFull":"Spausdintuvo konfigūracijos Įsitikinkite, kad spausdintuvas sukonfigūruotas ant plokščio, tvirto ir stabilaus paviršiaus. Bazinis modelis Bazinio spausdintuvo modelio dalys 1 Automatinis dokumentų tiektuvas (ADT) 2 ADT dėklas 3 ADT dėtuvė 4 Standartinė dėtuvė 5 Standartinis 520 lapų dėklas 6 Daugiafunkcis tiektuvas 7 Valdymo skydelis Sukonfigūruotas modelis Įprastame ar daugiafunkciame spausdintuve įrengiant vieną ar daugiau techninių galimybių gali prireikti ratukų pagrindo, baldo ar kitos funkcijos, kad būtų išvengta galimo su(si)žalojimo dėl įrenginio nestabilumo. Norėdami gauti daugiau informacijos apie palaikomas konfigūracijas, žr.  www.lexmark.com/multifunctionprinters . Įprastame ar daugiafunkciame spausdintuve įrengiant vieną ar daugiau techninių galimybių gali prireikti ratukų pagrindo, baldo ar kitos funkcijos, kad būtų išvengta galimo su(si)žalojimo dėl įrenginio nestabilumo. Norėdami gauti daugiau informacijos apie palaikomas konfigūracijas, kreipkitės į vietą, kurioje pirkote spausdintuvą. Siekdami sumažinti įrangos nestabilumo pavojų, į kiekvieną dėklą popierių dėkite atskirai. Visus kitus dėklus laikykite uždarytus, iki prireiks. Sukonfigūruoto spausdintuvo modelio dalys 1 Sąsagėlių segiklis Nepalaikoma, jei įrengtas kitas apipavidalinimo įtaisas. 2 Standartinis 520 lapų dėklas 3 Papildomas 3 x 520 lapų dėklas 4 Sąsagėlių segimo, skylmušos įtaisas Palaikoma tik tada, jei įdėti papildomi dėklai. 5 Papildomas 2520 lapų sudvejintas dėklas 6 Papildomai pasirenkamas 2000 lapų dėklas Tam tikra papildoma įranga gali būti negalima. Norėdami gauti daugiau informacijos, kreipkitės į vietą, kurioje pirkote spausdintuvą. spausdintuvo konfigūracijos bazinė spausdintuvo konfigūracija visiškai sukonfigūruotas spausdintuvas"},{"UUID":"02184150-923e-4d17-8290-ee9c1b112b49","title":"Žinios apie spausdintuvą","link":"using-control-panel-topic.html","desc":"Valdymo skydelio naudojimas Valdymo skydelio","descFull":"Valdymo skydelio naudojimas Valdymo skydelio dalys ir jų funkcijos Valdymo skydelio dalis Funkcija 1 Maitinimo mygtukas Spausdintuvas įjungiamas arba išjungiamas. Norėdami išjungti spausdintuvą, penkias sekundes palaikykite paspaudę maitinimo mygtuką. Spausdintuvas nustatomas veikti miego arba užmigdymo režimu. Spausdintuvas pažadinamas iš veikimo miego arba užmigdymo režimu. 2 Ekranas Peržiūrimi spausdintuvo pranešimai ir eksploatacinių medžiagų būsena. Nustatomas ir valdomas spausdintuvas. 3 Indikatoriaus lemputė Patikrinama spausdintuvo būsena. valdymo skydelis naudojimas valdymo skydelio naudojimas"},{"UUID":"f1b241af-a031-4b7e-b07e-7997110a27c9","title":"Žinios apie spausdintuvą","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Kaip suprasti indikatoriaus lemputės spalvas","descFull":"Kaip suprasti indikatoriaus lemputės spalvas Indikatoriaus lemputės spalva ir atitinkama spausdintuvo būsena Indikatoriaus lemputė Spausdintuvo būsena Išjungta Spausdintuvas yra išjungtas. Nemirkčiojanti mėlyna Spausdintuvas yra pasirengęs. Mirkčiojanti mėlyna Spausdintuvas spausdina arba apdoroja duomenis. Mirkčiojanti raudona Spausdintuvui būtinas naudotojo įsikišimas. Pastovi geltona Spausdintuvas veikia miego režimu. Mirkčiojanti geltona Spausdintuvas veikia giliaus miego arba užmigdymo režimu. indikatoriaus lemputė kaip suprasti būseną spausdintuvo būsena"},{"UUID":"52a1f48e-2a14-4421-a206-f96363d87940","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Popieriaus naudojimo rekomendacijos Naudokite tinkamą","descFull":"Popieriaus naudojimo rekomendacijos Naudokite tinkamą popierių, kad išvengtumėte jo strigčių ir užtikrintumėte sklandų spausdinimą. Visada naudokite naują, nepažeistą popierių. Prieš dėdami popierių sužinokite, ant kurios popieriaus pusės rekomenduojama spausdinti. Ši informacija paprastai nurodoma ant popieriaus pakuotės. Nenaudokite ranka nukirpto ar patrumpinto popieriaus. Nemaišykite popieriaus formatų, rūšių ir svorių tame pačiame dėkle; sumaišius, popierius užstringa. Nenaudokite kreidinio popieriaus, nebent jis yra skirtas būtent elektrofotografiniam spausdinimui. Jei norite sužinoti daugiau, žr.  Popieriaus ir specialiųjų laikmenų vadovas . popierius pasirinkimas popieriaus naudojimo rekomendacijos"},{"UUID":"6b74a7be-c05a-44d4-ab93-af1eaa0cd7f6","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Popieriaus savybės Toliau išvardytos popieriaus","descFull":"Popieriaus savybės Toliau išvardytos popieriaus savybės turi įtakos spausdinimo kokybei ir patikimumui. Prieš spausdindami ant jo apsvarstykite šiuos veiksnius. Svoris Dėklai gali tiekti skirtingo svorio popierių. Popierius, lengvesnis nei 60 g/m 2  (16 sv.), gali būti nepakankamai kietas tinkamai tiekti ir todėl strigti. Norėdami gauti daugiau informacijos, žr. temą „Palaikomi popieriaus svoriai“. Užsirietimas Užsirietimas – tai popieriaus tendencija užsiriesti kraštuose. Popieriui per daug užsiriečiant gali kilti jo tiekimo problemų. Popierius gali užsiriesti po to, kai pereina per spausdintuvą, kuriame yra veikiamas aukštos temperatūros. Nesupakuotą popierių laikant karštomis, drėgnomis, šaltomis ar sausomis sąlygomis, popierius gali užsiriesti prieš spausdinant ant jo, todėl gali kilti tiekimo problemų. Glotnumas Popieriaus glotnumas daro tiesioginę įtaką spausdinimo kokybei. Jei popierius per daug šiurkštus, dažai gali netinkamai su juo susilieti. Jei popierius per daug glotnus, gali kilti popieriaus tiekimo arba spausdinimo kokybės problemų. Rekomenduojame naudoti 50 Šefildo taškų popierių. Drėgmės kiekis Drėgmės kiekis popieriuje veikia ir spausdinimo kokybę, ir spausdintuvo gebėjimą tinkamai tiekti popierių. Iki naudodami, popierių laikykite originalioje pakuotėje. Naudojant drėgmės pokyčių paveiktą popierių gali pablogėti spausdinimo rezultatai. Prieš spausdindami, popierių originalioje pakuotėje palaikykite 24–48 valandas. Aplinka, kurioje laikomas popierius, turi būti tokia pati kaip spausdintuvo. Keliomis dienomis pailginkite laiką, jei popieriaus laikymo arba gabenimo aplinka labai skiriasi nuo spausdintuvo aplinkos. Ilgesnio laikotarpio gali prireikti ir storam popieriui. Pluošto (grūdėtumo) kryptis Pluošto kryptis reiškia popieriaus skaidulų išsidėstymą popieriaus lape. Pluoštas būna arba  išilginis , einantis išilgai popieriaus, arba  skersinis , einantis skersai popieriaus. Apie rekomenduojamą pluošto kryptį žr. temą „Palaikomi popieriaus svoriai“. Pluošto sudėtis Dauguma aukštos kokybės kserografinio popieriaus yra pagaminta iš 100 proc. chemiškai apdorotos medienos plaušienos. Ši sudėtis suteikia popieriui didelį stabilumą, todėl kyla mažiau popieriaus tiekimo problemų ir užtikrinama geresnė spausdinimo kokybė. Jei popieriaus sudėtyje yra tokių pluoštų kaip medvilnė, tai gali neigiamai paveikti popieriaus apdorojimą. popieriaus savybės"},{"UUID":"65816b82-9861-40e3-8c76-4bd4600d41ba","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Netinkamas popierius Spausdintuve nerekomenduojama naudoti","descFull":"Netinkamas popierius Spausdintuve nerekomenduojama naudoti šių popieriaus rūšių: chemiškai apdoroto popieriaus, naudojamo kopijoms be anglinio popieriaus. Jis taip pat vadinamas savaiminio kopijavimo popieriumi (CCP) arba neangliniu popieriumi (NCR); iš anksto paruoštos formos popieriaus, kuriame naudojamos cheminės medžiagos, galinčios užteršti spausdintuvą; iš anksto paruoštos formos popieriaus, kurį gali paveikti spausdintuvo kaitintuvo temperatūra; iš anksto paruoštos formos popieriaus, kuriame reikia įrašo (tikslios spausdinimo vietos puslapyje), didesnio arba mažesnio nei ±2,3 mm (±0,09 col.). Pavyzdžiui, optinio simbolių atpažinimo (OCR) formų. Kartais įrašą galima pakoreguoti programinės įrangos programa, kad būtų galima sėkmingai spausdinti ant šių formų; dengto popieriaus (nutrinamo standžiojo popieriaus), sintetinio popieriaus ar terminio popieriaus; popieriaus neapipjaustytais kraštais, šiurkščios ar sunkios tekstūros popieriaus arba glamžyto popieriaus; popieriaus, kuris neatitinka EN 12281:2002 standarto (Europoje); popieriaus, kuris sveria mažiau nei 60 g/m 2  (16 sv.); kelių dalių formų ar dokumentų. netinkamas popierius"},{"UUID":"f509f8be-507b-45db-8909-c354224b3faf","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Popieriaus laikymas Naudokitės šiomis popieriaus","descFull":"Popieriaus laikymas Naudokitės šiomis popieriaus laikymo rekomendacijomis, kurios padės išvengti popieriaus strigčių ir nevienodos spausdinimo kokybės: Prieš spausdindami, 24–48 valandas popierių laikykite originalioje pakuotėje toje pačioje aplinkoje kaip ir spausdintuvą. Keliomis dienomis pailginkite laiką, jei popieriaus laikymo arba gabenimo aplinka labai skiriasi nuo spausdintuvo aplinkos. Ilgesnio laikotarpio gali prireikti ir storam popieriui. Norėdami pasiekti geriausių rezultatų, popierių laikykite patalpoje, kurioje temperatūra siekia 21 °C (70 °F), o santykinė drėgmė – 40 procentų. Dauguma etikečių gamintojų rekomenduoja spausdinti esant 18–24 °C (65–75 °F) temperatūrai ir 40–60 procentų santykinei drėgmei. Laikykite popierių kartono dėžėse, ant padėklo arba lentynoje, o ne ant grindų. Atskiras pakuotes laikykite ant lygaus paviršiaus. Nieko nelaikykite ant atskirų popieriaus pakuočių viršaus. Popierių iš kartoninės dėžės arba pakuotės imkite tik tada, kai ruošiatės jį dėti į spausdintuvą. Dėžutėje ir pakuotėje laikomas popierius išlieka švarus, sausas ir lygus. popieriaus laikymas"},{"UUID":"2501ff12-6199-4f1c-a894-fd648e2bf43d","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Iš anksto paruoštų formų ir","descFull":"Iš anksto paruoštų formų ir firminių blankų pasirinkimas Naudokite išilginio pluošto popierių. Naudokite tik formas ir firminius blankus, kurie bus spausdinami naudojant ofsetinį litografinį arba graviruoto spausdinimo metodą. Venkite popieriaus šiurkščiu ar sunkios tekstūros paviršiumi. Naudokite spaustuvinius dažus, kurių neveikia spausdintuvo dažų derva. Paprastai šiuos reikalavimus atitinka spaustuviniai dažai, kurie yra stabilios oksidacijos arba aliejiniai; latekso rašalai gali netikti. Prieš pirkdami didelius kiekius, ant iš anksto paruoštų formų ir firminių blankų, kuriuos ketinate naudoti, atsispausdinkite bandinius. Nuo šio veiksmo priklauso, ar iš anksto paruoštų formų ar firminių blankų dažai turės įtakos spausdinimo kokybei. Jei abejojate, kreipkitės į popieriaus tiekėją. Spausdindami ant firminių blankų spausdintuve popierių dėkite tinkama orientacija. Jei norite sužinoti daugiau, žr.  Popieriaus ir specialiųjų laikmenų vadovas . popierius iš anksto paruoštos formos iš anksto paruoštos formos pasirinkimas popierius firminiai blankai firminiai blankai pasirinkimas"},{"UUID":"d7bd6be8-636f-4d50-acad-cf8c414437f3","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Palaikomi popieriaus formatai Popieriaus formatai,","descFull":"Palaikomi popieriaus formatai Popieriaus formatai, kuriuos palaiko standartinis dėklas, daugiafunkcis spausdintuvas, vokų dėklas ir dvipusis spausdinimas Popieriaus formatas Standartinis 520 lapų dėklas Daugiafunkcis tiektuvas Vokų dėklas Abipusis spausdinimas 1  Įkeliama tik esant trumpo krašto orientacijai. 2  Įkeliama tik esant ilgo krašto orientacijai. 3  Palaikomas nuo 139,7 x 181,86 mm (5,5 x 7,16 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. 4  Palaikomas nuo 88,9 x 98,38 mm (3,5 x 3,87 col.) iki 296,93 x 482,6 mm (11,69 x 19 col.) dydžio popierius. 5  Palaikomas nuo 128 x 139,7 mm (5 x 5,5 col.) iki 296,93 x 482,6 mm (11,69 x 19 col.) dydžio popierius. A3 1 297 x 420 mm (11,69 x 16,54 col.) X A4 210 x 297 mm (8,27 x 11,7 col.) 2 X A5 148 x 210 mm (5,83 x 8,27 col.) 1 2 X A6 105 x 148 mm (4,13 x 5,83 col.) X 1 X X „Executive“ 184,2 x 266,7 mm (7,25 x 10,5 col.) 2 X „Folio“ 1 215,9 x 330,2 mm (8,5 x 13 col.) X „Hagaki“ 100 x 148 mm (3,94 x 5,83 col.) X 1 X X JIS B4 1 257 x 364 mm (10,12 x 14,33 col.) X JIS B5 182 x 257 mm (7,17 x 10,1 col.) 2 X Didžioji knyga 1 279,4 x 4431,8 mm (11 x 17 col.) X „Legal“ 1 215,9 x 355,6 mm (8,5 x 14 col.) X „Letter“ 215,9 x 279,4 mm (8,5 x 11 col.) 2 X „Oficio (Mexico)“ 1 215,9 x 340,4 mm (8,5 x 13,4 col.) X „Statement“ 139,7 x 215,9 mm (5,5 x 8,5 col.) 1 2 X Universalus 3 4 X 5 „7 3/4 Envelope“ 98,4 x 190,5 mm (3,875 x 7,5 col.) X 2 X „9 Envelope“ 98,4 x 225,4 mm (3,875 x 8,9 col.) X 2 X „10 Envelope“ 104,8 x 241,3 mm (4,12 x 9,5 col.) X 2 X „B5 Envelope“ 176 x 250 mm (6,93 x 9,84 col.) X 1 X „C5 Envelope“ 162 x 229 mm (6,38 x 9,01 col.) X 2 X „DL Envelope“ 110 x 220 mm (4,33 x 8,66 col.) X 2 X ADT palaiko nuo 125 x 85 mm (4,92 x 3,35 col.) iki 297 x 431,8 mm (11,69 x 17 col.) dydžio popierių. Plokščiasis skeneris palaiko didžiausią 297 x 431,8 mm (11,69 x 17 col.) dydžio popierių. Popieriaus formatai, kuriuos palaiko papildomi dėklai Popieriaus formatas Papildomas 520 lapų dėklas, papildomas 520 lapų dėklas su dėže ir papildomas 3 x 520 lapų dėklas Papildomas 2520 lapų sudvejintas dėklas Papildomai pasirenkamas 2000 lapų dėklas 1  Įkeliama tik esant trumpo krašto orientacijai. 2  Įkeliama tik esant ilgo krašto orientacijai. 3  Palaikomas nuo 139,7 x 181,86 mm (5,5 x 7,16 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. A3 1 297 x 420 mm (11,69 x 16,54 col.) X A4 210 x 297 mm (8,27 x 11,7 col.) 2 A5 1 148 x 210 mm (5,83 x 8,27 col.) X A6 105 x 148 mm (4,13 x 5,83 col.) X X X „Executive“ 184,2 x 266,7 mm (7,25 x 10,5 col.) 2 „Folio“ 1 215,9 x 330,2 mm (8,5 x 13 col.) X „Hagaki“ 100 x 148 mm (3,94 x 5,83 col.) X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 col.) X JIS B5 182 x 257 mm (7,17 x 10,1 col.) 2 Didžioji knyga 1 279,4 x 4431,8 mm (11 x 17 col.) X „Legal“ 1 215,9 x 355,6 mm (8,5 x 14 col.) X „Letter“ 215,9 x 279,4 mm (8,5 x 11 col.) 2 „Oficio (Mexico)“ 1 215,9 x 340,4 mm (8,5 x 13,4 col.) X „Statement“ 1 139,7 x 215,9 mm (5,5 x 8,5 col.) X Universalus 3 3 3 „7 3/4 Envelope“ 98,4 x 190,5 mm (3,875 x 7,5 col.) X X X „9 Envelope“ 98,4 x 225,4 mm (3,875 x 8,9 col.) X X X „10 Envelope“ 104,8 x 241,3 mm (4,12 x 9,5 col.) X X X „B5 Envelope“ 176 x 250 mm (6,93 x 9,84 col.) X X X „C5 Envelope“ 162 x 229 mm (6,38 x 9,01 col.) X X X „DL Envelope“ 110 x 220 mm (4,33 x 8,66 col.) X X X Popieriaus formatai, kuriuos palaiko išvedinių dėtuvės Popieriaus formatas Standartinė dėtuvė Viršutinė dėtuvė Sukrovimas į krūvą Poslinkis Sukrovimas į krūvą 1  Įkeliama tik esant trumpo krašto orientacijai. 2  Įkeliama tik esant ilgo krašto orientacijai. 3  Palaikomas nuo 88,9 x 98,38 mm (3,5 x 3,87 col.) iki 296,93 x 482,6 mm (11,69 x 19 col.) dydžio popierius. 4  Palaikomas nuo 88,9 x 98,38 mm (3,5 x 3,87 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. A3 1 297 x 420 mm (11,69 x 16,54 col.) A4 210 x 297 mm (8,27 x 11,7 col.) A5 148 x 210 mm (5,83 x 8,27 col.) A6 1 105 x 148 mm (4,13 x 5,83 col.) „Executive“ 184,2 x 266,7 mm (7,25 x 10,5 col.) „Folio“ 1 215,9 x 330,2 mm (8,5 x 13 col.) „Hagaki“ 1 100 x 148 mm (3,94 x 5,83 col.) JIS B4 1 257 x 364 mm (10,12 x 14,33 col.) JIS B5 182 x 257 mm (7,17 x 10,1 col.) Didžioji knyga 1 279,4 x 4431,8 mm (11 x 17 col.) „Legal“ 1 215,9 x 355,6 mm (8,5 x 14 col.) „Letter“ 215,9 x 279,4 mm (8,5 x 11 col.) „Oficio (Mexico)“ 1 215,9 x 340,4 mm (8,5 x 13,4 col.) „Statement“ 139,7 x 215,9 mm (5,5 x 8,5 col.) Universalus 3 4 X „7 3/4 Envelope“ 2 98,4 x 190,5 mm (3,875 x 7,5 col.) „9 Envelope“ 2 98,4 x 225,4 mm (3,875 x 8,9 col.) „10 Envelope“ 2 104,8 x 241,3 mm (4,12 x 9,5 col.) „B5 Envelope“ 2 176 x 250 mm (6,93 x 9,84 col.) „C5 Envelope“ 2 162 x 229 mm (6,38 x 9,01 col.) „DL Envelope“ 2 110 x 220 mm (4,33 x 8,66 col.) Popieriaus formatai, kuriuos palaiko apipavidalinimo įtaisai Popieriaus formatas Sąsagėlių segiklis Sąsagėlių segimo, skylmušos įtaisas Sukrovimas į krūvą Poslinkis Susegimas Sukrovimas į krūvą Poslinkis Susegimas Skylmuša 1  Įkeliama tik esant trumpo krašto orientacijai. 2  Įkeliama tik esant ilgo krašto orientacijai. 3  Palaikomas nuo 88,9 x 98,38 mm (3,5 x 3,87 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. 4  Palaikomas nuo 190 x 139,7 mm (7,48 x 5,5 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. 5  Palaikomas nuo 202,9 x 182,03 mm (7,99 x 7,17 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. 6  Palaikomas tik iki 2 skylių pramušimas. 7  Palaikomas tik iki 2 skylių pramušimas, kai įkeliama esant trumpo krašto orientacijai. 8  Palaikomas nuo 88,9 x 98,38 mm (3,5 x 3,87 col.) iki 320,04 x 1320,8 mm (12,6 x 52 col.) dydžio popierius. 9  Palaikomas nuo 209,97 x 148 mm (8,27 x 5,83 col.) iki 296,93 x 431,8 mm (11,69 x 17 col.) dydžio popierius. A3 1 297 x 420 mm (11,69 x 16,54 col.) A4 210 x 297 mm (8,27 x 11,7 col.) A5 148 x 210 mm (5,83 x 8,27 col.) 2 X 2 2 6 A6 105 x 148 mm (4,13 x 5,83 col.) X X X X X „Banner“ Didžiausias plotis: 215,9 mm (8,5 col.) Didžiausias ilgis: 1320,8 mm (52 col.) 1 X X 1 X X X „Executive“ 184,2 x 266,7 mm (7,25 x 10,5 col.) 2 2 2 2 2 2 „Folio“ 1 215,9 x 330,2 mm (8,5 x 13 col.) „Hagaki“ 100 x 148 mm (3,94 x 5,83 col.) X X X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 col.) JIS B5 182 x 257 mm (7,17 x 10,1 col.) 2 2 2 2 7 Didžioji knyga 1 279,4 x 4431,8 mm (11 x 17 col.) „Legal“ 1 215,9 x 355,6 mm (8,5 x 14 col.) „Letter“ 215,9 x 279,4 mm (8,5 x 11 col.) „Oficio (Mexico)“ 1 215,9 x 340,4 mm (8,5 x 13,4 col.) „Statement“ 139,7 x 215,9 mm (5,5 x 8,5 col.) 2 X X X X X Universalus 3 4 5 8 9 9 X „7 3/4 Envelope“ 98,4 x 190,5 mm (3,875 x 7,5 col.) X X X X X X „9 Envelope“ 98,4 x 225,4 mm (3,875 x 8,9 col.) X X X X X X „10 Envelope“ 104,8 x 241,3 mm (4,12 x 9,5 col.) X X X X X X „B5 Envelope“ 176 x 250 mm (6,93 x 9,84 col.) 2 X X X X X X „C5 Envelope“ 162 x 229 mm (6,38 x 9,01 col.) 1 X X X X X X „DL Envelope“ 110 x 220 mm (4,33 x 8,66 col.) X X X X X X palaikomi popieriaus formatai popieriaus formatai, palaikomi"},{"UUID":"1d167c44-cb5f-4cd6-8165-76f790c19449","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Palaikomos popieriaus rūšys Palaikomos popieriaus","descFull":"Palaikomos popieriaus rūšys Palaikomos popieriaus rūšys Popieriaus rūšys, kurias palaiko standartinis dėklas, daugiafunkcis spausdintuvas, vokų dėklas ir dvipusis spausdinimas Popieriaus rūšis Standartinis 520 lapų dėklas Daugiafunkcis tiektuvas Vokų dėklas Abipusis spausdinimas Standus popierius X Kartoninis popierius („Card Stock“)  X Spalvotas popierius X Tinkinta rūšis X Vokai X X Blizgus popierius („Glossy“) X Sunkus blizgus popierius („Heavy Glossy“) X Sunkus popierius X Etiketės X X Firminiai blankai X Lengvas popierius X Paprastas popierius („Plain Paper“) X Iš anksto paruoštos formos X Perdirbtas popierius X Šiurkštūs vokai („Rough Envelope“) X X Šiurkštus medvilninis popierius X Vinilinės etiketės („Vinyl Labels“) X X X X Popieriaus rūšys, kurias palaiko papildomi dėklai Popieriaus rūšis Papildomas 520 lapų dėklas, papildomas 520 lapų dėklas su dėže ir papildomas 3 x 520 lapų dėklas Papildomas 2520 lapų sudvejintas dėklas Papildomai pasirenkamas 2000 lapų dėklas Standus popierius Kartoninis popierius („Card Stock“)  Spalvotas popierius Tinkinta rūšis Vokai X X X Blizgus popierius („Glossy“) Sunkus blizgus popierius („Heavy Glossy“) Sunkus popierius Etiketės Firminiai blankai Lengvas popierius Paprastas popierius („Plain Paper“) Iš anksto paruoštos formos Perdirbtas popierius Šiurkštūs vokai („Rough Envelope“) X X X Šiurkštus medvilninis popierius Vinilinės etiketės („Vinyl Labels“) X X X Popieriaus rūšys, kurias palaiko išvedinių dėtuvės Popieriaus rūšis Standartinė dėtuvė Viršutinė dėtuvė Sukrovimas į krūvą Poslinkis Sukrovimas į krūvą Standus popierius Kartoninis popierius („Card Stock“)  Spalvotas popierius Tinkinta rūšis Vokai Blizgus popierius („Glossy“) Sunkus blizgus popierius („Heavy Glossy“) Sunkus popierius Etiketės Firminiai blankai Lengvas popierius Paprastas popierius („Plain Paper“) Iš anksto paruoštos formos Perdirbtas popierius Šiurkštūs vokai („Rough Envelope“) Šiurkštus medvilninis popierius Vinilinės etiketės („Vinyl Labels“) X X X Popieriaus rūšys, kurias palaiko apipavidalinimo įtaisai Popieriaus rūšis Sąsagėlių segiklis Sąsagėlių segimo, skylmušos įtaisas Sukrovimas į krūvą Poslinkis Susegimas Sukrovimas į krūvą Poslinkis Susegimas Skylmuša Standus popierius Kartoninis popierius („Card Stock“)  X X Spalvotas popierius Tinkinta rūšis Vokai X X X X X X Blizgus popierius („Glossy“) Sunkus blizgus popierius („Heavy Glossy“) X X Sunkus popierius X X Etiketės X X X X X Firminiai blankai Lengvas popierius Paprastas popierius („Plain Paper“) Iš anksto paruoštos formos Perdirbtas popierius Šiurkštūs vokai („Rough Envelope“) X X X X X X Šiurkštus medvilninis popierius X X Vinilinės etiketės („Vinyl Labels“) X X X X X X X palaikomos popieriaus rūšys popieriaus rūšys palaikomi"},{"UUID":"b9e1daea-29f2-4932-8f39-1940f693a8e2","title":"Popieriaus parinkimas","link":"paper-guidelines-topic.html","desc":"Palaikomi popieriaus svoriai Spausdintuve palaikomi","descFull":"Palaikomi popieriaus svoriai Spausdintuve palaikomi popieriaus svoriai 520 lapų dėklas, 520 lapų dėklas su dėže, 3 x 520 lapų dėklas ir 2520 lapų sudvejintas dėklas Daugiafunkcis tiektuvas Vokų dėklas Papildomai pasirenkamas 2000 lapų dėklas 60–256 g/m 2 (12–68 sv.) 60–216 g/m 2 (12–57 sv.) 75–90 g/m 2 (20–24 sv.) 60–216 g/m 2 (12–57 sv.) Jei popierius sveria 60–176 g/m 2  (16– 47 sv. stand.), rekomenduojama naudoti išilginio pluošto popierių. Ant popieriaus, kurio svoris mažesnis nei 75 g/m 2  (20 sv. stand.), reikia spausdinti  Popieriaus rūšį  nustačius į parinktį  Lengvas popierius . To nepadarius, popierius gali per daug užsiriesti ir dėl to atsirasti tiekimo klaidų, ypač esant drėgnesnei aplinkai. Spausdinant ant abiejų pusių palaikomas popieriaus svoris nuo 60–162 g/m 2  (16–43 sv. stand.). Maksimalus 100 % medvilnės sudėties laikmenos svoris – 90 g/m 2  (24 sv. stand.). palaikomi popieriaus svoriai popieriaus svoriai palaikomi"},{"UUID":"6c8d078a-0336-432a-8a3c-f2ef4eabcb45","title":"Nustatymas, įrengimas ir konfigūravimas","link":"selecting-location-printer-topic.html","desc":"Vietos spausdintuvui parinkimas Palikite pakankamai","descFull":"Vietos spausdintuvui parinkimas Palikite pakankamai vietos dėklams, dangčiams, durelėms atidaryti ir papildomai aparatinei įrangai įrengti. Spausdintuvą pastatykite arti elektros lizdo. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Norėdami išvengti elektros smūgio pavojaus, nestatykite arba nenaudokite šio gaminio netoli vandens arba drėgnose vietose. Įsitikinkite, kad oro srautas patalpoje atitinka naujausią persvarstytą ASHRAE 62 standartą arba CEN Technikos komiteto 156 standartą. Pasirūpinkite lygiu, tvirtu ir stabiliu grindų paviršiumi. Spausdintuvą laikykite tokiomis sąlygomis: Jis turi būti švarus, sausas ir nedulkėtas. Ant jo neturi būti išsibarsčiusių sąsagėlių ir sąvaržėlių. Jis turi būti atokiau nuo tiesioginio kondicionierių, šildytuvų ir ventiliatorių oro srauto. Jis turi būti apsaugotas nuo tiesioginių saulės spindulių ir per didelės drėgmės. Laikykitės rekomenduojamos temperatūros ir venkite jos svyravimų: Rekomenduojama temperatūra Aplinkos temperatūra Laikymo temperatūra Aplink spausdintuvą palikite šiuos rekomenduojamus laisvus atstumus, kad jis būtų tinkamai vėdinamas: Rekomenduojama tuščia erdvė aplink spausdintuvą 1 Viršus 2 Galas 3 Dešinė pusė 4 Priekis 5 Kairė pusė spausdintuvas vietos parinkimas vietos parinkimas spausdintuvui spausdintuvas minimalūs tarpai spausdintuvo perkėlimas"},{"UUID":"a4884be9-572c-4d44-a2ae-2ed4baf079eb","title":"Nustatymas, įrengimas ir konfigūravimas","link":"attaching-cables-topic.html","desc":"Laidų ir kabelių prijungimas Norėdami","descFull":"Laidų ir kabelių prijungimas Norėdami išvengti elektros smūgio pavojaus, nenustatinėkite šio gaminio arba nejunkite jokių elektros ar kabelių jungčių, pavyzdžiui, maitinimo laido, fakso funkcijos ar telefono, perkūnijos metu. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Norėdami išvengti gaisro ar elektros smūgio pavojaus, naudokite tik kartu su šiuo gaminiu pateiktą maitinimo laidą arba gamintojo leistą pakaitinį laidą. Jei norite sumažinti gaisro pavojų, jungdami šį gaminį prie viešo komutuojamo telefono ryšio tinklo, naudokite tik 26 AWG ar storesnį telekomunikacinės linijos (RJ-11) laidą. Jei tai Australijos vartotojai, laidas turi būti patvirtintas Australijos ryšių ir žiniasklaidos tarnybos. Norėdami išvengti duomenų praradimo arba spausdintuvo veikimo sutrikimo, aktyviai spausdindami spausdintuvu nelieskite USB laido, belaidžio tinklo adapterio ar spausdintuvo nurodytose vietose. Spausdintuvo jungtys ir kištukinis lizdas bei jų funkcijos Spausdintuvo jungtis Funkcija 1 USB jungtis Prijungiama klaviatūra arba panašus suderinamas įtaisas. 2 Spausdintuvo USB jungtis Spausdintuvas prijungiamas prie kompiuterio. 3 Eterneto prievadas Spausdintuvas prijungiamas prie tinklo. 4 LINE jungtis Prieinama tik tada, kai įdėta fakso kortelė. Spausdintuvas prie veikiančios telefono ryšio linijos prijungiamas naudojantis standartiniu sieniniu lizdu (RJ-11), DSL filtru, VoIP adapteriu ar bet kokiu kitu adapteriu, kuris suteikia prieigą prie telefono ryšio linijos, kad būtų galima siųsti ir priimti faksogramas. 5 Maitinimo laido kištukinis lizdas Spausdintuvas įjungiamas į tinkamai įžemintą elektros lizdą. laidų ir kabelių prijungimas spausdintuvo jungtys USB kabelis eterneto kabelis USB jungtis Eterneto prievadas maitinimo laido kištukinis lizdas"},{"UUID":"8fead1e0-ec37-4d76-a2dc-8504257dfedb","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Pradžios ekrano naudojimas Jūsų pradžios","descFull":"Pradžios ekrano naudojimas Jūsų pradžios ekranas gali skirtis priklausomai nuo jo tinkinimo nustatymų, administracinės sąrankos ir aktyvių įtaisytųjų sprendimų. Pradžios ekrano piktogramos ir jų funkcijos Nr. Piktograma Funkcija 1 Sustabdymo arba atšaukimo mygtukas Sustabdoma dabartinė užduotis. 2 Kopijavimas Daromos kopijos. 3 Keisti kalbą Keičiama spausdintuvo ekrano kalba. 4 El. paštas Siunčiami elektroniniai laiškai. 5 Nustatymai Patenkama į įvairius spausdintuvo meniu. 6 Faksas Siunčiamos faksogramos. 7 Adresų knyga Pasiekiami, kuriami ir tvarkomi adresatai. 8 Būsena / eksploataciniai reikmenys Rodomas spausdintuvo įspėjimas arba klaidos pranešimas, kai reikia naudotojo įsikišimo, kad spausdintuvas galėtų tęsti užduotį. Peržiūrima daugiau informacijos apie spausdintuvo įspėjimą ar pranešimą ir apie tai, kaip juos išvalyti. Šį nustatymą galima pasiekti ir palietus viršutinę pradžios ekrano dalį. 9 Turimos užduotys Rodomos visos šiuo metu užlaikomos spausdinimo užduotys. 10 Užduočių eilė Rodomos visos esamos spausdinimo užduotys. Šį nustatymą galima pasiekti ir palietus viršutinę pradžios ekrano dalį. 11 USB atmintukas Peržiūrimos, pasirenkamos arba spausdinamos nuotraukos ir dokumentai iš atmintuko. 12 Skenavimo profiliai Dokumentai nuskaitomi ir išsaugomi tiesiai kompiuteryje. 13 FTP Dokumentai nuskaitomi ir išsaugomi tiesiai FTP profilyje. 14 Adresynas Tvarkomi visi adresyno įrašai. 15 Standusis diskas Peržiūrimi, pasirenkami ir tvarkomi dokumentai iš standžiojo disko arba išmoningojo atminties įrenginio. 16 Tinklo aplankas Nuskenuojama į tinklo aplanką arba tinklo vietą. 17 Paleidimo mygtukas Atsižvelgiant į pasirinktą režimą pradedama užduotis. 18 Ekraninė klaviatūra Įvesties lauke įvedami skaičiai arba simboliai. naudojant pradžios ekraną pradžios ekranas naudojimas"},{"UUID":"f455f11a-8df5-41b7-b312-acf9b8cdf8ba","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Pradžios ekrano tinkinimas Atidarykite interneto","descFull":"Pradžios ekrano tinkinimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Įrenginys Pradžios ekrano tinkinimas . Atlikite vieną ar daugiau iš šių veiksmų: Jei norite pridėti piktogramą pradžios ekrane, spustelėkite  , pasirinkite programos pavadinimą ir spustelėkite  Pridėti . Jei norite pašalinti pradžios ekrane esančią piktogramą, pasirinkite programos pavadinimą ir spustelėkite  Pašalinti . Jei norite tinkinti programos pavadinimą, pasirinkite programos pavadinimą, spustelėkite  Redaguoti  ir priskirkite pavadinimą. Jei norite atkurti programos pavadinimą, pasirinkite programos pavadinimą, spustelėkite  Redaguoti  ir pasirinkite  Atkurti programos etiketę . Jei norite pridėti tarpą tarp programų, spustelėkite  , pasirinkite  TUŠČIA VIETA  ir spustelėkite  Pridėti . Jei norite išdėstyti programas, vilkite programų pavadinimus norima tvarka. Jei norite atkurti numatytąjį pradžios ekraną, spustelėkite  Atkurti pradžios ekraną . Vykdykite pakeitimus. pradžios ekrano piktogramos rodymas piktogramos pradžios ekrane rodymas pradžios ekranas tinkinimas programų rodymas pradžios ekrane programų pridėjimas pradžios ekrane"},{"UUID":"2cfb4720-c278-439b-b51d-fe308e9665df","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Palaikomos programos Programos ir jų","descFull":"Palaikomos programos Programos ir jų palaikomi spausdintuvų modeliai Programa Spausdintuvų modeliai Skenavimo centras CX930, CX931, XC9325, XC9335 Sparčiųjų nuorodų centras CX930, CX931, XC9325, XC9335 „Kortelių kopijavimas“ CX930, CX931, XC9325, XC9335 Ekrano tinkinimas CX930, CX931, XC9325, XC9335 Klientų aptarnavimo skyrius XC9325, XC9335 Įrenginio kvotos XC9325, XC9335 palaikomos programos"},{"UUID":"2228a71b-2d55-466a-920d-a789553cf40b","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Nuskaitymo centro diegimas Pradžios ekrane","descFull":"Nuskaitymo centro diegimas Pradžios ekrane palieskite  Nuskaitymo centras . Pasirinkite ir sukurkite paskirties vietą, po to sukonfigūruokite nustatymus. Kurdami tinklo paskirties vietą, būtinai patikrinkite ir pakoreguokite nustatymus, kol nebus jokių klaidų. Išsaugomos tik įtaisytajame tinklo serveryje sukurtos paskirties vietos. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su programa. Vykdykite pakeitimus. Nuskaitymo centras diegimas"},{"UUID":"d7a238f4-aab5-4503-855f-281edca03cdb","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Sparčiosios nuorodos kūrimas Pradžios ekrane","descFull":"Sparčiosios nuorodos kūrimas Pradžios ekrane palieskite  Sparčiųjų nuorodų centras . Piktograma ir pavadinimas gali būti pakeisti. Norėdami gauti daugiau informacijos, kreipkitės į administratorių. Pasirinkite spausdintuvo funkciją ir palieskite  Kurti sparčiąją nuorodą . Saugaus el. pašto funkcija nepalaikoma. Sukonfigūravę nustatymus, palieskite  Išsaugoti . Įveskite unikalų sparčiosios nuorodos pavadinimą. Norėdami išvengti nukirptų pavadinimų pradžios ekrane, įveskite ne daugiau nei 25 simbolius. Palieskite  Gerai . Programa automatiškai sukuria unikalų sparčiosios nuorodos numerį. Norėdami vykdyti sparčiąją nuorodą, palieskite   , palieskite  Nr.  ir įveskite sparčiosios nuorodos numerį. sparčiųjų nuorodų kūrimas sparčiosios nuorodos kūrimas sparčioji nuoroda Kopijavimas sparčioji nuoroda El. paštas sparčioji nuoroda Faksas sparčioji nuoroda FTP"},{"UUID":"ee8c2918-5398-412f-82bf-9b292f1a1352","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"„Card Copy“ diegimas Atidarykite interneto","descFull":"„Card Copy“ diegimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Programos „Kortelių kopijavimas“ Konfigūruoti . Įsitikinkite, kad įjungta  Ekrano piktograma . Įsitikinkite, kad sukonfigūruoti  El. pašto nustatymai  ir  Tinklo bendrinimo nustatymai . Nuskaitydami kortelę įsitikinkite, kad spalvoto nuskaitymo skiriamoji geba yra ne didesnė kaip 200 tšk./col., o nespalvoto – 400 tšk./col. Nuskaitydami ne vieną kortelę įsitikinkite, kad spalvoto nuskaitymo skiriamoji geba yra ne didesnė kaip 150 tšk./col., o nespalvoto – 300 tšk./col. Vykdykite pakeitimus. Norint nuskaityti ne vieną kortelę, reikia spausdintuvo standžiojo disko arba išmoningojo atminties įrenginio. „Kortelių kopijavimas“ nustatymas"},{"UUID":"32b566ce-d041-42d2-b295-3dca778dbd7a","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Ekrano tinkinimo funkcijos naudojimas Prieš","descFull":"Ekrano tinkinimo funkcijos naudojimas Prieš naudodami programą būtinai atlikite šiuos veiksmus: Įtaisytajame tinklo serveryje spustelėkite  Programos Ekrano tinkinimas Konfigūruoti . Įgalinkite ir konfigūruokite ekrano užsklandą, skaidrių demonstravimą ir darbalaukio fono nustatymus. Ekrano užsklandos ir skaidrių demonstravimo vaizdų tvarkymas Skiltyse „Ekrano užsklanda“ ir „Skaidrių demonstravimo vaizdai“ pridėkite, redaguokite arba šalinkite vaizdą. Galima pridėti iki 10 vaizdų. Kai įjungta, būsenos piktogramos ekrano užsklandoje rodomos tik tada, kai yra klaidų, įspėjimų ar debesijos pranešimų. Vykdykite pakeitimus. Darbalaukio fono vaizdo keitimas Pradžios ekrane palieskite  Keisti darbalaukio foną . Pasirinkite norimą naudoti vaizdą. Vykdykite pakeitimus. Skaidrių demonstracijos paleidimas iš atmintuko Įkiškite atmintuką į USB lizdą. Pradžios ekrane palieskite  Skaidrių demonstravimas . Vaizdai rodomi abėcėlės tvarka. Pradėjus skaidrių demonstravimą atmintuką galima išimti, tačiau vaizdai spausdintuve nėra išsaugomi. Jei skaidrių demonstravimas sustoja, vėl įdėkite atmintuką, kad galėtumėte peržiūrėti vaizdus. Ekrano tinkinimas naudojimas naudojimasis ekrano tinkinimo funkcija ekrano tinkinimas darbalaukio fono keitimas skaidrių demonstracijos paleidimas ekrano užsklandos tvarkymas"},{"UUID":"9077a471-1386-4f60-94c4-e2843e9b56b6","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Naudojimasis klientų aptarnavimo paslaugomis Ši","descFull":"Naudojimasis klientų aptarnavimo paslaugomis Ši programa palaikoma tik kai kurių modelių spausdintuvuose. Norėdami gauti daugiau informacijos, žr.  . Ši programa palaikoma tik kai kurių modelių spausdintuvuose. Informacijos apie tai, kaip sukonfigūruoti programos nustatymus, ieškokite  Klientų aptarnavimo administratoriaus vadove. Pradžios ekrane palieskite  Klientų aptarnavimas . Atsispausdinkite arba išsiųskite el. laišką. Klientų aptarnavimo skyrius naudojimas naudojimasis  Klientų aptarnavimo  paslaugomis"},{"UUID":"2b775f7e-aaee-427c-a8b6-448c9ab8ec73","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Įrenginio kvotų nustatymas Ši programa","descFull":"Įrenginio kvotų nustatymas Ši programa palaikoma tik kai kurių modelių spausdintuvuose. Norėdami gauti daugiau informacijos, žr.  . Ši programa palaikoma tik kai kurių modelių spausdintuvuose. Informacijos, kaip konfigūruoti programos nustatymus, ieškokite  Įrenginio kvotų administratoriaus vadove . Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Programos Įrenginio kvotos Konfigūruoti . Skiltyje  Naudotojų paskyros  pridėkite arba redaguokite naudotoją, o tada nustatykite naudotojo kvotą. Vykdykite pakeitimus. Įrenginio kvotų  nustatymas Įrenginio kvotos nustatymas"},{"UUID":"d158849a-e05f-4304-96bb-9d1fab55a345","title":"Adresyno įrašų tvarkymas","link":"using-home-screen-topic.html","desc":"Adresyno kūrimas Naudokitės adresynu spausdindami","descFull":"Adresyno kūrimas Naudokitės adresynu spausdindami dažnai naudojamus dokumentus, kurie saugomi serveriuose ar žiniatinklyje. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Adresyno įrašai Pridėti adresyno įrašą  ir įrašykite adresyno įrašo pavadinimą. Pasirinkite  adreso  protokolo tipą ir atlikite vieną iš šių veiksmų: Jei naudojate HTTP ir HTTPS protokolą, įveskite URL, kurį norite įrašyti į adresyną. Jei naudojate HTTPS protokolą, būtinai naudokite pagrindinio kompiuterio vardą, o ne IP adresą. Pavyzdžiui, įveskite  myWebsite.com/sample.pdf  vietoj  123.﻿123.123.123/sample.pdf . Įsitikinkite, kad pagrindinio kompiuterio vardas taip pat atitinka serverio liudijime nurodytą bendrąjį vardą (CN). Norėdami gauti daugiau informacijos apie tai, kaip gauti CN vertę serverio liudijime, žr. savo interneto naršyklės žinyno informaciją. FTP protokolo atveju įveskite FTP adresą. Pavyzdžiui,  myServer/myDirectory . Įveskite FTP prievado numerį. 21 prievadas – numatytasis prievadas komandoms siųsti. SMB protokolo atveju įveskite tinklo aplanko adresą. Pavyzdžiui,  myServer/myShare/myFile.pdf . Įveskite tinklo srities vardą. Jei reikia, pasirinkite FTP ir SMB  tapatybės nustatymo  tipą. Norėdami apriboti prieigą prie adresyno įrašo, įveskite PIN kodą. Programoje palaikomi šie failų tipai: PDF, JPEG ir TIFF. Kai kuriuose spausdintuvų modeliuose palaikomi kiti failų tipai, pavyzdžiui, DOCX ir XLSX. Spustelėkite  Išsaugoti . adresyno įrašai kūrimas adresyno kūrimas"},{"UUID":"bc1916ad-ee6a-4387-8040-9b1f75bf9086","title":"Adresyno įrašų tvarkymas","link":"using-home-screen-topic.html","desc":"Aplankų kūrimas Atidarykite interneto naršyklę","descFull":"Aplankų kūrimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Adresyno įrašai Pridėti aplanką  ir įrašykite aplanko pavadinimą. Norėdami apriboti prieigą prie aplanko, įveskite PIN kodą. Spustelėkite  Išsaugoti . Galima kurti aplankus ar adresyno įrašus ir aplanko viduje. Norėdami sukurti adresyno įrašą, žr.  . adresyno įrašai aplankų kūrimas aplankų kūrimas adresyno įrašams"},{"UUID":"71bac71f-88ad-4c9c-8662-9116177edd0e","title":"Pradžios ekrano programų diegimas ir naudojimas","link":"using-home-screen-topic.html","desc":"Adresų knyga Adresatų tvarkymas Pradžios","descFull":"Adresų knyga Adresatų tvarkymas Pradžios ekrane palieskite  Adresų knyga. . Atlikite vieną ar daugiau iš šių veiksmų: Norėdami pridėti adresatą, palieskite  ekrano viršuje, po to palieskite  Kurti adresatą . Jei reikia, nurodykite prisijungimo metodą, kad būtų galima pasiekti programas. Norėdami pašalinti adresatą, palieskite  ekrano viršuje, palieskite  Šalinti adresatus  ir pasirinkite adresatą. Norėdami redaguoti adresato informaciją, palieskite adresato vardą. Norėdami sukurti grupę, palieskite  ekrano viršuje, po to palieskite  Kurti grupę . Jei reikia, nurodykite prisijungimo metodą, kad būtų galima pasiekti programas. Norėdami pašalinti grupę, palieskite  ekrano viršuje, palieskite  Šalinti grupes  ir pasirinkite grupę. Norėdami redaguoti adresatų grupę, palieskite  GRUPĖS pasirinkite grupės pavadinimą  pasirinkite veiksmą, kurį norite atlikti. Vykdykite pakeitimus. adresatų pridėjimas adresatų šalinimas adresatų grupių pridėjimas adresatų grupių šalinimas adresatų redagavimas Adresų knyga naudojimas"},{"UUID":"b129bcdb-4427-4c4a-a06e-af2d94105635","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Valdymo balsu aktyvinimas pradžios ekrane;","descFull":"Valdymo balsu aktyvinimas pradžios ekrane; Vienu judesiu vienu pirštu ekrane lėtai braukite kairėn, o tada aukštyn, kol išgirsite balso pranešimą. Dviem pirštais palieskite  Gerai . Jei gestas neveikia, spauskite stipriau. Klaviatūroje Nuspauskite ir palaikykite  5  klavišą, kol išgirsite balso pranešimą. Paspauskite  Tab , kad įvesties žymeklį nuvestumėte prie mygtuko „Gerai“, ir paspauskite  Įvesti . Kai įjungtas valdymas balsu, bet kurį elementą ekrane visada pasirinkite dviem pirštais. Valdymas balsu palaikomas ne visomis kalbomis. valdymas balsu aktyvinimas valdymo balsu aktyvinimas"},{"UUID":"370e2c30-dab1-4ba7-885a-e62e96ba2f44","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Valdymo balsu pasyvinimas Vienu judesiu","descFull":"Valdymo balsu pasyvinimas Vienu judesiu vienu pirštu ekrane lėtai braukite kairėn, o tada aukštyn, kol išgirsite balso pranešimą. Dviem pirštais atlikite vieną iš šių veiksmų: Palieskite  Valdymas balsu , tada palieskite  Gerai . Palieskite  Atšaukti . Jei gestas neveikia, spauskite stipriau. Valdymą balsu galite pasyvinti ir atlikdami vieną iš šių veiksmų: Dviem pirštais dukart bakstelėkite pradžios ekraną. Paspauskite maitinimo mygtuką, kad įvestumėte spausdintuvą į miego arba užmigdymo režimą. valdymas balsu pasyvinimas valdymo balsu pasyvinimas"},{"UUID":"bb82f357-2b17-4372-8019-97dffd29ca2e","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Naršymas ekrane naudojant gestus Dauguma","descFull":"Naršymas ekrane naudojant gestus Dauguma gestų naudojami tik tada, kai suaktyvinama valdymo balsu funkcija. Įjunkite didinimo funkciją, kad galėtumėte naudoti mastelio keitimo ir vaizdo išskleidimo gestus. Jei norite įrašyti simbolius ir koreguoti tam tikrus nustatymus, naudokite fizinę klaviatūrą. Gestai ir jų funkcijos Gestas Funkcija Vienu pirštu braukite kairėn, tada aukštyn Paleidžiamas pritaikymo neįgaliesiems režimas. Norint išeiti iš pritaikymo neįgaliesiems režimo naudojamas tas pats gestas. Šis gestas naudojamas ir kai spausdintuvas veikia įprastu režimu. Dukart bakstelėkite vienu pirštu Ekrane pasirenkama parinktis arba elementas. Dviem pirštais dukart bakstelėkite pradžios ekrano piktogramą Išjungiamas pritaikymo neįgaliesiems režimas. Triskart bakstelėkite vienu pirštu Padidinamas arba sumažinamas teksto ir atvaizdų mastelis. Vienu pirštu braukite dešinėn arba žemyn Pereinama prie kito elemento ekrane. Vienu pirštu braukite kairėn arba aukštyn Pereinama prie ankstesnio elemento ekrane. Vienu pirštu braukite aukštyn, tada žemyn Pereinama prie pirmojo elemento ekrane. Vaizdo išskleidimas Prieinama prie padidinto vaizdo elementų, kurie yra už ekrano ribos. Padidintam vaizdui traukti naudojami du pirštai. Vienu pirštu braukite aukštyn, tada dešinėn Padidinama apimtis. Šis gestas naudojamas ir kai spausdintuvas veikia įprastu režimu. Vienu pirštu braukite žemyn, tada dešinėn Sumažinama apimtis. Šis gestas naudojamas ir kai spausdintuvas veikia įprastu režimu. Vienu pirštu braukite aukštyn, tada kairėn Išeinama iš programos ir grįžtama į pradžios ekraną. Vienu pirštu braukite žemyn, tada kairėn Grįžtama į ankstesnį nustatymą. naršymas ekrane gestų naudojimas naršymas ekrane naudojant gestus"},{"UUID":"cab6b0f2-97ec-4551-bee7-40b786f47c21","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Ekraninės klaviatūros naudojimas Pasirodžius ekraninei","descFull":"Ekraninės klaviatūros naudojimas Pasirodžius ekraninei klaviatūrai atlikite vieną ar daugiau iš toliau nurodytų veiksmų. Palieskite klavišą, kad paskelbtumėte ir įvestumėte simbolį lauke. Vilkite pirštu per skirtingus simbolius, kad paskelbtumėte ir įvestumėte simbolį lauke. Dviem pirštais palieskite teksto laukelį, kad paskelbtumėte simbolius lauke. Norėdami ištrinti simbolius, palieskite  Grįžimas . ekraninė klaviatūra naudojimas"},{"UUID":"ad1d54ba-c2d5-4414-b4a4-50fbeef110d2","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Didinimo režimo įgalinimas Vienu judesiu","descFull":"Didinimo režimo įgalinimas Vienu judesiu vienu pirštu ekrane lėtai braukite kairėn, o tada aukštyn, kol išgirsite balso pranešimą. Jei naudojate spausdintuvo modelį be įmontuotų garsiakalbių, norėdami išgirsti pranešimą naudokite ausines. Dviem pirštais atlikite šiuos veiksmus: Palieskite  Didinimo režimas . Palieskite  Gerai . Jei gestas neveikia, spauskite stipriau. Jei norite sužinoti daugiau apie padidinto ekrano naršymą, žr.  . didinimo režimas įgalinimas didinimo režimo įgalinimas"},{"UUID":"bda2dcaf-2b3c-4ce7-9de5-fef9ae8ac6e4","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Kalbėjimo tempo valdant balsu koregavimas","descFull":"Kalbėjimo tempo valdant balsu koregavimas Pradžios ekrane palieskite  Nustatymai Įrenginys Pritaikymas neįgaliesiems Kalbėjimo tempas . Pasirinkite kalbėjimo tempą. valdymas balsu kalbėjimo tempas kalbėjimo tempas valdant balsu koregavimas kalbėjimo tempo koregavimas valdymas balsu"},{"UUID":"1dd2cf76-7c25-45c6-a11d-9aca1ec9921c","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Numatytojo ausinių garsumo koregavimas Pradžios","descFull":"Numatytojo ausinių garsumo koregavimas Pradžios ekrane palieskite  Nustatymai Įrenginys Pritaikymas neįgaliesiems . Koreguojamas ausinių garsumas. Garsumas iš naujo nustatomas į numatytąją vertę naudotojui išėjus iš pritaikymo neįgaliesiems režimo arba spausdintuvui atsibudus iš miego ar užmigdymo režimo. numatytasis ausinių garsumas koregavimas numatytojo garsumo koregavimas ausinės"},{"UUID":"2cb01531-09b5-4692-a856-deb654779fc6","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Numatytojo vidinio garsiakalbio garsumo koregavimas","descFull":"Numatytojo vidinio garsiakalbio garsumo koregavimas Pradžios ekrane palieskite  . Pakoreguokite garsumą. Jei įgalinamas tylusis režimas, garsiniai įspėjimai išjungiami. Įjungus šį nustatymą, sulėtėja spausdintuvo našumas. Garsumas iš naujo nustatomas į numatytąją vertę naudotojui išėjus iš pritaikymo neįgaliesiems režimo arba spausdintuvui atsibudus iš miego ar užmigdymo režimo. numatytasis garsiakalbio garsumas koregavimas numatytojo garsumo koregavimas garsiakalbis"},{"UUID":"cf9fe59f-dd53-4c9c-a1a4-3206dbeeb667","title":"Prieinamumo funkcijų nustatymas ir naudojimas","link":"activating-voice-guidance-topic.html","desc":"Ištariamų slaptažodžių arba asmens identifikavimo","descFull":"Ištariamų slaptažodžių arba asmens identifikavimo numerių įgalinimas Pradžios ekrane palieskite  Nustatymai Įrenginys Pritaikymas neįgaliesiems Sakyti slaptažodžius / PIN kodus . Įgalinkite nustatymą. ištariami slaptažodžiai įgalinimas asmeninio identifikavimo numeriai įgalinimas ištariamų slaptažodžių įgalinimas asmeninio identifikavimo numerių įgalinimas"},{"UUID":"c97b064e-c1b5-4533-add5-4deb9a976e21","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Palaikomas faksimilinis ryšys Spausdintuvų modeliai","descFull":"Palaikomas faksimilinis ryšys Spausdintuvų modeliai ir juose palaikomas faksimilinis ryšys Spausdintuvo modelis Analoginis faksimilinis ryšys 1 „etherFAX“ 2 Fakso serveris „Fax over IP“ (FoIP) 3 1  Reikalinga įdiegta fakso kortelė. Norėdami gauti daugiau informacijos, kreipkitės į vietą, kurioje pirkote spausdintuvą. 2  Reikia prenumeratos. Norėdami gauti daugiau informacijos, apsilankykite adresu  https://www.etherfax.net/lexmark  arba kreipkitės į vietą, kurioje pirkote spausdintuvą. 3  Reikia įdiegto licencijos paketo. Norėdami gauti daugiau informacijos, kreipkitės į vietą, kurioje pirkote spausdintuvą. CX930 CX931 XC9325 XC9335 palaikomas faksimilinis ryšys"},{"UUID":"c7cd0c0d-7fc4-4ad5-945b-ca2cc0e905ec","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Fakso funkcijos nustatymas naudojant analoginį","descFull":"Fakso funkcijos nustatymas naudojant analoginį faksimilinį ryšį Kad spausdintuvas galėtų naudoti analoginį faksimilinį ryšį, turi būti įrengta fakso plokštė. Kai kurie ryšio metodai taikomi tik kai kuriose šalyse ar regionuose. Jei fakso funkcija yra įjungta ir nėra visiškai nustatyta, indikatoriaus lemputė gali mirksėti raudona spalva. Jei nėra TCP / IP aplinkos, nustatydami faksą naudokitės valdymo skydeliu. Norėdami išvengti duomenų praradimo arba spausdintuvo veikimo sutrikimo, aktyviai siųsdami ar priimdami faksogramas nelieskite laidų arba spausdintuvo nurodytose vietose. Meniu  Nustatymai  naudojimas spausdintuve Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Bendrieji fakso nustatymai . Sukonfigūruokite nustatymus. Įtaisytojo interneto serverio (EWS) naudojimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Pradžios ekrane pasižiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Faksas Faksimilinio ryšio sąranka Bendrieji fakso nustatymai . Sukonfigūruokite nustatymus. Vykdykite pakeitimus. analoginis faksimilinis ryšys nustatymas nustatymas analoginis faksimilinis ryšys"},{"UUID":"1277b60d-84d8-42fe-9a11-18bce9617ff9","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Faksimilinio ryšio funkcijos nustatymas naudojant","descFull":"Faksimilinio ryšio funkcijos nustatymas naudojant „etherFAX“ Spausdintuvo programinę aparatinę įrangą reikia atnaujinti į naujausią versiją. Norėdami gauti daugiau informacijos, žr.  . Jūsų spausdintuve turi būti įdiegtas atitinkamas licencijos paketas. Norėdami gauti daugiau informacijos, kreipkitės į „etherFAX“. Įsitikinkite, kad spausdintuvą esate užregistravę „etherFAX“ portale. Norėdami gauti daugiau informacijos, apsilankykite adresu  https://www.etherfax.net/lexmark . Registruojant spausdintuvą reikia jo serijos numerio. Norėdami rasti serijos numerį žr.  . Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Pradžios ekrane pasižiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Faksas Faksimilinio ryšio sąranka Bendrieji fakso nustatymai . Meniu elementas  Faksimilinio ryšio sąranka  rodomas tik tada, kai  Fakso režimas  yra nustatytas į  Faksas . Lauke  Fakso pavadinimas  įveskite unikalų vardą. Lauke  Fakso numeris  įveskite „etherFAX“ suteiktą fakso numerį. Meniu  Faksogramų transportas  pasirinkite  „etherFAX“ . Šis meniu rodomas tik tada, kai galimas daugiau nei vienas faksogramų transportas. Jei spausdintuve įdiegta tik „etherFAX“, jis sukonfigūruojamas automatiškai. Vykdykite pakeitimus. „etherFAX“ faksimilinio ryšio funkcijos diegimas faksimilinio ryšio funkcijos diegimas „etherFAX“ naudojimas"},{"UUID":"d23c9101-1d96-4032-9de3-4f1cf1a4edec","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Fakso funkcijos nustatymas naudojant fakso","descFull":"Fakso funkcijos nustatymas naudojant fakso serverį Ši funkcija leidžia siųsti faksogramas faksimilinių paslaugų teikėjui, palaikančiam el. laiškų gavimą. Ši funkcija palaiko tik išsiunčiamas faksogramas. Norėdami palaikyti faksogramų priėmimą, įsitikinkite, kad spausdintuve turite sukonfigūruotą faksimilinį ryšį pagal įrenginį, pavyzdžiui, analoginį faksimilinį ryšį, „etherFAX“ arba „Fax over IP“ (FoIP). Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Pradžios ekrane pasižiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Faksas . Meniu  Fakso režimas  pasirinkite  Fakso serveris , tada spustelėkite  Išsaugoti . Spustelėkite  Fakso serverio sąranka . Lauke  Formatuoti  įveskite  [#]@myfax.com , kai  [#]  reiškia fakso numerį, o  myfax.com  – fakso paslaugos teikėjo sritį (domeną). Jei reikia, sukonfigūruokite laukus  Atgalinis adresas ,  Tema  arba  Pranešimas . Norėdami leisti spausdintuvui priimti faksogramas, įgalinkite faksogramų priėmimo nustatymą pagal įrenginį. Įsitikinkite, kad esate sukonfigūravę faksimilinį ryšį pagal įrenginį. Spustelėkite  Išsaugoti . Spustelėkite  Fakso serverio el. pašto nustatymai , po to atlikite vieną iš šių veiksmų: Įgalinkite parinktį  Naudoti el. pašto SMTP serverį . Jei el. pašto SMTP nustatymai nesukonfigūruoti, žr  . Sukonfigūruokite SMTP nustatymus. Norėdami gauti daugiau informacijos, kreipkitės į el. pašto paslaugos teikėją. Vykdykite pakeitimus. fakso serveris, naudojimas faksimilinio ryšio funkcijos diegimas faksimilinio ryšio funkcijos diegimas naudojant fakso serverį"},{"UUID":"741748d8-cbc4-4b21-b0bd-2678cbf70deb","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Faksimilinio ryšio diegimas naudojant įprastą","descFull":"Faksimilinio ryšio diegimas naudojant įprastą telefono ryšio liniją Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami gauti daugiau informacijos, žr.  . Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami išvengti elektros smūgio pavojaus, nenustatinėkite šio gaminio arba nejunkite jokių elektros ar kabelių jungčių, pavyzdžiui, maitinimo laido, fakso funkcijos ar telefono, perkūnijos metu. Norėdami išvengti elektros smūgio pavojaus, nesinaudokite fakso funkcija perkūnijos metu. Jei norite sumažinti gaisro pavojų, jungdami šį gaminį prie viešo komutuojamo telefono ryšio tinklo, naudokite tik 26 AWG ar storesnį telekomunikacinės linijos (RJ-11) laidą. Jei tai Australijos vartotojai, laidas turi būti patvirtintas Australijos ryšių ir žiniasklaidos tarnybos. 1 sąranka: Spausdintuvas prijungiamas prie faksimiliniam ryšiui skirtos linijos Vieną telefono laido galą prijunkite prie spausdintuvo linijos prievado. Kitą laido galą prijunkite prie veikiančio analoginio sieninio lizdo. Galite nustatyti, kad spausdintuvas faksogramas priimtų automatiškai (parinktį  Automatinis atsiliepimas  nustatykite į  Įjungta ) arba rankiniu būdu (parinktį  Automatinis atsiliepimas  nustatykite į  Išjungta ). Jei faksogramas norite priimti automatiškai, nustatykite, kad spausdintuvas atsilieptų po tam tikro skambėjimų skaičiaus. 2 sąranka: Spausdintuvas prijungiamas prie tos pačios linijos kaip ir automatinis atsakiklis Jei užsisakote skiriamojo skambėjimo paslaugą, įsitikinkite, kad spausdintuve nustatote tinkamą skambėjimo melodiją. Priešingu atveju, spausdintuvas nepriims faksogramų, net jei nustatėte, kad jis jas priimtų automatiškai. Įjungiama į skirtingus sieninius lizdus Vieną telefono laido galą prijunkite prie spausdintuvo linijos prievado. Kitą laido galą prijunkite prie veikiančio analoginio sieninio lizdo. Jei į liniją įjungtas tik vienas telefono numeris, nustatykite, kad spausdintuvą faksogramas priimtų automatiškai. Nustatykite, kad spausdintuvas atsilieptų po dviejų automatinio atsakiklio skambėjimų. Pavyzdžiui, jei atsakiklis atsiliepia po keturių skambėjimų, spausdintuvo nustatymą  Skambėjimai prieš atsiliepiant  nustatykite į  6 . faksimilinio ryšio diegimas prijungimas prie įprastos telefono ryšio linijos faksimilinio ryšio sąranka prijungimas prie įprastos telefono ryšio linijos atsakiklis nustatymas"},{"UUID":"9eccc87e-aa41-4054-8506-c19a3e11affe","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Fakso diegimas šalyse arba regionuose,","descFull":"Fakso diegimas šalyse arba regionuose, kuriuose naudojami skirtingi sieniniai telefono lizdai ir kištukai Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami gauti daugiau informacijos, žr.  . Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami išvengti elektros smūgio pavojaus, nenustatinėkite šio gaminio arba nejunkite jokių elektros ar kabelių jungčių, pavyzdžiui, maitinimo laido, fakso funkcijos ar telefono, perkūnijos metu. Norėdami išvengti elektros smūgio pavojaus, nesinaudokite fakso funkcija perkūnijos metu. Jei norite sumažinti gaisro pavojų, jungdami šį gaminį prie viešo komutuojamo telefono ryšio tinklo, naudokite tik 26 AWG ar storesnį telekomunikacinės linijos (RJ-11) laidą. Jei tai Australijos vartotojai, laidas turi būti patvirtintas Australijos ryšių ir žiniasklaidos tarnybos. Daugelyje šalių ir regionų pasirinktas standartinis sieninis lizdas – RJ-11. Jei sieninis lizdas ar įranga jūsų patalpose yra nesuderinamas su šiuo jungties tipu, naudokite telefono adapterį. Adapteris jūsų šalyje ar regione gali nebūti pridėtas prie spausdintuvo, todėl gali prireikti jį įsigyti atskirai. Adapterio kištukas gali būti įkišamas į spausdintuvo telefono ryšio prievadą. Jei jungiatės prie nuoseklios ar pakopinės telefono ryšio sistemos, neištraukite adapterio kištuko iš spausdintuvo telefono ryšio prievado. Adapterio kištuko dalies numeris Dalies pavadinimas Dalies numeris „Lexmark“ adapterio kištukas 40X8519 Spausdintuvo įjungimas į ne RJ-11 sieninį lizdą Vieną telefono laido galą prijunkite prie spausdintuvo linijos prievado. Kitą laido galą prijunkite prie RJ-11 adapterio, o tada adapterį įjunkite į sieninį lizdą. Jei į tą patį sieninį lizdą norite įjungti kitą įrenginį su ne RJ-11 jungtimi, prijunkite jį tiesiai prie telefono adapterio. faksimilinio ryšio sąranka skirta konkrečiai šaliai arba regionui faksimilinio ryšio diegimas skirta konkrečiai šaliai arba regionui RJ‑11 adapteris adapterio kištukas"},{"UUID":"98e03449-020c-48f3-9541-35f26f6e97ef","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Prijungimas prie skiriamojo skambėjimo paslaugos","descFull":"Prijungimas prie skiriamojo skambėjimo paslaugos Skiriamojo skambėjimo paslauga suteikia galimybę viena telefono linija naudoti kelis telefono numerius. Kiekvienam telefono numeriui priskiriamas skirtingas skambėjimo tonas. Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami gauti daugiau informacijos, žr.  . Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų gavimo nustatymai Administratoriaus valdikliai Atsiliepti į . Pasirinkite skambėjimo toną. skiriamojo skambėjimo paslauga, faksas įgalinimas spausdintuvo prijungimas prie skiriamojo skambėjimo paslaugos spausdintuvo priskyrimas skambėjimo tonui"},{"UUID":"918c72fd-036a-4c8b-b7d7-d3b243298e51","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Faksogramos datos ir laiko nustatymas","descFull":"Faksogramos datos ir laiko nustatymas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos, žr.  . Pradžios ekrane palieskite  Nustatymai Įrenginys Parinktys Data ir laikas Konfigūruoti . Sukonfigūruokite nustatymus. siuntimas faksu datos ir laiko nustatymas data ir laikas fakso nustatymai"},{"UUID":"27fc1b60-287d-4df5-ae53-e79707bec895","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Vasaros laiko konfigūravimas Įsitikinkite, kad","descFull":"Vasaros laiko konfigūravimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane palieskite  Nustatymai Įrenginys Nuostatos Data ir laikas Konfigūruoti . Meniu  Laiko juosta  palieskite  (UTC+naudotojas) pasirinktinis . Palieskite  UTC (GMT) poslinkis  ir sukonfigūruokite nustatymus. vasaros laiko konfigūravimas vasaros laikas konfigūravimas"},{"UUID":"5c3645bf-954b-4fff-8c99-a7868af67ae5","title":"Fakso nustatymas spausdintuve","link":"setting-up-printer-to-fax-group.html","desc":"Fakso garsiakalbio nustatymų konfigūravimas Įsitikinkite,","descFull":"Fakso garsiakalbio nustatymų konfigūravimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane pasirinkite  Nustatymai Faksas Faksimilinio ryšio sąranka Garsiakalbio nustatymai . Atlikite šiuos veiksmus: Parinktį  Garsiakalbio režimas  nustatykite į  Visada įjungta . Parinktį  Garsiakalbio garsumas  nustatykite į  Didelis . Įjunkite parinktį  Šaukiklio garsumas . fakso garsiakalbio nustatymų konfigūravimas fakso garsiakalbio nustatymai konfigūravimas"},{"UUID":"8984a6f3-e13b-4e2a-bd92-abd6871d23d8","title":"Nustatymas, įrengimas ir konfigūravimas","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"El. pašto SMTP nustatymų konfigūravimas","descFull":"El. pašto SMTP nustatymų konfigūravimas Norėdami nusiųsti nuskenuotą dokumentą el. paštu, sukonfigūruokite paprastojo pašto siuntimo protokolo (SMTP) nustatymus. Kiekvieno el. pašto paslaugų teikėjo nustatymai skiriasi. Prieš pradėdami įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo, o tinklas yra prijungtas prie interneto. Įtaisytojo interneto serverio (EWS) naudojimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai El. laiškas . Dalyje  El. pašto sąranka  sukonfigūruokite nustatymus. Norėdami gauti daugiau informacijos, peržiūrėkite  el. pašto paslaugų teikėjų  sąrašą. Jei jūsų paslaugų teikėjo sąraše nėra, susisiekite su savo paslaugų teikėju ir paprašykite nustatymų. Spustelėkite  Išsaugoti . Meniu  Nustatymai  naudojimas spausdintuve Pradžios ekrane palieskite  Nustatymai El. paštas Elektroninio pašto sąranka . Sukonfigūruokite nustatymus. Norėdami gauti daugiau informacijos, peržiūrėkite  el. pašto paslaugų teikėjų  sąrašą. Jei jūsų paslaugų teikėjo sąraše nėra, susisiekite su savo paslaugų teikėju ir paprašykite nustatymų. El. pašto paslaugų teikėjai „AOL Mail“ „Comcast Mail“ „Gmail“ „iCloud Mail“ „Mail.com“ „NetEase Mail“ (mail.126.com) „NetEase Mail“ (mail.163.com) „NetEase Mail“ (mail.yeah.net) „Outlook Live“ arba „Microsoft 365“ „QQ Mail“ „Sina Mail“ „Sohu Mail“ „Yahoo! Mail“ „Zoho Mail“ Jei naudodami pateiktus nustatymus pastebite klaidų, susisiekite su savo el. pašto paslaugų teikėju. Jei jūsų paslaugų teikėjo sąraše nėra, susisiekite su savo paslaugų teikėju. „AOL Mail“ „AOL Mail“ nustatymas Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.aol.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Programos slaptažodis  Norėdami sukurti programos slaptažodį, eikite į puslapį  AOL paskyrų saugumas , prisijunkite prie savo paskyros ir spustelėkite  Generuoti programos slaptažodį . „Comcast Mail“ „Comcast Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.comcast.net Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Paskyros slaptažodis Įsitikinkite, kad paskyroje įgalintas trečiosios šalies prieigos saugos nustatymas. Daugiau informacijos rasite  „Comcast Xfinity Connect“ žinyno puslapyje . „Gmail“ Įsitikinkite, kad jūsų „Google“ paskyroje įgalintas verifikavimas dviem veiksmais. Jei norite įgalinti verifikavimą dviem veiksmais, eikite į puslapį  „Google“ paskyrų saugumas , prisijunkite prie savo paskyros ir sekcijoje „ Prisijungimas prie „Google“ “ spustelėkite  Verifikavimas dviem veiksmais . „Gmail“ SMTP nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.gmail.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Programos slaptažodis Jei norite sukurti programos slaptažodį, eikite į puslapį  „Google“ paskyrų saugumas , prisijunkite prie savo paskyros ir sekcijoje „ Prisijungimas prie „Google“ “ spustelėkite  Programų slaptažodžiai . Elementas „ Programų slaptažodžiai “ rodomas, tik jei yra įgalintas verifikavimas dviem veiksmais. „iCloud Mail“ Įsitikinkite, kad jūsų paskyroje įgalintas verifikavimas dviem veiksmais. „iCloud Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.mail.me.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Programos slaptažodis Jei norite sukurti programos slaptažodį, eikite į puslapį  „iCloud“ paskyrų tvarkymas , prisijunkite prie savo paskyros ir sekcijoje  Saugumas  spustelėkite  Generuoti slaptažodį . „Mail.com“ „Mail.com“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.mail.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Paskyros slaptažodis „NetEase Mail“ (mail.126.com) Įsitikinkite, kad jūsų paskyroje įgalinta SMTP paslauga. Norėdami įjungti paslaugą, „NetEase Mail“ tinklapyje spustelėkite  Nustatymai POP3 / SMTP / IMAP , o tada įjunkite  IMAP / SMTP  arba  POP3 / SMTP  paslaugą. „NetEase Mail“ (mail.126.com) nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.126.com Pirminio SMTP tinklų sietuvo prievadas 465 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Prieigos teisės slaptažodis Prieigos teisės slaptažodis suteikiamas, kai yra įgalinta  IMAP/SMTP paslauga  arba  POP3/SMTP paslauga . „NetEase Mail“ (mail.163.com) Įsitikinkite, kad jūsų paskyroje įgalinta SMTP paslauga. Norėdami įjungti paslaugą, „NetEase Mail“ tinklapyje spustelėkite  Nustatymai POP3 / SMTP / IMAP , o tada įjunkite  IMAP / SMTP  arba  POP3 / SMTP  paslaugą. „NetEase Mail“ (mail.163.com) nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.163.com Pirminio SMTP tinklų sietuvo prievadas 465 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Prieigos teisės slaptažodis Prieigos teisės slaptažodis suteikiamas, kai yra įgalinta  IMAP/SMTP paslauga  arba  POP3/SMTP paslauga . „NetEase Mail“ (mail.yeah.net) Įsitikinkite, kad jūsų paskyroje įgalinta SMTP paslauga. Norėdami įjungti paslaugą, „NetEase Mail“ tinklapyje spustelėkite  Nustatymai POP3 / SMTP / IMAP , o tada įjunkite  IMAP / SMTP  arba  POP3 / SMTP  paslaugą. „NetEase Mail“ (mail.yeah.net) nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.yeah.net Pirminio SMTP tinklų sietuvo prievadas 465 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Prieigos teisės slaptažodis Prieigos teisės slaptažodis suteikiamas, kai yra įgalinta  IMAP/SMTP paslauga  arba  POP3/SMTP paslauga . „Outlook Live“ arba „Microsoft 365“ Šie nustatymai taikomi outlook.com ir hotmail.com el. pašto sritims (domenams) bei „Microsoft 365“ paskyroms. „Outlook Live“ arba „Microsoft 365“ skirti nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.office365.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Paskyros slaptažodis arba programos slaptažodis Paskyroms, kurioms išjungtas verifikavimas dviem veiksmais, naudokite savo paskyros slaptažodį. outlook.com arba hotmail.com paskyroms, kurioms įjungtas verifikavimas dviem veiksmais, naudokite programos slaptažodį. Norėdami sukurti programos slaptažodį, eikite į puslapį  „Outlook Live“ paskyrų tvarkymas  ir prisijunkite prie savo paskyros. Norėdami sužinoti apie papildomus sąrankos variantus „Microsoft 365“ naudojančiam verslui, eikite į  „Microsoft 365“ žinyno puslapį . „QQ Mail“ Įsitikinkite, kad jūsų paskyroje įgalinta SMTP paslauga. Norėdami įjungti paslaugą, „QQ Mail“ tinklalapyje spustelėkite  Nustatymai Paskyra . Sekcijoje  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV paslauga  įgalinkite arba  POP3/SMTP paslaugą , arba  IMAP/SMTP paslaugą . „QQ Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.qq.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Prieigos teisės kodas Norėdami sugeneruoti prieigos teisės kodą, „QQ Mail“ pradžios tinklalapyje spustelėkite  Nustatymai Paskyra , o tada skyriuje  POP3 / IMAP / SMTP / Exchange / CardDAV / CalDAV paslauga  spustelėkite  Generuoti prieigos kodą . „Sina Mail“ Įsitikinkite, kad jūsų paskyroje įgalinta POP3/SMTP paslauga. Norėdami įjungti paslaugą, „Sina Mail“ tinklalapyje spustelėkite  Nustatymai Daugiau nustatymų Naudotojo POP / IMAP / SMTP , o tada įjunkite  POP3 / SMTP pasalugą . „Sina Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.sina.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Prieigos teisės kodas Norėdami sukurti prieigos kodą, el. pašto tinklalapyje spustelėkite  Nustatymai Daugiau nustatymų Naudotojo POP / IMAP / SMTP , o tada įjunkite  Patvirtinimo kodo būsena . „Sohu Mail“ Įsitikinkite, kad jūsų paskyroje įgalinta SMTP paslauga. Norėdami įjungti paslaugą, „Sohu Mail“ tinklalapyje spustelėkite  Parinktys Nustatymai POP3 / SMTP / IMAP , o tada įjunkite  IMAP / SMTP  arba  POP3 / SMTP  paslaugą. „Sohu Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.sohu.com Pirminio SMTP tinklų sietuvo prievadas 465 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Nepriklausomas slaptažodis Nepriklausomas slaptažodis suteikiamas, kai yra įgalinta  IMAP/SMTP paslauga  arba  POP3/SMTP paslauga . „Yahoo! Mail“ „Yahoo! Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.mail.yahoo.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Programos slaptažodis  Norėdami sukurti programos slaptažodį, eikite į puslapį  „Yahoo“ paskyrų saugumas , prisijunkite prie savo paskyros ir spustelėkite  Generuoti programos slaptažodį . „Zoho Mail“ „Zoho Mail“ nustatymai Nustatymas Vertė Pirminis SMTP tinklų sietuvas smtp.zoho.com Pirminio SMTP tinklų sietuvo prievadas 587 Naudoti SSL/TLS Privalomas Būtinas patikimas liudijimas Išjungta Atgalinis adresas Jūsų el. pašto adresas SMTP serverio tapatumo nustatymas Prisijungimas / atviras tekstas Įrenginio inicijuojamas elektroninis laiškas Naudoti įrenginio SMTP prisijungimo duomenis Įrenginio naudotojo vardas Jūsų el. pašto adresas Įrenginio slaptažodis Paskyros slaptažodis arba programos slaptažodis Paskyroms, kurioms išjungtas verifikavimas dviem veiksmais, naudokite savo paskyros slaptažodį. Paskyroms, kurioms įjungtas verifikavimas dviem veiksmais, naudokite programos slaptažodį. Jei norite sukurti programos slaptažodį, eikite į puslapį  „Zoho Mail“ paskyrų saugumas , prisijunkite prie savo paskyros ir sekcijoje  Konkrečių programų slaptažodžiai  spustelėkite  Generuoti naują slaptažodį . el. pašto paslaugų teikėjai el. pašto serverio nustatymų konfigūravimas SMTP nustatymai konfigūravimas el. pašto funkcija nustatymas el. pašto serveris konfigūravimas"},{"UUID":"4c4c934d-1f93-4049-a78d-f6350bad9450","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Specialiųjų laikmenų formato ir rūšies","descFull":"Specialiųjų laikmenų formato ir rūšies nustatymas Dėklai automatiškai nustato paprasto popieriaus formatą. Jei naudojate specialiąsias laikmenas, pavyzdžiui, etiketes, kartoninį popierių ar vokus, atlikite toliau nurodytus veiksmus. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis  pasirinkite popieriaus šaltinį. Nustatykite specialiųjų laikmenų formatą ir rūšį. popieriaus formato nustatymas popieriaus rūšies nustatymas popieriaus formatas nustatymas popieriaus rūšis nustatymas"},{"UUID":"15aaf784-9464-400a-a91a-eab2e261bde3","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Universalaus popieriaus formato nustatymų konfigūravimas","descFull":"Universalaus popieriaus formato nustatymų konfigūravimas Pradžios ekrane palieskite  Nustatymai Popierius Laikmenų konfigūracija Universalaus popieriaus formato sąranka . Sukonfigūruokite nustatymus. popierius universalaus formato nustatymas universalaus popieriaus formato nustatymas universalus popieriaus formatas nustatymas"},{"UUID":"95a53a89-55f8-4563-9404-29c184655c60","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Nustatymo  Įvairūs universalūs formatai","descFull":"Nustatymo  Įvairūs universalūs formatai  įjungimas Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Dėklų konfigūracija . Įjunkite nustatymą  Įvairūs universalūs formatai . Įvairūs universalūs formatai įgalinimas popieriaus formato nustatymas Įvairūs universalūs formatai"},{"UUID":"01f1f00e-b719-4bfa-8669-3f3848dd9bbe","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Popieriaus įdėjimas į 520 lapų","descFull":"Popieriaus įdėjimas į 520 lapų dėklą Siekdami sumažinti įrangos nestabilumo pavojų, į kiekvieną dėklą popierių dėkite atskirai. Visus kitus dėklus laikykite uždarytus, iki prireiks. Ištraukite dėklą. Norėdami išvengti popieriaus strigčių, neištraukite dėklų, kol spausdintuvas veikia. Nustatykite kreiptuvus, kad jie atitiktų įdedamo popieriaus formatą. Naudokite dėklo apačioje esančius indikatorius, kurie padės nustatyti kreiptuvų vietą. Prieš dėdami popierių, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Įdėkite popieriaus krūvą spausdinamąja puse į viršų. Dėdami firminius blankus ar iš anksto perforuotą popierių, atlikite vieną iš šių veiksmų: Vienpusiam spausdinimui, popieriui ilgais kraštais Firminius blankus dėkite gerąja puse į viršų, viršutine antrašte dėdami į dėklo galą. Įdėkite iš anksto perforuotą popierių gerąja puse į viršų, kad skylutės būtų kairėje dėklo pusėje. Vienpusiam spausdinimui, popieriui trumpais kraštais Firminius blankus dėkite gerąja puse į viršų, viršutine antrašte dėdami į dėklo kairę pusę. Įdėkite iš anksto perforuotą popierių gerąja puse į viršų, kad skylutės būtų nukreiptos į dėklo priekį. Dvipusiam spausdinimui, popieriui ilgais kraštais Firminius blankus dėkite gerąja puse į apačią, viršutine antrašte dėdami į dėklo galą. Įdėkite iš anksto perforuotą popierių gerąja puse į apačią, kad skylutės būtų dešinėje dėklo pusėje. Dvipusiam spausdinimui, popieriui trumpais kraštais Firminius blankus dėkite gerąja puse į apačią, viršutine antrašte dėdami į dėklo kairę pusę. Įdėkite iš anksto perforuotą popierių gerąja puse į apačią, kad skylutės būtų nukreiptos į dėklo galą. Nestumkite popieriaus į dėklą. Įsitikinkite, kad šoniniai kreiptuvai tvirtai priglunda prie popieriaus. Įsitikinkite, kad popieriaus pluoštas yra žemiau maksimalaus popieriaus užpildymo indikatoriaus. Perpildžius, popierius gali užstrigti. Įdėkite dėklą. Jei reikia, nustatykite popieriaus formatą ir rūšį, kurie atitiktų į dėklą įdėto popieriaus formatą ir rūšį. Įdėjus apipavidalinimo įtaisą, spausdinami vaizdai pasukami 180° kampu. 520 lapų dėklas įdėjimas 520 lapų dėklo įdėjimas dėklų įdėjimas"},{"UUID":"cc61ce36-a36d-42ce-b729-f972def9f950","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Popieriaus įdėjimas į 2520 lapų","descFull":"Popieriaus įdėjimas į 2520 lapų sudvejintą dėklą Siekdami sumažinti įrangos nestabilumo pavojų, į kiekvieną dėklą popierių dėkite atskirai. Visus kitus dėklus laikykite uždarytus, iki prireiks. Ištraukite dėklą. Norėdami išvengti popieriaus strigčių, neištraukite dėklų, kol spausdintuvas veikia. Nustatykite kreiptuvus, kad jie atitiktų įdedamo popieriaus formatą. Prieš dėdami popierių, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Įdėkite popierių. Vienpusiam spausdinimui įdėkite popierių spausdinama puse į viršų. Dvipusiam spausdinimui dėkite popierių spausdinama puse į apačią. Dėdami firminius blankus ar iš anksto perforuotą popierių, atlikite vieną iš šių veiksmų: Vienpusiam spausdinimui Firminius blankus dėkite gerąja puse į viršų, viršutine antrašte dėdami į dėklo galą. Įdėkite iš anksto perforuotą popierių gerąja puse į viršų, kad skylutės būtų kairėje dėklo pusėje. Abipusiam spausdinimui Firminius blankus dėkite gerąja puse į apačią, viršutine antrašte dėdami į dėklo galą. Įdėkite perforuotą popierių gerąja puse į apačią, kad skylutės būtų dešinėje dėklo pusėje. Nestumkite popieriaus į dėklą. Įsitikinkite, kad popieriaus pluoštas yra žemiau maksimalaus popieriaus užpildymo indikatoriaus. Perpildžius, popierius gali užstrigti. Įdėkite dėklą. Jei reikia, nustatykite popieriaus formatą ir rūšį, kurie atitiktų į dėklą įdėto popieriaus formatą ir rūšį. Įdėjus apipavidalinimo įtaisą, spausdinami vaizdai pasukami 180° kampu. 2520 lapų sudvejintas dėklas įdėjimas 2520 lapų sudvejinto dėklo įdėjimas dėklų įdėjimas"},{"UUID":"0e5716f4-f6ac-4885-ad57-f6e959f82720","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Popieriaus įdėjimas į 2000 lapų","descFull":"Popieriaus įdėjimas į 2000 lapų dėklą Siekdami sumažinti įrangos nestabilumo pavojų, į kiekvieną dėklą popierių dėkite atskirai. Visus kitus dėklus laikykite uždarytus, iki prireiks. Ištraukite dėklą ir atidarykite šonines dėklo dureles. Norėdami išvengti popieriaus strigčių, neištraukite dėklų, kol spausdintuvas veikia. Sureguliuokite dėklo gale esantį kreiptuvą. Tą patį atlikite ir dėklo priekyje. Sureguliuokite dėklo šoninių durelių svirtį. Prieš dėdami popierių, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Įdėkite popieriaus krūvą spausdinamąja puse į viršų. Dėdami firminius blankus ar iš anksto perforuotą popierių, atlikite vieną iš šių veiksmų: Vienpusiam spausdinimui Firminius blankus dėkite gerąja puse į apačią, viršutine antrašte dėdami į dėklo galą. Įdėkite iš anksto perforuotą popierių gerąja puse į apačią, kad skylutės būtų kairėje dėklo pusėje. Abipusiam spausdinimui Firminius blankus dėkite gerąja puse į viršų, viršutine antrašte dėdami į dėklo galą. Įdėkite iš anksto perforuotą popierių gerąja puse į viršų, kad skylutės būtų kairėje dėklo pusėje. Įsitikinkite, kad popieriaus pluoštas yra žemiau maksimalaus popieriaus užpildymo indikatoriaus. Perpildžius, popierius gali užstrigti. Uždarykite dėklo šonines dureles ir įdėkite dėklą. Jei reikia, nustatykite popieriaus formatą ir rūšį, kurie atitiktų į dėklą įdėto popieriaus formatą ir rūšį. Įdėjus apipavidalinimo įtaisą, spausdinami vaizdai pasukami 180° kampu. 2520 lapų sudvejintas dėklas įdėjimas 2520 lapų sudvejinto dėklo įdėjimas"},{"UUID":"f4d66e36-a666-43e4-b2e5-c1233c29991d","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Vokų dėklo įdėjimas Siekdami sumažinti","descFull":"Vokų dėklo įdėjimas Siekdami sumažinti įrangos nestabilumo pavojų, į kiekvieną dėklą popierių dėkite atskirai. Visus kitus dėklus laikykite uždarytus, iki prireiks. Ištraukite vokų dėklą. Norėdami išvengti popieriaus strigčių, neištraukite dėklų, kol spausdintuvas veikia. Prieš dėdami voką, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Nustatykite kreiptuvus, kad jie atitiktų įdedamo voko formatą. Naudokite dėklo apačioje esančius indikatorius, kurie padės nustatyti kreiptuvų vietą. Vokus dėkite atlanko puse žemyn ir prie kairiojo dėklo šono. Įsitikinkite, kad šoniniai kreiptuvai tvirtai priglunda prie vokų. Įsitikinkite, kad pluoštas yra žemiau maksimalaus užpildymo indikatoriaus. Perpildžius gali įvykti strigtys. Įdėkite dėklą. Jei reikia, nustatykite popieriaus formatą ir rūšį, kurie atitiktų į dėklą įdėto voko formatą ir rūšį. vokų dėklas įdėjimas vokų dėklo įdėjimas"},{"UUID":"8ce6e9a4-2ffb-49fc-b696-7ff12b842325","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Popieriaus įdėjimas į daugiafunkcį tiektuvą","descFull":"Popieriaus įdėjimas į daugiafunkcį tiektuvą Atidarykite daugiafunkcį tiektuvą. Nustatykite šonų kreiptuvus, kad jie atitiktų įdedamo popieriaus formatą. Prieš dėdami popierių, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Įdėkite popierių. Įsitikinkite, kad šoniniai kreiptuvai tvirtai priglunda prie popieriaus. Dedant ilguoju kraštu: jei tai vienpusis spausdinimas, firminius blankus dėkite gerąja puse į apačią, viršutine antrašte dėdami į spausdintuvo galą. Įdėkite perforuotą popierių gerąja puse į apačią, kad skylutės būtų dešinėje popieriaus pusėje. Jei tai dvipusis spausdinimas, firminius blankus dėkite gerąja puse į viršų, viršutine antrašte dėdami į spausdintuvo galą. Įdėkite perforuotą popierių gerąja puse į viršų, kad skylutės būtų kairėje popieriaus pusėje. Dedant trumpuoju kraštu: jei tai vienpusis spausdinimas, firminius blankus dėkite gerąja puse į apačią, viršutine antrašte į kairę popieriaus pusę. Įdėkite perforuotą popierių gerąja puse į apačią, kad skylutės būtų į spausdintuvo priekį. Jei tai dvipusis spausdinimas, firminius blankus dėkite gerąja puse į viršų, viršutine antrašte į kairę popieriaus pusę. Įdėkite perforuotą popierių gerąja puse į viršų, kad skylutės būtų galinėje spausdintuvo pusėje. Įdėjus apipavidalinimo įtaisą, spausdintuvas pasuka vaizdus 180° kampu. daugiafunkcis tiektuvas įdėjimas daugiafunkcio tiektuvo įdėjimas firminių blankų įdėjimas perforuoto popieriaus įdėjimas"},{"UUID":"a7ebb9d0-ee64-4684-9dd0-8c26aec5a600","title":"Popieriaus ir specialiųjų laikmenų įdėjimas","link":"loading-trays-group.html","desc":"Dėklų susiejimas Pradžios ekrane palieskite","descFull":"Dėklų susiejimas Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija pasirinkite popieriaus šaltinį. Dėklams, kuriuos norite susieti, nustatykite tą patį popieriaus formatą ir rūšį. Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Dėklų konfigūracija Dėklų susiejimas . Palieskite  Automatinis . Norėdami atsieti dėklus įsitikinkite, kad jokiems dėklams nėra nustatyti vienodi popieriaus formato ar rūšies nustatymai. Kaitintuvo temperatūra kinta priklausomai nuo nurodytos popieriaus rūšies. Norėdami išvengti spausdinimo problemų, suderinkite popieriaus rūšies nustatymą spausdintuve pagal į dėklą dedamą popierių. dėklų atsiejimas dėklų susiejimas dėklai susiejimas dėklai atsiejimas"},{"UUID":"217377b7-75dd-44d8-8c18-f38e00f8c867","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Spausdintuvo programinės įrangos diegimas Spausdinimo","descFull":"Spausdintuvo programinės įrangos diegimas Spausdinimo tvarkyklė yra programinės įrangos diegimo programos pakete. Jei naudojate „Macintosh“ kompiuterius su „macOS“ 10.7 ar naujesne versija, jums nereikia įdiegti tvarkyklės norint spausdinti „AirPrint“ sertifikuotu spausdintuvu. Jei pageidaujate tinkintų spausdinimo funkcijų, atsisiųskite spausdinimo tvarkyklę. Gaukite programinės įrangos diegimo programos paketą. Programinės įrangos kompaktiniame diske, kurį gavote kartu su spausdintuvu. Eikite adresu  www.lexmark.com/downloads . Eikite adresu  www.dell.com/support/printers . Mūsų interneto svetainėje arba vietoje, kurioje pirkote spausdintuvą. Paleidę diegimo programą vykdykite kompiuterio ekrane pateikiamus nurodymus. spausdintuvo programinės įrangos diegimas spausdintuvo programinė įranga įrengimas, įdiegimas spausdinimo tvarkyklės diegimas spausdinimo tvarkyklė įrengimas, įdiegimas"},{"UUID":"17dd0e98-60ff-4af6-888b-6cfdaa706cde","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Fakso tvarkyklės diegimas Eikite į","descFull":"Fakso tvarkyklės diegimas Eikite į  www.lexmark.com/downloads , suraskite savo spausdintuvo modelį ir atsisiųskite atitinkamos diegimo programos paketą. Eikite į mūsų svetainę arba vietą, kurioje įsigijote spausdintuvą ir įsigykite diegimo programos paketą. Eikite į  www.dell.com/support  ir atsisiųskite atitinkamos diegimo programos paketą. Kompiuteryje spustelėkite  Spausdintuvo savybės  ir atverkite kortelę  Konfigūracija . Paleidę diegimo programą vykdykite kompiuterio ekrane pateikiamus nurodymus. Pasirinkite  Faksas  ir spustelėkite  Vykdyti . fakso tvarkyklė diegimas fakso tvarkyklės diegimas"},{"UUID":"0ca86f3e-8410-4fe1-99eb-85f13dc39381","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Spausdintuvų pridėjimas prie kompiuterio Prieš","descFull":"Spausdintuvų pridėjimas prie kompiuterio Prieš pradėdami atlikite vieną iš šių veiksmų: Prijunkite spausdintuvą ir kompiuterį prie to paties tinklo. Norėdami gauti daugiau informacijos apie spausdintuvo prijungimą prie tinklo, žr.  . Prijunkite kompiuterį prie spausdintuvo. Norėdami gauti daugiau informacijos, žr.  . Spausdintuvą prie kompiuterio prijunkite USB laidu. Norėdami gauti daugiau informacijos, žr.  . USB laidas parduodamas atskirai. „Windows“ naudotojams Kompiuteryje įdiekite spausdinimo tvarkyklę. Norėdami gauti daugiau informacijos, žr.  . Atidarykite  Spausdintuvai ir skeneriai , po to spustelėkite  Pridėti spausdintuvą arba skenerį . Priklausomai nuo prijungto spausdintuvo atlikite vieną iš šių veiksmų: Pasirinkite spausdintuvą iš sąrašo ir spustelėkite  Pridėti įrenginį . Spustelėkite  Rodyti „Wi‑Fi Direct“ spausdintuvus , pasirinkite spausdintuvą ir spustelėkite  Pridėti įrenginį . Spustelėkite  Spausdintuvo, kurio pageidauju, nėra sąraše  ir lange  Pridėti spausdintuvą  atlikite šiuos veiksmus: Pasirinkite  Pridėti spausdintuvą naudojant TCP/IP adresą arba kompiuterio vardą  ir spustelėkite  Toliau . Lauke „ Kompiuterio vardas arba IP adresas “ įveskite spausdintuvo IP adresą ir spustelėkite  Toliau . Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Pasirinkite spausdinimo tvarkyklę ir spustelėkite  Toliau . Pasirinkite  Naudoti spausdinimo tvarkyklę, kuri šiuo metu yra įdiegta (rekomenduojama)  ir spustelėkite  Toliau . Įvedę spausdintuvo vardą, spustelėkite  Toliau . Pasirinkite spausdintuvo bendrinimo parinktį ir spustelėkite  Toliau . Spustelėkite  Baigti . „Macintosh“ naudotojams Kompiuteryje atidarykite  Spausdintuvai ir skeneriai . Spustelėkite   ir pasirinkite spausdintuvą. Meniu  Naudoti  pasirinkite spausdinimo tvarkyklę. Norėdami naudoti „Macintosh“ spausdinimo tvarkyklę, pasirinkite arba  „AirPrint“ , arba  Saugus „AirPrint“ . Jei pageidaujate tinkintų spausdinimo funkcijų, pasirinkite „Lexmark“ spausdinimo tvarkyklę. Norėdami įdiegti tvarkyklę žr.  . Jei pageidaujate tinkintų spausdinimo funkcijų, pasirinkite gamintojo spausdinimo tvarkyklę. Norėdami įdiegti tvarkyklę žr.  . Pridėkite spausdintuvą. spausdintuvų pridėjimas prie kompiuterio"},{"UUID":"f991d9a2-f743-44c3-8961-5fd04accfd71","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Programinės aparatinės įrangos naujinimas Norėdami","descFull":"Programinės aparatinės įrangos naujinimas Norėdami pagerinti spausdintuvo našumą ir išspręsti problemas, reguliariai atnaujinkite spausdintuvo programinę aparatinę įrangą. Norėdami gauti daugiau informacijos apie programinės aparatinės įrangos atnaujinimą, kreipkitės į savo „Lexmark“ atstovą. Norėdami gauti daugiau informacijos apie programinės aparatinės įrangos atnaujinimą, kreipkitės į savo „Dell“ atstovą. Norėdami gauti daugiau informacijos apie programinės aparatinės įrangos atnaujinimą, kreipkitės į savo pardavimo atstovą. Jei norite gauti naujausią programinę aparatinę įrangą, eikite adresu  www.lexmark.com/downloads  ir raskite savo spausdintuvo modelį. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Įrenginys Atnaujinti programinę aparatinę įrangą . Atlikite vieną iš šių veiksmų: Spustelėkite  Patikrinti, ar yra naujinių Sutinku, pradėti atnaujinimą . Įkelkite atmintuko failą. Parinkite atmintuko failą. Įsitikinkite, kad programinės aparatinės įrangos ZIP failą ištraukėte. Spustelėkite  Įkelti Pradėti . programinės aparatinės įrangos naujinimas programinė aparatinė įranga, atnaujinimas"},{"UUID":"3f951d8a-f1c1-44e6-9e7a-fe02f0f149df","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Konfigūracijos failo eksportavimas arba importavimas","descFull":"Konfigūracijos failo eksportavimas arba importavimas Spausdintuvo konfigūracijos nustatymus galite eksportuoti į tekstinį failą, o tada importuoti failą, kad nustatymus galėtumėte pritaikyti kitiems spausdintuvams. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Įtaisytajame interneto serveryje (EWS) spustelėkite  Eksportuoti konfigūraciją  arba  Importuoti konfigūraciją . Vadovaukitės ekrane pateikiamais nurodymais. Jei spausdintuve palaikomos programos, atlikite toliau nurodytus veiksmus: Spustelėję  Programos pasirinkite programą Konfigūruoti . Spustelėkite  Eksportuoti  arba  Importuoti . konfigūracijos failo eksportavimas įtaisytojo interneto serverio (EWS) naudojimas konfigūracijos failo importavimas įtaisytojo interneto serverio (EWS) naudojimas"},{"UUID":"152dd7c2-751d-4942-b76b-fb78a7d8422b","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas","link":"installing-printer-software-topic.html","desc":"Galimos papildomos įrangos pridėjimas spausdinimo","descFull":"Galimos papildomos įrangos pridėjimas spausdinimo tvarkyklėje „Windows“ naudotojams Atidarykite spausdintuvų aplanką. Pasirinkę spausdintuvą, kurį norite atnaujinti, atlikite vieną iš šių veiksmų: Jei naudojatės „Windows 7“ ar naujesnėmis versijomis, pasirinkite  Spausdintuvo savybės . Jei naudojatės senesnėmis versijomis, pasirinkite  Savybės . Paspaudę ąselę „Konfigūracija“ pasirinkite  Atnaujinti dabar – Paklausti spausdintuvo . Vykdykite pakeitimus. „Macintosh“ naudotojams Meniu „Apple“ esančiose Sistemos parinktyse eikite į savo spausdintuvą ir pasirinkite  Papildoma įranga ir eksploatacinės medžiagos . Įėję į papildomos aparatinės įrangos sąrašą pridėkite įrengtą papildomą įrangą. Vykdykite pakeitimus. papildomos aparatinės įrangos pridėjimas spausdinimo tvarkyklė spausdinimo tvarkyklė papildoma aparatinė įranga, pridėjimas papildomos vidinės įrangos pridėjimas spausdinimo tvarkyklė papildoma aparatinė įranga, pridėjimas spausdinimo tvarkyklė papildoma vidinė įranga, pridėjimas spausdinimo tvarkyklė"},{"UUID":"c8e5d657-3672-4115-a336-8a7e501108b7","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Vokų dėklo įdėjimas Išimkite standartinį","descFull":"Vokų dėklo įdėjimas Išimkite standartinį dėklą. Neišmeskite standartinio dėklo. Išpakuokite vokų dėklą ir nuimkite visas pakuotės medžiagas. Įdėkite vokų dėklą. Norėdami, kad vokų dėklą būtų galima naudoti spausdinimo užduotims, pagrindiniame ekrane palieskite  Nustatymai Įrenginys Priežiūra Konfigūracijos meniu Dėklo konfigūracija Vokų dėklo sąranka Įjungta . vokų dėklo įdėjimas vokų dėklas įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai vokų dėklas"},{"UUID":"2a35d2ef-ec6f-46bc-9279-fd3db96de552","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Papildomo 520 lapų dėklo įrengimas","descFull":"Papildomo 520 lapų dėklo įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite papildomą dėklą ir nuimkite visas pakuotės medžiagas. Sulygiuokite spausdintuvą su papildomu dėklu ir nuleiskite į vietą. Jei spausdintuvo svoris yra didesnis nei 20 kg (44 sv.), norint jį saugiai pakelti gali prireikti dviejų ar daugiau žmonių. Išimkite standartinį dėklą. Papildomą dėklą prie spausdintuvo pritvirtinkite varžtais. Įdėkite standartinį dėklą. Nuimkite jungties dangtelį nuo galinės spausdintuvo dalies. Prijunkite dėklo jungtį prie spausdintuvo ir uždėkite dangtelį. Papildomo dėklo galinę dalį pritvirtinkite prie spausdintuvo. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite dėklą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . 520 lapų dėklo įrengimas 520 lapų dėklas įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai 520 lapų dėklas"},{"UUID":"1d802c38-9417-4021-b418-c0e0e19dcf88","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Papildomo 520 lapų dėklo su","descFull":"Papildomo 520 lapų dėklo su dėže įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite papildomą dėklą ir nuimkite visas pakuotės medžiagas. Užfiksuokite ratuką, kad dėžė nejudėtų. Sulygiuokite spausdintuvą su papildomu dėklu ir nuleiskite į vietą. Jei spausdintuvo svoris yra didesnis nei 20 kg (44 sv.), norint jį saugiai pakelti gali prireikti dviejų ar daugiau žmonių. Išimkite standartinį dėklą. Papildomą dėklą prie spausdintuvo pritvirtinkite varžtais. Įdėkite standartinį dėklą. Nuimkite jungties dangtelį nuo galinės spausdintuvo dalies. Prijunkite dėklo jungtį prie spausdintuvo ir uždėkite dangtelį. Papildomo dėklo galinę dalį pritvirtinkite prie spausdintuvo. Sureguliuokite lyginimo varžtus, kad visi spausdintuvų šonai būtų tokiame pačiame aukštyje. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite dėklą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . 520 lapų dėklo su dėže įrengimas 520 lapų dėklas su dėže įrengimas, įdiegimas papildomas aparatinės įrangos įtaisas 520 lapų dėklas su dėže"},{"UUID":"4ba48533-25eb-4697-92fb-825d7c932a4b","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Papildomo 3 x 520 lapų","descFull":"Papildomo 3 x 520 lapų dėklo įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite papildomą dėklą ir nuimkite visas pakuotės medžiagas. Užfiksuokite ratuką, kad dėklas nejudėtų. Sulygiuokite spausdintuvą su papildomu dėklu ir nuleiskite į vietą. Jei spausdintuvo svoris yra didesnis nei 20 kg (44 sv.), norint jį saugiai pakelti gali prireikti dviejų ar daugiau žmonių. Išimkite standartinį dėklą. Papildomą dėklą prie spausdintuvo pritvirtinkite varžtais. Įdėkite standartinį dėklą. Nuimkite jungties dangtelį nuo galinės spausdintuvo dalies. Prijunkite dėklo jungtį prie spausdintuvo ir uždėkite dangtelį. Papildomo dėklo galinę dalį pritvirtinkite prie spausdintuvo. Sureguliuokite lyginimo varžtus, kad visi spausdintuvo šonai būtų tokiame pačiame aukštyje. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite dėklą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . 3 x 520 lapų dėklo įrengimas 3 x 520 lapų dėklas įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai 3 x 520 lapų dėklas"},{"UUID":"14b37d02-9a39-4b93-9068-71f7491cea79","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Papildomo 2520 lapų sudvejinto dėklo","descFull":"Papildomo 2520 lapų sudvejinto dėklo įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite papildomą dėklą ir nuimkite visas pakuotės medžiagas. Užfiksuokite ratuką, kad dėklas nejudėtų. Sulygiuokite spausdintuvą su papildomu dėklu ir nuleiskite į vietą. Jei spausdintuvo svoris yra didesnis nei 20 kg (44 sv.), norint jį saugiai pakelti gali prireikti dviejų ar daugiau žmonių. Išimkite standartinį dėklą. Papildomą dėklą prie spausdintuvo pritvirtinkite varžtais. Įdėkite standartinį dėklą. Nuimkite jungties dangtelį nuo galinės spausdintuvo dalies. Prijunkite dėklo jungtį prie spausdintuvo ir uždėkite dangtelį. Papildomo dėklo galinę dalį pritvirtinkite prie spausdintuvo. Sureguliuokite lyginimo varžtus, kad visi spausdintuvų šonai būtų tokiame pačiame aukštyje. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite dėklą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . 2520 lapų dėklo įrengimas 2520 lapų dėklas įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai 2520 lapų dėklas"},{"UUID":"91545678-6539-4ebd-9cd3-83ef75b53e95","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Papildomo 2000 lapų dėklo įrengimas","descFull":"Papildomo 2000 lapų dėklo įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite papildomą dėklą ir nuimkite visas pakuotės medžiagas. Išsukite išlyginimo varžtą iš kairiosios spausdintuvo pusės. Neišmeskite varžto. Prie spausdintuvo pritvirtinkite prijungimo laikiklį. Naudokite kartu su papildomu dėklu pateiktą prijungimo laikiklį. Įdėkite papildomą dėklą. Prijunkite dėklo jungtį prie spausdintuvo. Sureguliuokite išlyginimo varžtus, kad dėklas su spausdintuvu būtų tokiame pačiame aukštyje. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite dėklą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . 2000 lapų dėklo įrengimas 2000 lapų dėklas įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai 2000 lapų dėklas"},{"UUID":"501aaa7c-824a-4b7a-a6c1-880c2230dd52","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Fakso plokštės įrengimas Fakso plokštės","descFull":"Fakso plokštės įrengimas Fakso plokštės įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Naudodami plokščiąjį atsuktuvą nuimkite fakso dangtį. Išimkite standžiojo disko dangtį. Nuimkite apsauginį valdiklių plokštės gaubtą. Išpakuokite fakso plokštę. Pritvirtinkite fakso plokštę prie standžiojo disko dangčio. Įkiškite fakso jungiamąjį laidą į valdiklių plokštės skyrių. Uždėkite standžiojo disko dangtį. Prijunkite fakso jungiamąjį laidą prie valdiklių plokštės. Pritvirtinkite valdiklių plokštės apsauginį gaubtą. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia gaminio ir lengvai pasiekiamas. Įjunkite spausdintuvą. fakso plokštė įrengimas, įdiegimas papildomos vidinės įrangos įrengimas fakso plokštė"},{"UUID":"c24729c6-8c87-41e6-b268-523516a6b63e","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Spausdintuvo standžiojo disko įrengimas Spausdintuvo","descFull":"Spausdintuvo standžiojo disko įrengimas Spausdintuvo standžiojo disko įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite standųjį diską ir nuimkite laikiklį. Nelieskite ir nespauskite standžiojo disko vidurio. Išimkite standžiojo disko dangtį. Nuimkite apsauginį valdiklių plokštės gaubtą. Įkiškite standžiojo disko jungiamąjį laidą į valdiklių plokštės. Nustatykite standžiojo disko padėtį virš montavimo angų, tada spauskite, kol jis  užsifiksuos . Uždėkite standžiojo disko dangtį. Prijunkite standžiojo disko jungiamąjį laidą prie valdiklių plokštės. Pritvirtinkite valdiklių plokštės apsauginį gaubtą. Įkiškite maitinimo laidą į elektros lizdą ir įjunkite spausdintuvą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia gaminio ir lengvai pasiekiamas. spausdintuvo standusis diskas įrengimas, įdiegimas papildomos įrangos įrengimas spausdintuvo standusis diskas"},{"UUID":"d47e4a31-f9c5-48f4-a84f-4f7a26ee253d","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Darbo lentynos įdėjimas Išjunkite spausdintuvą.","descFull":"Darbo lentynos įdėjimas Išjunkite spausdintuvą. Naudodami atsuktuvą nuimkite dangtelius. Išpakuokite darbo lentyną. Pritvirtinkite darbo lentyną prie spausdintuvo. Pritvirtinkite lentyną prie spausdintuvo. Įjunkite spausdintuvą. darbo lentynos įdėjimas darbo lentyna įrengimas, įdiegimas"},{"UUID":"63f563b2-d792-4a41-a427-ad6eb52a1d52","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"dvigubo paėmimo krepšelio įrengimas Išpakuokite","descFull":"dvigubo paėmimo krepšelio įrengimas Išpakuokite dvigubo paėmimo krepšelį. Pritvirtinkite dvigubo paėmimo krepšelį prie spausdintuvo. Kad krepšelis būtų prieinamas spausdinimo darbams, pradžios lange paspauskite  Nustatymai Įrenginys Techninė priežiūra Meniu „Konfigūracija“ Apipavidalinimo įtaiso konfigūracija 2 dėklo išėjimo nustatymas Įjungta . dvigubo paėmimo krepšelio įrengimas dvigubo paėmimo krepšelis įrengimas, įdiegimas"},{"UUID":"48a848e3-3442-47a4-86e8-e1ffab059267","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Sąsagėlių segiklio įrengimas Jei norite","descFull":"Sąsagėlių segiklio įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Nuimkite standartinę dėtuvę. Neišmeskite dėtuvės. Atidarykite priekines dureles ir nuimkite mėlyną sukamąją rankenėlę. Neišmeskite rankenėlės. Nuimkite standartinės dėtuvės šoninį dangtį. Neišmeskite dėtuvės šoninio dangčio. Išpakuokite sąsagėlių segiklį ir nuimkite pakuotės medžiagas. Pastatykite sąsagėlių segiklį ant galinės dalies ir nuimkite pakuotės medžiagą. Sureguliuokite laikiklį. Įdėkite apipavidalinimo įtaisą. Uždarykite priekines dureles. Pritvirtinkite apipavidalinimo įtaisą prie spausdintuvo. Naudokite kartu su apipavidalinimo įtaisu pateiktus varžtus. Pritvirtinkite apipavidalinimo įtaiso kabelį prie spausdintuvo. Naudokite kartu su apipavidalinimo įtaisu pateiktus spaustukus. Prijunkite apipavidalinimo įtaiso kabelį prie spausdintuvo. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite apipavidalinimo įtaisą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . sąsagėlių segiklio įrengimas sąsagėlių segiklis įrengimas, įdiegimas papildomi aparatinės įrangos įtaisai sąsagėlių segiklis"},{"UUID":"415fdef9-fb1c-4231-9e26-3a9849e5b1bb","title":"Papildomos aparatinės įrangos įrengimas","link":"installing-envelope-tray-topic.html","desc":"Sąsagėlių, skylmušos įtaiso įrengimas Jei","descFull":"Sąsagėlių, skylmušos įtaiso įrengimas Jei norite išvengti elektros smūgio pavojaus, kai bandote prieiti prie valdiklių plokštės arba įrenginėjate papildomą aparatinę įrangą ar atminties įtaisus jau būdami nustatę spausdintuvą, prieš vykdydami veiksmus išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Jei prie spausdintuvo esate prijungę kokius nors kitus įrenginius, juos taip pat išjunkite ir atjunkite visus į spausdintuvą einančius kabelius. Išjunkite spausdintuvą. Ištraukite maitinimo laidą iš elektros lizdo, po to – iš spausdintuvo. Išpakuokite sąsagėlių segimo, skylmušos įtaisą ir nuimkite visas pakuotės medžiagas. Įdėkite sąsagėlių kasetės apkabą į apipavidalinimo įtaisą. Naudodami plokščiąjį atsuktuvą pritvirtinkite laikiklius prie apipavidalinimo įtaiso. Įkiškite dėtuvę į apipavidalinimo įtaisą. Nuimkite standartinę dėtuvę. Neišmeskite standartinės dėtuvės. Atidarykite priekines dureles ir nuimkite mėlyną sukamąją rankenėlę. Neišmeskite rankenėlės. Nuimkite standartinės dėtuvės šoninį dangtį. Neišmeskite dėtuvės šoninio dangčio. Naudodami plokščiąjį atsuktuvą pritvirtinkite laikiklius dešinėje spausdintuvo pusėje. Įdėkite popieriaus perkėlimo įtaisą ir priveržkite varžtais. Naudokite kartu su apipavidalinimo įtaisu pateiktus varžtus. Uždarykite priekines dureles. Prie spausdintuvo pritvirtinkite apipavidalinimo įtaisą. Sureguliuokite lyginimo varžtus, kad visos apipavidalinimo pusės būtų viename aukštyje su spausdintuvu. Atidarykite apipavidalinimo įtaiso dureles ir įsukite varžtą į kairiąją apipavidalinimo įtaiso dalį. Uždarykite apipavidalinimo įtaiso dureles. Prijunkite popieriaus perdavimo laidą prie apipavidalinimo įtaiso galo. Prijunkite apipavidalinimo įtaiso laidą prie galinės spausdintuvo dalies. Maitinimo laidą prijunkite prie spausdintuvo ir įjunkite į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Įjunkite spausdintuvą. Pridėkite apipavidalinimo įtaisą spausdintuvo tvarkyklėje, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . Norėdami, kad spausdinimo užduotims būtų galima naudoti apipavidalinimo įtaisą, pagrindiniame ekrane palieskite  Nustatymai Įrenginys Priežiūra Konfigūracijos meniu Apipavidalinimo įtaiso konfigūracija Skylmušos konfigūracija , kad pasirinktumėte konfigūraciją. sąsagėlių, skylmušos įtaiso įrengimas įrengimas, įdiegimas Sąsagėlių segimo, skylmušos įtaisas"},{"UUID":"854efaeb-c199-4b3b-b967-905f7cd678ff","title":"Belaidžio spausdinimo serverio įrengimas","link":"installing-envelope-tray-topic.html","desc":"Belaidžio tinklo spausdinimo serverio „MarkNet","descFull":"Belaidžio tinklo spausdinimo serverio „MarkNet N8372“ prijungimas Išjunkite spausdintuvą. Užpilkite izopropilo alkoholio ant drėgno, minkšto, nepūkuoto audinio ir nuvalykite paviršių aplink USB jungtį. Prijunkite belaidžio tinklo modulį. Tvirtai spauskite, kad įsitikintumėte, jog juosta prilimpa prie spausdintuvo paviršiaus. Įsitikinkite, kad spausdintuvo paviršius yra sausas ir ant jo nėra susikondensavusios drėgmės. Modulis geriausiai prisitvirtins prie spausdintuvo po 72 valandų. Patikrinkite, ar tarp modulio ir spausdintuvo nėra tarpo; jei reikia, pritvirtinkite tarpiklio modulį. Pritvirtinkite NFC kortelę. Įjunkite spausdintuvą. belaidis spausdinimo serveris įrengimas, įdiegimas belaidžio spausdinimo serverio įrengimas „MarkNet“ N8372 belaidis spausdinimo serveris"},{"UUID":"6b25903b-fcb3-4500-a376-2def3c0f1ffb","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"Šis gaminys belaidžio tinklo adapterio","descFull":"Šis gaminys belaidžio tinklo adapterio neturi. Jei norite naudoti belaidį tinklą, įsigykite ir įdiekite šį priedą: Toliau pateikti nurodymai taikomi tik jei įdiegtas šis priedas. Daugiau informacijos apie priedo įdiegimą rasite skyriuje „Belaidžio spausdinimo serverio įdiegimas“."},{"UUID":"d981f11a-ff24-4b2a-b197-a5ef458cefd6","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"Spausdintuvo prijungimas prie „Wi-Fi“ tinklo","descFull":"Spausdintuvo prijungimas prie „Wi-Fi“ tinklo Prieš pradėdami įsitikinkite, kad: spausdintuve yra įrengtas belaidžio tinklo modulis. Aktyvus adapteris  yra nustatytas į  Automatiškai . Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Tinklo apžvalga Aktyvus adapteris . Valdymo skydelio naudojimas Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Belaidis tinklas Sąranka spausdintuvo skydelyje Pasirinkti tinklą . Pasirinkite „Wi‑Fi“ tinklą ir įveskite tinklo slaptažodį. „Wi-Fi“ tinklui parengtuose spausdintuvuose pradinės sąrankos metu rodomas raginimas nustatyti „Wi-Fi“ tinklą. „Lexmark Mobile Assistant“ naudojimas Priklausomai nuo mobiliojo prietaiso programą „Lexmark Mobile Assistant“ atsisiųskite arba iš „App Store“ internetinės parduotuvės, arba iš  Google Play . Spausdintuvo pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Belaidis tinklas Sąranka naudojant programą mobiliesiems Spausdintuvo ID . Mobiliajame prietaise paleiskite programą, tada sutikite su naudojimo sąlygų nuostatomis. Jei reikia, suteikite leidimus. Bakstelėkite  Prisijungti prie spausdintuvo Eiti į „Wi‑Fi“ nustatymus . Prijunkite savo mobilųjį prietaisą prie belaidžio spausdintuvo tinklo. Grįžkite į programą ir bakstelėkite  Nustatyti „Wi-Fi“ ryšį Pasirinkite „Wi‑Fi“ tinklą ir įveskite tinklo slaptažodį. Bakstelėkite  Atlikta . belaidis tinklas spausdintuvo prijungimas prie spausdintuvo prijungimas prie belaidžio tinklo prijungimas prie belaidžio tinklo"},{"UUID":"d47b0b7c-c322-4742-be3a-e3f1818a699f","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"Spausdintuvo prijungimas prie belaidžio tinklo","descFull":"Spausdintuvo prijungimas prie belaidžio tinklo naudojant „Wi‑Fi“ apsaugotą sąranką (WPS) Prieš pradėdami įsitikinkite, kad: Prieigos taškas (belaidis maršruto parinktuvas) yra patvirtintas arba suderinamas su „Wi-Fi“ apsaugota sąranka (WPS). Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su prieigos tašku. Spausdintuve yra įrengtas belaidžio tinklo adapteris. Norėdami gauti daugiau informacijos, žr instrukciją, kurią gavote kartu su adapteriu. Aktyvus adapteris  yra nustatytas į  Automatiškai . Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Tinklo apžvalga Aktyvus adapteris . Mygtuko paspaudimo metodo naudojimas Pradžios ekrane palieskite  Nustatymai Tinklas/ prievadai Belaidis tinklas „Wi‑Fi“ apsaugota sąranka Pradėti mygtuko paspaudimo metodą . Vadovaukitės ekrane pateikiamais nurodymais. Asmeninio identifikavimo numerio (PIN) metodo naudojimas Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Belaidis tinklas „Wi‑Fi“ apsaugota sąranka Pradėti PIN kodo metodą . Nukopijuokite aštuonių skaitmenų WPS PIN kodą. Atidarykite interneto naršyklę ir adreso lauke įveskite prieigos taško IP adresą. Norėdami sužinoti IP adresą, žr. dokumentaciją, kurią gavote kartu su prieigos tašku. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Pereikite į WPS nustatymus. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su prieigos tašku. Įveskite aštuonių skaitmenų PIN kodą ir išsaugokite pakeitimus. „Wi‑Fi“ apsaugota sąranka belaidis tinklas belaidis tinklas „Wi‑Fi“ apsaugota sąranka prijungimas prie belaidžio tinklo PIN kodo metodo naudojimas asmeninio identifikavimo numerio metodas prijungimas prie belaidžio tinklo mygtuko paspaudimo metodo naudojimas mygtuko paspaudimo metodas"},{"UUID":"7ba6c5a1-6e69-457b-a259-45932af2f476","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"„Wi‑Fi Direct“ konfigūravimas „Wi‑Fi Direct“","descFull":"„Wi‑Fi Direct“ konfigūravimas „Wi‑Fi Direct“  yra „Wi-Fi“ pagrindu sukurta lygiarangių technologija, suteikianti galimybę belaidžiams įrenginiams tiesiogiai prisijungti prie spausdintuvo, kuriame įgalinta „Wi-Fi Direct“, nenaudojant prieigos taško (belaidžio maršruto parinktuvo). Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai „Wi-Fi Direct“ . Sukonfigūruokite nustatymus. Įgalinti „Wi‑Fi Direct“  – spausdintuvas įgalinamas transliuoti jo paties „Wi‑Fi Direct“ tinklą. „Wi‑Fi Direct“ vardas  – „Wi‑Fi Direct“ tinklui priskiriamas vardas. „Wi‑Fi Direct“ slaptažodis  – priskiriamas slaptažodis dėl belaidžio ryšio saugumo, kai naudojamas lygiarangių ryšys. Rodyti slaptažodį sąrankos puslapyje  – slaptažodis rodomas tinklo sąrankos puslapyje. Automatiškai priimti mygtukinio prijungimo užklausas  – spausdintuvui leidžiama automatiškai priimti prijungimo užklausas. Mygtukinio prijungimo užklausų priėmimas automatiškai nėra apsaugotas. Pagal numatytuosius nustatymus „Wi-Fi Direct“ tinklo slaptažodis spausdintuvo ekrane nerodomas. Jei norite, kad slaptažodis būtų parodytas, įgalinkite žvilgtelėjimo į slaptažodį piktogramą. Pradžios ekrane palieskite  Nustatymai Saugumas Įvairūs Įgalinti slaptažodžio / PIN kodo parodymą . Norėdami sužinoti „Wi-Fi Direct“ tinklo slaptažodį jo nerodydami spausdintuvo ekrane, pradžios ekrane palieskite  Nustatymai Ataskaitos Tinklas Tinklo sąrankos puslapis . „Wi‑Fi Direct“ konfigūravimas „Wi‑Fi Direct“ konfigūravimas"},{"UUID":"41dc6dcb-4ef4-4d22-a0b6-a2270638f82c","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"Mobiliojo prietaiso prijungimas prie spausdintuvo","descFull":"Mobiliojo prietaiso prijungimas prie spausdintuvo Prieš prijungdami savo mobilųjį prietaisą įsitikinkite, kad sukonfigūruotas „Wi‑Fi Direct“. Norėdami gauti daugiau informacijos, žr.  . Prijungimas naudojant Wi‑Fi Direct Šie nurodymai taikomi tik „Android“ mobiliesiems prietaisams. Mobiliajame prietaise eikite į nustatymų meniu. Įjunkite  „Wi‑Fi“  ir bakstelėkite  „Wi‑Fi Direct“ . Pasirinkite spausdintuvo „Wi-Fi Direct“ vardą. Spausdintuvo valdymo skydelyje patvirtinkite prijungimą. Prijungimas naudojant „Wi‑Fi“ Mobiliajame prietaise eikite į nustatymų meniu. Bakstelėkite  „Wi-Fi“  ir pasirinkite spausdintuvo „Wi‑Fi Direct“ vardą. Prieš „Wi-Fi Direct“ vardą pridedama eilutė DIRECT-xy (kai x ir y – du atsitiktiniai simboliai). Įveskite „Wi‑Fi Direct“ slaptažodį. mobiliojo prietaiso prijungimas prie spausdintuvo mobilusis prietaisas prijungimas prie spausdintuvo „Wi‑Fi Direct“ įgalinimas įgalinant „Wi‑Fi Direct“"},{"UUID":"a353c193-cb80-42c9-bf3d-83ea4a0b324a","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"„Wi‑Fi Direct“ Kompiuterio prijungimas prie","descFull":"„Wi‑Fi Direct“ Kompiuterio prijungimas prie spausdintuvo Prieš prijungdami savo kompiuterį įsitikinkite, kad sukonfigūruotas „Wi‑Fi Direct“. Norėdami gauti daugiau informacijos, žr.  . „Windows“ naudotojams Atidarykite  Spausdintuvai ir skeneriai , po to spustelėkite  Pridėti spausdintuvą arba skenerį . Spustelėkite  Rodyti „Wi-Fi Direct“ spausdintuvus , po to pasirinkite spausdintuvo „Wi‑Fi Direct“ vardą. Spausdintuvo ekrane atkreipkite dėmesį į aštuonių skaitmenų spausdintuvo PIN kodą. Kompiuteryje įveskite PIN kodą. Jei spausdinimo tvarkyklė dar neįdiegta, „Windows“ atsisiunčia atitinkamą tvarkyklę. „Macintosh“ naudotojams Spustelėkite belaidžio ryšio piktogramą ir pasirinkite spausdintuvo „Wi-Fi Direct“ vardą. Prieš „Wi-Fi Direct“ vardą pridedama eilutė DIRECT-xy (kai x ir y – du atsitiktiniai simboliai). Įveskite „Wi‑Fi Direct“ slaptažodį. Atsijungę nuo „Wi-Fi Direct“ tinklo, kompiuterį vėl prijunkite prie ankstesnio tinklo. kompiuteris prijungimas prie spausdintuvo kompiuterio prijungimas prie spausdintuvo"},{"UUID":"d7e08a1d-b29a-46ba-999b-5d3274765c96","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"„Wi‑Fi“ tinklo pasyvinimas Pradžios ekrane","descFull":"„Wi‑Fi“ tinklo pasyvinimas Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Tinklo apžvalga Aktyvus adapteris Standartinis tinklas . Vadovaukitės ekrane pateikiamais nurodymais. „Wi‑Fi“ tinklas pasyvinimas „Wi‑Fi“ tinklo pasyvinimas"},{"UUID":"a73e443e-fefb-42bd-800c-4a87bc9a6890","title":"Prijungimas prie tinklo","link":"networking-intro-topic.html","desc":"Spausdintuvo prijungimo tikrinimas Pradžios ekrane","descFull":"Spausdintuvo prijungimo tikrinimas Pradžios ekrane palieskite  Nustatymai Ataskaitos Tinklas Tinklo sąrankos puslapis . Patikrinę pirmąją tinklo sąrankos puslapio dalį patvirtinkite, kad būsena – prijungta. Jei tinklo būsena – neprijungta, gali būti, kad nėra aktyvus vietinio tinklo (LAN) ryšio taškas arba sugadintas tinklo kabelis. Susisiekite su administratoriumi, kad gautumėte pagalbos. spausdinimas tinklo sąrankos puslapis tinklo sąrankos puslapio spausdinimas tinklo sąrankos puslapis spausdinimas"},{"UUID":"9de6c750-0ecf-4bd2-926b-fc619c599391","title":"Nustatymas, įrengimas ir konfigūravimas","link":"setting-up-serial-printing-topic.html","desc":"Spausdinimo per nuoseklųjį prievadą diegimas","descFull":"Spausdinimo per nuoseklųjį prievadą diegimas (tik „Windows“) Prieš pradėdami įsitikinkite, kad spausdintuve yra įrengtas nuoseklusis vidaus sprendimų prievadas. Nustatykite parametrus spausdintuve. Valdymo skydelyje eikite į prievadų nustatymams skirtą meniu. Raskite nuosekliųjų prievadų nustatymų meniu ir, jei reikia, pakoreguokite nustatymus. Vykdykite pakeitimus. Kompiuteryje atidarę spausdintuvų aplanką, pasirinkite savo spausdintuvą. Atidarę spausdintuvo savybes, iš sąrašo pasirinkite COM prievadą. Įtaisų tvarkytuvėje nustatykite COM prievado parametrus. Spausdinant per nuoseklųjį prievadą sulėtėja spausdinimo greitis. Įsitikinkite, kad nuoseklusis laidas yra prijungtas prie spausdintuvo nuosekliojo prievado. spausdinimo per nuoseklųjį prievadą diegimas spausdinimas per nuoseklųjį prievadą nustatymas"},{"UUID":"72114897-1c51-4a55-81e8-04eb734df78b","title":"Spausdintuvo apsaugojimas","link":"locating-security-slot-topic.html","desc":"Saugos lizdo vietos nustatymas Spausdintuve","descFull":"Saugos lizdo vietos nustatymas Spausdintuve yra įrengta saugumo užrakto funkcija. Nurodytoje vietoje pritvirtinkite saugumo užraktą, kuris yra suderinamas su dauguma nešiojamųjų kompiuterių, kad apsaugotumėte spausdintuvą ir standųjį diską. saugos lizdas vietos nustatymas saugos lizdo vietos nustatymas"},{"UUID":"d06d3ec0-4c9a-4d59-ac62-a523c2ad96aa","title":"Spausdintuvo apsaugojimas","link":"erasing-printer-memory-topic.html","desc":"Spausdintuvo atminties išvalymas Norėdami spausdintuve","descFull":"Spausdintuvo atminties išvalymas Norėdami spausdintuve išvalyti neišliekamąją atmintį arba buferinius duomenis, išjunkite spausdintuvą. Norėdami išvalyti išliekamąją atmintį, įrenginio, tinklo ir saugos nustatymus bei įtaisytuosius sprendimus, atlikite šiuos veiksmus: Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija priežiūra Nenaudojamus duomenis išvalyti . Palieskite žymimąjį langelį  Apvalyti visą neišliekamojoje atmintyje esančią informaciją , po to palieskite  IŠVALYTI . Palieskite  Paleisti pradinės sąrankos vediklį  arba  Palikti spausdintuvą neprijungtą , tada palieskite  Toliau . Pradėkite darbą. Šis procesas taip pat sunaikina šifravimo raktą, kuris naudojamas naudotojo duomenims apsaugoti. Sunaikinus šifravimo raktą, duomenys tampa neatkuriami. neišliekamoji atmintis išvalymas išliekamoji atmintis išvalymas spausdintuvo atmintis išvalymas išvalymas spausdintuvo atmintis"},{"UUID":"437e6756-1ca4-4a05-982e-64c099f2b9af","title":"Spausdintuvo apsaugojimas","link":"erasing-printer-storage-drive-topic.html","desc":"Spausdintuvo atminties įrenginio išvalymas Pradžios","descFull":"Spausdintuvo atminties įrenginio išvalymas Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija priežiūra Nenaudojamus duomenis išvalyti . Atsižvelgdami į tai, koks atminties įrenginys yra įrengtas jūsų spausdintuve, atlikite vieną iš šių veiksmų: Jei naudojate standųjį diską, palieskite žymimąjį langelį  Apvalyti visą standžiajame diske esančią informaciją , palieskite  TRINTI  ir pasirinkite duomenų trynimo metodą. Standžiojo disko apvalymas gali trukti nuo kelių minučių iki daugiau nei valandą, o jo metu spausdintuvu negalima atlikti kitų užduočių. Išmoningajame atminties įrenginyje (ISD) palieskite  Išvalyti išmoningąjį atminties įrenginį , tada palieskite  TRINTI , kad ištrintumėte visus naudotojo duomenis. Pradėkite darbą. atminties įrenginys išvalymas spausdintuvo atminties įrenginio išvalymas standusis diskas išvalymas išmoningasis atminties įrenginys išvalymas"},{"UUID":"f3c17be1-f6b8-45dd-929d-e6b24c8eb8d1","title":"Spausdintuvo apsaugojimas","link":"restoring-factory-default-settings-topic.html","desc":"Gamyklinių numatytųjų nustatymų atkūrimas Pradžios","descFull":"Gamyklinių numatytųjų nustatymų atkūrimas Pradžios ekrane palieskite  Nustatymai Įrenginys Atkurti numatytuosius gamyklinius nustatymus . Palieskite  Atkurti nustatymus pasirinkite nustatymus, kuriuos norite atkurti ATKURTI . Pradėkite darbą. gamykliniai numatytieji nustatymai atkūrimas spausdintuvo nustatymai gamyklinio numatytojo nustatymo atkūrimas"},{"UUID":"42bde568-3d3e-4eee-8da5-5946ba9aac47","title":"Spausdintuvo apsaugojimas","link":"statement-of-volatility-topic.html","desc":"Pareiškimas dėl neišliekamosios atminties įtaisų","descFull":"Pareiškimas dėl neišliekamosios atminties įtaisų Atminties tipai ir jų paaiškinimai Atminties tipas Paaiškinimas Neišliekamoji atmintis Spausdintuve naudojama standartinė laisvosios prieigos atmintis (RAM), skirta laikinai apsaugoti naudotojo duomenis paprastų spausdinimo ir kopijavimo užduočių metu. Išliekamoji atmintis Spausdintuve gali būti naudojama dviejų formų išliekamoji atmintis: EEPROM ir NAND (atmintukas). Abiejuose tipuose saugoma operacinė sistema, spausdintuvo nustatymai ir tinklo informacija. Juose taip pat saugomi skenerio ir adresyno nustatymai bei įtaisytieji sprendimai. Standžiojo disko atminties įrenginys Kai kuriuose spausdintuvuose gali būti įrengta standžiojo disko atmintinė. Spausdintuvo standusis diskas yra skirtas spausdintuvui būdingoms funkcijoms palaikyti. Standusis diskas leidžia spausdintuvui išlaikyti saugomus naudotojo duomenis iš kompleksinių spausdinimo užduočių, taip pat formų ir šriftų duomenis. Išmoningasis atminties įrenginys(ISD) Kai kuriuose spausdintuvuose gali būti įrengtas ISD. ISD naudojama išliekamoji atmintuko atmintis, kad jame būtų saugomi naudotojo duomenys iš sudėtingų spausdinimo užduočių bei formų ir šriftų duomenys. Įdiegtos spausdintuvo atminties turinį išvalykite esant šioms aplinkybėms: Nutraukiamas spausdintuvo naudojimas. Pakeičiamas spausdintuvo standusis diskas arba ISD. Spausdintuvas perkeliamas į kitą skyrių ar vietą. Spausdintuvas aptarnaujamas ne jūsų organizacijai priklausančių asmenų. Spausdintuvas išgabenamas remontui iš jūsų patalpų. Spausdintuvas parduodamas kitai organizacijai. Norėdami išmesti atminties įrenginį, vadovaukitės savo organizacijos taisyklėmis ir tvarka. pareiškimas dėl neišliekamosios atminties įtaisų neišliekamoji atmintis išliekamoji atmintis standžiojo disko atminties įrenginys išmoningasis atminties įrenginys spausdintuvo atminties išvalymas spausdintuvo duomenų apsaugojimas"},{"UUID":"5a029d75-9b04-4240-b8be-9e8a9f28bce4","title":"Spausdinimas","link":"printing-from-computer-h2-topic.html","desc":"Spausdinimas iš kompiuterio Jei tai","descFull":"Spausdinimas iš kompiuterio Jei tai etiketės, kartoninis popierius ir vokai, prieš spausdindami dokumentą spausdintuve nustatykite popieriaus formatą ir rūšį. Dokumente, kurį bandote spausdinti, atidarykite dialogo langą „Spausdinti“. Jei reikia, pakoreguokite nustatymus. Atspausdinkite dokumentą. spausdinimas iš kompiuterio dokumentai, spausdinimas iš kompiuterio spausdinimas iš kompiuterio"},{"UUID":"d30b049d-9d8c-4cda-9fd7-12f489f860c2","title":"Spausdinimas iš mobiliojo prietaiso","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Spausdinimas iš mobiliojo prietaiso naudojant","descFull":"Spausdinimas iš mobiliojo prietaiso naudojant „Lexmark Mobile Print“ Spausdinimas iš mobiliojo prietaiso naudojant „Lexmark Mobile Print“ Lexmark  „Mobile Print“ leidžia siųsti dokumentus ir vaizdus tiesiai į palaikomą „Lexmark“ spausdintuvą. Atidarykite dokumentą ir jį išsiųskite arba bendrinkite su „Lexmark Mobile Print“. Kai kuriose trečiųjų šalių programose siuntimo ar bendrinimo funkcija gali būti nepalaikoma. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su programa. Pasirinkite spausdintuvą. Atspausdinkite dokumentą. „Lexmark Mobile Print“ naudojimas dokumentai, spausdinimas iš mobiliojo prietaiso mobilusis prietaisas spausdinimas iš"},{"UUID":"b4900943-9c97-40ca-a53a-342bb0a39f02","title":"Spausdinimas iš mobiliojo prietaiso","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Spausdinimas iš mobiliojo prietaiso naudojant","descFull":"Spausdinimas iš mobiliojo prietaiso naudojant „Lexmark Print“ Lexmark  „Print“ yra mobiliojo spausdinimo programa mobiliesiems prietaisams su  Android  6.0 ir naujesnėmis versijomis. Ji suteikia galimybę siųsti dokumentus ir vaizdus į prie tinklo prijungtus spausdintuvus ir spausdinimo valdymo serverius. Atsisiuntę „Lexmark Print“ programą iš  Google Play  parduotuvės, būtinai ją įgalinkite mobiliajame prietaise. Įsitikinkite, kad spausdintuvas ir mobilusis prietaisas yra prijungti prie to paties tinklo. Mobiliajame prietaise pasirinkite dokumentą failų tvarkytuvėje. Dokumentą siųskite į „Lexmark Print“ arba bendrinkite su ja. Kai kuriose trečiųjų šalių programose siuntimo ar bendrinimo funkcija gali būti nepalaikoma. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su programa. Pasirinkite spausdintuvą ir, jei reikia, pakoreguokite nustatymus. Atspausdinkite dokumentą. „Lexmark Print“ naudojimas dokumentai, spausdinimas iš mobiliojo prietaiso mobilusis prietaisas spausdinimas iš"},{"UUID":"cb331b59-aa5f-4eb9-b3b3-2383c877cc45","title":"Spausdinimas iš mobiliojo prietaiso","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Spausdinimas iš mobiliojo prietaiso naudojant","descFull":"Spausdinimas iš mobiliojo prietaiso naudojant „Mopria Print Service“ „Mopria  Print Service“ yra mobiliojo spausdinimo programa mobiliesiems prietaisams su  Android  5.0 ir naujesnėmis versijomis. Ji leidžia spausdinti tiesiai į bet kurį „Mopria“ patvirtintą spausdintuvą. Atsisiuntę „Mopria Print Service“ programą iš  Google Play  parduotuvės, būtinai ją įgalinkite mobiliajame prietaise. „Android“ mobiliajame prietaise paleiskite suderinamą programą arba pasirinkite dokumentą iš failų tvarkytuvės. Bakstelėkite  Spausdinti . Pasirinkite spausdintuvą ir, jei reikia, pakoreguokite nustatymus. Bakstelėkite  . „Mopria Print Service“ spausdinimas iš mobiliojo prietaiso mobilusis prietaisas spausdinimas iš spausdinimas naudojant „Mopria Print Service“"},{"UUID":"20f0af25-cfec-495d-9122-5f818eaa52a1","title":"Spausdinimas iš mobiliojo prietaiso","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Spausdinimas iš mobiliojo prietaiso naudojant","descFull":"Spausdinimas iš mobiliojo prietaiso naudojant „AirPrint“ Programinės įrangos funkcija „AirPrint“ yra mobiliojo spausdinimo programa, leidžianti iš „Apple“ prietaisų siųsti spausdinimo užduotis tiesiai į „AirPrint“ patvirtintą spausdintuvą. Įsitikinkite, kad „Apple“ prietaisas ir spausdintuvas yra prijungti prie to paties tinklo. Jei tinkle yra keli belaidžiai šakotuvai, įsitikinkite, kad abu įrenginiai yra prijungti prie to paties potinklio. Ši programa yra palaikoma tik tam tikruose „Apple“ prietaisuose. Mobiliajame prietaise pasirinkite dokumentą iš failų tvarkytuvės arba paleiskite suderinamą programą. Bakstelėkite  Spausdinti . Pasirinkite spausdintuvą ir, jei reikia, pakoreguokite nustatymus. Atspausdinkite dokumentą. „AirPrint“ naudojimas spausdinimas iš mobiliojo prietaiso mobilusis prietaisas spausdinimas iš"},{"UUID":"19137d69-a262-462d-81ca-f9c817351f02","title":"Spausdinimas iš mobiliojo prietaiso","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Spausdinimas iš mobiliojo prietaiso naudojant","descFull":"Spausdinimas iš mobiliojo prietaiso naudojant „Wi-Fi Direct®“ „Wi‑Fi Direct“  yra spausdinimo paslauga, kuri leidžia spausdinti bet kuriuo su „Wi‑Fi Direct“ suderintu spausdintuvu. Įsitikinkite, kad mobilusis prietaisas yra prijungtas prie belaidžio spausdintuvo tinklo. Norėdami gauti daugiau informacijos, žr.  . Mobiliajame prietaise paleiskite suderinamą programą arba pasirinkite dokumentą iš failų tvarkytuvės. Priklausomai nuo savo mobiliojo prietaiso atlikite vieną iš šių veiksmų: Bakstelėkite  Spausdinti . Bakstelėkite  Spausdinti . Bakstelėkite  Spausdinti . Pasirinkite spausdintuvą ir, jei reikia, pakoreguokite nustatymus. Atspausdinkite dokumentą. „Wi‑Fi Direct“ spausdinimas iš mobiliojo prietaiso spausdinimas iš mobiliojo prietaiso mobilusis prietaisas spausdinimas iš spausdinimas naudojant „Wi‑Fi Direct“"},{"UUID":"eb49bc7d-c6fb-4c18-983d-f72b3e1f1238","title":"Spausdinimas","link":"printing-from-flash-drive-topic.html","desc":"Spausdinimas iš atmintuko Įdėkite atmintuką.","descFull":"Spausdinimas iš atmintuko Įdėkite atmintuką. Jei atmintukas įdedamas, kai rodomas klaidos pranešimas, spausdintuvas atmintuką ignoruoja. Jei atmintukas įdedamas, kai spausdintuvas atlieka kitas spausdinimo užduotis, ekrane parodomas pranešimas  Užimtas . Ekrane palieskite norimą spausdinti dokumentą. Jei reikia, sukonfigūruokite spausdinimo nustatymus. Atspausdinkite dokumentą. Jei norite spausdinti kitą dokumentą, palieskite  USB atmintukas . Norėdami išvengti duomenų praradimo arba spausdintuvo veikimo sutrikimo, aktyviai spausdindami, nuskaitydami ar įrašydami iš atminties įtaiso, nelieskite atmintuko arba spausdintuvo nurodytose vietose. spausdinimas iš atmintuko atmintukas spausdinimas iš"},{"UUID":"6bbce3db-2082-4d00-affa-bfebff012537","title":"Spausdinimas","link":"supported-flash-drives-and-file-types-topic.html","desc":"Palaikomi atmintukai ir failų tipai","descFull":"Palaikomi atmintukai ir failų tipai Atmintukai „Lexar JumpDrive S70“ (16 GB ir 32 GB) „SanDisk Cruzer Micro“ (16 GB ir 32 GB) „PNY Attaché“ (16 GB ir 32 GB) Spausdintuve palaikomi didelės spartos atmintukai su didelės spartos („full-speed“) standartu. Atmintukuose turi būti palaikoma FAT failų išdėstymo sistema. Failų tipai Palaikomi failų tipai Dokumentai Paveikslai PDF (1.7 arba ankstesnė versija) „Microsoft“ failų formatai (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG arba JPG TIFF arba TIF GIF BMP PNG PCX DCX palaikomi atmintukai atmintukai palaikomi palaikomi failų tipai failų tipai palaikomi"},{"UUID":"3d866bc0-0584-4eef-8f2e-a951d0f5f31c","title":"Spausdinimas","link":"configuring-confidential-jobs-topic.html","desc":"Konfidencialių užduočių konfigūravimas Pradžios ekrane","descFull":"Konfidencialių užduočių konfigūravimas Pradžios ekrane palieskite  Nustatymai Saugumas Konfidencialaus spausdinimo sąranka . Sukonfigūruokite nustatymus. Meniu  Konfidencialaus spausdinimo sąranka   elementai ir jų paaiškinimai Nustatymas Paaiškinimas Maksimalus neteisingo PIN kodo įvedimų skaičius Nustatoma neteisingo PIN kodo įvedimų skaičiaus riba. Pasiekus maksimalų skaičių su to naudotojo vardu susijusios spausdinimo užduotys yra pašalinamos. Konfidencialių užduočių galiojimo laikas Nustatomas atskiras kiekvienos užlaikomos užduoties galiojimo laikas, kol ji automatiškai pašalinama iš spausdintuvo atminties, standžiojo disko arba išmoningojo atminties įrenginio. Užlaikoma užduotis gali būti  Konfidenciali ,  Kartotina ,  Atidėta  arba  Tikrintina . Kartotinų užduočių galiojimo laikas Nustatomas spausdinimo užduočių, kurias norima pakartoti, galiojimo laikas. Tikrintinų užduočių galiojimo laikas Nustatomas užduoties kopijos spausdinimo galiojimo laikas, kad būtų galima patikrinti jos kokybę prieš spausdinant likusias kopijas. Atidėtų užduočių galiojimo laikas Nustatomas galiojimo laikas užduotims, kurias norima išsaugoti spausdintuve, kad būtų galima atspausdinti vėliau. Reikalauti, kad visos užduotys būtų užlaikomos Nustatoma, kad spausdintuvas užlaikytų visas spausdinimo užduotis. Išlaikyti besidubliuojančius dokumentus Nustatoma, kad spausdintuvas visus dokumentus išlaikytų tuo pačiu failo pavadinimu. konfidencialios spausdinimo užduotys konfigūravimas turimos užduotys galiojimo laiko nustatymas spausdinimo užduočių saugojimas kartotinės spausdinimo užduotys tikrintinos spausdinimo užduotys"},{"UUID":"a76d926d-33eb-49b3-9194-59bcd7472426","title":"Spausdinimas","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Konfidencialių ir kitų turimų užduočių","descFull":"Konfidencialių ir kitų turimų užduočių spausdinimas „Windows“ naudotojams Esant atidarytam dokumentui spustelėkite  Failas Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Spausdinti ir laikyti . Pasirinkite  Naudoti funkciją „Spausdinti ir laikyti“  ir priskirkite naudotojo vardą. Pasirinkite spausdinimo užduoties rūšį (konfidenciali, kartotinė, atidėta ar tikrintina). Jei pasirenkate  Konfidenciali , spausdinimo užduotį apsaugokite asmeniniu identifikavimo numeriu (PIN kodu). Spustelėkite  Gerai  arba  Spausdinti . Spausdintuvo pradžios ekrane paleiskite spausdinimo užduotį. Konfidencialių spausdinimo užduočių atveju palieskite  Turimos užduotys  pasirinkite naudotojo vardą Konfidenciali  įveskite PIN kodą  pasirinkite spausdinimo užduotį  sukonfigūruokite nustatymus Spausdinti . Kitoms spausdinimo užduotimis palieskite  Turimos užduotys  pasirinkite naudotojo vardą  pasirinkite spausdinimo užduotį  sukonfigūruokite nustatymus Spausdinti . „Macintosh“ naudotojams „AirPrint“ naudojimas Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą ir išskleidžiamajame meniu, kuris eina po meniu  Orientacija  pasirinkite  Spausdinimas naudojant PIN kodą . Įgalinkite  Spausdinti su PIN kodu  ir įveskite keturių skaitmenų PIN kodą. Spustelėkite  Spausdinti . Spausdintuvo pradžios ekrane paleiskite spausdinimo užduotį. Palieskite  Turimos užduotys  pasirinkite kompiuterio vardą Konfidenciali  įveskite PIN kodą pasirinkite spausdinimo užduotį Spausdinti . Spausdinimo tvarkyklės naudojimas Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą ir išskleidžiamajame meniu, kuris eina po meniu  Orientacija  pasirinkite  Spausdinti ir laikyti . Pasirinkite  Konfidencialus spausdinimas  ir įveskite keturių skaitmenų PIN kodą. Spustelėkite  Spausdinti . Spausdintuvo pradžios ekrane paleiskite spausdinimo užduotį. Palieskite  Turimos užduotys  pasirinkite savo kompiuterio vardą Konfidenciali pasirinkite spausdinimo užduotį  įveskite PIN kodą Spausdinti . spausdinimas turimos užduotys spausdinimas konfidencialios spausdinimo užduotys konfidencialios spausdinimo užduotys spausdinimas turimos užduotys spausdinimas"},{"UUID":"577b0713-073a-43bc-8189-73288d124a67","title":"Spausdinimas","link":"printing-font-sample-list-h2-topic.html","desc":"Šriftų pavyzdžių sąrašo spausdinimas Pradžios","descFull":"Šriftų pavyzdžių sąrašo spausdinimas Pradžios ekrane palieskite  Nustatymai  Ataskaitos Spausdinti Spausdinti šriftus . Palieskite  PCL šriftai  arba  PS šriftai . spausdinimas šriftų pavyzdžių sąrašas šriftų pavyzdžių sąrašo spausdinimas šriftų pavyzdžių sąrašas spausdinimas"},{"UUID":"5e0f1236-d144-4776-b725-d6d44cd41300","title":"Spausdinimas","link":"printing-directory-list-h2-topic.html","desc":"Katalogo sąrašo spausdinimas Pradžios ekrane","descFull":"Katalogo sąrašo spausdinimas Pradžios ekrane palieskite  Nustatymai  Ataskaitos Spausdinti Spausdinti katalogą . spausdinimas katalogo sąrašas katalogo sąrašo spausdinimas katalogo sąrašas spausdinimas"},{"UUID":"34e4c82c-0936-48cc-ad59-b1754b3f8d61","title":"Spausdinimas","link":"placing-separator-sheets-topic.html","desc":"Skiriamųjų lapų dėjimas tarp kopijų","descFull":"Skiriamųjų lapų dėjimas tarp kopijų Pradžios ekrane palieskite  Nustatymai Spausdinti Išdėstymas Skiriamieji lapai Tarp kopijų . Atspausdinkite dokumentą. skiriamieji lapai dėjimas skiriamųjų lapų įdėjimas"},{"UUID":"589878e4-ae4a-4374-9b1b-138253a00df7","title":"Spausdinimas","link":"stapling-printed-sheets-topic.html","desc":"Spausdintų lapų susegimas „Windows“ naudotojams","descFull":"Spausdintų lapų susegimas „Windows“ naudotojams Esant atidarytam dokumentui spustelėkite  Failas Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Popierius / Apipavidalinimas . Jei reikia, sukonfigūruokite popieriaus nustatymus. Apipavidalinimo meniu sąsagėlių nustatymą. Spustelėkite  Gerai  arba  Spausdinti . „Macintosh“ naudotojams Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą ir išskleidžiamajame meniu, kuris eina po  Orientacijos  meniu, pasirinkite  Apipavidalinimas . Spustelėkite  Sąsagėlės  ir pasirinkite nustatymą. Spustelėkite  Spausdinti . spausdintų lapų susegimas spausdinti lapai susegimas"},{"UUID":"1ac61275-7e14-4cc0-be20-3053bb73f779","title":"Spausdinimas","link":"punching-holes-printed-sheets-topic.html","desc":"Skylmuša spausdintuose lapuose Prieš pradėdami","descFull":"Skylmuša spausdintuose lapuose Prieš pradėdami įsitikinkite, kad sukonfigūruoti skylmušos nustatymai. Pradžios ekrane palieskite  Nustatymai Įrenginys Priežiūra Konfigūracijos meniu Apipavidalinimo įtaiso konfigūracija Skylmušos konfigūracija , kad pasirinktumėte konfigūraciją. „Windows“ naudotojams Esant atidarytam dokumentui spustelėkite  Failas Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Popierius / Apipavidalinimas . Jei reikia, sukonfigūruokite popieriaus nustatymus. Apipavidalinimo meniu pasirinkite skylmušos nustatymą. Spustelėkite  Gerai  arba  Spausdinti . „Macintosh“ naudotojams Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą ir išskleidžiamajame meniu, kuris eina po orientacijos meniu, pasirinkite  Apipavidalinimas . Spustelėkite  Skylmuša  ir pasirinkite nustatymą. Spustelėkite  Spausdinti . skylmuša spausdintuose lapuose spausdinti lapai skylmuša"},{"UUID":"998bc7e7-8d4e-4db2-b4d3-e2535a858a59","title":"Spausdinimas","link":"using-offset-stacking-printed-sheets-topic.html","desc":"Komplektavimo grupavimo naudojimas spausdintiems lapams","descFull":"Komplektavimo grupavimo naudojimas spausdintiems lapams „Windows“ naudotojams Esant atidarytam dokumentui spustelėkite  Failas Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Popierius / Apipavidalinimas . Jei reikia, sukonfigūruokite popieriaus nustatymus. Apipavidalinimo meniu pasirinkite nustatymą „Sukomplektuoti“. Spustelėkite  Gerai  arba  Spausdinti . „Macintosh“ naudotojams Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą ir išskleidžiamajame meniu, kuris eina po  Orientacijos  meniu, pasirinkite  Apipavidalinimas . Spustelėkite  Sukomplektuoti  ir pasirinkite nustatymą. Spustelėkite  Spausdinti . komplektavimo grupavimas spausdintuose lapuose spausdinti lapai komplektavimo grupavimas"},{"UUID":"a7801670-efb4-4eee-ad5d-34b0373e4664","title":"Spausdinimas","link":"canceling-print-job-topic.html","desc":"Spausdinimo užduoties atšaukimas Pradžios ekrane","descFull":"Spausdinimo užduoties atšaukimas Pradžios ekrane palieskite  . Pasirinkite užduotį, kurią norite atšaukti. Užduotį galite atšaukti ir palietę parinktį  Užduočių eilė . spausdinimo užduotis atšaukimas spausdinimo užduoties atšaukimas"},{"UUID":"2b8f3863-b940-4360-b6ad-c3c2e539291c","title":"Spausdinimas","link":"adjusting-toner-darkness-topic.html","desc":"Dažų tamsumo koregavimas Pradžios ekrane","descFull":"Dažų tamsumo koregavimas Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė . Meniu „Dažų tamsumas“ pakoreguokite nustatymą. dažų tamsumas koregavimas dažų tamsumo koregavimas"},{"UUID":"80b40059-832f-48d3-ada7-ec4dba863219","title":"Kopijavimas","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Automatinio dokumentų tiektuvo ir skenerio","descFull":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas Popieriaus dėjimas į ADT dėklą ir ant skenerio stiklo Automatinis dokumentų tiektuvas (ADT) Skenerio stiklas ADT naudokite kelių puslapių arba ant abiejų pusių spausdinamiems dokumentams. Dokumento originalą dėkite gerąja puse į viršų. Jei tai – kelių ar daugiau puslapių dokumentai, prieš juos dėdami būtinai sulygiuokite jų priekinį kraštą. Būtinai pareguliuokite popieriaus kreiptuvus, kad jie atitiktų įdedamo popieriaus plotį. Skenerio stiklą naudokite vieno puslapio dokumentams, knygų puslapiams, nedidelėms laikmenoms (pavyzdžiui, atvirukams arba nuotraukoms), permatomoms laikmenoms, foto popieriui arba plonoms laikmenoms (pavyzdžiui, iškarpoms iš žurnalų). Dokumentą dėkite gerąja puse žemyn į kampą su rodykle. kopijavimas naudojant automatinį dokumentų tiektuvą (ADT) kopijavimas naudojant skenerio stiklą"},{"UUID":"223cbf0f-c72f-4a88-b10c-cd2b41768f51","title":"Kopijavimas","link":"making-copies-topic.html","desc":"Kopijų darymas Dokumento originalą įdėkite","descFull":"Kopijų darymas Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Norėdami išvengti apkarpyto vaizdo, įsitikinkite, kad dokumento originalas ir spaudinys yra tokio paties popieriaus formato. Pradžios ekrane palieskite  Kopijuoti  ir nurodykite kopijų skaičių. Jei reikia, pakoreguokite kopijavimo nustatymus. Nukopijuokite dokumentą. Norėdami kopiją padaryti greitai, pradžios ekrane palieskite  . kopijų darymas ADT naudojimas kopijavimas naudojant skenerio stiklą kopijavimas kopijavimas iš pasirinktas dėklas skirtingų popieriaus formatų kopijavimas skirtingi popieriaus formatai, kopijavimas"},{"UUID":"8cf4a95b-6a7f-4175-b8b6-221ed352e838","title":"Kopijavimas","link":"copying-photos-topic.html","desc":"Nuotraukų kopijavimas Padėkite nuotrauką ant","descFull":"Nuotraukų kopijavimas Padėkite nuotrauką ant skaitytuvo stiklo. Pradžios ekrane palieskite  Kopijuoti Turinys Turinio rūšis Nuotrauka . Palieskite  Turinio šaltinis  ir pasirinkite nustatymą, kuris labiausiai atitinka nuotraukos originalą. Nukopijuokite nuotrauką. kopijavimas nuotraukos nuotraukos, kopijavimas"},{"UUID":"98d41b0d-5c32-4363-b3b8-96be98df8cdb","title":"Kopijavimas","link":"copying-transparencies-or-letterhead-topic.html","desc":"Kopijavimas ant firminių blankų Dokumento","descFull":"Kopijavimas ant firminių blankų Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Kopijuoti Kopijuoti iš pasirinkite dokumento originalo formatą. Palieskite  Kopijuoti į , tada pasirinkite popieriaus šaltinį, kuriame yra firminiai blankai. Jei firminius blankus įdėjote į daugiafunkcį tiektuvą, palieskite  Kopijuoti į Daugiafunkcis tiektuvas pasirinkite popieriaus formatą Firminiai blankai . Nukopijuokite dokumentą. kopijavimas ant firminių blankų firminiai blankai kopijavimas ant"},{"UUID":"fd5c1095-2074-4b15-8ce9-fbad85eddef3","title":"Kopijavimas","link":"copying-on-both-sides-of-paper-topic.html","desc":"Kopijavimas ant abiejų popieriaus pusių","descFull":"Kopijavimas ant abiejų popieriaus pusių Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Kopijuoti Pusės . Palieskite  Iš vienpusio į dvipusį  arba  Iš dvipusio į dvipusį . Nukopijuokite dokumentą. kopijavimas ant abiejų popieriaus pusių dvipusis spausdinimas"},{"UUID":"6f8fc981-bf76-42fb-8873-3bc8951928e2","title":"Kopijavimas","link":"reducing-enlarging-copies-topic.html","desc":"Kopijų mažinimas arba didinimas Dokumento","descFull":"Kopijų mažinimas arba didinimas Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Kopijuoti Mastelis pasirinkite mastelio vertę. Pakeitus dokumento originalo arba spaudinio dydį esant nustatytai parinkčiai  Mastelis , mastelio vertė bus atkurta į  Automatiškai . Nukopijuokite dokumentą. kopijos formato mažinimas kopijos formato didinimas"},{"UUID":"1bb93180-7bb7-4b5b-933d-7486fe911e93","title":"Kopijavimas","link":"collating-copies-topic.html","desc":"Kopijų sudėstymas Dokumento originalą įdėkite","descFull":"Kopijų sudėstymas Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skaitytuvo stiklo. Pradžios ekrane palieskite  Kopijavimas Sudėstyti Įjungta [1,2,1,2,1,2] . Nukopijuokite dokumentą. kopijų sudėstymas kelių kopijų rikiavimas"},{"UUID":"8a8c423a-6929-4aa4-ae4c-87b76c8aa1e2","title":"Kopijavimas","link":"placing-separator-sheets-between-copies-topic.html","desc":"Skiriamųjų lapų dėjimas tarp kopijų","descFull":"Skiriamųjų lapų dėjimas tarp kopijų Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skaitytuvo stiklo. Pradžios ekrane palieskite  Kopijuoti Skiriamieji lapai . Pakoreguokite nustatymus. Išsiųskite kopijavimo užduotį. skiriamųjų lapų dėjimas tarp kopijų kopijavimas"},{"UUID":"411cce28-28d8-43cc-ba61-9b5f4adb5727","title":"Kopijavimas","link":"saving-paper-topic.html","desc":"Kelių puslapių kopijavimas viename lape","descFull":"Kelių puslapių kopijavimas viename lape Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skaitytuvo stiklo. Pradžios ekrane palieskite  Kopijuoti Puslapiai vienoje pusėje . Pakoreguokite nustatymus. Nukopijuokite dokumentą. kelių puslapių kopijavimas ant vieno lapo popieriaus taupymas dažų taupymas"},{"UUID":"0f1e80ee-8092-4ce0-a3df-80f66191909e","title":"Kopijavimas","link":"copying-cards-topic.html","desc":"Kortelių kopijavimas Padėkite kortelę ant","descFull":"Kortelių kopijavimas Padėkite kortelę ant skaitytuvo stiklo. Pradžios ekrane palieskite  Kopijuoti Kopijuoti iš . Palieskite  Asmens tapatybės kortelė . Nukopijuokite kortelę. kopijavimas kortelės kortelės kopijavimas"},{"UUID":"fa1273af-0d23-438e-a5d1-d2c85d70c0df","title":"Kopijavimas","link":"stapling-copies-topic.html","desc":"kopijų susegimas Dokumento originalą įdėkite","descFull":"kopijų susegimas Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Norėdami išvengti apkarpyto vaizdo, įsitikinkite, kad dokumento originalas ir spaudinys yra tokio paties popieriaus formato. Pradžios ekrane palieskite  Kopijuoti  ir nurodykite kopijų skaičių. Jei reikia, pakoreguokite kopijavimo nustatymus. Palieskite  Apipavidalinimas Sąsagėlės  ir pasirinkite sąsagėlių nustatymą. Nukopijuokite dokumentą. kopijų susegimas kopijos susegimas"},{"UUID":"b4fd238a-2f81-45c1-98a0-fb9780d36224","title":"Kopijavimas","link":"punching-holes-copies-topic.html","desc":"Skylmuša kopijoms Dokumento originalą įdėkite","descFull":"Skylmuša kopijoms Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Norėdami išvengti apkarpyto vaizdo, įsitikinkite, kad dokumento originalas ir spaudinys yra tokio paties popieriaus formato. Pradžios ekrane palieskite  Kopijuoti  ir nurodykite kopijų skaičių. Jei reikia, pakoreguokite kopijavimo nustatymus. Palieskite  Apipavidalinimas Išmušti  ir pasirinkite skylmušos nustatymą. Nukopijuokite dokumentą. skylmuša kopijoms kopijos skylmuša"},{"UUID":"e020a6b8-de3c-4986-98cc-8e76242b6507","title":"Kopijavimas","link":"using-offset-stacking-copies-topic.html","desc":"Komplektavimo grupavimo naudojimas kopijoms Dokumento","descFull":"Komplektavimo grupavimo naudojimas kopijoms Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Norėdami išvengti apkarpyto vaizdo, įsitikinkite, kad dokumento originalas ir spaudinys yra tokio paties popieriaus formato. Pradžios ekrane palieskite  Kopijuoti  ir nurodykite kopijų skaičių. Jei reikia, pakoreguokite kopijavimo nustatymus. Palieskite  Sukomplektuoti lapus  ir pasirinkite nustatymą. Nukopijuokite dokumentą. komplektavimo grupavimas kopijoms kopijos komplektavimo grupavimas"},{"UUID":"625b32ff-146c-426b-90f2-fa302f67d6d9","title":"Kopijavimas","link":"creating-copy-shortcut-topic.html","desc":"Sparčiosios kopijavimo nuorodos kūrimas Pradžios","descFull":"Sparčiosios kopijavimo nuorodos kūrimas Pradžios ekrane palieskite  Kopijuoti . Sukonfigūravę nustatymus, palieskite  . Sukurkite sparčiąją nuorodą. sparčiosios nuorodos kūrimas kopija, kopijavimas sparčiosios nuorodos pridėjimas kopija, kopijavimas sparčioji nuoroda, kūrimas kopija, kopijavimas"},{"UUID":"8c55618e-5f01-4af3-979c-99dafddfbd6c","title":"El. paštas","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Automatinio dokumentų tiektuvo ir skenerio","descFull":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas Popieriaus dėjimas į ADT dėklą ir ant skenerio stiklo Automatinis dokumentų tiektuvas (ADT) Skenerio stiklas ADT naudokite kelių puslapių arba ant abiejų pusių spausdinamiems dokumentams. Dokumento originalą dėkite gerąja puse į viršų. Jei tai – kelių ar daugiau puslapių dokumentai, prieš juos dėdami būtinai sulygiuokite jų priekinį kraštą. Būtinai pareguliuokite popieriaus kreiptuvus, kad jie atitiktų įdedamo popieriaus plotį. Skenerio stiklą naudokite vieno puslapio dokumentams, knygų puslapiams, nedidelėms laikmenoms (pavyzdžiui, atvirukams arba nuotraukoms), permatomoms laikmenoms, foto popieriui arba plonoms laikmenoms (pavyzdžiui, iškarpoms iš žurnalų). Dokumentą dėkite gerąja puse žemyn į kampą su rodykle. siuntimas el. paštu naudojant automatinį dokumentų tiektuvą (ADT) siuntimas el. paštu naudojant skenerio stiklą"},{"UUID":"407a15db-21da-479f-b58b-e564b09ca85b","title":"El. paštas","link":"sending-email-topic.html","desc":"Elektroninio laiško siuntimas Prieš pradėdami","descFull":"Elektroninio laiško siuntimas Prieš pradėdami įsitikinkite, kad sukonfigūruoti SMTP nustatymai. Norėdami gauti daugiau informacijos, žr.  . Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  El. paštas  ir įveskite reikiamą informaciją. Jei reikia, sukonfigūruokite skenavimo nustatymus. Išsiųskite elektroninį laišką. el. laiškas siuntimas elektroninių laiškų siuntimas"},{"UUID":"4dd2f527-d131-432d-bdfa-61c697c022d2","title":"El. paštas","link":"creating-email-shortcut-topic.html","desc":"El. pašto sparčiosios nuorodos kūrimas","descFull":"El. pašto sparčiosios nuorodos kūrimas Pradžios ekrane palieskite  El. paštas . Sukonfigūravę nustatymus, palieskite  . Sukurkite sparčiąją nuorodą. sparčiosios nuorodos kūrimas siųsti el. paštu, el. laiškas sparčiosios nuorodos pridėjimas siųsti el. paštu, el. laiškas sparčioji nuoroda, kūrimas siųsti el. paštu, el. laiškas el. pašto sparčioji nuoroda kūrimas"},{"UUID":"5c47de15-a63b-461c-b2db-5e9e4e2bfd11","title":"Faksas","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Automatinio dokumentų tiektuvo ir skenerio","descFull":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas Popieriaus dėjimas į ADT dėklą ir ant skenerio stiklo Automatinis dokumentų tiektuvas (ADT) Skenerio stiklas ADT naudokite kelių puslapių arba ant abiejų pusių spausdinamiems dokumentams. Dokumento originalą dėkite gerąja puse į viršų. Jei tai – kelių ar daugiau puslapių dokumentai, prieš juos dėdami būtinai sulygiuokite jų priekinį kraštą. Būtinai pareguliuokite popieriaus kreiptuvus, kad jie atitiktų įdedamo popieriaus plotį. Skenerio stiklą naudokite vieno puslapio dokumentams, knygų puslapiams, nedidelėms laikmenoms (pavyzdžiui, atvirukams arba nuotraukoms), permatomoms laikmenoms, foto popieriui arba plonoms laikmenoms (pavyzdžiui, iškarpoms iš žurnalų). Dokumentą dėkite gerąja puse žemyn į kampą su rodykle. siuntimas faksu naudojant automatinį dokumentų tiektuvą (ADT) siuntimas faksu naudojant skenerio stiklą"},{"UUID":"de9957f9-c2f7-4598-a2cb-f3bb338dda9c","title":"Faksas","link":"sending-fax-topic.html","desc":"Faksogramos siuntimas Įsitikinkite, kad faksas","descFull":"Faksogramos siuntimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Valdymo skydelio naudojimas Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Faksas  ir įveskite reikiamą informaciją. Jei reikia, pakoreguokite nustatymus. Išsiųskite faksogramą. Naudojant kompiuterį Prieš pradėdami įsitikinkite, kad įdiegta fakso tvarkyklė. Norėdami gauti daugiau informacijos, žr.  . „Windows“ naudotojams Dokumente, kurį bandote išsiųsti faksu, atidarykite dialogo langą  Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Faksas Įgalinti faksą Prieš siunčiant faksu visada rodyti nustatymus  ir įveskite gavėjo numerį. Jei reikia, sukonfigūruokite kitus fakso nustatymus. Išsiųskite faksogramą. „Macintosh“ naudotojams Esant atidarytam dokumentui pasirinkite  Failas Spausdinti . Pasirinkite spausdintuvą, po kurio pavadinimo yra parašyta  ‑ Siųsti faksu . Lauke  Kam  įveskite gavėjo numerį. Jei reikia, sukonfigūruokite kitus fakso nustatymus. Išsiųskite faksogramą. faksogramos siuntimas faksograma siuntimas"},{"UUID":"bfc03065-a07c-475c-89a0-cba336861031","title":"Faksas","link":"scheduling-fax-topic.html","desc":"Faksogramos siuntimo planavimas Įsitikinkite, kad","descFull":"Faksogramos siuntimo planavimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Faksas Kam įveskite fakso numerį Atlikta . Palieskite  Siuntimo laikas , sukonfigūruotumėte datą ir laiką, po to paliekite  Gerai . Išsiųskite faksogramą. faksogramos siuntimo planavimas faksograma, siuntimo planavimas"},{"UUID":"4d501499-b4d5-4543-9a24-76c6cf07237a","title":"Faksas","link":"creating-fax-destination-shortcut-topic.html","desc":"Faksogramų paskirties vietos sparčiosios nuorodos","descFull":"Faksogramų paskirties vietos sparčiosios nuorodos kūrimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane palieskite  Faksas Kam . Įveskite gavėjo numerį ir palieskite  Atlikta . Sukonfigūravę nustatymus, palieskite  . Sukurkite sparčiąją nuorodą. sparčiosios nuorodos kūrimas faksogramų paskirties vieta sparčiosios nuorodos pridėjimas faksogramų paskirties vieta sparčioji nuoroda, kūrimas faksogramų paskirties vieta faksogramų paskirties vietos sparčioji nuoroda kūrimas"},{"UUID":"c240a3b4-1110-43f1-8d93-5e88bf9a25d3","title":"Faksas","link":"changing-fax-resolution-topic.html","desc":"Faksogramos skiriamosios gebos keitimas Įsitikinkite,","descFull":"Faksogramos skiriamosios gebos keitimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Faksas  ir įveskite reikiamą informaciją. Palieskite  Skiriamoji geba  ir pasirinkite nustatymą. Išsiųskite faksogramą. faksogramos skiriamoji geba keitimas faksogramų skiriamosios gebos keitimas"},{"UUID":"852b937a-2385-47b9-9f4e-31648017516f","title":"Faksas","link":"adjusting-fax-darkness-topic.html","desc":"Faksogramos tamsumo koregavimas Įsitikinkite, kad","descFull":"Faksogramos tamsumo koregavimas Įsitikinkite, kad faksas yra sukonfigūruotas. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Pradžios ekrane palieskite  Faksas  ir įveskite reikiamą informaciją. Palieskite  Tamsumas  ir pakoreguokite nustatymą. Išsiųskite faksogramą. faksogramos tamsumo koregavimas faksogramos tamsumas koregavimas"},{"UUID":"ede27fdb-a895-4966-9ba0-053ba9cede48","title":"Faksas","link":"printing-fax-log-topic.html","desc":"Faksogramų žurnalo spausdinimas Įsitikinkite, kad","descFull":"Faksogramų žurnalo spausdinimas Įsitikinkite, kad sukonfigūruotas analoginis faksimilinis ryšys arba „etherFAX“. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane palieskite  Nustatymai Ataskaitos Faksas . Palieskite  Fakso užduočių žurnalas  arba  Fakso skambučių žurnalas . faksogramų žurnalas spausdinimas faksogramų žurnalo spausdinimas"},{"UUID":"eccd3d34-2796-4ead-afa7-89cad8c5556d","title":"Faksas","link":"blocking-junk-faxes-topic.html","desc":"Brukalo faksogramų blokavimas Įsitikinkite, kad","descFull":"Brukalo faksogramų blokavimas Įsitikinkite, kad sukonfigūruotas analoginis faksimilinis ryšys arba „etherFAX“. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų gavimo nustatymai Administratoriaus valdikliai . Parinktį  Blokuoti bevardę faksogramą  nustatykite į  Įjungta . brukalo faksogramos blokavimas brukalo faksogramų blokavimas"},{"UUID":"f6a05b7c-c516-4b13-a460-035d1464d4c2","title":"Faksas","link":"holding-faxes-topic.html","desc":"Faksogramų užlaikymas Įsitikinkite, kad sukonfigūruotas","descFull":"Faksogramų užlaikymas Įsitikinkite, kad sukonfigūruotas analoginis faksimilinis ryšys arba „etherFAX“. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų gavimo nustatymai Faksogramų užlaikymas . Pasirinkite režimą. faksogramų užlaikymas gautos faksogramos užlaikymas faksograma užlaikymas"},{"UUID":"6ff8a436-97f8-4103-abc4-4b372ddf3a88","title":"Faksas","link":"forwarding-fax-topic.html","desc":"Faksogramos persiuntimas Įsitikinkite, kad sukonfigūruotas","descFull":"Faksogramos persiuntimas Įsitikinkite, kad sukonfigūruotas analoginis faksimilinis ryšys arba „etherFAX“. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Sukurkite paskirties vietos sparčiąją nuorodą. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Pradžios ekrane pasižiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Sparčiosios nuorodos Pridėti sparčiąją nuorodą . Pasirinkite sparčiosios nuorodos tipą ir sukonfigūruokite nustatymus. Atkreipkite dėmesį į sparčiosios nuorodos numerį. Vykdykite pakeitimus. Spustelėkite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų priėmimo nustatymai Administratoriaus valdymas . Meniu  Faksogramų persiuntimas  pasirinkite  Persiųsti  arba  Spausdinti ir persiųsti . Meniu  Persiųsti į  pasirinkite paskirties vietos tipą ir įveskite sparčiosios nuorodos numerį. Vykdykite pakeitimus. faksogramų persiuntimas faksograma persiuntimas"},{"UUID":"e3223f56-30c5-4dc1-abe8-cd9fb0c9a07d","title":"Skenavimas","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Automatinio dokumentų tiektuvo ir skenerio","descFull":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas Popieriaus dėjimas į ADT dėklą ir ant skenerio stiklo Automatinis dokumentų tiektuvas (ADT) Skenerio stiklas ADT naudokite kelių puslapių arba ant abiejų pusių spausdinamiems dokumentams. Dokumento originalą dėkite gerąja puse į viršų. Jei tai – kelių ar daugiau puslapių dokumentai, prieš juos dėdami būtinai sulygiuokite jų priekinį kraštą. Būtinai pareguliuokite popieriaus kreiptuvus, kad jie atitiktų įdedamo popieriaus plotį. Skenerio stiklą naudokite vieno puslapio dokumentams, knygų puslapiams, nedidelėms laikmenoms (pavyzdžiui, atvirukams arba nuotraukoms), permatomoms laikmenoms, foto popieriui arba plonoms laikmenoms (pavyzdžiui, iškarpoms iš žurnalų). Dokumentą dėkite gerąja puse žemyn į kampą su rodykle. skenavimas naudojant automatinį dokumentų tiektuvą (ADT) skenavimas naudojant skenerio stiklą"},{"UUID":"e5381b78-026b-46e9-9f31-4375feba1d27","title":"Skenavimas","link":"scanning-to-computer-topic.html","desc":"Skenavimas į kompiuterį Prieš pradėdami","descFull":"Skenavimas į kompiuterį Prieš pradėdami įsitikinkite, kad kompiuteris ir spausdintuvas yra prijungti prie to paties tinklo. „Windows“ naudotojams Skenavimo paslaugų programos „Lexmark ScanBack Utility“ naudojimas Kompiuteryje paleiskite skenavimo paslaugų programą „Lexmark ScanBack Utility“ ir spustelėkite  Toliau . Jei norite atsisiųsti paslaugų programą, eikite adresu  www.lexmark.com/downloads . Spustelėkite  Sąranka  ir pridėkite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Spustelėkite  Uždaryti Toliau . Pasirinkę dokumento originalo formatą, spustelėkite  Toliau . Pasirinkę failo formatą ir skenavimo skiriamąją gebą, spustelėkite  Toliau . Įrašę unikalų skenavimo profilio vardą, spustelėkite  Toliau . Raskite, kur norite išsaugoti nuskenuotą dokumentą, sukurkite failo pavadinimą ir spustelėkite  Toliau . Norėdami pakartotinai naudoti skenavimo profilį įgalinkite parinktį  Kurti sparčiąją nuorodą  ir sukurkite unikalų sparčiosios nuorodos vardą. Spustelėkite  Baigti . Dokumento originalą įdėkite į automatinį dokumentų tiektuvą arba padėkite ant skenerio stiklo. Spausdintuvo pradžios ekrane palieskite  Skenuoti profilius Skenuoti į kompiuterį  ir pasirinkite skenavimo profilį. Įsitikinkite, kad  Skenuoti profilius  yra įtraukta į pradžios ekraną. Norėdami gauti daugiau informacijos, žr.  . „Windows“ naudotojams „Windows“ fakso ir skenavimo funkcijų naudojimas Įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo. Norėdami gauti daugiau informacijos, žr.  . Dokumento originalą įdėkite į automatinį dokumentų tiektuvą arba padėkite ant skenerio stiklo. Kompiuteryje atidarykite funkciją  „Windows“ siuntimas faksu ir skenavimas . Meniu  Pirminis šaltinis  pasirinkite pirminį skenerio šaltinį. Jei reikia, pakeiskite skenavimo nustatymus. Nuskenuokite dokumentą. „Macintosh“ naudotojams Įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo. Norėdami gauti daugiau informacijos, žr.  . Dokumento originalą įdėkite į automatinį dokumentų tiektuvą arba padėkite ant skenerio stiklo. Kompiuteryje atlikite vieną iš šių veiksmų: Atidarykite  Vaizdo fiksavimas . Atidarykite  Spausdintuvai ir skeneriai  ir pasirinkite spausdintuvą. Spustelėkite  Skenuoti Atidaryti skenerį . Lange  Skeneris  atlikite vieną ar daugiau iš toliau nurodytų veiksmų: Pasirinkite, kur norite išsaugoti skenuojamą dokumentą. Pasirinkite dokumento originalo formatą. Jei norite skenuoti iš ADT, pasirinkite meniu elementą  Dokumentų tiektuvas , esantį  Meniu „Skenuoti“ , arba įgalinkite elementą  Naudoti dokumentų tiektuvą . Jei reikia, sukonfigūruokite skenavimo nustatymus. Spustelėkite  Skenuoti . skenavimas į kompiuterį kompiuteris, skenavimas į skenavimo paslaugų programa „Lexmark ScanBack Utility“ naudojimas"},{"UUID":"d11bca28-8f31-43a7-884f-1cf384aef61d","title":"Skenavimas","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Nuskaitymas į FTP serverį Dokumento","descFull":"Nuskaitymas į FTP serverį Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skaitytuvo stiklo. Pradžios ekrane palieskite  FTP  ir įveskite reikiamą informaciją. Jei reikia, sukonfigūruokite kitus FTP nustatymus. Išsiųskite FTP užduotį. FTP serveris, nuskaitymas į valdymo skydelio naudojimas nuskaitymas į FTP serverį nuskaitymas į FTP serverį valdymo skydelio naudojimas"},{"UUID":"8e3c86b5-91c7-474c-bcd7-e011c8528640","title":"Skenavimas","link":"creating-FTP-shortcut-topic.html","desc":"Sparčiosios FTP nuorodos kūrimas Pradžios","descFull":"Sparčiosios FTP nuorodos kūrimas Pradžios ekrane palieskite  FTP . Įveskite FTP serverio adresą ir palieskite  . Sukurkite sparčiąją nuorodą. sparčiosios nuorodos kūrimas FTP adresas sparčiosios nuorodos pridėjimas FTP adresas FTP adresas sparčiosios nuorodos kūrimas sparčioji nuoroda, kūrimas FTP adresas"},{"UUID":"8cdc429d-71d6-482f-b168-bd43d537d2bb","title":"Skenavimas","link":"s2a-scanning-to-network-folders-topic.html","desc":"Nuskaitymas į tinklo aplanką Dokumento","descFull":"Nuskaitymas į tinklo aplanką Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skaitytuvo stiklo. Pradžios ekrane palieskite  Nuskaitymo centras . Piktograma ir pavadinimas gali būti pakeisti. Norėdami gauti daugiau informacijos, kreipkitės į administratorių. Atlikite vieną iš šių veiksmų: Pasirinkite paskirties vietą. SFTP nustatykite  22  prievado numerį. Naudokite sparčiąją nuorodą, paliesdami  , o tada iš sąrašo pasirinkdami nuorodą. Nuskaitykite dokumentą. nuskaitymas į tinklo aplanką SMB nuskaitymas"},{"UUID":"15ac2453-e024-4eb1-bcff-74a69f264b6d","title":"Skenavimas","link":"creating-network-folder-shortcut-topic.html","desc":"Tinklo aplanko sparčiosios nuorodos kūrimas","descFull":"Tinklo aplanko sparčiosios nuorodos kūrimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Sparčiosios nuorodos Pridėti sparčiąją nuorodą . Meniu „Sparčiosios nuorodos tipas“ pasirinkite  Tinklo aplankas  ir sukonfigūruokite nustatymus. Vykdykite pakeitimus. tinklo aplankas sparčiosios nuorodos kūrimas sparčiosios nuorodos kūrimas tinklo aplankas"},{"UUID":"6fb9f7b0-7b7f-4684-8597-5ddde25336f6","title":"Skenavimas","link":"scanning-to-flash-drive-topic.html","desc":"Skenavimas į atmintuką Dokumento originalą","descFull":"Skenavimas į atmintuką Dokumento originalą įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Įdėkite atmintuką. Palieskite  Skenuoti į USB  ir, jei reikia, pakoreguokite nustatymus. Jei nuskenuotą dokumentą norite išsaugoti aplanke, palieskite  Skenuoti į , pasirinkite aplanką ir palieskite  Skenuoti čia . Jei nerodomas ekranas  USB atmintukas , valdymo skydelyje palieskite  USB atmintukas . Nuskenuokite dokumentą. Norėdami išvengti duomenų praradimo arba spausdintuvo veikimo sutrikimo, aktyviai spausdindami, nuskaitydami ar įrašydami iš atminties įtaiso, nelieskite atmintuko arba spausdintuvo nurodytose vietose. skenavimas į atmintuką atmintukas skenavimas į"},{"UUID":"b4b75f6b-1afb-483e-b3c2-4d594af9e5ed","title":"Kaip naudoti spausdintuvo meniu","link":"menu-map-mfp-topic.html","desc":"Meniu planas Įrenginys Parinktys Ekonominis","descFull":"Meniu planas Įrenginys Parinktys Ekonominis režimas Nuotolinis operatoriaus skydelis Pranešimai Energijos sąnaudų valdymas Anoniminių duomenų rinkimas Prieinamumas Atkurti gamyklinius numatytuosius nustatymus Techninė priežiūra Pradžios ekrano tinkinimas Apie šį spausdintuvą Spausdinimas Išdėstymas Apipavidalinimas Sąranka Kokybė Užduočių apskaita PDF „PostScript“ PCL Vaizdas Popierius Dėklų konfigūracija Laikmenų konfigūracija Kopijavimas Numatytieji kopijavimo nustatymai Faksas Numatytieji fakso nustatymai El. paštas Elektroninio pašto sąranka Numatytieji el. pašto nustatymai Saityno sąranka FTP Numatytieji FTP nustatymai USB atmintukas Skenavimas iš atmintuko Spausdinimas iš atmintuko Tinklas / prievadai Tinklo apžvalga Belaidis ryšys „Wi‑Fi Direct“ „AirPrint“ Mobiliųjų paslaugų valdymas Eternetas TCP / IP SNMP IPSec 802.1x LPD konfigūracija HTTP / FTP nustatymai „ThinPrint“ USB Apriboti išorinę tinklo prieigą Saugumas Prisijungimo metodai Sudaryti USB įtaisų tvarkaraštį Saugumo audito žurnalas Prisijungimo apribojimai Konfidencialaus spausdinimo sąranka Disko užšifravimas Išvalyti laikinuosius duomenų failus Sprendimų LDAP nustatymai Įvairūs Debesų paslaugos Registracija debesų paslaugose Ataskaitos Meniu nustatymų puslapis Įrenginys Spausdinimas Sparčiosios nuorodos Faksas Tinklas Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai Skenerio valymas spausdintuvo meniu"},{"UUID":"35a258c7-c9e0-4bc6-ab47-d0d1bc75f9fd","title":"Įrenginys","link":"preferences-topic.html","desc":"Parinktys Meniu  Parinktys ","descFull":"Parinktys Meniu  Parinktys  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Ekrano kalba [Kalbų sąrašas] Nustatoma ekrane rodomo teksto kalba. Šalis / regionas [Šalių arba regionų sąrašas] Nurodoma šalis arba regionas, kuriuose spausdintuvas sukonfigūruotas veikti. Paleisti pradinę sąranką Išjungta * Įjungta Paleidžiamas sąrankos vediklis. Klaviatūra Klaviatūros tipas [Kalbų sąrašas] Pasirenkama kalba kaip klaviatūros tipas. Ne visos  Klaviatūros tipas  reikšmės gali būti rodomos arba tam, kad būtų rodomos, gali prireikti specialios aparatinės įrangos. Rodytina informacija 1 rodomas tekstas  ( IP adresas *) 2 rodomas tekstas  ( Data / laikas *) 1 tinkintas tekstas 2 tinkintas tekstas Nurodoma informacija, kuri bus rodoma pradžios ekrane. Data ir laikas Konfigūruoti Dabartinė data ir laikas Rankiniu būdu nustatyti datą ir laiką Datos formatas  (MM‑DD‑MMMM*) Laiko formatas  (12 valandų priešpiet / popiet*) Laiko juosta  (UTC‑5:00*) Tinklo laiko protokolas (angl. Network Time Protocol, NTP) Įjungti NTP  ( Įjungta *) NTP serveris Įgalinti tapatumo nustatymą  ( Nėra *) Sukonfigūruojama spausdintuvo data, laikas ir tinklo laiko protokolas. Popieriaus formatai JAV * Metrinė matų sistema Nurodomas popieriaus formatų matavimo vienetas. Pradinis popieriaus formato nustatymas priklauso nuo pradinės sąrankos vediklyje pasirinktos šalies arba regiono. Ekrano skaistis 20–100 % (100*) Koreguojamas ekrano skaistis. Prieiga prie atmintuko Išjungta Įgalinta * Įgalinama prieiga prie atmintuko. Leisti fono pašalinimą Išjungta Įjungta * Nurodoma, ar bus leidžiamas fono pašalinimas. Leisti tinkintų užduočių nuskaitymą Išjungta Įjungta * Nurodoma, ar nustatymas  Tinkintos užduoties skenavimas  rodomas kopijaivimui skenavimui ar siuntimui faksu. Šis meniu nustatymas rodomas tik tada, kai yra įrengtas standusis diskas. Vieno puslapio skenavimas ant stiklo plokštumos Išjungta * Įjungta Nustatoma, kad spausdintuvas bet kokio tipo užduotis, padėtas ant skaitytuvo stiklo, skenuotų kaip vieną puslapį. Atlikęs vieno puslapio skenavimą ant stiklo plokštumos spausdintuvas grįžta į pradžios ekraną, o ne rodo raginimus. Įrenginio garsai Nutildyti visus garsus  ( Išjungta *) Mygtukinis atsakas  ( Įjungta *) Prieigos įrenginio atsakas Įjungta *) Garsumas  (5*) Pyptelėjimas įdėjus popieriaus į ADT  ( Įjungta *) Pavojaus signalų valdymas  ( Pavienis *) Kasetės pavojaus signalas  ( Pavienis *) Garsiakalbio režimas  ( Visada išjungta *) Šaukiklio garsumas  ( Išjungta *) Konfigūruojami spausdintuvo garsų nustatymai. Ekrano skirtasis laikas 5–300 sekundžių (60*) Nustatomas neveikos laikas sekundėmis, iki parodomas pradžios ekranas arba iki spausdintuvas automatiškai atjungia naudotojo paskyrą. meniu Parinktys"},{"UUID":"665f68a4-69d6-42c5-98b3-e0df2dfd5df6","title":"Įrenginys","link":"preferences-topic.html","desc":"Ekonominis režimas Meniu  Ekonominis","descFull":"Ekonominis režimas Meniu  Ekonominis režimas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spausdinimas Pusės Vienpusis * Dvipusis Nurodoma, ar bus spausdinama iš vienos popieriaus pusės ar iš abiejų. Spausdinimas Puslapiai vienoje pusėje Išjungta * 2 puslapiai vienoje pusėje 3 puslapiai vienoje pusėje 4 puslapiai vienoje pusėje 6 puslapiai vienoje pusėje 9 puslapiai vienoje pusėje 12 puslapių vienoje pusėje 16 puslapių vienoje pusėje Kelių puslapių atvaizdai spausdinami ant vienos popieriaus lapo pusės. Spausdinimas Dažų tamsumas 1–5 (4*) Nustatomas teksto atvaizdų šviesumas arba tamsumas. Spausdinimas Spalvų taupymas Išjungta * Įjungta Sumažinamas grafikai ir vaizdams atspausdinti naudojamas dažų kiekis. Kopijavimas Pusės Viepusis į vienpusį * Viepusis į abipusį Abipusis į viepusį Abipusis į abipusį Nurodoma originalaus dokumento skenavimo elgsena. Kopijavimas Puslapiai vienoje pusėje Išjungta * 2 stati puslapiai 4 stati puslapiai 2 gulsti puslapiai 4 gulsti puslapiai Nurodoma originalaus dokumento skenavimo elgsena. Kopijavimas Tamsumas 1–9 (5*) Nustatomas skenuojamo teksto atvaizdų tamsumas. meniu Ekonominis režimas"},{"UUID":"8ee79f82-838d-4ab3-8500-df48ec185809","title":"Įrenginys","link":"preferences-topic.html","desc":"Nuotolinis operatoriaus skydelis Meniu ","descFull":"Nuotolinis operatoriaus skydelis Meniu  Nuotolinis operatoriaus skydelis  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Išorinis VNC prijungimas Neleisti * Leisti Išorinis virtualiojo tinklo kompiuterijos (angl. Virtual Network Computing, VNC) klientas prijungiamas prie nuotolinio valdymo skydelio. Autentifikavimo tipas Nėra * Standartinis autentifikavimas Nustatomas autentifikavimo tipas prisijungiant prie VNC kliento serverio. VNC slaptažodis Nurodomas slaptažodis, skirtas prisijungti prie VNC kliento serverio. Šis meniu elementas rodomas, tik jei  Autentifikavimo tipas  yra nustatytas į  Standartinis autentifikavimas . meniu Nuotolinis operatoriaus skydelis"},{"UUID":"d84505b5-7160-47eb-a99a-b8bf18df28cf","title":"Įrenginys","link":"preferences-topic.html","desc":"Pranešimai Meniu  Pranešimai ","descFull":"Pranešimai Meniu  Pranešimai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Pyptelėjimas įdėjus popieriaus į ADT Išjungta Įjungta * Dedant popierių į ADT įgalinamas garsinis signalas. Pavojaus signalų valdymas Išjungta Pavienis * Ištisinis Nustatoma, kiek kartų suskamba pavojaus signalas, kai spausdintuve reikia naudotojo įsikišimo. Eksploataciniai reikmenys Rodyti likusį eksploatacinių reikmenų kiekį Rodyti likusį kiekį * Nerodyti likusio kiekio Rodoma apytikrė spausdintuvo eksploatacinių reikmenų būsena. Eksploataciniai reikmenys Kasetės pavojaus signalas  ( Pavienis *) Segiklio pavojaus signalas  ( Išjungta *) Skylmušos pavojaus signalas  ( Išjungta *) Nustatoma, kiek kartų suskambės pavojaus signalas, kai dažų kasetėje bus likę nedaug dažų, sąsagėlių kasetė bus tuščia arba kai skylmušos talpykla bus pilna arba jos nebus. Meniu elementai  Segiklio pavojaus signalas  ir  Skylmušos pavojaus signalas  rodomi tik tada, kai yra įrengti papildomi išvedinių įtaisai. Eksploataciniai reikmenys Tinkinti pranešimai dėl eksploatacinių reikmenų Nustatomas įrenginys, kurį spausdintuvas naudoja, kad įvertintų eksploatacinių medžiagų sunaudojimą ir suaktyvintų tinkintus pranešimus, kai reikalingas naudotojo įsikišimas. Šis meniu elementas rodomas tik įtaisytajame interneto serveryje (EWS). El. pašto įspėjimų sąranka Elektroninio pašto sąranka Pirminis SMTP tinklų sietuvas Pirminio SMTP tinklų sietuvo prievadas  (25*) Antrinis SMTP tinklų sietuvas Antrinio SMTP tinklų sietuvo prievadas  (25*) SMTP skirtasis laikas  (30 sekundžių*) Atgalinis adresas Visada naudoti SMTP numatytąjį atgalinį adresą  ( Išjungta *) Naudoti SSL/TLS  ( Neveiksnus * Būtinas patikimas liudijimas  ( Įjungta *) SMTP serverio autentifikavimas  ( Autentifikavimo nereikia *) Įrenginio inicijuojamas elektroninis laiškas  ( Nėra *) Naudotojo inicijuojamas elektroninis laiškas  ( Nėra *) Naudoti veikiamojo katalogo įrenginio prisijungimo duomenis  ( Išjungta *) Įrenginio naudotojo vardas Įrenginio slaptažodis „Kerberos 5“ sritis NTLM sritis Išjungti „SMTP serveris neįdiegtas“ klaidą  ( Išjungta *) Konfigūruojami spausdintuvo el. pašto nustatymai. El. pašto įspėjimų sąranka Nustatyti el. pašto adresų sąrašus ir įspėjimus 1 el. pašto adresų sąrašas 2 el. pašto adresų sąrašas El. pašto įvykiai Nurodomi el. pašto adresai ir įgalinami el. pašto įspėjimų įvykiai. Šis meniu elementas rodomas tik įtaisytajame interneto serveryje (EWS). Klaidų prevencija Strigčių pagelbiklis Išjungta Įjungta * Nustatoma, kad pašalinus užstrigusį lapą spausdintuvas automatiškai išleistų tuščius lapus arba lapus su daliniais spaudiniais. Klaidų prevencija Automatiškai tęsti Išjungta Įjungta * (5 sekundės) Išvalius tam tikras spausdintuvo sąlygas, kurioms reikia naudotojo įsikišimo, spausdintuvui leidžiama tęsti užduoties apdorojimą arba spausdinimą. Klaidų prevencija Automatinis kartotinis paleidimas Automatinis kartotinis paleidimas Pakartoti paleidimą, kai nenaudojamas Visada pakartoti paleidimą * Niekada nekartoti paleidimo Nustatoma, kad įvykus klaidai spausdintuvas būtų paleidžiamas iš naujo. Klaidų prevencija Automatinis kartotinis paleidimas Maksimalus automatinių pakartotinių paleidimų skaičius 1–20 (2*) Nustatomas automatinių kartotinių spausdintuvo paleidimų, kuriuos jis gali atlikti, skaičius. Klaidų prevencija Automatinis kartotinis paleidimas Automatinio kartotinio paleidimo langas 1–525600 sekundžių (720*) Nustatomas laikas, po kurio spausdintuvas atliks automatinį kartotinį paleidimą. Klaidų prevencija Automatinis kartotinis paleidimas Automatinių kartotinių paleidimų skaitiklio vertės Rodoma nekeičiamoji kartotinių paleidimų skaitiklio informacija. Klaidų prevencija Automatinis kartotinis paleidimas Iš naujo nustatyti automatinių kartotinių paleidimų skaitiklį Atšaukti Tęsti Iš naujo nustatomas  Automatinių kartotinių paleidimų skaitiklis . Klaidų prevencija Rodyti klaidą dėl per trumpo popieriaus Įjungta Automatinis išvalymas * Nustatoma, kad spausdintuve būtų rodomas pranešimas, kai įvyksta klaida dėl per trumpo popieriaus. „Per trumpas popierius“ reiškia įdėto popieriaus formatą. Klaidų prevencija Puslapio apsauga Išjungta * Įjungta Nustatoma, kad prieš spausdindamas spausdintuvas visą lapą apdorotų atmintyje. Turinio atkūrimas po strigčių šalinimo Atkūrimas po strigčių šalinimo Išjungta Įjungta Automatiškai * Nustatoma, kad spausdintuvas visada iš naujo atspausdintų užstrigusius puslapius. Turinio atkūrimas po strigčių šalinimo Skaitytuvo atkūrimas po strigčių šalinimo Užduoties lygmuo Puslapio lygmuo * Nurodoma, kaip iš naujo paleisti nuskaitymo užduotį pašalinus popieriaus strigtį. meniu Pranešimai"},{"UUID":"43caed6c-7c62-415f-af55-357532cda0d6","title":"Įrenginys","link":"preferences-topic.html","desc":"Energijos sąnaudų valdymas Meniu ","descFull":"Energijos sąnaudų valdymas Meniu  Energijos sąnaudų valdymas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Miego režimo profilis Spausdinti esant miego režimui Po spausdinimo likti parengties režime Po spausdinimo įeiti į miego režimą * Nustatoma, kad po spausdinimo spausdintuvas liktų parengties režime arba įeitų į miego režimą. Miego režimo profilis Paliesti norint pažadinti iš giliaus miego režimo Išjungta * Įjungta Spausdintuvas pažadinamas iš giliaus miego režimo paliečiant spausdintuvo ekraną. Skirtieji laikai Miego režimas 1–114 min. (15*) Nustatoma spausdintuvo nenaudojimo trukmė, po kurios jis pradeda veikti miego režimu. Skirtieji laikai Užmigdymo skirtasis laikas Išjungta 1 valanda 2 valandos 3 valandos 6 valandos 1 diena 2 dienos 3 dienos * 1 savaitė 2 savaitės 1 mėnuo Nustatomas laikas, kuriam praėjus spausdintuvas išsijungia. Skirtieji laikai Užmigdymo skirtasis laikas prisijungiant Užmigdymas Neužmigdyti * Nustatomas  Užmigdymo skirtasis laikas , kuriam praėjus spausdintuvas išjungiamas esant aktyviam eterneto ryšiui. Nustatyti energijos režimų tvarkaraštį Tvarkaraščiai Pridėti naują tvarkaraštį Suplanuojama, kada spausdintuvas veiks miego arba užmigdymo režimu. meniu Energijos sąnaudų valdymas"},{"UUID":"79fd4777-6d01-4023-ba81-38e46708691e","title":"Įrenginys","link":"preferences-topic.html","desc":"Anoniminių duomenų rinkimas Meniu ","descFull":"Anoniminių duomenų rinkimas Meniu  Anoniminių duomenų rinkimas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Anoniminių duomenų rinkimas Įrenginio naudojimo ir našumo informacija Nėra * Įmonei „Lexmark“ siunčiama spausdintuvo naudojimo ir našumo informacija. Gamintojui siunčiama spausdintuvo naudojimo ir našumo informacija. Meniu elementas  Anoniminių duomenų siuntimo laikas  rodomas, tik kai  Anoniminių duomenų rinkimas  yra nustatytas į  Įrenginio naudojimas ir našumas . Anoniminių duomenų siuntimo laikas Pradžios laikas Pabaigos laikas meniu Anoniminių duomenų rinkimas"},{"UUID":"8eb6feed-c252-468d-a218-e5b1c60bad67","title":"Įrenginys","link":"preferences-topic.html","desc":"Prieinamumas Meniu „Prieinamumas“ elementai ir","descFull":"Prieinamumas Meniu „Prieinamumas“ elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Laiko tarpas tarp pakartotinių klavišo paspaudimų 0–5 (0*) Nustatomas laiko tarpas sekundėmis, per kurias spausdintuvas ignoruoja prijungtoje klaviatūroje antrą kartą paspaudžiamą klavišą. Pradinės delsos trukmė iki pakartotinai paspaudžiant klavišą 0,25–5 (1*) Nustatoma pradinės delsos trukmė sekundėmis, kol bus galima iš naujo paspausti pakartotinai spaudžiamą klavišą. Šis meniu elementas rodomas tik tada, kai prie spausdintuvo yra prijungta klaviatūra. Pakartotinių klavišo paspaudimų dažnis 0,5-30 (30*) Nustatomas pakartotinių klavišo paspaudimų per sekundę skaičius. Šis meniu elementas rodomas tik tada, kai prie spausdintuvo yra prijungta klaviatūra. Prailginti ekrano skirtąjį laiką Išjungta * Įjungta Naudotojui leidžiama likti toje pačioje vietoje ir yra iš naujo nustatomas  Ekrano skirtasis laikas laikmatis, o ne grįžtama į pradžios ekraną. Ausinių garsumas 1–10 (5*) Koreguojamas ausinių garsumas. Šis meniu elementas rodomas tik tada, kai prie spausdintuvo yra prijungtos ausinės. Įgalinti valdymą balsu, kai yra prijungtos ausinės Išjungta * Įjungta Įgalinamas valdymo balsu funkcija, kai prie spausdintuvo yra prijungtos ausinės Ištarti slaptažodžius / PIN kodus Išjungta * Įjungta Nustatoma, kad spausdintuvas kad galėtų nuskaityti garsiai ištartus slaptažodžius arba asmens identifikavimo numerius. Šis meniu elementas rodomas tik tada, kai prie spausdintuvo yra prijungtos ausinės arba garsiakalbis. Kalbėjimo tempas Labai lėtas Lėtas Normalu * Greitas Greitesnis Labai greitas Spartus Labai spartus Greičiausias Nustatomas kalbėjimo tempas valdant balsu. Šis meniu elementas rodomas tik tada, kai prie spausdintuvo yra prijungtos ausinės arba garsiakalbis. meniu Prieinamumas"},{"UUID":"54dabedf-2373-46ed-8291-45b6ea9b4906","title":"Įrenginys","link":"preferences-topic.html","desc":"Atkurti gamyklinius numatytuosius nustatymus Meniu","descFull":"Atkurti gamyklinius numatytuosius nustatymus Meniu  Atkurti gamyklinius numatytuosius nustatymus  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Atkurti nustatymus Atkurti visus nustatymus Atkurti spausdintuvo nustatymus Atkurti tinklo nustatymus Atkurti fakso nustatymus Atkurti programų nustatymus Atkuriami gamykliniai numatytieji spausdintuvo nustatymai. meniu Atkurti gamyklinius numatytuosius nustatymus"},{"UUID":"396e7b65-1601-4884-99e2-0ddd2b5d221e","title":"Techninė priežiūra","link":"preferences-topic.html","desc":"Meniu „Konfigūracija“ Meniu „Konfigūracija“ ","descFull":"Meniu „Konfigūracija“ Meniu „Konfigūracija“  elementai ir jų paaiškinimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. USB konfigūracija USB PnP 1* 2 Keičiamas spausdintuvo USB tvarkyklės režimas, kad pagerėtų jo suderinamumas su asmeniniu kompiuteriu. USB konfigūracija USB nuskaitymas į vietinį Įjungta * Išjungta Nustatoma, ar USB įrenginį tvarkyklė įvardija kaip paprastą USB įrenginį (vienos sąsajos) arba kaip USB sudėtinį įrenginį (kelių sąsajų). USB konfigūracija USB sparta Visa Automatiškai * Nustatoma, kad USB jungtis veiktų visa sparta ir būtų išjungtos didelės spartos galimybės. Dėklų konfigūracija Formato atpažinimas Dėklo [x] atpažinimas Išjungta Įjungta * „Oficio“ / „Folio“ atpažinimas Folio * „Oficio (Mexico)“ Pareiškimas / A5 atpažinimas „Sense“ atpažinimas * „Sense A5“ „Executive“ / B5 atpažinimas Sense Exec * „Sense B5“ Nustatoma, kad dėklas automatiškai atpažintų į jį įdėto popieriaus formatą. Dėklų konfigūracija Dėklų susiejimas Automatinis * Išjungta Spausdintuve nustatoma, kad būtų susieti dėklai, kurių popieriaus rūšies ir formato nustatymai yra tokie patys. Dėklų konfigūracija Rodyti pranešimą apie dėklo įdėjimą Išjungta Tik nežinomiems formatams * Visada Rodomas pranešimas, leidžiantis naudotojui pakeisti popieriaus formato ir rūšies nustatymus įdėjus dėklą. Dėklų konfigūracija Raginimai įdėti popieriaus Automatiškai * Daugiafunkcis tiektuvas Rankiniu būdu įdedamas popierius Nustatomas popieriaus šaltinis, kurį naudotojas pripildo, kai parodomas raginimas įdėti popieriaus. Tam, kad meniu elementas  Daugiafunkcis tiektuvas  būtų rodomas meniu  Popierius , parinktį  Konfigūruoti rankiniu būdu įdedamą popierių  nustatykite į  Kasetinis . Dėklų konfigūracija Raginimai įdėti vokų Automatiškai * Daugiafunkcis tiektuvas Rankiniu būdu įdedami vokai Nustatomas popieriaus šaltinis, kurį naudotojas pripildo, kai parodomas raginimas įdėti vokų. Tam, kad meniu elementas  Daugiafunkcis tiektuvas  būtų rodomas meniu  Popierius , parinktį  Konfigūruoti rankiniu būdu įdedamą popierių  nustatykite į  Kasetinis . Dėklų konfigūracija Veiksmai reaguojant į raginimus Klausti naudotojo * Tęsti Naudoti esamą (-us) Nustatoma, kad spausdintuve būtų atlikti su raginimais dėl popieriaus ar vokų pakeitimo susiję veiksmai. Dėklų konfigūracija Vokų dėklo sąranka Išjungta * Įjungta Norėdami spausdinti vokus, įjunkite vokų dėklą. Dėklų konfigūracija Įvairūs universalūs formatai Išjungta * Įjungta Nustatoma, kad dėklas palaikytų kelis universalius popieriaus formatus. Ataskaitos Meniu nustatymų puslapis Įvykių žurnalas Įvykių žurnalo suvestinė Spausdinamos ataskaitos apie spausdintuvo meniu nustatymus ir būseną bei įvykių žurnalai. Eksploatacinių reikmenų naudojimas ir skaitikliai Išvalyti eksploatacinių reikmenų naudojimo istoriją Eksploatacinių reikmenų naudojimo istorija, pavyzdžiui, puslapių ir likusių dienų skaičius, iš naujo nustatoma į gamyklinį lygį. Eksploatacinių reikmenų naudojimas ir skaitikliai Didelių laikmenų koregavimai Išjungta * Įjungta Leidžiama koreguoti spausdinant didelei arba storai laikmenai. Eksploatacinių reikmenų naudojimas ir skaitikliai ITM nustatymas iš naujo Iš naujo nustatyti juodos spalvos dažų kasetės skaitiklį Iš naujo nustatyti žydros spalvos dažų kasetės skaitiklį Iš naujo nustatyti purpurinės spalvos dažų kasetės skaitiklį Iš naujo nustatyti geltonos spalvos dažų kasetės skaitiklį Iš naujo nustatyti techninės priežiūros skaitiklį Įdėjus naują eksploatacinį reikmenį ar techninės priežiūros komplektą skaitiklis nustatomas iš naujo. Eksploatacinių reikmenų naudojimas ir skaitikliai Skirtingo padengimo diapazonai Kiekvienam spausdinimo diapazonui koreguojama spalvinio padengimo apimtis. Spausdintuvo emuliacijos PPDS emuliacija Išjungta * Įjungta Nustatoma, kad spausdintuvas atpažintų ir naudotų PPDS duomenų srautą. Spausdintuvo emuliacijos PS emuliacija Išjungta Įjungta * Nustatoma, kad spausdintuvas atpažintų ir naudotų PS duomenų srautą. Spausdintuvo emuliacijos Įgalinti „Prescribe“ Išjungta * Įjungta Suaktyvinama „Prescribe“. Turi būti įdiegta „Prescribe“ licencija. Spausdintuvo emuliacijos Emuliatoriaus saugumas Puslapio skirtasis laikas 0-60 (60*) Nustatomas puslapio skirtasis laikas emuliacijos metu. Spausdintuvo emuliacijos Emuliatoriaus saugumas Po užduoties emuliatorių nustatyti iš naujo Išjungta * Įjungta Po spausdinimo užduoties emuliatorius nustatomas iš naujo. Spausdintuvo emuliacijos Emuliatoriaus saugumas Išjungti prieigą prie spausdintuvo pranešimų Išjungta Įjungta * Emuliacijos metu išjungiama prieiga prie spausdintuvo pranešimų. Fakso konfigūracija Fakso mažos galios palaikymas Išjungti miego režimą Leisti miego režimą Automatiškai * Nustatoma, kad faksas įeitų į miego režimą spausdintuvui tai nustačius. Fakso konfigūracija Faksogramų atmintinės vieta NAND Diskas * Nustatoma atmintinės vieta visoms faksogramoms. Šis meniu elementas rodomas tik tada, kai yra įrengtas standusis diskas arba ISD. Spausdinimo konfigūracija Režimas „Tik nespalvotai“ Išjungta * Įjungta Ne kopijavimo užduotys spausdinamos pilkais tonais. Spausdinimo konfigūracija Spalvų persidengimas Išjungta 1 2* 3 4 5 Spaudiniai paryškinami, kad būtų subalansuotas neteisingas spausdintuvo spalvų registras. Spausdinimo konfigūracija Šrifto ryškinimas 0-150 (24*) Nustatoma teksto taškų dydžio reikšmė, žemiau kurios spausdinant šrifto duomenis naudojami aukšto dažnio ekranai. Pavyzdžiui, jei vertė – 24, visi šriftai, kurių dydis 24 ar mažesnis, naudojami aukšto dažnio ekranuose. Įrenginio veiksenos Tylusis režimas Išjungta * Įjungta Nustatoma, kad spausdintuvas veiktų  Tyliuoju režimu . Įgalinus šį nustatymą sulėtėja bendras spausdintuvo darbas. Įrenginio veiksenos Skydelio meniu Išjungta Įjungta * Prieiga prie spausdintuvo meniu įgalinama iš valdymo skydelio. Įrenginio veiksenos Ribotoji veiksena Išjungta * Įjungta Nustatoma, kad spausdintuvas veiktų specialiu režimu, kuriame bandoma ir toliau siūlyti kuo daugiau funkcijų nepaisant žinomų problemų. Pavyzdžiui, kai spausdintuvas yra  Įjungtas , bet neveikia dvipusio spausdinimo įrenginio variklis, spausdintuvas atlieka vienpusį dokumentų spausdinimą, net jei užduotis – dvipusis spausdinimas. Įrenginio veiksenos Minimali kopijavimo atmintis 80 MB* 100 MB Nustatomas minimalios atminties paskyrimas kopijavimo užduočių saugojimui. Įrenginio veiksenos Išvalyti pasirinktinę būseną Ištrinamos naudotojo nustatytos eilutės tinkintuose pranešimuose  Numatytieji  arba  Alternatyvieji . Įrenginio veiksenos Išvalyti visus nuotoliniu būdu įdiegtus pranešimus Ištrinami nuotoliniu būdu įdiegti pranešimai. Įrenginio veiksenos Automatiškai rodyti klaidų ekranus Išjungta Įjungta * Ekrane rodomi esami klaidų pranešimai, kai spausdintuvo pradžios ekranas tam tikrą laiką būna neaktyvus. Įrenginio veiksenos Nustatyti orientaciją kopijuojant greituoju būdu Išjungta * Įjungta Kai siunčiamos greito kopijavimo užduotys, spausdintuvas įgalinamas naudoti meniu  Kopijuoti  esantį orientacijos nustatymą. Programų konfigūracija LES programos Išjungta Įjungta * Įgalinamos „Lexmark“ įtaisytųjų sprendimų (LES) programos. Apipavidalinimo įtaiso konfigūracija 2 dėklo išėjimo nustatymas Išjungta * Įjungta Įjunkite antrosios išvedinių dėtuvės naudojimą. Skenerio konfigūracija Neautomatinė skenerio registracija Spausdinti greitąjį testą Atspausdinamas tikslinis greitojo testo puslapis. Patikrinkite, ar tiksliniame puslapyje paraščių tarpai yra visur vienodi. Jei taip nėra, spausdintuve reikia iš naujo nustatyti paraštes. Skenerio konfigūracija Neautomatinė skenerio registracija Priekinė ADT registracija Galinė ADT registracija Skenerio plokštumos registracija Pakeitus ADT, skenerio stiklą arba valdiklių plokštę, rankiniu būdu užregistruojama skenerio plokštuma ir ADT. Skenerio konfigūracija Iš naujo nustatyti techninės priežiūros skaitiklį Pakeitę ADT eksploatacijos komplektą, iš naujo nustatykite skaitiklį. Skenerio konfigūracija Kraštų išvalymas Skenerio plokštumos kraštų išvalymas  (3*) ADT kraštų išvalymas  (3*) Nustatomas skenavimo užduoties nespausdintinos srities dydis (milimetrais) aplink ADT arba skenerio plokštumą. Skenerio konfigūracija Išjungti skenerį Ne * Taip Tik ADT Jei skeneris netinkamai veikia, jis išjungiamas. Skenerio konfigūracija TIFF baitų eiliškumas CPU baitų eiliškumas * Mažėjantys baitai Didėjantys baitai Nustatomas TIFF formato skenavimo išvedinių baitų eiliškumas. Skenerio konfigūracija Tikslios TIFF formato eilutės juostoje Įjungta * Išjungta Nustatoma TIFF formato skenavimo išvedinių suženklinimo vertė „Eilutės juostoje“. meniu Meniu „Konfigūracija“"},{"UUID":"e647f48d-7821-41e7-b44a-6fc7b842c133","title":"Techninė priežiūra","link":"preferences-topic.html","desc":"Nenaudojamų duomenų išvalymas Meniu ","descFull":"Nenaudojamų duomenų išvalymas Meniu  Nenaudojamų duomenų išvalymas  elementai ir jo paaiškinimai Meniu elementas Paaiškinimas Nenaudojamų duomenų išvalymas Paskutinį kartą atmintis apvalyta Paskutinį kartą standusis diskas apvalytas Paskutinį kartą ištrintas ISD Rodoma nekeičiamoji informacija apie tai, kada paskutinį kartą buvo išvalyta spausdintuvo atmintis arba atminties įrenginys. Meniu elementas  Paskutinį kartą standusis diskas apvalytas  rodomas tik tada, kai yra įrengtas standusis diskas. Nenaudojamų duomenų išvalymas Apvalyti visą išliekamojoje atmintyje esančią informaciją Išvalyti visus spausdintuvo ir tinklo nustatymus Išvalyti visas programas ir programų nustatymus Išvalyti visas sparčiąsias nuorodas ir sparčiųjų nuorodų nustatymus Apvalyti visą standžiajame diske esančią informaciją Išvalyti siuntas (išvalomos visos makrokomandos, šriftai, PFO ir t. t.) Išvalyti buferines užduotis Išvalyti turimas užduotis Išvalyti išmoningąjį atminties įrenginį Išvaloma visa išliekamosios atminties informacija ir informacija atminties įrenginyje. Meniu elementas  Apvalyti visą standžiajame diske esančią informaciją  rodomas tik tada, kai yra įrengtas standusis diskas. meniu Nenaudojamų duomenų išvalymas"},{"UUID":"1565f9b0-22a4-4a19-93a0-2a587a5800cb","title":"Įrenginys","link":"preferences-topic.html","desc":"Pradžios ekrano tinkinimas * Šis","descFull":"Pradžios ekrano tinkinimas * Šis meniu rodomas tik įtaisytajame interneto serveryje (EWS). Meniu  Pradžios ekrano tinkinimas  elementas ir jo paaiškinimas Meniu Paaiškinimas Kopijavimas Elektroninis paštas Faksas Užlaikytos faksogramos Perduoti užlaikytas faksogramas Būsena / eksploataciniai reikmenys Užduočių eilė Nustatymai Keisti kalbą Adresų knyga Adresynas Turimos užduotys USB atmintukas FTP Skenavimo profiliai Užrakinti įrenginį Skenavimo centras „Kortelių kopijavimas“ Sparčiųjų nuorodų centras Nurodoma, kurios piktogramos bus rodomos pradžios ekrane. meniu Pradžios ekrano tinkinimas"},{"UUID":"084650d5-10ca-465c-abeb-c18006cb4fdd","title":"Įrenginys","link":"preferences-topic.html","desc":"Apie šį spausdintuvą Meniu ","descFull":"Apie šį spausdintuvą Meniu  Apie šį spausdintuvą  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Įrenginio etiketė Nurodomas spausdintuvo tapatumas. Maksimalus ilgis – 32 ženklai. Spausdintuvo buvimo vieta Nurodoma spausdintuvo buvimo vieta. Maksimalus ilgis – 63 ženklai. Kontaktinis asmuo Nurodomas spausdintuvo kontaktinio asmens informacija. Maksimalus ilgis – 63 ženklai. Programinės aparatinės įrangos versija Rodoma spausdintuve įdiegta programinės įrangos versija. Variklis Rodomas spausdintuvo variklio numeris. Serijos numeris Rodomas spausdintuvo serijos numeris. Eksportuoti konfigūracijos failą į USB Konfigūracijos failas eksportuojamas į atmintuką. Eksportuoti suglaudintus žurnalus į USB Suglaudinti žurnalų failai eksportuojami į atmintuką. Siųsti žurnalus Įmonei „Lexmark“ siunčiama spausdintuvo žurnalų informacija. meniu Apie šį spausdintuvą"},{"UUID":"588ca264-bc48-4129-b1e3-b2a60c587a3a","title":"Spausdinimas","link":"layout-topic.html","desc":"Išdėstymas Meniu  Išdėstymas ","descFull":"Išdėstymas Meniu  Išdėstymas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Pusės Vienpusis * Dvipusis Nurodoma, ar bus spausdinama iš vienos popieriaus pusės ar iš abiejų. Apvertimo stilius Ilgasis kraštas * Trumpasis kraštas Nustatoma, kuriuo popieriaus kraštu įrišama, kai spausdinama iš abiejų pusių. Tušti lapai Spausdinti Nespausdinti * Spausdinami į spausdinimo užduotį įterpiami tušti lapai. Sudėstyti Išjungta (1,1,1,2,2,2) Įjungta (1,2,1,2,1,2) * Spausdinimo užduoties puslapiai sudėliojami iš eilės, ypač spausdinant keletą užduoties kopijų. Skiriamieji lapai Nėra * Tarp kopijų Tarp užduočių Tarp puslapių Spausdinant įterpiami tušti skiriamieji lapai. Skiriamųjų lapų šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Nurodomas skiriamųjų lapų popieriaus šaltinis. Puslapiai vienoje pusėje Išjungta * 2 puslapiai vienoje pusėje 3 puslapiai vienoje pusėje 4 puslapiai vienoje pusėje 6 puslapiai vienoje pusėje 9 puslapiai vienoje pusėje 12 puslapių vienoje pusėje 16 puslapių vienoje pusėje Kelių puslapių atvaizdai spausdinami ant vienos popieriaus lapo pusės. Puslapių vienoje pusėje rikiavimas Horizontaliai * Horizontaliai atvirkštine tvarka Vertikaliai Vertikaliai atvirkštine tvarka Naudojant meniu  Puslapiai vienoje pusėje  nurodoma, kaip bus išdėstyti kelių puslapių atvaizdai. Puslapių vienoje pusėje orientacija Automatinė * Gulsčiai Stačiai Naudojant meniu  Puslapiai vienoje pusėje  nurodoma, kokia bus kelių puslapių atvaizdų orientacija. Puslapių vienoje pusėje rėmelis Nėra * Ištisinis Naudojant meniu  Puslapiai vienoje pusėje  aplink kiekvieną puslapyje esantį atvaizdą atspausdinamas rėmelis. Kopijos 1–9999 (1*) Kiekvienai spausdinimo užduočiai nurodomas kopijų skaičius. Spausdinimo plotas Įprastas * Talpinti į puslapį Visas puslapis Nurodomas spausdintinas plotas popieriaus lape. meniu Išdėstymas"},{"UUID":"050679bd-7313-4342-ba2c-312ee3005f9e","title":"Spausdinimas","link":"layout-topic.html","desc":"Apipavidalinimas Meniu  Apipavidalinimas ","descFull":"Apipavidalinimas Meniu  Apipavidalinimas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Susegimo sąsagėlėmis užduotis Išjungta * 1 sąsagėlė, viršutiniame kairiajame kampe 2 sąsagėlės, kairėje 1 sąsagėlė, viršutiniame dešiniajame kampe 2 sąsagėlės, viršuje 1 sąsagėlė, apatiniame kairiajame kampe 2 sąsagėlės, apačioje 1 sąsagėlė, apatiniame dešiniajame kampe 2 sąsagėlės, dešinėje Nurodoma sąsagėlių padėtis visoms spausdinimo užduotims. Šis meniu elementas rodomas tik tada, kai yra įrengtas segiklis. Susegimo testavimas Pradėti Nustatoma, ar segiklis veikia tinkamai. Šis meniu elementas rodomas tik tada, kai yra įrengtas segiklis. Skylmuša Išjungta * Įjungta Išmušamos skylės palei spaudinių kraštą. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. Skylmušos režimas 2 skylės 3 skylės 4 skylės Spaudiniams nustatomas skylmušos režimas. 3 skylės  – JAV gamyklinis numatytasis nustatymas.  4 skylės  – tarptautinis gamyklinis numatytasis nustatymas. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. Sukomplektuoti lapus Nėra * Tarp kopijų Tarp užduočių Sukomplektuojami kiekvienos spausdinimo užduoties spaudiniai arba kiekviena spausdinimo užduoties kopija. Esant nustatymui  Tarp kopijų  sukomplektuojama kiekviena spausdinimo užduoties kopija, jei parinktis  Sudėstyti  nustatyta į  Įjungta  [1,2,1,2,1,2]. Jei parinktis  Sudėstyti  nustatyta į  Išjungta  [1,1,1,2,2,2], kiekvienas atspausdintų puslapių rinkinys sukomplektuojamas į visus pirmuosius (1) puslapius ir visus antruosius (2) puslapius. Esant nustatymui  Tarp užduočių  visai spausdinimo užduočiai nustatoma ta pati komplektavimo pozicija nepriklausomai nuo spausdinamų kopijų skaičiaus. meniu Apipavidalinimas"},{"UUID":"8e614ad8-9f60-4ccd-94d1-cd6e1317b75d","title":"Spausdinimas","link":"layout-topic.html","desc":"Sąranka Sąrankos meniu elementai ir","descFull":"Sąranka Sąrankos meniu elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spausdintuvo kalba PCL emuliacija PS emuliacija * Nustatoma spausdintuvo kalba. Numatytosios spausdintuvo kalbos nustatymas netrukdo programinės įrangos programai siųsti spausdinimo užduotis, kuriose naudojama kita spausdintuvo kalba. Laukia užduotis Išjungta * Įjungta Išsaugomos spausdinimo užduotys, kurioms atlikti reikia eksploatacinių medžiagų, kad būtų galima spausdinti užduotis, kurioms nereikia nesamų eksploatacinių medžiagų. Šis meniu elementas rodomas tik tada, kai spausdintuve yra įrengtas standusis diskas. Užduoties atidėjimo skirtasis laikas 0 – 255  ( 30 *) Nustatomas laikas sekundėmis, kurį spausdintuvas laukia naudotojo įsikišimo, po kurio užduotys, kurioms reikia neturimų išteklių, užlaikomos. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Spausdintuvo naudojimas Maksimali sparta Maksimali išeiga * Nustatoma, kaip ryškalo blokai veiks spausdinimo metu. Pasirinkus nustatymą  Maksimali išeiga  ir spausdinant tik nespalvotų puslapių grupes, ryškalo blokai veiks lėčiau arba nustos veikti. Pasirinkus nustatymą  Maksimali sparta , ryškalo blokai spausdinimo metu visuomet veiks, ar būtų spausdinami spalvoti, ar nespalvoti puslapiai. Siuntų paskirties vieta Laisvosios prieigos atmintis (RAM) * Diskas Nurodoma, kur išsaugoti visus nuolatinius išteklius, kurie buvo atsiųsti į spausdintuvą. Šis meniu elementas rodomas tik tada, kai spausdintuve yra įrengtas standusis diskas. Išteklių išsaugojimas Išjungta * Įjungta Nustatoma, ką spausdintuvas daro su atsisiųstais ištekliais, kai gauna užduotį, kuriai atlikti reikia daugiau laisvos atminties. Pasirinkus nustatymą  Išjungta , spausdintuvas atsisiųstus išteklius išsaugo, tik kol reikia atminties. Su neaktyvia spausdintuvo kalba susiję ištekliai ištrinami. Pasirinkus nustatymą  Įjungta , spausdintuvas išsaugo visus nuolatinius atsisiųstus išteklius kiekviena perjungiama kalba. Jei reikia, spausdintuvas ne ištrina nuolatinius išteklius, o rodo pranešimus, kad atmintis užpildyta. „Spausdinti viską“ tvarka Abėcėlinė * Pirma naujausios Pirma seniausios Nurodoma tvarka, kada pasirenkate spausdinti visas laikomas ir konfidencialias užduotis. meniu Sąranka"},{"UUID":"b8f5df5d-560f-4118-8c36-95a7e79e4750","title":"Spausdinimas","link":"layout-topic.html","desc":"Kokybė Meniu  Kokybė ","descFull":"Kokybė Meniu  Kokybė  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spausdinimo režimas Nespalvotai Spalvotai * Nustatoma, kaip spausdintuvas generuos spalvotą turinį. Spausdinimo skiriamoji geba 2400 vaizdo kokybė * 1200 tšk./col. Nustatoma atspausdintų išvedinių skiriamoji geba. Dažų tamsumas Nuo 1 iki 5 (4*) Nustatomas teksto atvaizdų šviesumas arba tamsumas. Pustoninis spausdinimas Normalu * Detalus Paryškinami atspausdinti išvediniai, kad būtų lygesnės linijos ir ryškesni kraštai. Spalvų taupymas Išjungta * Įjungta Sumažinamas grafikai ir vaizdams atspausdinti naudojamas dažų kiekis. Kai šis nustatymas būna nustatytas į  Įjungta , jis pakeičia nustatymo  Dažų tamsumas  vertę. RGB (RŽM) spalvų skaistis Nuo –6 iki 6 (0*) Koreguojamas kiekvieno RGB (RŽM) ir pilkos spalvos objekto skaistis puslapyje. Šis nustatymas neturi įtakos failams, kuriuose naudojamos CMYK (ŽPGJ) spalvų specifikacijos. RGB (RŽM) spalvų kontrastas Nuo –6 iki 6 (0*) Koreguojamas kiekvieno RGB (RŽM) ir pilkos spalvos objekto kontrastas puslapyje. Šis nustatymas neturi įtakos failams, kuriuose naudojamos CMYK (ŽPGJ) spalvų specifikacijos. RGB (RŽM) spalvų grynis Nuo 0 iki 5 (0*) Koreguodami kiekvieno puslapyje esančio objekto spalvų vertes išsaugokite juodos ir baltos spalvų vertes. Šis nustatymas neturi įtakos failams, kuriuose naudojamos CMYK (ŽPGJ) spalvų specifikacijos. Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Žydra  (0*) Purpurinė  (0*) Geltona  (0*) Juoda  (0*) Koreguojamas kiekvienai spalvai naudojamų dažų kiekis. Spalvų balansas Atkurti numatytuosius nustatymus Atkuriamos visų spalvų nustatymų numatytosios vertės. Spalvų korekcija Išjungta Automatiškai * Rankinis Keičiami dokumentams spausdinti naudojami spalvų nustatymai. Parinktimi  Išjungta  nustatoma, kad spausdintuvas spalvų korekciją gautų iš programinės įrangos. Parinktimi  Automatinė  nustatoma, kad spausdintuvas kiekvienam objektui spausdinamame puslapyje pritaikytų skirtingus spalvų profilius. Parinktimi  Neautomatinė  kiekvienam objektui spausdinamame puslapyje galima pritaikyti RGB (RŽM) arba CMYK (ŽPGJ) spalvų konvertavimus. Spalvų modeliai Spausdinti spalvų modelius Atspausdinami pavyzdiniai kiekvienos spausdintuve naudojamos RGB (RŽM) ir CMYK (ŽPGJ) spalvų konvertavimo lentelės puslapiai. Spalvų priderinimas Spausdintuvas sukalibruojamas, kad spausdinamuose išvediniuose būtų priderinti spalvų variantai. Papildomų spalvų pakeitimas Nustatyti tinkintas CMYK (ŽPGJ) spalvas Nurodytoms dvidešimčiai papildomų spalvų (spot colors) priskiriamos tam tikros CMYK (ŽPGJ) spalvų modelio vertės. meniu Kokybė"},{"UUID":"8d878bc3-1dd6-4c14-a9a6-7abfb5d1b738","title":"Spausdinimas","link":"layout-topic.html","desc":"Užduočių apskaita Meniu  Užduočių","descFull":"Užduočių apskaita Meniu  Užduočių apskaita  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Užduočių apskaita Išjungta * Įjungta Nustatoma, kad spausdintuvas sukurtų gaunamų spausdinimo užduočių žurnalą. Šis meniu elementas rodomas tik tada, kai yra įdėtas atmintukas arba įrengtas standusis diskas. Apskaitos žurnalo failo sukūrimo dažnis Kasdien Kas savaitę Kas mėnesį * Nurodoma, kaip dažnai spausdintuvas sukurs žurnalo failą. Žurnalo reagavimas pasibaigus nustatyto dažnio laikui Nėra * Išsiųsti dabartinį žurnalą į el. paštą Išsiųsti dabartinį žurnalą į el. paštą ir pašalinti Išsiųsti dabartinį žurnalą Išsiųsti dabartinį žurnalą ir pašalinti Nurodoma, kaip spausdintuvas reaguoja, kai pasibaigia nustatyto dažnio laikas. Meniu elemento  Apskaitos žurnalo failo sukūrimo dažnis  vertė lemia, kada prasideda šis reagavimas. Žurnalas beveik užpildytas Išjungta Įjungta  (5)* Nurodomas maksimalus žurnalo failo dydis, iki spausdintuve įvyksta  Žurnalo reagavimas jam esant beveik užpildytam . Šis meniu elementas rodomas tik tada, kai yra įdėtas atmintukas arba įrengtas standusis diskas. Žurnalo reagavimas jam esant beveik užpildytam Nėra * Išsiųsti dabartinį žurnalą į el. paštą Išsiųsti dabartinį žurnalą į el. paštą ir pašalinti Išsiųsti seniausią žurnalą į el. paštą ir pašalinti Išsiųsti dabartinį žurnalą Išsiųsti dabartinį žurnalą ir pašalinti Išsiųsti seniausią žurnalą ir pašalinti Pašalinti dabartinį žurnalą Pašalinti seniausią žurnalą Pašalinti visus, išskyrus dabartinį Pašalinti visus žurnalus Nurodoma, kaip spausdintuvas reaguoja standžiajam diskui esant beveik užpildytam. Meniu elemento  Žurnalas beveik užpildytas  vertė lemia, kada prasideda šis reagavimas. Žurnalo reagavimas jam esant užpildytam Nėra * Išsiųsti dabartinį žurnalą į el. paštą ir pašalinti Išsiųsti seniausią žurnalą į el. paštą ir pašalinti Išsiųsti dabartinį žurnalą ir pašalinti Išsiųsti seniausią žurnalą ir pašalinti Pašalinti dabartinį žurnalą Pašalinti seniausią žurnalą Pašalinti visus, išskyrus dabartinį Pašalinti visus žurnalus Nurodoma, kaip spausdintuvas reaguoja standžiojo disko panaudojimui pasiekus didžiausią ribą (100 MB). URL žurnalo siuntimui Nurodoma, kur spausdintuvas išsiunčia užduočių apskaitos žurnalus. El. pašto adresas žurnalams siųsti Nurodomas el. pašto adresas, kuriuo spausdintuvas siunčia užduočių apskaitos žurnalus. Žurnalo failo priešdėlis Nurodomas žurnalo failų pavadinimo priešdėlis. Kaip numatytasis žurnalo failo priešdėlis naudojamas dabartinis  TCP/IP  meniu nustatytas kompiuterio vardas. meniu Užduočių apskaita"},{"UUID":"e0dbf1cf-60fc-4c70-b324-c7c2988d98b2","title":"Spausdinimas","link":"layout-topic.html","desc":"PDF Meniu  PDF ","descFull":"PDF Meniu  PDF  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Nustatyti tinkantį mastelį Išjungta * Įjungta Nustatomas mastelis, kad puslapio turinys tilptų pasirinktame popieriaus formate. Komentarai Spausdinti Nespausdinti * Nurodoma, ar spausdinti komentarus PDF faile. Spausdinti PDF klaidą Išjungta Įjungta * Įgalinamas PDF klaidos spausdinimas. meniu PDF"},{"UUID":"2b986c0a-c8f6-43e8-b2eb-1e8270df6878","title":"Spausdinimas","link":"layout-topic.html","desc":"„PostScript“ Meniu  PostScript ","descFull":"„PostScript“ Meniu  PostScript  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Atspausdinti PS klaidą Išjungta * Įjungta Atspausdinamas puslapis, kuriame apibūdinama „PostScript“ klaida. Įvykus klaidai užduoties apdorojimas sustoja, spausdintuvas atspausdina klaidos pranešimą, o likusi spausdinimo užduotis yra išvaloma. Minimalus eilutės plotis 1–30 (2*) Nustatomas minimalus stulpelio plotis. Užduotims, spausdinamoms 1200 tšk./col., vertė naudojama tiesiogiai. Užrakinti PS paleidimo režimą Išjungta Įjungta * Išjungiamas „SysStart“ failas. Jei aktyvinsite „SysStart“ failą, spausdintuvas ar vietinis tinklas bus pažeidžiami išorinių pavojų. Vaizdo glodinimas Išjungta * Įjungta Padidinamas mažos skiriamosios gebos vaizdų kontrastas ir ryškumas. Šis nustatymas neturi įtakos vaizdams, kurių skiriamoji geba yra 300 tšk./col. ar didesnė. Šrifto prioritetas Rezidentinis * Atmintukas / diskas Nustatoma šrifto paieškos tvarka. Pasirinkus  Rezidentinis  nustatoma, kad spausdintuvas, prieš ieškodamas prašomo šrifto standžiajame diske arba išmoningajame atminties įrenginyje (ISD), pirmiausia jo ieškos savo atmintyje. Pasirinkus  Atmintukas / diskas  nustatoma, kad spausdintuvas, prieš ieškodamas prašomo šrifto savo atmintyje, pirmiausia jo ieško standžiajame diske arba ISD. Šis meniu elementas rodomas tik tada, kai yra įrengtas standusis diskas arba ISD. Laukimo skirtasis laikas Išjungta Įjungta * ( 40 sekundžių ) Įgalinama, kad spausdintuvas lauktų daugiau duomenų iki atšaukiant spausdinimo užduotį. meniu „PostScript“"},{"UUID":"1c1c7087-ef07-416a-96b2-986e70d3afde","title":"Spausdinimas","link":"layout-topic.html","desc":"PCL Meniu  PCL ","descFull":"PCL Meniu  PCL  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Šrifto šaltinis Rezidentinis * Diskas Siunta Atmintukas Visi Pasirenkamas šaltinis, kuriame yra numatytasis šrifto parinkimas. Elementai  Diskas  ir  Atmintukas  rodomi tik tada, kai yra įdėtas nesugadintas, neapsaugotas standusis diskas arba atmintukas su šriftais. Elementas  Siunta  rodomas tik tada, kai spausdintuvo atmintyje yra atsisiųstų šriftų. Šrifto pavadinimas [Prieinamų šriftų sąrašas] ( Courier *) Iš nurodyto šriftų šaltinio pasirenkamas šriftas. Simbolių rinkinys [Prieinamų simbolių rinkinių sąrašas] (10U PC‑8*) Kiekvienam šrifto pavadinimui nurodomas simbolių rinkinys. Simbolių rinkinys – raidinių ir skaitinių simbolių, skyrybos ženklų ir specialių simbolių rinkinys. Simbolių rinkinius tinka naudoti skirtingoms kalboms arba konkrečioms programoms, pavyzdžiui, matematinius simbolius moksliniam tekstui. Intervalas 0,08–100,00 (10,00*) Nurodomas intervalas fiksuoto dydžio arba lygiapločiams šriftams. Intervalas  reiškia fiksuoto dydžio ženklų skaičių horizontaliame šrifto colyje. Orientacija Stačiai * Gulsčiai Pakeisti stačiai Pakeisti gulsčiai Nurodoma puslapio teksto ir grafikos orientacija. Eilučių viename puslapyje skaičius 1–255 Nurodomas kiekvieno puslapio, išspausdinto per PCL® duomenų srautą, teksto eilučių skaičius. Šis meniu elementas suaktyvina vertikalaus judėjimo reguliatorių, dėl kurio pasirinktas prašomų eilučių skaičius spausdinamas tarp numatytųjų puslapio paraščių. 60 – JAV gamyklinis numatytasis nustatymas. 64 – tarptautinis gamyklinis numatytasis nustatymas. PCL5 minimalus eilutės plotis 1–30 (2*) Nustatomas pradinis minimalus stulpelio plotis. PCLXL minimalus eilutės plotis 1–30 (2*) A4 formato plotis 198 mm* 203 mm Nustatomas loginio puslapio plotis A4 formato popieriuje. Loginis puslapis – tai vieta fiziniame puslapyje, kuriame spausdinami duomenys. Automatinis grįžimas į eilutės pradžią (CR) po eilutės patraukimo (LF) Įjungta Išjungta * Nustatoma, kad spausdintuvas atliktų grįžimą į eilutės pradžią po eilutės patraukimo valdymo komandos. Grįžimas į eilutės pradžią – mechanizmas, kuris leidžia spausdintuvui perkelti žymeklio padėtį į pirmąją tos pačios eilutės poziciją. Automatinis eilutės patraukimas (LF) po grįžimo į eilutės pradžią (CR) Įjungta Išjungta * Nustatoma, kad spausdintuvas atliktų eilutės patraukimą po grįžimo į eilutės pradžią valdymo komandos. Dėklų pernumeravimas Priskirti DF tiektuvą Priskirti dėklą  [x] Priskirti rankiniu būdu įdedamą popierių Priskirti rankiniu būdu įdedamus vokus Sukonfigūruojama, kad spausdintuvas veiktų su kita spausdinimo tvarkykle arba tinkinta programa, kurioje naudojamas kitoks šaltinio paskyrimų rinkinys, norint paprašyti tam tikro popieriaus šaltinio. Dėklų pernumeravimas Peržiūrėti gamyklinius numatytuosius nustatymus Rodoma kiekvienam popieriaus šaltiniui priskirta gamyklinė numatytoji vertė. Dėklų pernumeravimas Atkurti numatytuosius nustatymus Dėklų pernumeravimo vertės atkuriamos į gamyklines numatytąsias. Spausdinimo skirtasis laikas Išjungta Įjungta * (90 sekundžių) Spausdintuvas nustatomas, kad užbaigtų spausdinimo užduotį po to, kai buvo nenaudojamas nurodytą laiko tarpą. meniu PCL"},{"UUID":"28785086-9138-4d50-bc96-ca10ce86ec6f","title":"Spausdinimas","link":"layout-topic.html","desc":"Vaizdas Meniu  Vaizdas ","descFull":"Vaizdas Meniu  Vaizdas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Automatiškai pritaikyti Įjungta Išjungta * Vaizdui parenkamas geriausias galimas popieriaus formato ir padėties nustatymas. Kai šis meniu elementas yra nustatytas į  Įjungta , nepaisoma vaizdo mastelio ir padėties nustatymų. Invertuoti Išjungta * Įjungta Invertuojami bitiniai nespalvoti vaizdai. Šis meniu elementas netaikomas GIF arba JPEG formato vaizdams. Mastelis Pririšti viršuje kairėje Labiausiai tinka * Pririšti per vidurį Pritaikyti aukštį / plotį Pritaikyti aukštį Pritaikyti plotį Vaizdas koreguojamas, kad tilptų į spausdintiną plotą. Kai parinktis  Automatiškai pritaikyti  yra nustatyta į  Įjungta ,  Mastelis  automatiškai nustatomas į  Labiausiai tinka . Padėtis Stačiai * Gulsčiai Pakeisti į stačią padėtį Pakeisti į gulsčią padėtį Nurodoma puslapio teksto ir grafikos padėtis. meniu Vaizdas"},{"UUID":"9d9a4fec-6a6c-474f-85e1-5f440f11ff0d","title":"Popierius","link":"tray-configuration-topic.html","desc":"Dėklų konfigūracija Meniu  Dėklų","descFull":"Dėklų konfigūracija Meniu  Dėklų konfigūracija  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Numatytasis šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Rankiniu būdu įdedamas popierius Rankiniu būdu įdedami vokai Visoms spausdinimo užduotims nustatomas popieriaus šaltinis. Popieriaus formatas / rūšis Dėklas  [x] Daugiafunkcis tiektuvas Rankiniu būdu įdedamas popierius Rankiniu būdu įdedami vokai Nurodomas į kiekvieną popieriaus šaltinį įdėto popieriaus formatas arba rūšis. Pakaitinis formatas Išjungta „Statement“ / A5 „Letter“ / A4 11 x 17/A3 Visi išvardyti * Nustatoma, kad spausdintuve būtų pakeistas nurodytas popieriaus formatas, jei reikalaujamo formato popieriaus nėra įdėta nei į vieną popieriaus šaltinį. Esant nustatymui  Išjungta , naudotojas paraginamas įdėti reikiamo formato popieriaus. Esant nustatymui  Visi išvardyti  leidžiami visi galimi pakeitimai. Konfigūruoti daugiafunkcį tiektuvą Kasetinis * Rankinis Pirmasis Nustatomas daugiafunkcio tiektuvo veikimas. Pasirinkus nustatymą  Kasetinis  daugiafunkcis tiektuvas sukonfigūruojamas kaip automatinis popieriaus šaltinis. Pasirinkus nustatymą  Rankinis  daugiafunkcis tiektuvas nustatomas tik spausdinimo užduotimis, kurias atliekant popierius paduodamus rankiniu būdu. Pasirinkus nustatymą  Pirmasis  daugiafunkcis tiektuvas sukonfigūruojamas kaip pirminis popieriaus šaltinis. meniu Dėklų konfigūracija"},{"UUID":"02ddd8e1-1b85-4423-9c75-24f64f2ac960","title":"Laikmenų konfigūracija","link":"tray-configuration-topic.html","desc":"Universalaus formato sąranka Meniu ","descFull":"Universalaus formato sąranka Meniu  Universalaus formato sąranka  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Matavimo vienetai Coliai Milimetrai Nurodomas universalaus popieriaus formato matavimo vienetas. Coliai  – JAV gamyklinis numatytasis nustatymas.  Milimetrai  – tarptautinis gamyklinis numatytasis nustatymas. Stačio lapo plotis 3,5–19 col. (8.5*) 88,9–482,6 mm (216*) Nustatomas universalaus formato popieriaus stačio lapo plotis. Stačio lapo aukštis 3,5–19 col. (14*) 88,9–482,6 mm (356*) Nustatomas universalaus formato popieriaus stačio lapo aukštis. Tiekimo kryptis Trumpasis kraštas * Ilgasis kraštas Nustatoma, kad spausdintuvas popierių imtų trumpuoju arba ilguoju kraštu. Nustatymas  Ilgasis kraštas  rodomas tik tada, kai ilgiausias kraštas yra trumpesnis nei didžiausias palaikomas plotis. Įvairūs universalūs formatai Dėklas [x] Daugiafunkcis tiektuvas Priskirkite unikalų matmenį keliems universaliems formatams, įkeliamiems į kiekvieną popieriaus šaltinį. Šis nustatymas rodomas tik tada, kai įjungtas meniu  Įrenginys . Pradžios ekrane palieskite  Nustatymai Įrenginys Priežiūra Konfigūracijos meniu Dėklų konfigūracija Keli universalūs dydžiai . meniu Universalaus formato sąranka"},{"UUID":"dab21960-1a1d-4ee0-ac2b-8216180f2705","title":"Laikmenų konfigūracija","link":"tray-configuration-topic.html","desc":"Tinkinti skenavimo formatai Meniu ","descFull":"Tinkinti skenavimo formatai Meniu  Tinkinti skenavimo formatai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Tinkintas skenavimo formatas  [x] Skenavimo formato pavadinimas Plotis 1–8,5 col. (8,5*) 25,4–215,9 mm (215,9*) Aukštis 1–25 col. (11*) 25,4–635 mm (279,4*) Orientacija Stačiai * Gulsčiai 2 vienos pusės nuskaitymai Išjungta * Įjungta Priskiriamas nuskaitomo dokumento popieriaus formato pavadinimas ir sukonfigūruojami nuskaitymo nustatymai. meniu Tinkinti skenavimo formatai"},{"UUID":"08b9e066-e9b4-4c62-9aaf-24d3324f016e","title":"Laikmenų konfigūracija","link":"tray-configuration-topic.html","desc":"Laikmenų rūšys Meniu  Laikmenų","descFull":"Laikmenų rūšys Meniu  Laikmenų rūšys  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Paprastas popierius Kartoninis popierius („Card Stock“) Perdirbtas popierius Blizgus popierius („Glossy“) Etiketės Standus popierius Vokai Šiurkštūs vokai („Rough Envelope“) Firminiai blankai Iš anksto paruoštos formos Spalvotas popierius Lengvas popierius Sunkus popierius Šiurkštus / medvilninis popierius Tinkinta rūšis  [X] Nurodoma popieriaus tekstūra, svoris ir orientacija. meniu Laikmenų rūšys"},{"UUID":"2f94823f-9bb6-49cf-97ad-61cd602232fd","title":"Kopijavimas","link":"copy-defaults-topic.html","desc":"Numatytieji kopijavimo nustatymai Meniu ","descFull":"Numatytieji kopijavimo nustatymai Meniu  Numatytieji kopijavimo nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Turinio rūšis Tekstas Tekstas / nuotrauka * Nuotrauka Grafika Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turiniu. Turinio šaltinis Nespalvinis lazerinis spausdintuvas Spalvinis lazerinis spausdintuvas * Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo šaltiniu. Pusės Viepusis į vienpusį * Viepusis į abipusį Abipusis į viepusį Abipusis į abipusį Nurodoma originalaus dokumento skenavimo elgsena. Skiriamieji lapai Nėra * Tarp kopijų Tarp užduočių Tarp puslapių Nurodoma, ar spausdinant įterpti tuščius skiriamuosius lapus. Skiriamųjų lapų šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Nurodomas skiriamųjų lapų popieriaus šaltinis. Spalva Išjungta Įjungta * Automatiškai Nustatoma, kad spausdintuvo skenavimo užduotyje būtų generuojama spalvota išvestis. Puslapiai vienoje pusėje Išjungta * 2 stati puslapiai 4 stati puslapiai 2 gulsti puslapiai 4 gulsti puslapiai Nurodoma, kiek puslapių vaizdų bus spausdinama ant vienos popieriaus lapo pusės. Spausdinti puslapio rėmelius Išjungta * Įjungta Spausdinant kelis puslapius viename puslapyje aplink kiekvieną atvaizdą uždedamas rėmelis. Sudėstyti Išjungta [1,1,1,2,2,2] Įjungta [1,2,1,2,1,2] * Spausdinama keletas kopijų iš eilės. Sukomplektuoti lapus Nėra * Tarp kopijų Tarp užduočių Sukomplektuojami kiekvienos spausdinimo užduoties spaudiniai arba kiekviena spausdinimo užduoties kopija. Esant nustatymui  Tarp kopijų  sukomplektuojama kiekviena spausdinimo užduoties kopija, jei parinktis  Sudėstyti  nustatyta į  Įjungta [1,2,1,2,1,2] . Jei parinktis  Sudėstyti  nustatyta į  Išjungta [1,1,1,2,2,2] , kiekvienas atspausdintų puslapių rinkinys sukomplektuojamas į visus pirmuosius puslapius ir visus antruosius puslapius. Esant nustatymui  Tarp užduočių  visai spausdinimo užduočiai nustatoma ta pati komplektavimo pozicija nepriklausomai nuo spausdinamų kopijų skaičiaus. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. Susegimas Išjungta * 1 sąsagėlė, viršutiniame kairiajame kampe 2 sąsagėlės, kairėje 1 sąsagėlė, viršutiniame dešiniajame kampe 2 sąsagėlės, viršuje 1 sąsagėlė, apatiniame kairiajame kampe 2 sąsagėlės, apačioje 1 sąsagėlė, apatiniame dešiniajame kampe 2 sąsagėlės, dešinėje 4 sąsagėlės Nurodoma sąsagėlių padėtis visoms spausdinimo užduotims. Šis meniu elementas rodomas tik tada, kai yra įrengtas segiklis. Skylmuša Išjungta * 2 skylės 3 skylės 4 skylės Spaudiniuose išmuštos skylės. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. „Kopijuoti iš“ formatas [Popieriaus formatų sąrašas] Nurodomas dokumento originalo popieriaus formatas. Letter  – JAV gamyklinis numatytasis nustatymas.  A4  – tarptautinis gamyklinis numatytasis nustatymas. „Kopijuoti į“ šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Automatiškai priderinti formatą Nurodomas kopijavimo užduoties popieriaus šaltinis. Temperatūra Nuo –4 iki 4 (0*) Nurodoma, ar išvediniai bus vėsesni ar šiltesni. Tamsumas Nuo 1 iki 9 (5*) Koreguojamas skenuojamo vaizdo tamsumas. Kopijų skaičius 1-9999 (1*) Nurodomas kopijų skaičius. Puslapinė antraštė ir poraštė Puslapinė antraštė kairėje Puslapinė antraštė per vidurį Puslapinė antraštė dešinėje Puslapinė poraštė kairėje Puslapinė poraštė per vidurį Puslapinė poraštė dešinėje Nurodoma skenuojamo vaizdo antraštės arba poraštės informacija. Užkloja Konfidencialu Kopijavimas Projektas Skubu Tinkinta Išjungta * Nurodomas užklojos tekstas, kuris bus spausdinamas ant kiekvienos kopijos. Tinkinta užkloja Įvedamas tekstas pasirinkus meniu elementą  Tinkinta  meniu  Užkloja . Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Nuo žydros iki raudonos Nuo –4 iki 4 (0*) Nuo purpurinės iki žalios Nuo –4 iki 4 (0*) Nuo geltonos iki mėlynos Nuo –4 iki 4 (0*) Reguliuojamas mėlynos, purpurinės ir geltonos spalvos ryškumas. Spalvų pašalinimas Spalvų pašalinimas  ( Nėra *) Numatytoji ribinė raudonos spalvos vertė  (128*) Numatytoji ribinė žalios spalvos vertė  (128*) Numatytoji ribinė mėlynos spalvos vertė  (128*) Nurodoma, kurią spalvą pašalinti nuskaitant, ir pakoreguojamas tos spalvos pašalinimo nustatymas. Automatinis spalvų aptikimas Spalvų aptikimas 1–9 (5*) Ploto aptikimas 1–9 (5*) Sukonfigūruojamas automatinio spalvų aptikimo nustatymas. Kontrastas Labiausiai tinka turiniui * 0–5 Nurodomas skenuojamo vaizdo kontrastas. Fono pašalinimas Fono aptikimas Turinio pagrindu* Fiksuotas Lygis Nuo –4 iki 4 (0*) Pašalinamas dokumento originale esantis fono atspalvis arba vaizdo triukšmas. Pasirinkus  Turinio pagrindu , pašalinamas dokumento originale esančio fono atspalvis. Pasirinkus  Fiksuotas , iš nuotraukos pašalinamas vaizdo triukšmas. Automatiškai centre Išjungta * Įjungta Sulygiuojamas turinys puslapio centre. Veidrodinis atvaizdas Išjungta * Įjungta Sukuriamas veidrodinis originalaus dokumento atvaizdas. Negatyvinis atvaizdas Išjungta * Įjungta Sukuriamas negatyvinis originalaus dokumento atvaizdas. Šešėlių detalės Nuo –4 iki 4 (0*) Koreguojamos šešėlių detalės originaliame dokumente. Nuskaityti nuo krašto iki krašto Išjungta * Įjungta Dokumento originalas skenuojamas nuo krašto iki krašto. Ryškumas 1–5 (3*) Koreguojamas skenuojamo vaizdo ryškumas. Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Leisti spalvotas kopijas Išjungta Įjungta * Spausdinamos spalvotos kopijos. Leisti prioritetines kopijas Išjungta Įjungta * Nutraukiama spausdinimo užduotis, kad būtų padarytos kopijos. Tinkintos užduoties nuskaitymas Išjungta * Įjungta Nustatoma, kad spausdintuvas pirmąjį dokumentų originalų rinkinį skenuotų pagal nurodytus nustatymus, o kitą rinkinį skenuotų esant tiems patiems arba skirtingiems nustatymams. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Leisti išsaugoti kaip sparčiąją nuorodą Išjungta Įjungta * Kopijų nustatymai išsaugomi kaip sparčioji nuoroda. Kopijos mėginys Išjungta * Įjungta Prieš spausdindami likusias kopijas, atsispausdinkite kopijos mėginį, kad patikrintumėte kokybę. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. meniu Numatytieji kopijavimo nustatymai"},{"UUID":"239baf72-2c35-4c4f-b7a6-be9b5772394e","title":"Numatytieji fakso nustatymai","link":"fax-defaults-subgroup.html","desc":"Fakso režimas Meniu  Fakso","descFull":"Fakso režimas Meniu  Fakso režimas  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Fakso režimas Faksas Fakso serveris Išjungta Pasirenkamas fakso režimas. Priklausomai nuo spausdintuvo modelio gamyklinis numatytasis nustatymas gali skirtis. meniu Fakso režimas"},{"UUID":"8a29ab1a-e41f-42b9-92e6-f315e816ae83","title":"Numatytieji fakso nustatymai","link":"fax-defaults-subgroup.html","desc":"Faksimilinio ryšio sąranka Šis meniu","descFull":"Faksimilinio ryšio sąranka Šis meniu galimas tik „etherFax“ portale užregistruotiems arba su fakso kortele įdiegtiems spausdintuvams. Bendrieji fakso nustatymai Meniu  Bendrieji fakso nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Fakso vardas Nustatomas fakso aparato tapatumas. Fakso numeris Nustatomas fakso numeris. Fakso identifikavimas Fakso vardas Fakso numeris * Faksogramų gavėjams pranešamas fakso vardas arba fakso numeris. Įgalinti faksogramų siuntimą neautomatiniu būdu Išjungta * Įjungta Spausdintuve įjungiama neautomatinė fakso funkcija. Šiam meniu elementui reikia linijos skirstytuvo ir telefono ragelio. Į gaunamą fakso užduotį atsiliepti ir fakso numeriui rinkti naudojama įprasta telefono linija. Norėdami eiti tiesiai į faksogramų siuntimo neautomatiniu būdu funkciją, klaviatūroje palieskite  #  ir  0 . Atminties naudojimas Visas priimti Daugiausia priimti Vienodai * Daugiausia siųsti Visas siųsti Nustatomas vidinės spausdintuvo atminties, skirtos faksogramoms siųsti, kiekis. Šis meniu elementas apsaugo nuo atminties buferio sąlygų ir neišsiųstų faksogramų. Atšaukti faksogramas Leisti * Neleisti Atšaukiamos siunčiamos ir gaunamos faksogramos. Siuntėjo identifikavimas Išjungta Įjungta Pakaitinis Įjungiamas siuntėjo ID šablonas. Šis nustatymas rodomas tik tada, kai pradinės sąrankos vediklyje pasirinkta šalis arba regionas palaiko kelis siuntėjo ID šablonus. Fakso numerio maskavimas Išjungta * Iš kairės Iš dešinės Nurodomas išsiuntimo fakso numerio maskavimo formatas. Maskuotini skaitmenys 0-58 (0*) Nurodomas maskuotinų siunčiančiojo fakso numerio skaitmenų skaičius. Įgalinti linijos prijungimo aptikimą Išjungta Įjungta * Nustatoma, ar prie spausdintuvo prijungta telefono linija. Įvykiai nustatomi tuojau pat. Įgalinti linijos neteisingame lizde aptikimą Išjungta Įjungta * Nustatoma, ar telefono linija įjungta į teisingą spausdintuvo prievadą. Įvykiai nustatomi tuojau pat. Įgalinti plėtinį naudojimo palaikyme Išjungta Įjungta * Nustatoma, ar telefono liniją naudos kitas įrenginys, pavyzdžiui, kitas telefonas toje pačioje linijoje. Įvykiai nustatomi tuojau pat. Optimizuoti fakso suderinamumą Sukonfigūruojamas spausdintuvo fakso funkcionalumas, kad jį būtų galima optimaliai suderinti su kitais fakso aparatais. Faksogramų transportas T.38 Analoginis (-ė) G.711 „etherFAX“ Nustatomas faksogramų transporto metodas. Šis meniu elementas rodomas tik tada, jei spausdintuve yra įdiegtas „etherFAX“ arba „Fax over IP“ (FoIP) licencijos paketas. HTTPS fakso nustatymai Šis meniu rodomas tik tuo atveju, jei  Faksogramų transportas  yra nustatytas į  „etherFAX“ . Meniu  HTTPS fakso nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. HTTPS tarnybos URL Nurodomas „etherFAX“ tarnybos URL. HTTPS įgaliotasis serveris Nurodomas įgaliotojo serverio URL. HTTPS įgaliotojo serverio naudotojas Nurodomas įgaliotojo serverio naudotojo vardas ir slaptažodis. HTTPS įgaliotojo serverio slaptažodis Faksogramų siuntimo užšifravimas Išjungta Įgalinta * Privalomas Įgalinamas išsiunčiamų faksogramų užšifravimas. Faksogramų priėmimo užšifravimas Išjungta Įgalinta * Privalomas Įgalinamas priimamų faksogramų užšifravimas. HTTPS faksimilinio ryšio būsena Rodoma „etherFAX“ ryšio būsena. Faksogramų siuntimo nustatymai Meniu  Faksogramų siuntimo nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Skiriamoji geba Standartinė * Didelė Labai didelė Itin didelė Nurodoma skenuojamo vaizdo skiriamoji geba. Standartinė  ir  Labai didelė  rodoma tik tada, kai pagal numatytuosius nustatymus nuostata  Įjungti spalvotą faksogramų nuskaitymą  nustatyta į  Išjungta . Nustačius didesnę skiriamąją gebą pailgėja faksogramų perdavimo laikas ir reikia daugiau atminties. Originalus formatas [Popieriaus formatų sąrašas] (Įvairūs formatai*) Nurodomas originalaus dokumento formatas. Orientacija Stačiai * Gulsčiai Nurodoma dokumento originalo orientacija. Pusės Išjungta * Trumpasis kraštas Ilgasis kraštas Nurodoma dokumento originalo orientacija skenuojant abi dokumento puses. Turinio rūšis Tekstas * Tekstas / nuotrauka Nuotrauka Grafika Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turiniu. Turinio šaltinis Nespalvinis lazerinis spausdintuvas Spalvinis lazerinis spausdintuvas * Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo šaltiniu. Tamsumas 1–9 (5*) Koreguojamas skenuojamo vaizdo tamsumas. Už PABX Įjungta Išjungta * Nustatoma, kad spausdintuvas rinktų fakso numerį, nelaukdamas, kol atpažins rinkimo toną. PABX (privačioji automatizuota telefono stotis) – tai telefonų tinklas, kuriame vienos prieigos numeris gali suteikti keletą linijų skambučiams iš išorės. Skambinimo režimas Signalas * Impulsas Nurodomas skambinimo režimas gaunamoms ir siunčiamoms faksogramoms. Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Žydra – raudona Nuo –4 iki 4 (0*) Purpurinė – žalia Nuo –4 iki 4 (0*) Geltona – mėlyna Nuo –4 iki 4 (0*) Skenuojant koreguojamas spalvų intensyvumas. Spalvų pašalinimas Spalvų pašalinimas  ( Nėra *) Numatytoji ribinė raudonos spalvos vertė  (128*) Numatytoji ribinė žalios spalvos vertė  (128*) Numatytoji ribinė mėlynos spalvos vertė  (128*) Nurodoma, kurią spalvą pašalinti nuskaitant, ir pakoreguojamas tos spalvos pašalinimo nustatymas. Kontrastas Labiausiai tinka turiniui * 0 1 2 3 4 5 Nustatomas išvedinių kontrastas. Fono pašalinimas Lygis Nuo –4 iki 4 (0*) Koreguojamas skenuojamame vaizde matomas fonas. Veidrodinis atvaizdas Išjungta * Įjungta Sukuriamas veidrodinis originalaus dokumento atvaizdas. Negatyvinis atvaizdas Išjungta * Įjungta Sukuriamas negatyvinis originalaus dokumento atvaizdas. Šešėlių detalės Nuo –4 iki 4 (0*) Koreguojamos skenuojamame vaizde matomos šešėlių detalės. Nuskaityti nuo krašto iki krašto Įjungta Išjungta * Dokumento originalą leidžiama skenuoti nuo krašto iki krašto. Ryškumas 1–5 (3*) Koreguojamas skenuojamo vaizdo ryškumas. Temperatūra Nuo –4 iki 4 (0*) Nurodoma, ar išvediniai bus vėsesni ar šiltesni. Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Automatinis numerio perrinkimas 0-9 (5*) Koreguojamas pakartotinio rinkimo bandymų skaičius, atsižvelgiant į gavėjų fakso aparatų veikimo lygius. Numerio perrinkimo dažnis 1–200 min. (3*) Pailginamas laikas tarp pakartotinio rinkimo bandymų siekiant padidinti galimybę sėkmingai išsiųsti faksogramas. Įjungti klaidų taisymo režimą Įjungta * Išjungta Įjungiamas klaidų taisymo režimas (ECM) faksogramų siuntimo užduotims. ECM aptinka ir ištaiso perduodamų faksogramų klaidas, kurios atsiranda dėl telefono linijos triukšmo ir prasto signalo stiprumo. Įjungti nuskenuotų dokumentų siuntimą faksu Įjungta * Išjungta Faksu siunčiami spausdintuve nuskenuoti dokumentai. Tvarkyklė faksogramoms siųsti Įjungta * Išjungta Spausdintuvo tvarkyklei leidžiama siųsti faksogramas. Leisti išsaugoti kaip sparčiąją nuorodą Įjungta * Išjungta Fakso numeriai išsaugomi spausdintuve kaip sparčiosios nuorodos. Maksimali sparta 33600 * 14400 9600 4800 2400 Nustatoma maksimali faksogramos siuntimo sparta. Tinkintos užduoties nuskaitymas Išjungta * Įjungta Įjungiamas tinkintų užduočių nuskaitymas pagal numatytuosius nustatymus. Šis meniu elementas rodomas tik tada, kai yra įrengtas standusis diskas arba išmoningasis atminties įrenginys (ISD). Skenuojamo dokumento peržiūra Išjungta * Įjungta Ekrane galima peržiūrėti skenuojamus dokumentus. Šis meniu elementas rodomas tik tada, kai yra įrengtas standusis diskas arba ISD. Įjungti spalvotą faksogramų skenavimą Numatytasis nustatymas – „Išjungta“ * Numatytasis nustatymas – „Įjungta“ Niekada nenaudoti Visada naudoti Įgalinamas spalvotas faksogramų skenavimas. Automatiškai konvertuoti spalvotas faksogramas į vienspalves Įjungta * Išjungta Visos siunčiamos spalvotos faksogramos konvertuojamos į nespalvotas. Patvirtinti fakso numerį Išjungta * Įjungta Naudotojo prašoma patvirtinti fakso numerį. Renkamo numerio prefiksas Nustatomas renkamo numerio prefiksas. Renkamo numerio prefikso taisyklės Sukuriama renkamo numerio prefikso taisyklė. Faksogramų priėmimo nustatymai Meniu  Faksogramų priėmimo nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Laukia fakso užduotis Nėra * Dažai Dažai ir eksploatacinės medžiagos Pašalinamos fakso užduotys, kurioms reikia konkrečių nepasiekiamų išteklių iš spausdinimo eilės. Skambėjimai prieš atsiliepiant 1–25 (3*) Nustatomas reikiamas skambėjimų skaičius prieš prietaisui atsiliepiant į gaunamuosius skambučius. Automatinis mažinimas Įjungta * Išjungta Nustatomas gaunamos faksogramos mastelis, kad tilptų į puslapį. Popieriaus šaltinis Dėklas  [X] Automatiškai * Nustatomas popieriaus šaltinis gaunamoms fakso užduotims spausdinti. Pusės Įjungta Išjungta * Spausdinama ant abiejų popieriaus pusių. Skiriamieji lapai Nėra * Prieš užduotį Po užduoties Nurodoma, ar spausdinant įterpti tuščius skiriamuosius lapus. Skiriamųjų lapų šaltinis Dėklas  [X] (1*) Nurodomas skiriamųjų lapų popieriaus šaltinis. Išvedinių dėtuvė Standartinė dėtuvė Nurodoma gautų faksogramų dėtuvė. Faksogramos poraštė Įjungta Išjungta * Kiekvieno gautos faksogramos puslapio apačioje spausdinama perdavimo informacija. Faksogramos poraštės laiko žyma Gavimas * Spausdinimas Kiekvieno gautos faksogramos puslapio apačioje atspausdinama laiko žyma. Skylmuša Išjungta * 2 skylės 3 skylės 4 skylės Nurodoma skylmušos funkcija gaunamoms faksogramoms. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. Susegimas Išjungta * 1 sąsagėlė 2 sąsagėlės 4 sąsagėlės Nurodoma sąsagėlių funkcija gaunamoms faksogramoms. Šis meniu elementas rodomas tik tada, kai yra įrengtas segiklis. Faksogramų užlaikymas Užlaikomų faksogramų režimas Išjungta * Visada įjungta Rankinis Suplanuotas Gautos faksogramos užlaikomos, iki bus atspausdintos. Faksogramų užlaikymas Faksogramų užlaikymo tvarkaraštis Priskiriamas faksogramų užlaikymo tvarkaraštis. Šis nustatymas rodomas tik tada, kai  Faksogramų užlaikymo režimas  nustatytas į  Suplanuotas . Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įjungti faksogramų priėmimą Įjungta * Išjungta Nustatoma, kad spausdintuvas priimtų faksogramas. Įjungti spalvotų faksogramų priėmimą Įjungta * Išjungta Nustatoma, kad spausdintuvas faksogramas priimtų spalvotai. Įgalinti siuntėjo identifikavimą Įjungta Išjungta * Rodomas gaunamo skambučio telefono numeris valdymo skydelyje. Blokuoti bevardę faksogramą Įjungta Išjungta * Blokuojamos gaunamos faksogramos, siunčiamos iš įrenginių be tarnybinės stoties arba fakso identifikavimo ženklų. Blokuojamų faksų sąrašas Pridėti blokuojamą faksą Nurodomi blokuotini telefono numeriai. Atsiliepti Į visus skambučius * Tik suskambėjus vieną kartą Tik suskambėjus du kartus Tik suskambėjus tris kartus Tik suskambėjus vieną arba du kartus Tik suskambėjus vieną arba tris kartus Tik suskambėjus du arba tris kartus Nustatomas skiriamasis gaunamos faksogramos skambėjimo signalas. Automatinis atsiliepimas Įjungta * Išjungta Nustatoma, kad spausdintuvas faksogramas priimtų automatiškai. Rankinio atsiliepimo kodas 0–9 (9*) Telefono numerių rinkimo klaviatūra rankiniu būdu įvedamas kodas, kad būtų galima priimti faksogramą. Šis meniu elementas rodomas tik tada, tik kai spausdintuvui ir telefonui priskiriama ta pati ryšio linija. Šis meniu elementas rodomas tik tada, kai nustatoma, kad spausdintuve faksogramos būtų priimamos rankiniu būdu. Faksogramų persiuntimas Spausdinti * Spausdinti ir persiųsti Persiųsti Nurodoma, ar persiųsti gautą faksogramą. Persiųsti į Paskirties vieta 1 Paskirties vieta 2 Nurodoma, kur persiųsti gautą faksogramą. Šis meniu elementas rodomas tik tada, kai  Faksogramų persiuntimas  yra nustatyta į  Spausdinti ir persiųsti  arba  Persiųsti . Maksimali sparta 33600* 14400 9600 4800 2400 Nustatoma maksimali faksogramos perdavimo sparta. Faksogramos antraštinis lapas Meniu  Faksogramos antraštinis lapas  elementai ir jų paaiškinimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Faksogramos antraštinis lapas Numatytasis nustatymas – „Išjungta“ * Numatytasis nustatymas – „Įjungta“ Niekada nenaudoti Visada naudoti Sukonfigūruojami faksogramos antraštinio lapo nustatymai. Įtraukti į lauką Išjungta * Įjungta Įtraukti ne lauke Išjungta * Įjungta Nuo Įtraukti laiško lauką Išjungta * Įjungta Laiškas: Įtraukti logotipą Išjungta * Įjungta Įtraukti poraštę [x] Išjungta * Įjungta Poraštė [x] Faksogramų žurnalo nustatymai Meniu  Faksogramų žurnalo nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Perdavimo žurnalo sukūrimo dažnis Visada * Niekada Tik esant klaidai Nurodoma, kaip dažnai spausdintuvas sukurs perdavimo žurnalą. Veiksmas, susijęs su perdavimo žurnalu Spausdinimas Išjungta Įjungta * El. paštas Išjungta * Įjungta Atspausdinamas arba išsiunčiamas el. paštu sėkmingai perduotų faksogramų arba perdavimo klaidų žurnalas. Gauti klaidų žurnalą Niekada nespausdinti * Spausdinti esant klaidai Atspausdinamas faksogramų, kurių nepavyko priimti, žurnalas. Automatiškai spausdinti žurnalus Įjungta * Išjungta Atspausdinama visa siuntimo faksu veikla. Žurnalų popieriaus šaltinis Dėklas  [x] (1*) Nurodomas popieriaus šaltinis žurnalams spausdinti. Rodymas žurnaluose Nuotolinio fakso vardas * Rinktas numeris Siuntėjas nurodomas nuotolinio fakso vardu arba fakso numeriu. Įjungti užduočių žurnalą Įjungta * Išjungta Peržiūrima visų fakso užduočių suvestinė. Įjungti skambučių žurnalą Įjungta * Išjungta Peržiūrima faksu rinktų numerių istorijos suvestinė. Žurnalo išvesčių dėtuvė Standartinė dėtuvė * Dėtuvė [x] Nurodoma atspausdintų žurnalų dėtuvė. Garsiakalbio nustatymai Meniu  Garsiakalbio nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Garsiakalbio režimas Visada išjungta * Visada įjungta Įjungta iki sujungimo Nustatomas fakso garsiakalbio režimas. Garsiakalbio garsumas Mažas * Didelis Koreguojamas fakso garsiakalbio garsumas. Šaukiklio garsumas Išjungta * Įjungta Įjungiamas šaukiklio garsumas. VoIP nustatymai Meniu  VoIP nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. VoIP protokolas SIP * H.323 Nustatomas interneto telefonijos protokolas (VoIP). STUN serveris Nurodomas STUN serveris, kad būtų galima pereiti užkardą. Priverstinio faksogramos siuntimo režimas Išjungta Įjungta * Fakso skambučio pradžioje analoginis VoIP tinklų sietuvas perjungiamas į T.38. Priverstinio faksogramos siuntimo režimo delsa 0–15 (7*) Nustatoma laiko delsa sekundėmis siunčiant kitą  Priverstinio faksogramos siuntimo režimo  kvietimą. SIP nustatymai Meniu  SIP nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įgaliotasis serveris Nurodomas sistemos, konvertuojančios telefono numerį į IP adresą, kuriuo siunčiama faksograma, IP adresas. Registratorius Nurodomas sistemos, tvarkančios SIP kliento registraciją, pavadinimas arba IP adresas. Naudotojas Nurodomas SIP įgaliotojo serverio naudotojo vardas. Slaptažodis Nurodomas SIP registratoriuje naudojamas slaptažodis. Aut. ID Nurodomas SIP registratoriaus naudotojo vardas. Jei Aut. ID nustatymas nenustatytas, vietoj jo nustatymui naudojamas laukas  Naudotojas . Registracijos transportas UDP * TCP Nustatomas registracijos SIP transporto tipas. Gaunamųjų skambučių transportas UDP * TCP UDP ir TCP Nustatomas gaunamųjų skambučių SIP transporto tipas. Išsiunčiamųjų skambučių transportas UDP * TCP Nustatomas išsiunčiamųjų skambučių SIP transporto tipas. Įgaliotasis išsiuntimo serveris Nurodomas įgaliotasis išsiuntimo serveris visai SIP komunikacijai persiųsti. Kontaktinis asmuo Nurodomas SIP kontaktinio asmens vardas. Sritis Nurodomas SIP srities vardas. Jei srities nustatymas nenustatytas, vietoj jo naudojamas  Kontaktinio asmens  vardas. SIP registracijos būsena Rodoma SIP registracijos būsena. H.323 nustatymai Meniu  H.323 nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Tinklų sietuvas Nurodomas H.323 tinklų sietuvo IP adresas. Prieigos kontrolės sistema Nurodoma H.323 prieigos kontrolės sistema. Naudotojas Nurodomas naudotojo vardas, naudojamas H.323 tinklų sietuve. Slaptažodis Nurodomas H.323 tinklų sietuvo slaptažodis. Įgalinti greitąjį paleidimą Išjungta * Įjungta Įgalinamas greitasis paleidimas. Išjungti H.245 tuneliavimą Išjungta * Įjungta Išjungiamas H.323 tuneliavimas. Išjungti prieigos kontrolės sistemos atskleidimą Išjungta Įjungta * Išjungiamas H.323 prieigos kontrolės sistemos atskleidimas. T.38 nustatymai Meniu  T.38 nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Indikatoriaus perteklumas 0–5 (3*) Nustatoma, kiek kartų fakso indikatorius pasikartos T.38 ryšiu. Mažos spartos perteklumas 0–5 (3*) Nustatoma, kiek kartų mažos spartos duomenys pasikartos T.38 ryšiu. Didelės spartos perteklumas 0–5 (1*) Nustatoma, kiek kartų didelės spartos duomenys pasikartos T.38 ryšiu. meniu Faksimilinio ryšio sąranka"},{"UUID":"bb1198f7-9511-44b2-8a38-756b04408298","title":"Numatytieji fakso nustatymai","link":"fax-defaults-subgroup.html","desc":"Fakso serverio sąranka Bendrieji fakso","descFull":"Fakso serverio sąranka Bendrieji fakso nustatymai Meniu  Bendrieji fakso nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Formatuoti Nurodomas faksogramos gavėjas. Jei norite naudoti fakso numerį, prieš jį įveskite numerio ženklą (#). Atgalinis adresas Nurodomas atgalinis adresas siunčiant faksogramą. Tema Nurodoma faksogramos tema ir laiško turinys. Laiškas Įjungti analoginį priėmimą Išjungta * Įjungta Nustatoma, kad spausdintuvas priimtų analogines faksogramas. Fakso serverio elektroninio pašto nustatymai Meniu  Fakso serverio elektroninio pašto nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Naudoti el. pašto SMTP serverį Įjungta Išjungta * Faksogramoms priimti ir siųsti naudojami paprastojo pašto siuntimo protokolo (SMTP) nustatymai el. paštui. Esant nustatymui  Įjungta , visi kiti meniu  Fakso serverio elektroninio pašto nustatymai  nustatymai nerodomi. Pirminis SMTP tinklų sietuvas Įvedamas pirminio SMTP serverio IP adresas arba pagrindinio kompiuterio vardas. Pirminio SMTP tinklų sietuvo prievadas 1–65535 (25*) Įvedamas pirminio SMTP serverio prievado numeris. Antrinis SMTP tinklų sietuvas Įvedamas antrinio arba atsarginio SMTP serverio IP adresas arba pagrindinio kompiuterio vardas. Antrinio SMTP tinklų sietuvo prievadas 1–65535 (25*) Įvedamas antrinio arba atsarginio SMTP serverio prievado numeris. SMTP skirtasis laikas 5–30 (30*) Nustatoma, kada baigsis spausdintuvo skirtasis laikas, jei SMTP serveris neatsako. Atgalinis adresas Nurodomas atgalinis adresas siunčiant faksogramą. Naudoti SSL/TLS Išjungtas * Sutartinis Privalomas Nurodoma, ar faksogramą siųsti naudojant šifruotą nuorodą. Reikalauti patikimo liudijimo Išjungta Įjungta * Jungiantis prie SMTP serverio nurodomas patikimas liudijimas. SMTP serverio tapatumo nustatymas Nereikia tapatumo nustatymo * Prisijungimas / atviras tekstas NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nustatomas SMTP serverio tapatumo nustatymo tipas. Įrenginio inicijuojamas elektroninis laiškas Nėra * Naudoti įrenginio SMTP prisijungimo duomenis Nurodoma, ar įrenginio inicijuojamam el. laiškui reikalingi prisijungimo duomenys. Naudotojo inicijuojamas elektroninis laiškas Nėra * Naudoti įrenginio SMTP prisijungimo duomenis Naudoti seanso naudotojo vardą ir slaptažodį Naudoti seanso elektroninio pašto adresą ir slaptažodį Klausti apie naudotoją Nurodoma, ar naudotojo inicijuojamam el. laiškui reikalingi prisijungimo duomenys. Naudoti veikiamojo katalogo įrenginio prisijungimo duomenis Išjungta * Įjungta Prie SMTP serverio leidžiama prisijungti naudojant naudotojo prisijungimo duomenis ir grupines paskirties vietas. Įrenginio naudotojo vardas Nurodomas naudotojo vardas ir slaptažodis, skirti prisijungti prie SMTP serverio. Įrenginio slaptažodis „Kerberos 5“ sritis Nurodoma „Kerberos 5“ autentifikavimo protokolo sritis. NTLM sritis Nurodomas NTLM saugumo protokolo srities vardas. Išjungti „SMTP serveris neįdiegtas“ klaidą Išjungta* Įjungta Paslepiamas „SMTP serveris neįdiegtas“ klaidos pranešimas. Fakso serverio skenavimo nustatymai Meniu  Fakso serverio skenavimo nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Atvaizdo formatas TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Nurodomas skenuojamo vaizdo failo formatas. Turinio rūšis Tekstas * Tekstas / nuotrauka Nuotrauka Grafika Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turiniu. Turinio šaltinis Nespalvinis lazerinis spausdintuvas Spalvinis lazerinis spausdintuvas * Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo šaltiniu. Faksogramos skiriamoji geba Standartinė * Didelė Labai didelė Itin didelė Nustatoma faksogramos skiriamoji geba. Pusės Išjungta * Trumpasis kraštas Ilgasis kraštas Nurodoma dokumento originalo orientacija skenuojant abi dokumento puses. Tamsumas 1–9 (5*) Nustatomas išvedinių tamsumas. Orientacija Stačiai * Gulsčiai Nurodoma puslapio teksto ir grafikos orientacija. Originalus formatas [Popieriaus formatų sąrašas] Nurodomas dokumento originalo popieriaus formatas. Įvairūs formatai  – JAV gamyklinis numatytasis nustatymas. A4 – tarptautinis gamyklinis numatytasis nustatymas. Šis nustatymas gali skirtis priklausomai nuo spausdintuvo modelio. Naudoti kelių puslapių TIFF Išjungta Įjungta * Pasirenkami arba vieno puslapio, arba kelių puslapių TIFF failai. meniu Fakso serverio sąranka"},{"UUID":"af44f410-7c87-401b-b291-631662ec2927","title":"El. paštas","link":"email-setup-topic.html","desc":"Elektroninio pašto sąranka Meniu ","descFull":"Elektroninio pašto sąranka Meniu  Elektroninio pašto sąranka  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Pirminis SMTP tinklų sietuvas Įvedamas pirminio SMTP serverio IP adresas arba pagrindinio kompiuterio vardas el. pašto siuntimui. Pirminio SMTP tinklų sietuvo prievadas 1–65535 (25*) Įvedamas pirminio SMTP serverio prievado numeris. Antrinis SMTP tinklų sietuvas Įvedamas antrinio arba atsarginio SMTP serverio IP adresas arba pagrindinio kompiuterio vardas. Antrinio SMTP tinklų sietuvo prievadas 1–65535 (25*) Įvedamas antrinio arba atsarginio SMTP serverio prievado numeris. SMTP skirtasis laikas 5–30 sek. (30*) Nustatoma, kada baigsis spausdintuvo skirtasis laikas, jei SMTP serveris neatsako. Atgalinis adresas Elektroniniame laiške nurodomas atgalinis adresas. Visada naudoti SMTP numatytąjį atgalinį adresą Įjungta Išjungta * Visada naudojamas SMTP serveryje numatytasis atgalinis adresas. Naudoti SSL/TLS Išjungtas * Sutartinis Privalomas Nurodoma, ar el. laišką siųsti naudojant šifruotą nuorodą. Reikalauti patikimo liudijimo Išjungta Įjungta * Jungiantis prie SMTP serverio reikalaujama patikimo liudijimo. SMTP serverio tapatumo nustatymas Nereikia autentifikavimo * Prisijungimas / atviras tekstas NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nustatomas autentifikavimo tipas SMTP serveriui. Įrenginio inicijuojamas elektroninis laiškas Nėra * Naudoti įrenginio SMTP prisijungimo duomenis Nurodoma, ar įrenginio inicijuojamam el. laiškui reikalingi prisijungimo duomenys. Naudotojo inicijuojamas elektroninis laiškas Nėra * Naudoti įrenginio SMTP prisijungimo duomenis Naudoti seanso naudotojo vardą ir slaptažodį Naudoti seanso elektroninio pašto adresą ir slaptažodį Klausti apie naudotoją Nurodoma, ar naudotojo inicijuojamam el. laiškui reikalingi prisijungimo duomenys. Naudoti veikiamojo katalogo įrenginio prisijungimo duomenis Išjungta * Įjungta Nurodoma, ar naudotojo inicijuojamam el. laiškui reikalingi prisijungimo duomenys. Įrenginio naudotojo vardas Nurodomas naudotojo vardas ir slaptažodis, skirti prisijungti prie SMTP serverio. Įrenginio slaptažodis „Kerberos 5“ sritis Nurodoma „Kerberos 5“ autentifikavimo protokolo sritis. NTLM sritis Nurodomas NTLM saugumo protokolo srities vardas. Išjungti „SMTP serveris neįdiegtas“ klaidą Išjungta * Įjungta Paslepiamas „SMTP serveris neįdiegtas“ klaidos pranešimas. meniu Elektroninio pašto sąranka"},{"UUID":"24013544-3a4e-41eb-bed6-bd405d4efdfe","title":"El. paštas","link":"email-setup-topic.html","desc":"Numatytieji el. pašto nustatymai Meniu","descFull":"Numatytieji el. pašto nustatymai Meniu  Numatytieji elektroninio laiško nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Tema: Nurodoma elektroninio laiško tema ir laiško turinys. Laiškas: Failo pavadinimas Nurodomas skenuojamo dokumento failo pavadinimas. Failo formatas JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Nurodomas skenuojamo dokumento failo formatas. Šie meniu elementai gali skirtis priklausomai nuo spausdintuvo modelio. Globalieji OCR (optinio ženklų atpažinimo) nustatymai Atpažįstamos kalbos Automatiškai pasukti Panaikinti taškelius Automatiškai padidinti kontrastą Sukonfigūruojami optinio ženklų atpažinimo (OCR) nustatymai. Šis meniu elementas rodomas tik tuo atveju, jei įsigijote ir įdiegėte OCR programą. PDF nustatymai PDF versija  (1.5*) Archyvinė versija  (A‑1a*) Labai suglaudinta  ( Išjungta *) Saugi  ( Išjungta *) Archyvinė (PDF/A)  ( Išjungta *) Konfigūruojami skenuojamo dokumento PDF nustatymai. Meniu elementai  Archyvinė versija  ir  Archyvinė (PDF/A)  palaikomi tik tuo atveju, kai meniu elementas  PDF versija  yra nustatytas į 1.4. Meniu elementas  Labai suglaudinta  rodomas tik tada, kai yra įrengtas standusis diskas. Turinio rūšis Tekstas Tekstas / nuotrauka * Nuotrauka Grafika Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio rūšimi. Turinio šaltinis Nespalvinis lazerinis spausdintuvas * Spalvinis lazerinis spausdintuvas Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio šaltiniu. Spalva Nespalvotai Pilkai Spalvotai * Automatiškai Nustatoma, kad spausdintuvas failų turinį užfiksuotų spalvotai arba vienspalviai. Skiriamoji geba 75 tšk./col. 150 tšk./col. * 200 tšk./col. 300 tšk./col. 400 tšk./col. 600 tšk./col. Nurodoma skenuojamo vaizdo skiriamoji geba. Tamsumas 1–9 (5*) Koreguojamas skenuojamo vaizdo tamsumas. Orientacija Stačiai * Gulsčiai Nurodoma dokumento originalo orientacija. Originalus formatas Įvairūs formatai * Nurodomas dokumento originalo popieriaus formatas. Pusės Išjungta * Trumpasis kraštas Ilgasis kraštas Nurodoma dokumento originalo orientacija skenuojant abi dokumento puses. Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Žydra  (0*) Purpurinė  (0*) Geltona  (0*) Reguliuojamas mėlynos, purpurinės ir geltonos spalvos ryškumas. Spalvų pašalinimas Spalvų pašalinimas Nėra * Raudona Žalia Mėlyna Numatytoji ribinė raudonos spalvos vertė 0–255 (128*) Numatytoji ribinė žalios spalvos vertė 0–255 (128*) Numatytoji ribinė mėlynos spalvos vertė 0–255 (128*) Nurodoma, kurią spalvą pašalinti nuskaitant, ir pakoreguojamas tos spalvos pašalinimo nustatymas. Automatinis spalvų aptikimas Spalvų aptikimas 1–9 (5*) Ploto aptikimas 1–9 (5*) Siuntimo el. paštu gylis bitais 1 bitas * 8 bitai Minimum Scan Resolution 75 tšk./col. 150 tšk./col. 200 tšk./col. 300 tšk./col. * Sukonfigūruojamas automatinio spalvų aptikimo nustatymas. JPEG kokybė Labiausiai tinka turiniui * 5–95 Nustatoma skenuojamo vaizdo JPEG formato kokybė. Kontrastas Labiausiai tinka turiniui * 0–5 Nurodomas skenuojamo vaizdo kontrastas. Fono pašalinimas Fono aptikimas Turinio pagrindu * Fiksuotas Lygis  nuo –4 iki 4 (0*) Pašalinamas dokumento originale esantis fono atspalvis arba vaizdo triukšmas. Pasirinkus  Turinio pagrindu , pašalinamas dokumento originale esančio fono atspalvis. Pasirinkus  Fiksuotas , iš nuotraukos pašalinamas vaizdo triukšmas. Veidrodinis atvaizdas Išjungta * Įjungta Sukuriamas veidrodinis originalaus dokumento atvaizdas. Negatyvinis atvaizdas Išjungta * Įjungta Sukuriamas negatyvinis originalaus dokumento atvaizdas. Šešėlių detalės Nuo –4 iki 4 (0*) Koreguojamos šešėlių detalės skenuojamame vaizde. Skenuoti nuo krašto iki krašto Išjungta * Įjungta Dokumento originalas skenuojamas nuo krašto iki krašto. Ryškumas 1–5 (3*) Koreguojamas skenuojamo vaizdo ryškumas. Temperatūra Nuo –4 iki 4 (0*) Sugeneruojama, kas dokumento originalo išvediniai turėtų mėlynesnį ar raudonesnį atspalvį. Tušti lapai Tuščių lapų pašalinimas  ( Nepašalinti *) Tuščių lapų atpažinimas  (5*) Nustatomas skenuojamų dokumentų atpažinimas dokumento originale esančių tuščių lapų atžvilgiu. Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Maksimalus el. laiško dydis 0–65535 (0*) Kiekvienam el. laiškui nustatomas leistinas failo dydis. Dydžio klaidos pranešimas Nurodomas klaidos pranešimas, kurį spausdintuvas siunčia el. laiškui viršijus leistiną failo dydį. Galima įvesti iki 1024 ženklų. Apriboti paskirties vietas El. laiškų siuntimas apribojamas tik nurodytu sričių vardų sąrašu. Kiekviena sritis atskiriama kableliu. Siųsti man kopiją Niekada nerodoma * Numatytasis nustatymas – „Įjungta“ Numatytasis nustatymas – išjungta Visada įjungta Atsisiunčiama el. laiško kopija sau. Leisti tik el. laiškus sau Išjungta * Įjungta Nustatoma, kad spausdintuvas el. laiškus siųstų tik jums. Naudoti cc:/bcc: (kopija: / nematomoji kopija:) Išjungta * Įjungta El. laiške įgalinama kopija ir nematomoji kopija. Naudoti kelių puslapių TIFF Išjungta Įjungta * Įgalinamas kelių puslapių TIFF vaizdų skenavimas viename TIFF faile. TIFF glaudinimas JPEG LZW * Nustatomas TIFF failų glaudinimo tipas. Numatytasis nustatymas – „Tekstas“ 5–95 (75*) Nustatoma skenuojamo turinio teksto kokybė. Numatytasis nustatymas – „Tekstas / nuotrauka“ 5–95 (75*) Nustatoma skenuojamo turinio teksto ir nuotraukų kokybė. Numatytasis nustatymas – „Nuotrauka“ 5–95 (50*) Nustatoma skenuojamo turinio nuotraukų kokybė. Koreguoti ADT atvaizdo pakreipimą Išjungta * Įjungta Nustatoma, kad spausdintuvas koreguotų iš ADT skenuojamų dokumentų iškreiptus vaizdus. Perdavimo žurnalas Spausdinti žurnalą * Nespausdinti žurnalo Spausdinti tik esant klaidai Išspausdinamas el. paštu siunčiamų skenuotų vaizdų perdavimo žurnalas. Žurnalų popieriaus šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Nurodomas popieriaus šaltinis siuntimo el. paštu žurnalams spausdinti. Tinkintos užduoties nuskaitymas Išjungta * Įjungta Nustatoma, kad spausdintuvas pirmąjį dokumentų originalų rinkinį skenuotų pagal nurodytus nustatymus, o kitą rinkinį – pagal tuos pačius arba skirtingus nustatymus. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Skenuojamo dokumento peržiūra Išjungta Įjungta * Rodoma skenuojamo dokumento peržiūra. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Leisti išsaugoti kaip sparčiąją nuorodą Išjungta Įjungta * El. pašto adresas išsaugomas kaip sparčioji nuoroda. El. laiško vaizdai siunčiami kaip Priedas * Saitynas Nurodoma, kaip siųsti į el. laišką įtrauktus vaizdus. Po siuntimo iš naujo nustatyti el. laiško informaciją Išjungta Įjungta * Išsiuntus el. laišką, iš naujo nustatomi laukai „Kam“, „Tema“, „Laiškas“ ir „Failo pavadinimas“. meniu Numatytieji el. pašto nustatymai"},{"UUID":"5add7af2-11f2-4d78-832e-200c0636cc66","title":"El. paštas","link":"email-setup-topic.html","desc":"Saityno sąranka Meniu  Saityno","descFull":"Saityno sąranka Meniu  Saityno sąranka  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Serveris Nurodomi serverio, kuriame yra į el. laišką įtraukti vaizdai, prisijungimo duomenys. Prisijungimo vardas Slaptažodis Kelias Failo pavadinimas Saitynas meniu Saityno sąranka"},{"UUID":"43470b21-6481-4bff-95af-5a8ae6ca5508","title":"FTP","link":"ftp-defaults-topic.html","desc":"Numatytieji FTP nustatymai Meniu ","descFull":"Numatytieji FTP nustatymai Meniu  Numatytieji FTP nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Failo formatas JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Nurodomas skenuojamo vaizdo failo formatas. Globalieji OCR (optinio ženklų atpažinimo) nustatymai Atpažįstamos kalbos Automatiškai pasukti * Panaikinti taškelius Automatiškai padidinti kontrastą Sukonfigūruojami optinio ženklų atpažinimo (OCR) nustatymai. Šis meniu elementas rodomas tik tuo atveju, jei įsigijote ir įdiegėte OCR programą. PDF nustatymai PDF versija  (1.5*) Archyvinė versija  ( A‑1a *) Labai suglaudinta  ( Išjungta *) Saugi  ( Išjungta *) Archyvinė (PDF/A)  ( Išjungta *) Konfigūruojami skenuojamo vaizdo PDF nustatymai. Meniu elementas  Labai suglaudinta  rodomas tik tada, kai yra įrengtas standusis diskas. Turinio rūšis Tekstas Tekstas / nuotrauka * Grafika Nuotrauka Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio rūšimi. Turinio šaltinis Nespalvinis lazerinis spausdintuvas Spalvinis lazerinis spausdintuvas * Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio šaltiniu. Spalvotai Nespalvotai Pilkai Spalvotai * Automatiškai Nustatoma, kad spausdintuvas užfiksuotų failo turinį spalvotai arba vienspalviai. Skiriamoji geba 75 tšk./col. 150 tšk./col.* 200 tšk./col. 300 tšk./col. 400 tšk./col. 600 tšk./col. Nurodoma skenuojamo vaizdo skiriamoji geba. Tamsumas 1–9 (5*) Koreguojamas skenuojamo vaizdo tamsumas. Orientacija Stačiai * Gulsčiai Nurodoma dokumento originalo orientacija. Originalus formatas Įvairūs formatai * Nurodomas dokumento originalo popieriaus formatas. Pusės Išjungta * Ilgasis kraštas Trumpasis kraštas Nurodoma dokumento orientacija skenuojant abi jo puses. Failo pavadinimas Nurodomas skenuojamo vaizdo failo pavadinimas. Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Žydra  (0*) Purpurinė  (0*) Geltona  (0*) Reguliuojamas žydros, purpurinės ir geltonos spalvos ryškumas. Spalvų pašalinimas Spalvų pašalinimas  ( Joks *) Numatytoji ribinė raudonos spalvos vertė  (128*) Numatytoji ribinė žalios spalvos vertė  (128*) Numatytoji ribinė mėlynos spalvos vertė  (128*) Nurodoma, kurią spalvą pašalinti nuskaitant, ir pakoreguojamas tos spalvos pašalinimo nustatymas. Automatinis spalvų aptikimas Spalvų aptikimas  (5*) Ploto aptikimas  (5*) FTP gylis bitais  (1 bitas*) Minimali skiriamoji skenavimo geba  (300 tšk./col.*) Konfigūruojamas automatinio spalvų aptikimo nustatymas. JPEG kokybė Labiausiai tinka turiniui * 5–95 Nustatomas skenuojamo vaizdo JPEG kokybė. Kontrastas Labiausiai tinka turiniui * 0 1 2 3 4 5 Nurodomas skenuojamo vaizdo kontrastas. Fono pašalinimas Fono aptikimas ( Turinio pagrindu *) Lygis (0*) Iš dokumento originalo pašalinamas fono atspalvis arba vaizdo triukšmas. Pasirinkus  Turinio pagrindu  iš dokumento originalo pašalinamas fono atspalvis. Pasirinkus  Fiksuotas  iš nuotraukos pašalinamas vaizdo triukšmas. Veidrodinis atvaizdas Išjungta * Įjungta Sukuriamas veidrodinis originalaus dokumento atvaizdas. Negatyvinis atvaizdas Išjungta * Įjungta Sukuriamas negatyvinis originalaus dokumento atvaizdas. Šešėlių detalės Nuo –4 iki 4 (0*) Koreguojamos šešėlių detalės skenuojamame vaizde. Skenuoti nuo krašto iki krašto Išjungta * Įjungta Dokumento originalą leidžiama skenuoti nuo krašto iki krašto. Ryškumas 1–5 (3*) Koreguojamas skenuojamo vaizdo ryškumas. Temperatūra Nuo –4 iki 4 (0*) Sugeneruojama mėlynesnė arba raudonesnė dokumento originalo išvestis. Tušti lapai Tuščių lapų pašalinimas  ( Pašalinti *) Tuščių lapų aptikimas  (5*) Nustatomas skenuojamų vaizdų aptikimas, susijęs su tuščiais dokumento originalo puslapiais. Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Numatytasis nustatymas – „Tekstas“ 5–95 (75*) Nustatoma teksto kokybė skenuojamame vaizde. Numatytasis nustatymas – „Tekstas / nuotrauka“ 5–95 (75*) Nustatoma teksto ir nuotraukos kokybė skenuojamame vaizde. Numatytasis nustatymas – „Nuotrauka“ 5–95 (50*) Nustatoma nuotraukos kokybė skenuojamame vaizde. Naudoti kelių puslapių TIFF Įjungta * Išjungta Įgalinamas kelių TIFF vaizdų skenavimas į vieną TIFF failą. TIFF glaudinimas LZW * JPEG Nustatomas TIFF failų glaudinimo tipas. Perdavimo žurnalas Spausdinti žurnalą * Nespausdinti žurnalo Spausdinti tik esant klaidai Atspausdinamas į FTP perduotų nuskenuotų dokumentų žurnalas. Žurnalų popieriaus šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Nurodomas popieriaus šaltinis FTP žurnalams spausdinti. Tinkintos užduoties nuskaitymas Išjungta * Įjungta Nustatoma, kad pagal nurodytus nustatymus spausdintuvas skenuotų pirmąjį originalių dokumentų rinkinį, o po to skenuotų kitą rinkinį esant tiems patiems arba skirtingiems nustatymams. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Nuskaitymo peržiūra Išjungta Įjungta * Rodoma dokumento originalo peržiūra. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Leisti išsaugoti kaip sparčiąją nuorodą Išjungta Įjungta * FTP adresas išsaugomas kaip sparčioji nuoroda. meniu Numatytieji FTP nustatymai"},{"UUID":"3793d3db-1c96-4b5a-b1c7-846f44fb0a7f","title":"USB atmintukas","link":"flash-drive-scan-topic.html","desc":"Skenavimas iš atmintuko Meniu ","descFull":"Skenavimas iš atmintuko Meniu  Skenavimas iš atmintuko  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Failo formatas JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Nurodomas skenuojamo vaizdo failo formatas. Globalieji OCR (optinio ženklų atpažinimo) nustatymai Atpažįstamos kalbos Automatiškai pasukti Panaikinti taškelius Automatiškai padidinti kontrastą Sukonfigūruojami optinio ženklų atpažinimo (OCR) nustatymai. Šis meniu elementas rodomas tik tuo atveju, jei įsigijote ir įdiegėte OCR programą. PDF nustatymai PDF versija  (1.5*) Archyvinė versija  (A‑1a*) Labai suglaudinta  ( Išjungta *) Saugi  ( Išjungta *) Archyvinė (PDF/A)  ( Išjungta *) Konfigūruojami skenuojamo vaizdo PDF nustatymai. Meniu elementai  Archyvinė versija  ir  Archyvinė (PDF/A)  palaikomi tik tuo atveju, kai meniu elementas  PDF versija  yra nustatytas į 1.4. Meniu elementas  Labai suglaudinta  rodomas tik tada, kai yra įrengtas standusis diskas. Turinio rūšis Tekstas Tekstas / nuotrauka * Grafika Nuotrauka Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio rūšimi. Turinio šaltinis Nespalvinis lazerinis spausdintuvas Spalvinis lazerinis spausdintuvas * Rašalinis spausdintuvas Nuotrauka / fotojuosta Žurnalas Laikraštis Presas Kita Pagerinamas išvedinių rezultatas, pagrįstas dokumento originalo turinio šaltiniu. Spalva Nespalvotai Pilkai Spalvotai * Automatiškai Nustatoma, kad spausdintuvas failų turinį užfiksuotų spalvotai arba vienspalviai. Skiriamoji geba 75 tšk./col. 150 tšk./col.* 200 tšk./col. 300 tšk./col. 400 tšk./col. 600 tšk./col. Nurodoma skenuojamo vaizdo skiriamoji geba. Tamsumas 1–9 (5*) Koreguojamas skenuojamo vaizdo tamsumas. Orientacija Stačiai * Gulsčiai Nurodoma dokumento originalo orientacija. Originalus formatas Įvairūs formatai * Nurodomas dokumento originalo popieriaus formatas. Pusės Išjungta * Ilgasis kraštas Trumpasis kraštas Nurodoma dokumento originalo orientacija skenuojant abi dokumento puses. Failo pavadinimas Nurodomas skenuojamo vaizdo failo pavadinimas. Išplėstinis vaizdo gavimas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Spalvų balansas Žydra (0*) Purpurinė (0*) Geltona (0*) Reguliuojamas mėlynos, purpurinės ir geltonos spalvos ryškumas. Spalvų pašalinimas Spalvų pašalinimas  ( Nėra *) Numatytoji ribinė raudonos spalvos vertė (128*) Numatytoji ribinė žalios spalvos vertė (128*) Numatytoji ribinė mėlynos spalvos vertė (128*) Nurodoma, kurią spalvą pašalinti nuskaitant, ir pakoreguojamas tos spalvos pašalinimo nustatymas. Automatinis spalvų aptikimas Spalvų atpažinimas (5*) Ploto atpažinimas  (5*) Skenavimo gylis bitais  (1 bitas*) Minimali skiriamoji skenavimo geba  (300 tšk./col.*) Sukonfigūruojamas automatinio spalvų aptikimo nustatymas. JPEG kokybė Labiausiai tinka turiniui * 5–95 Nustatoma skenuojamo vaizdo JPEG formato kokybė. Kontrastas Labiausiai tinka turiniui * 0–5 Nurodomas skenuojamo vaizdo kontrastas. Fono pašalinimas Fono aptikimas Turinio pagrindu * Fiksuotas Lygis (0*) Pašalinamas dokumento originale esantis fono atspalvis arba vaizdo triukšmas. Pasirinkus  Turinio pagrindu , pašalinamas dokumento originale esančio fono atspalvis. Pasirinkus  Fiksuotas , iš nuotraukos pašalinamas vaizdo triukšmas. Veidrodinis atvaizdas Išjungta * Įjungta Sukuriamas veidrodinis originalaus dokumento atvaizdas. Negatyvinis atvaizdas Išjungta * Įjungta Sukuriamas negatyvinis originalaus dokumento atvaizdas. Šešėlių detalės Nuo –4 iki 4 (0*) Koreguojamos šešėlių detalės skenuojamame vaizde. Nuskaityti nuo krašto iki krašto Išjungta * Įjungta Dokumento originalas skenuojamas nuo krašto iki krašto. Ryškumas 1–5 (3*) Koreguojamas skenuojamo vaizdo ryškumas. Temperatūra Nuo –4 iki 4 (0*) Sugeneruojama mėlynesnė arba raudonesnė dokumento originalo išvestis. Tušti puslapiai Tuščių lapų pašalinimas  ( Pašalinti *) Tuščių lapų atpažinimas  (5*) Nustatomas skenuojamų dokumentų atpažinimas dokumento originale esančių tuščių lapų atžvilgiu. Administratoriaus valdymas Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Numatytasis nustatymas – „Tekstas“ 5–95 (75*) Nustatoma teksto kokybė skenuojamame vaizde. Numatytasis nustatymas – „Tekstas / nuotrauka“ 5–95 (75*) Nustatoma teksto arba nuotraukos kokybė skenuojamame vaizde. Numatytasis nustatymas – „Nuotrauka“ 5–95 (50*) Nustatoma nuotraukos kokybė skenuojamame vaizde. Naudoti kelių puslapių TIFF Išjungta Įjungta * Įgalinamas kelių puslapių TIFF vaizdų skenavimas viename TIFF faile. TIFF glaudinimas LZW * JPEG Nustatomas TIFF failų glaudinimo tipas. Tinkintos užduoties nuskaitymas Išjungta * Įjungta Nustatoma, kad spausdintuvas pirmąjį dokumentų originalų rinkinį skenuotų pagal nurodytus nustatymus, o kitą rinkinį skenuotų esant tiems patiems arba skirtingiems nustatymams. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Skenuojamo dokumento peržiūra Išjungta Įjungta * Rodoma skenuojamo dokumento peržiūra. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. Koreguoti ADT atvaizdo pakreipimą Išjungta Įjungta * Nustatoma, kad spausdintuvas koreguotų iš ADT skenuojamų dokumentų iškreiptus vaizdus. meniu Skenavimas iš atmintuko"},{"UUID":"a873f321-6002-437c-89a9-4e0bf5bde253","title":"USB atmintukas","link":"flash-drive-scan-topic.html","desc":"Spausdinimas iš atmintuko Meniu ","descFull":"Spausdinimas iš atmintuko Meniu  Spausdinimas iš atmintuko  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Kopijų skaičius 1-9999 (1*) Nustatomas kopijų skaičius. Popieriaus šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Rankiniu būdu įdedamas popierius Rankiniu būdu įdedami vokai Nustatomas spausdinimo užduoties popieriaus šaltinis. Sudėstyti (1,1,1) (2,2,2) (1,2,3) (1,2,3)* Spausdinimo užduoties puslapiai sudėliojami iš eilės, ypač spausdinant keletą užduoties kopijų. Pusės Vienpusis * Dvipusis Nurodoma, ar bus spausdinama iš vienos popieriaus pusės ar iš abiejų. Susegimas Išjungta * 1 sąsagėlė, viršutiniame kairiajame kampe 2 sąsagėlės, kairėje 1 sąsagėlė, viršutiniame dešiniajame kampe 2 sąsagėlės, viršuje 1 sąsagėlė, apatiniame kairiajame kampe 2 sąsagėlės, apačioje 1 sąsagėlė, apatiniame dešiniajame kampe 2 sąsagėlės, dešinėje 4 sąsagėlės Nurodoma sąsagėlių padėtis visoms spausdinimo užduotims. Šis meniu elementas rodomas tik tada, kai yra įrengtas segiklis. Skylmuša Išjungta * 2 skylės 3 skylės 4 skylės Visoms spausdinimo užduotims nustatoma skylių mušimo veiksena. Šis meniu elementas rodomas tik tada, kai segiklis, skylmuša yra įrengti. Sukomplektuoti lapus Nėra * Tarp kopijų Tarp užduočių Sukomplektuojami kiekvienos spausdinimo užduoties spaudiniai arba kiekviena spausdinimo užduoties kopija. Esant nustatymui  Tarp kopijų  sukomplektuojama kiekviena spausdinimo užduoties kopija, jei parinktis  Sudėstyti  nustatyta į  Įjungta  [1,2,1,2,1,2]. Jei parinktis  Sudėstyti  nustatyta į  Išjungta  [1,1,1,2,2,2], kiekvienas atspausdintų puslapių rinkinys sukomplektuojamas į visus pirmuosius (1) puslapius ir visus antruosius (2) puslapius. Esant nustatymui  Tarp užduočių  visai spausdinimo užduočiai nustatoma ta pati komplektavimo pozicija nepriklausomai nuo spausdinamų kopijų skaičiaus. Apvertimo stilius Ilgasis kraštas * Trumpasis kraštas Nustatoma, kuriuo popieriaus kraštu įrišama, kai spausdinama iš abiejų pusių. Puslapiai vienoje pusėje Išjungta * 2 puslapiai vienoje pusėje 3 puslapiai vienoje pusėje 4 puslapiai vienoje pusėje 6 puslapiai vienoje pusėje 9 puslapiai vienoje pusėje 12 puslapių vienoje pusėje 16 puslapių vienoje pusėje Kelių puslapių atvaizdai spausdinami ant vienos popieriaus lapo pusės. Puslapių vienoje pusėje rikiavimas Horizontaliai * Horizontaliai atvirkštine tvarka Vertikaliai atvirkštine tvarka Vertikaliai Naudojant meniu  Puslapiai vienoje pusėje  nurodoma, kaip bus išdėstyti kelių puslapių atvaizdai. Puslapių vienoje pusėje orientacija Automatiškai * Gulsčiai Stačiai Naudojant meniu  Puslapiai vienoje pusėje  nurodoma, kokia bus kelių puslapių atvaizdų orientacija. Puslapių vienoje pusėje rėmelis Nėra * Ištisinis Naudojant meniu  Puslapiai vienoje pusėje  aplink kiekvieną puslapyje esantį atvaizdą atspausdinamas rėmelis. Skiriamieji lapai Išjungta * Tarp kopijų Tarp užduočių Tarp puslapių Spausdinant įterpiami tušti skiriamieji lapai. Skiriamųjų lapų šaltinis Dėklas  [x] (1*) Daugiafunkcis tiektuvas Nurodomas skiriamųjų lapų popieriaus šaltinis. Tušti puslapiai Nespausdinti * Spausdinimas Spausdinimo užduotyje spausdinami tušti puslapiai. meniu Spausdinimas iš atmintuko"},{"UUID":"57210a8e-a524-4ca2-bbe7-39e1124dc88e","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"Tinklo apžvalga Meniu  Tinklo","descFull":"Tinklo apžvalga Meniu  Tinklo apžvalga  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Aktyvus adapteris Automatinė * Tipinis tinklas Belaidis ryšys Nurodomas tinklo ryšio tipas. Meniu elementas  Belaidis ryšys  galimas tik spausdintuvuose, prijungtuose prie belaidžio tinklo. Tinklo būsena Rodoma spausdintuvo prijungimo prie tinklo būsena. Rodyti spausdintuvo tinklo būseną Išjungta Įjungta * Ekrane rodoma tinklo būsena. Sparta, dvipusis spausdinimas Rodoma šiuo metu aktyvios tinklo plokštės sparta. IPv4 Rodomas IPv4 adresas. Visi IPv6 adresai Rodomi visi IPv6 adresai. Iš naujo nustatyti spausdintuvo serverį Iš naujo nustatomos visos aktyvios spausdintuvo tinklo jungtys. Šiuo nustatymu pašalinami visi tinklo konfigūracijos parametrai. Tinklo užduoties skirtasis laikas Išjungta Įjungta * (90  sekundžių ) Nustatomas laikas, iki spausdintuve atšaukiama tinklo spausdinimo užduotis. Reklamjuostės puslapis Išjungta * Įjungta Atspausdinamas reklamjuostės puslapis. Nuskaityti į kompiuterio prievadų sritį Nurodoma spausdintuvams tinkama prievadų, esančių už prievadų blokavimo užkardos, sritis. Įgalinti tinklo jungtis Išjungta Įjungta * Leidžiama spausdintuvui prisijungti prie tinklo. Įgalinti LLDP Išjungta * Įjungta Spausdintuve įgalinamas jungties lygmens aptikimo protokolas ( angl. Link Layer Discovery Protocol (LLDP). meniu Tinklo apžvalga"},{"UUID":"ad80f3a4-241a-4bcb-9b50-a693ab5df97f","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"Belaidis ryšys Šis meniu yra","descFull":"Belaidis ryšys Šis meniu yra galimas tik prie „Wi-Fi“ tinklo prijungtuose spausdintuvuose arba spausdintuvuose su belaidžio tinklo adapteriu. Belaidžio ryšio  nustatymai ir jų paaiškinimai Meniu elementas Paaiškinimas Sąranka naudojant mobiliąją programą „Wi-Fi“ ryšys sukonfigūruojamas naudojant „Lexmark Mobile Assistant“. Sąranka spausdintuvo valdymo skydelyje Pasirinkti tinklą Pridėti „Wi-Fi“ tinklą Tinklo pavadinimas Tinklo režimas Infrastruktūrinis Belaidžio tinklo saugumo režimas Išjungtas * WEP WPA2 / WPA – asmeninis WPA2 asmeninis 802.1X – RADIUS „W-Fi“ ryšys sukonfigūruojamas naudojant valdymo skydelį. 802.1x - RADIUS  galima sukonfigūruoti tik įtaisytajame tinklo serveryje (EWS). „Wi‑Fi“ apsaugota sąranka WPS automatinis aptikimas Išjungta Įjungta * Mygtukinis prijungimo metodas Prijungimo metodas naudojant PIN kodą Nustatomas „Wi-Fi“ tinklas ir įgalinama tinklo apsauga. Meniu elementas  WPS automatinis aptikimas  rodomas tik tada, kai  Belaidžio ryšio saugumo režimas  nustatytas kaip  WEP . Pasirinkus nustatymą  Mygtukinis prijungimo metodas  spausdintuvas prie „Wi-Fi“ tinklo prijungiamas per tam tikrą laiką paspaudžiant ir spausdintuvo, ir prieigos taško (belaidžio maršruto parinktuvo) mygtukus. Pasirinkus nustatymą  Prijungimo metodas naudojant PIN kodą  spausdintuvas prie „W-Fi“ tinklo prijungiamas spausdintuvo PIN kodą įvedant į prieigos taško belaidžio tinklo nustatymus. Tinklo režimas BSS tipas Infrastruktūrinis * Nurodomas tinklo režimas. Suderinama 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz / 5 GHz) 802.11a/n/ac (5 GHz) „Wi-Fi“ tinklui nurodomas belaidžio ryšio standartas. Meniu elementai  802.11a/b/g/n/ac (2,4 GHz / 5 GHz)  ir  802.11a/n/ac (5 GHz)  rodomi tik tada, kai yra įdiegta pasirinktinė „Wi‑Fi“ įranga. Belaidžio tinklo saugumo režimas Išjungtas * WEP WPA2 / WPA – asmeninis WPA2 – asmeninis 802.1X – RADIUS Nustatomas spausdintuvo prijungimo prie „Wi-Fi“ įrenginių saugumo režimas. 802.1x - RADIUS  galima sukonfigūruoti tik įtaisytajame tinklo serveryje (EWS). WEP tapatumo nustatymo režimas Automatinis * Atviras Bendras Nustatomas spausdintuvo naudojamo belaidžio šifravimo protokolo (WEP) tipas. Šis meniu elementas rodomas tik tada, kai  Belaidžio tinklo saugumo režimas  nustatytas kaip  WEP . Nustatyti WEP raktą Nurodomas saugaus „Wi-Fi“ ryšio WEP slaptažodis. WPA2 / WPA asmeninis AES Įgalinamas „Wi-Fi“ ryšio saugumas naudojant apsaugotąją „Wi-Fi“ prieigą (WPA). Šis meniu elementas rodomas tik tada, kai  Belaidžio tinklo saugumo režimas  nustatytas kaip  WPA2/WPA – asmeninis . Nustatyti bendrąjį raktą Nustatomas saugaus „Wi-Fi“ ryšio slaptažodis. WPA2 – asmeninis AES Įgalinamas „Wi-Fi“ ryšio saugumas naudojant WPA2. Šis meniu elementas rodomas tik tada, kai  Belaidžio tinklo saugumo režimas  nustatytas kaip  WPA2 – asmeninis . 802.1x šifravimo režimas WPA+ WPA2 * Įgalinamas „Wi-Fi“ ryšio saugumas naudojant 802.1x standartą. Šis meniu elementas rodomas tik tada, kai  Belaidžio tinklo saugumo režimas  nustatytas kaip  802.1x - RADIUS . 802.1x - RADIUS  galima sukonfigūruoti tik įtaisytajame tinklo serveryje (EWS). IPv4 Įjungti DHCP Įjungta * Išjungta Nustatyti statinį IP adresą IP adresas Tinklo kaukė Tinklų sietuvas Spausdintuve įgalinami ir sukonfigūruojami IPv4 nustatymai. IPv6 Įjungti IPv6 Įjungta * Išjungta Įjungti DHCPv6 Įjungta Išjungta * Automatinė neįsimenamojo adreso konfigūracija Įjungta * Išjungta DNS serverio adresas Rankiniu būdu priskiriamas IPv6 adresas Rankiniu būdu priskiriamas IPv6 maršruto parinktuvas Adreso priešdėlis Visi IPv6 adresai Visi IPv6 maršruto parinktuvo adresai Spausdintuve įgalinami ir sukonfigūruojami IPv6 nustatymai. Tinklo adresas UAA LAA Peržiūrimi tinklo adresai. „PCL SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų automatiškai perjungiamas į PCL emuliaciją, kai ji reikalinga spausdinimo užduočiai atlikti, nepriklausomai nuo numatytosios spausdintuvo kalbos. Parinkčiai  PCL SmartSwitch  esant išjungtai, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. „PS SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų automatiškai perjungiamas į PS emuliaciją, kai ji reikalinga spausdinimo užduočiai atlikti, nepriklausomai nuo numatytosios spausdintuvo kalbos. Parinkčiai  PS SmartSwitch  esant išjungtai, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. Užduoties suderinimas Įjungta Išjungta * Prieš spausdinant, spausdinimo užduotys laikinai išsaugomos spausdintuvo standžiajame diske. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. „Mac“ dvejetainė PS Automatinis * Įjungta Išjungta Nustatoma, kad spausdintuvas galėtų apdoroti „Macintosh“ dvejetainės „PostScript“ spausdinimo užduotis. Pasirinkus nustatymą  Įjungta , apdorojamos neapdorotos dvejetainės „PostScript“ spausdinimo užduotys. Pasirinkus nustatymą  Išjungta , spausdinimo užduotys filtruojamos naudojant standartinį protokolą. meniu Belaidis ryšys"},{"UUID":"5ee91d38-4d85-4712-a9f0-ce7798a0d746","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"„Wi‑Fi Direct“ Meniu  Wi‑Fi","descFull":"„Wi‑Fi Direct“ Meniu  Wi‑Fi Direct  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įjungti „Wi‑Fi Direct“ Įjungta Išjungta * Nustatoma, kad spausdintuvas tiesiogiai prisijungtų prie „Wi-Fi“ įrenginių. „Wi‑Fi Direct“ vardas Nurodomas „Wi-Fi Direct“ tinklo vardas. „Wi‑Fi Direct“ slaptažodis Nustatomas slaptažodis, kad būtų galima nustatyti ir patikrinti „Wi-Fi“ ryšio naudotojų tapatybę. Rodyti slaptažodį sąrankos puslapyje Išjungta Įjungta * „Wi‑Fi Direct“ slaptažodis  rodomas  Tinklo sąrankos puslapyje . Pageidaujamas kanalo numeris 1–11 Automatiškai * Nustatomas pageidaujamas „Wi‑Fi“ tinklo kanalas. Grupės savininko IP adresas Nurodomas grupės savininko IP adresas. Automatiškai priimti mygtukinio prijungimo užklausas Išjungta * Įjungta Automatiškai priimamos užklausos prisijungti prie tinklo. Automatinis klientų priėmimas nėra apsaugotas. meniu „Wi‑Fi Direct“"},{"UUID":"7f2edb85-9b59-4fad-8b64-c416d3634efc","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"„AirPrint“ * Šis meniu rodomas","descFull":"„AirPrint“ * Šis meniu rodomas tik įtaisytajame interneto serveryje (EWS). Meniu  AirPrint  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Visos „AirPrint“ funkcijos Rodoma spausdintuvo „AirPrint“ būsena. Įgalinti „AirPrint“ Įjungta * Išjungta Įjungiama „AirPrint“ funkcija. Šis meniu elementas rodomas tik tada, kai interneto spausdinimo protokolas (IPP) arba mDNS yra išjungti. Pasisveikinimo vardas Nustatykite spausdintuvo priskirtį ir vietą. Organizacijos pavadinimas Organizacijos padalinys Spausdintuvo vieta Spausdintuvo platuma Spausdintuvo ilguma Spausdintuvo altitudė Daugiau parinkčių meniu „AirPrint“"},{"UUID":"1b2fd93e-5e7b-4f16-8b68-9264998ed856","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"Mobiliųjų paslaugų valdymas * Šis","descFull":"Mobiliųjų paslaugų valdymas * Šis meniu rodomas tik įtaisytajame interneto serveryje (EWS). Meniu  Mobiliųjų paslaugų valdymas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įgalinti IPP spausdinimą Įjungta * Išjungta Leidžiama spausdinti iš mobiliųjų prietaisų naudojant interneto spausdinimo protokolą (IPP). Įgalinti IPP faksogramų siuntimą Įjungta * Išjungta Leidžiama siųsti faksogramas naudojant interneto spausdinimo protokolą (IPP). Įgalinti IPP per USB Įjungta * Išjungta Leidžiama spausdinti arba nuskaityti užduotis naudojant USB jungtį. Įgalinti nuskaitymą Įjungta * Išjungta Leidžiama nuskaityti naudojant eScL protokolą. Įgalinti „Mopria“ aptikimą Įjungta * Išjungta Leiskite prietaisams su įjungta „Mopria“ aptikti spausdintuvą. meniu Mobiliųjų paslaugų valdymas"},{"UUID":"d3fac4ac-4052-4e23-ad03-1d243e76afac","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"Eternetas Meniu  Eternetas ","descFull":"Eternetas Meniu  Eternetas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Tinklo sparta Rodoma aktyvaus tinklo adapterio veikimo sparta. IPv4 Įjungti DHCP  ( Įjungta *) Nustatyti statinį IP adresą Konfigūruojami IPv4 nustatymai. IPv6 Įjungti IPv6  ( Įjungta *) Įjungti DHCPv6  ( Išjungta *) Automatinė neįsimenamojo adreso konfigūracija  ( Įjungta *) DNS serverio adresas Rankiniu būdu priskiriamas IPv6 adresas Rankiniu būdu priskiriamas IPv6 maršruto parinktuvas Adreso priešdėlis (64*) Visi IPv6 adresai Visi IPv6 maršruto parinktuvo adresai Konfigūruojami IPv6 nustatymai. Tinklo adresas UAA LAA Nurodomas tinklo adresas. „PCL SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų automatiškai perjungiamas į PCL emuliaciją, kai ji reikalinga spausdinimo užduočiai atlikti, nepriklausomai nuo numatytosios spausdintuvo kalbos. Šiam nustatymui esant išjungtam, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. „PS SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų automatiškai perjungiamas į „PostScript“ emuliaciją, kai ji reikalinga spausdinimo užduočiai atlikti, nepriklausomai nuo numatytosios spausdintuvo kalbos. Šiam nustatymui esant išjungtam, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. Užduoties suderinimas Išjungta * Įjungta Prieš spausdinant, užduotys laikinai išsaugomos standžiajame diske. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. „Mac“ dvejetainė PS Automatinė * Įjungta Išjungta Nustatoma, kad spausdintuvas galėtų apdoroti „Macintosh“ dvejetainės „PostScript“ spausdinimo užduotis. Esant parinkčiai  Automatiškai , spausdintuvas apdoroja spausdinimo užduotis iš kompiuterių, kuriuose naudojamos „Windows“ arba „Macintosh“ operacinės sistemos. Pasirinkus nustatymą  Išjungta , spausdinimo užduotys filtruojamos naudojant standartinį protokolą. Efektyviai energiją vartojantis eternetas Įjungta Išjungta Automatinė * Sumažinamas energijos suvartojimas spausdintuvui negaunant duomenų iš eterneto tinklo. meniu Eternetas"},{"UUID":"8a441567-bc2e-4c14-8152-934dfdebac45","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"TCP / IP Šis meniu","descFull":"TCP / IP Šis meniu rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. Meniu  TCP/IP  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Nustatyti pagrindinio kompiuterio vardą Nustatomas esamas TCP / IP pagrindinio kompiuterio vardas. Srities vardas Nustatomas srities vardas. Leisti DHCP / BOOTP atnaujinti NTP serverį Įjungta * Išjungta DHCP ir BOOTP klientai gali atnaujinti spausdintuvo NTP nustatymus. Nulinės konfigūracijos pavadinimas Nurodomas nulinės konfigūracijos tinklo paslaugos pavadinimas. Įjungti automatinį IP Įjungta * Išjungta IP adresas priskiriamas automatiškai. DNS serverio adresas Nurodomas dabartinis sričių vardų sistemos (DNS) serverio adresas. Atsarginės kopijos DNS serverio adresas Nurodomi atsarginės kopijos DNS serverio adresai. 2 atsarginės kopijos DNS serverio adresas 3 atsarginės kopijos DNS serverio adresas Sričių paieškos tvarka Nurodomas sričių vardų sąrašas, kad būtų galima rasti spausdintuvą ir jo išteklius, esančius skirtingose tinklo srityse. Įjungti DDNS Išjungta * Įjungta Atnaujinami dinaminės DNS nustatymai. DDNS TTL 300–31536000 sekundžių (3600*) Nurodomi dabartiniai DDNS nustatymai. Numatytasis TTL 5–254 sekundės (254*) DDNS atnaujinimo laikas 300–31536000 sekundžių (604800*) Įjungti „mDNS“ Įjungta * Išjungta Atnaujinami daugiaadresės DNS nustatymai. WINS serverio adresas Nurodomas „Windows“ interneto vardų (WINS) serverio adresas. Įjungti BOOTP Išjungta * Įjungta BOOTP gali priskirti spausdintuvo IP adresą. Apribotas serverių sąrašas Nurodomas TCP jungčių IP adresas. Kiekvienas IP adresas atskiriamas kableliu. Galima pridėti iki 50 IP adresų. Apriboto serverių sąrašo parinktys Blokuoti visus prievadus * Blokuoti tik spausdinimą Blokuoti tik spausdinimą ir HTTP Nurodoma, kaip sąraše esantys IP adresai gali pasiekti spausdintuvo funkcijas. MTU 256–1500 (1500*) Nurodomas didžiausio perdavimo vieneto (MTU) parametras TCP prisijungimams. RAW spausdintuvo prievadas 1–65535 (9100*) Nurodomas prie tinklo prijungtų spausdintuvų RAW prievadų skaičius. Didžiausia duomenų išsiuntimo sparta Išjungtas * Įjungta 100–1000000 (100000*) Įgalinama didžiausia spausdintuvo duomenų perdavimo sparta. Įgalinti TLSv1.0 Įjungta * Išjungta Įgalinamas TLSv1.0 protokolas. Įgalinti TLSv1.1 Įjungta * Išjungta Įgalinamas TLSv1.1 protokolas. SSL šriftų sąrašas Nurodomi šriftų algoritmai, kurie bus naudojami SSL arba TLS ryšiui. meniu TCP / IP"},{"UUID":"7b013a46-bc9a-41b0-b06d-d9d2aa22623e","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"SNMP Šis meniu rodomas tik","descFull":"SNMP Šis meniu rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. Meniu  SNMP  elementai ir paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. 1 ir 2c SNMP versijos Įjungta Išjungta Įjungta * Leisti įdiegti SNMP Išjungta Įjungta * Įjungti PPM MIB Išjungta Įjungta * SNMP bendruomenė Sukonfigūruojamos paprastojo tinklo valdymo protokolo (angl. Simple Network Management Protocol, SNMP) 1 ir 2c versijos, kad būtų galima įdiegti spausdinimo tvarkykles ir programas. 3 SNMP versija Įjungta Išjungta Įjungta * Kontekstinis pavadinimas Nustatyti skaitymo ir rašymo prisijungimo duomenis Naudotojo vardas Autentifikavimo slaptažodis Privatumo slaptažodis Nustatyti pastoviuosius prisijungimo duomenis Naudotojo vardas Autentifikavimo slaptažodis Privatumo slaptažodis Autentifikavimo maiša MD5 SHA1 * Minimalus autentifikavimo lygis Be autentifikavimo, be privatumo Autentifikavimas, be privatumo Autentifikavimas, privatumas * Privatumo algoritmas DES AES‑128 * Sukonfigūruojama SNMP 3 versija, kad būtų galima įdiegti ir atnaujinti spausdintuvo saugumą. meniu SNMP"},{"UUID":"ca209617-d78c-468c-8952-80e3b52942d4","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"IPSec Šis meniu rodomas tik","descFull":"IPSec Šis meniu rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. IPSec  meniu elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įjungti IPSec Išjungta * Įjungta Įjungiama interneto protokolo apsauga (angl. Internet Protocol Security, IPSec). Bazinė konfigūracija Numatytoji * Suderinama Saugi Nustatoma bazinė IPSec konfigūracija. Šis meniu elementas rodomas tik tada, kai parinktis  Įjungti IPSec  yra nustatyta į  Įjungta . DH (Diffie-Hellman) grupės pasiūlymas modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Nustatoma bazinė IPSec konfigūracija. Šis meniu elementas rodomas tik tada, kai parinktis  Bazinė konfigūracija  yra nustatyta į  Suderinama . Siūlomas užšifravimo metodas 3DES AES * Nustatymas užšifravimo metodas. Šis meniu elementas rodomas tik tada, kai parinktis  Bazinė konfigūracija  yra nustatyta į  Suderinama . Siūlomas autentifikavimo metodas SHA1 SHA256 * SHA512 Nustatomas autentifikavimo metodas. Šis meniu elementas rodomas tik tada, kai parinktis  Bazinė konfigūracija  yra nustatyta į  Suderinama . IKE SA naudojimo trukmė (valandos) 1 2 4 8 24* Nurodoma IKE SA naudojimo trukmė. Šis meniu elementas rodomas tik tada, kai parinktis  Bazinė konfigūracija  yra nustatyta į  Saugi . IPSec SA naudojimo trukmė (valandos) 1 2 4 8* 24 Nurodoma IPSec SA naudojimo trukmė. Šis meniu elementas rodomas tik tada, kai parinktis  Bazinė konfigūracija  yra nustatyta į  Saugi . IPSec įrenginio sertifikatas Nurodomas IPSec sertifikatas. Šis meniu elementas rodomas tik tada, kai parinktis  Įjungti IPSec  yra nustatyta į  Įjungta . Bendruoju raktu (Pre-Shared Key) autentifikuojami prisijungimai Kompiuteris  [x] Sukonfigūruojami autentifikuojami spausdintuvo prisijungimai. Šie meniu elementai rodomi tik tada, kai parinktis  Įjungti IPSec  yra nustatyta į  Įjungta . Sertifikatu autentifikuojami prisijungimai Kompiuterio  [x]  adresas [/potinklis] meniu IPSec"},{"UUID":"03ab250b-8175-4129-94ee-a61eb822b5ca","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"802.1x Šis meniu rodomas tik","descFull":"802.1x Šis meniu rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. Meniu  802.1x  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Aktyvus Išjungta * Įjungta Spausdintuvas gali prisijungti prie tinklų, kuriuose prieš suteikiant prieigą reikalaujama autentifikavimo. 802.1x autentifikavimas Įrenginio prisijungimo vardas Įrenginio prisijungimo slaptažodis Patikrinti serverio sertifikatą  ( Įjungta *) Įgalinti įvykių registravimą  ( Išjungta *) 802.1x įrenginio sertifikatas Sukonfigūruojami 802.1x ryšio autentifikavimo nustatymai. Leistini autentifikavimo mechanizmai EAP ‑ MD5  ( Įjungta *) EAP - MSCHAPv2  ( Įjungta *) LEAP  ( Įjungta *) PEAP  ( Įjungta *) EAP - TLS  ( Įjungta *) EAP - TTLS  ( Įjungta *) TTLS autentifikavimo metodas  ( MSCHAPv2 *) Sukonfigūruojami leistini 802.1x ryšio autentifikavimo mechanizmai. meniu 802.1x"},{"UUID":"00e39f3a-749a-4bd6-ba0a-f7bd1efbda58","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"LPD konfigūracija Šis meniu rodomas","descFull":"LPD konfigūracija Šis meniu rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. Meniu  LPD konfigūracija  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. LPD skirtasis laikas 0–65535 sek. (90*) Nustatoma skirtojo laiko vertė, kad linijinio spausdintuvo posistemio (angl. Line Printer Daemon, LPD) serveris užstrigusių ar netinkamų spausdinimo užduočių nelauktų neribotą laiką. LPD reklamjuostės puslapis Išjungta * Įjungta Visoms LPD spausdinimo užduotims atspausdinamas reklamjuostės puslapis. Reklamjuostės puslapis – pirmasis spausdinimo užduoties puslapis, naudojamas kaip spausdinimo užduočių atskyriklis ir yra skirtas spausdinimo užduoties rengėjui identifikuoti. LPD pabaigoje pridedamas puslapis Išjungta * Įjungta Visoms LPD spausdinimo užduotims atspausdinamas pabaigoje pridedamas puslapis. Pabaigoje pridedamas puslapis – paskutinis spausdinimo užduoties puslapis. LPD grįžimo į eilutės pradžią konvertavimas Išjungta * Įjungta Įgalinamas grįžimo į eilutės pradžią konvertavimas. Grįžimas į eilutės pradžią – mechanizmas, kuris leidžia spausdintuvui perkelti žymeklio padėtį į pirmąją tos pačios eilutės poziciją. meniu LPD konfigūracija"},{"UUID":"450b944c-ea4f-406b-96fe-45a242fadae6","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"HTTP / FTP nustatymai Meniu","descFull":"HTTP / FTP nustatymai Meniu  HTTP/FTP nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įgaliotasis serveris HTPP įgaliotojo serverio IP adresas HTTP numatytasis IP prievadas FTP įgaliotojo serverio IP adresas FTP numatytasis IP prievadas Autentifikavimas Naudotojo vardas Slaptažodis Vietinės sritys Sukonfigūruojami HTTP ir FTP serverių nustatymai. Kiti nustatymai Įgalinti HTTP serverį  ( Įjungta *) Prisijungiama prie įtaisytojo interneto serverio (EWS), kad būtų galima stebėti ir valdyti spausdintuvą. Kiti nustatymai Įgalinti HTPPS  ( Įjungta *) Įgalinamas „Hypertext Transfer Protocol Secure“ (HTTPS, saugaus hipertekstų persiuntimo protokolas), kad būtų galima užšifruoti duomenų perkėlimą į spausdinimo serverį ir iš jo. Kiti nustatymai Paskatinti priverstinį prisijungimą per HTTPS  ( Išjungta *) Paskatinama, kad spausdintuve būtų naudojamas prisijungimas per HTTPS. Kiti nustatymai Įgalinti FTP / TFTP  ( Įjungta *) Siunčiami failai naudojantis FTP / TFTP. Kiti nustatymai HTTPS įrenginio sertifikatas  ( numatytasis *) Peržiūrimas spausdintuve naudojamas HTTP įrenginio sertifikatas. Kiti nustatymai HTTP / FTP užklausų atidėjimo laikas  (30*) Nurodoma, per kiek laiko baigsis prisijungimas prie serverio. Kiti nustatymai Pakartotiniai HTTP / FTP užklausų bandymai  (3*) Nustatomas pakartotinių bandymų prisijungti prie HTTP / FTP serverio skaičius. meniu HTTP / FTP nustatymai"},{"UUID":"8c20c1fc-d3c3-4f24-935f-53d30599a8c6","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"„ThinPrint“ Meniu  ThinPrint ","descFull":"„ThinPrint“ Meniu  ThinPrint  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įjungti „ThinPrint“ Išjungta * Įjungta Spausdinama naudojant „ThinPrint“. Jungties numeris 4000–4999 (4000*) Nustatomas jungties numeris „ThinPrint“ serveriui. Pralaidumas (b/s) 100–1000000 (0*) Nustatoma, kokia sparta „ThinPrint“ aplinkoje perduodami duomenys. Duomenų paketo dydis (kilobaitais) 0–64000 (0*) Nustatomas perduodamų duomenų paketo dydis. meniu „ThinPrint“"},{"UUID":"d2569084-cedd-4dab-a417-2247e3b3d407","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"USB Meniu  USB ","descFull":"USB Meniu  USB  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. „PCL SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų perjungiamas į PCL emuliaciją, kai ji reikalinga per USB prievadą gautai spausdinimo užduočiai, nepriklausomai nuo numatytosios spausdintuvo kalbos. Šiam nustatymui esant išjungtam, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. „PS SmartSwitch“ Išjungta Įjungta * Nustatoma, kad spausdintuvas būtų perjungiamas į „PostScript“ emuliaciją, kai ji reikalinga per USB prievadą gautai spausdinimo užduočiai, nepriklausomai nuo numatytosios spausdintuvo kalbos. Šiam nustatymui esant išjungtam, įeinantys duomenys spausdintuve neanalizuojami ir naudojama meniu  Sąranka  nurodyta numatytoji spausdintuvo kalba. Užduoties suderinimas Išjungta * Įjungta Prieš spausdinant, užduotys laikinai išsaugomos standžiajame diske. Šis meniu elementas rodomas tik tada, kai yra įdėtas standusis diskas. „Mac“ dvejetainė PS Automatinė * Įjungta Išjungta Nustatoma, kad spausdintuvas galėtų apdoroti „Macintosh“ dvejetainės „PostScript“ spausdinimo užduotis. Esant parinkčiai  Automatiškai , apdorojamos spausdinimo užduotys iš kompiuterių, kuriuose naudojamos „Windows“ arba „Macintosh“ operacinės sistemos. Pasirinkus nustatymą  Išjungta , „PostScript“ spausdinimo užduotys filtruojamos naudojant standartinį protokolą. Įgalinti USB jungtį Išjungta Įjungta * Įgalinamas priekinis USB atmintuko prievadas. meniu USB"},{"UUID":"9e2c0441-a268-4148-8667-1257eceea58e","title":"Tinklas / prievadai","link":"network-overview-topic.html","desc":"Apriboti išorinę tinklo prieigą Nustatymų","descFull":"Apriboti išorinę tinklo prieigą Nustatymų meniu  Apriboti išorinę tinklo prieigą  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Apriboti išorinę tinklo prieigą Išjungta * Įjungta Apribojama prieiga prie tinklo svetainių. Išorinis tinklo adresas Nurodomi tinklo adresai su apribota prieiga. El. pašto adresas pranešimams Nurodomas el. pašto adresas, kuriuo bus siunčiami pranešimai apie užregistruotus įvykius. Ryšio patikrinimo dažnis 1–300 (10*) Nurodomas tinklo ryšio patikrinimo intervalas sekundėmis. Tema Nurodoma elektroninio pranešimo laiško tema ir laiško turinys. Laiškas meniu Apriboti išorinę tinklo prieigą"},{"UUID":"28450577-4422-4f97-85ea-88be099c22b9","title":"Debesų paslaugos","link":"cloud-services-enrollment-topic.html","desc":"Registracija debesų paslaugose Meniu ","descFull":"Registracija debesų paslaugose Meniu  Registracija debesų paslaugose  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Peržiūrėti daugiau informacijos Peržiūrima papildoma informacija apie naudojimąsi „Lexmark“ debesų paslaugomis. Įgalinti ryšį su „Lexmark Cloud Services“ Išjungta * Įjungta Spausdintuvas įgalinamas užmegzti ryšį su „Lexmark“ debesų paslaugomis. Peržiūrėti dabartinę būseną Peržiūrima ryšio tarp spausdintuvo ir „Lexmark“ debesų paslaugų būsena. meniu Registracija debesų paslaugose"},{"UUID":"86200704-81b1-4e10-a8ff-10e1de7c1332","title":"Prisijungimo metodai","link":"login-methods-subgroup.html","desc":"Tvarkyti leidimus Meniu  Tvarkyti","descFull":"Tvarkyti leidimus Meniu  Tvarkyti leidimus  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Prieiga prie funkcijų Prisijungti prie adresų knygos programose Modifikuoti adresų knygą Tvarkyti sparčiąsias nuorodas Kurti profilius Tvarkyti adresyno įrašus Spausdinimas iš atmintuko Spalvotas spausdinimas iš atmintuko Skenavimas iš atmintuko Kopijavimo funkcija Spalvotų kopijų spausdinimas Spalvų pašalinimas El. pašto funkcija Fakso funkcija FTP funkcija Perduoti užlaikytas faksogramas Prieiga prie turimų užduočių Naudoti profilius Atšaukti užduotis įrenginyje Keisti kalbą Interneto spausdinimo protokolas (IPP) Inicijuoti nuskaitymą nuotoliniu būdu Nespalvotas spausdinimas Spalvotas spausdinimas Tinklo aplankas – skenuoti Standusis diskas – spausdinti Standusis diskas – spausdinti spalvotai Standusis diskas – skenuoti Valdoma prieiga prie spausdintuvo funkcijų. Kai kurie meniu elementai rodomi tik tada, kai yra įrengtas standusis diskas arba išmoningasis atminties įrenginys. Administraciniai meniu Meniu „Apsauga“ Meniu „Tinklas / prievadai“ Meniu „Popierius“ Meniu „Ataskaitos“ Meniu „Funkcijų konfigūracija“ Meniu „Eksploataciniai reikmenys“ Meniu „Papildomos plokštės“ Meniu „SE“ Meniu „Įrenginys“ Valdoma prieiga prie spausdintuvo meniu nustatymų. Įrenginio tvarkymas Nuotolinis tvarkymas Programinės aparatinės įrangos naujinimai Programų konfigūracija Operatoriaus skydelio užraktas Prieiga prie įtaisytojo interneto serverio (EWS) Importuoti / eksportuoti visus nustatymus Nenaudojamų duomenų išvalymas Registracija debesų paslaugose Valdoma prieiga prie spausdintuvo valdymo parinkčių. Programos Naujos programos Skaidrių demonstravimas Darbalaukio fono keitimas Ekrano užsklanda „Kortelių kopijavimas“ Skenavimo centras Tinkintas skenavimo centras  [x] Valdoma prieiga prie spausdintuvo programų. meniu Tvarkyti leidimus"},{"UUID":"bf4184cf-b9ea-4c9e-94f1-96c4335e1916","title":"Prisijungimo metodai","link":"login-methods-subgroup.html","desc":"Vietinės paskyros Meniu  Vietinės","descFull":"Vietinės paskyros Meniu  Vietinės paskyros  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Tvarkyti grupes / leidimus Rodomas visų spausdintuve išsaugotų grupių sąrašas. Pridėti naudotoją Naudotojo vardas / slaptažodis Naudotojo vardas Slaptažodis PIN kodas Sukuriamos vietinės paskyros ir nurodoma jų prieiga prie spausdintuvo funkcijų, administravimo meniu, spausdintuvo valdymo parinkčių ir programų. meniu Vietinės paskyros"},{"UUID":"11a24b4b-425a-4a62-ade0-7a2daea19e9c","title":"Prisijungimo metodai","link":"login-methods-subgroup.html","desc":"Numatytieji prisijungimo metodai Šis meniu","descFull":"Numatytieji prisijungimo metodai Šis meniu rodomas, kai sukonfigūruojami nustatymai meniu  Vietinės paskyros . Meniu  Numatytieji prisijungimo metodai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Valdymo skydelis Naudotojo vardas / slaptažodis Naudotojo vardas Slaptažodis PIN kodas Nurodomas numatytasis prisijungimo metodas prieigai prie valdymo skydelio. Naršyklė Naudotojo vardas / slaptažodis Naudotojo vardas Slaptažodis PIN kodas Nurodomas numatytasis prisijungimo metodas prieigai prie naršyklės. meniu Numatytieji prisijungimo metodai"},{"UUID":"40f5c926-2edd-47d9-b80d-f7f1716768c5","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Sudaryti USB įtaisų tvarkaraštį Meniu","descFull":"Sudaryti USB įtaisų tvarkaraštį Meniu  Sudaryti USB įtaisų tvarkaraštį  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Tvarkaraščiai Pridėti naują tvarkaraštį Sudarykite prieigos prie priekinio USB lizdo tvarkaraštį. meniu Sudaryti USB įtaisų tvarkaraštį"},{"UUID":"8b49cc43-919d-483d-b787-c14533fb845e","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Saugumo audito žurnalas Meniu ","descFull":"Saugumo audito žurnalas Meniu  Saugumo audito žurnalas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Įjungti auditą Išjungta * Įjungta Saugiame audito žurnale ir nuotoliniame sisteminiame žurnale registruojami įvykiai. Įjungti nuotolinį sisteminį žurnalą Išjungta * Įjungta Audito žurnalai siunčiami į nuotolinį serverį. Nuotolinio sisteminio žurnalo serveris Nurodomas nuotolinis sisteminio žurnalo serveris. Nuotolinio sisteminio žurnalo prievadas 1–65535 (514*) Nurodomas nuotolinis sisteminio žurnalo prievadas. Nuotolinio sisteminio žurnalo metodas Įprastas UDP * „Stunnel“ Nurodomas sisteminio žurnalo metodas, kuriuo užregistruoti įvykiai perduodami į nuotolinį serverį. Nuotolinio sisteminio žurnalo priemonė 0 ‑ branduolio pranešimai (Kernel Messages) 1 ‑ naudotojo lygmens pranešimai (User‑Level Messages) 2 ‑ pašto sistema (Mail System) 3 ‑ sistemos tarnybos (System Daemons) 4 ‑ saugumo / leidimo pranešimai  (Security/Authorization Messages)* 5 ‑ sisteminių žurnalų sukurti pranešimai (Messages Generated Internally by Syslogs) 6 ‑ linijinis spausdintuvo posistemis (Line Printer Subsystem) 7 ‑ tinklo naujienų posistemis (Network News Subsystem) 8 ‑ UUCP posistemis (UUCP Subsystem) 9 ‑ laikrodžio tarnyba (Clock Daemon) 10 ‑ saugumo / leidimo pranešimai (Security/Authorization Messages) 11 ‑ FTP tarnyba (FTP Daemon) 12 ‑ NTP posistemis (NTP Subsystem) 13 ‑ žurnalų auditas (Log Audit) 14 ‑ įspėjimai dėl žurnalų (Log Alert) 15 ‑ laikrodžio tarnyba (Clock Daemon) 16 ‑ vietinis naudojimas (Local Use) 0 (vietinis 0) 17‑ vietinis naudojimas (Local Use) 1 (vietinis 1) 18 ‑ vietinis naudojimas (Local Use) 2 (vietinis 2) 19 ‑ vietinis naudojimas (Local Use) 3 (vietinis 3) 20 ‑ vietinis naudojimas (Local Use) 4 (vietinis 4) 21 ‑ vietinis naudojimas (Local Use) 5 (vietinis 5) 22 ‑ vietinis naudojimas (Local Use) 6 (vietinis 6) 23 ‑ vietinis naudojimas (Local Use) 7 (vietinis 7) Nurodomas priemonės kodas, kuris naudojamas spausdintuvui siunčiant žurnalo įvykius į nuotolinį serverį. Registruotinų įvykių svarbumas 0 ‑ avarinė situacija (Emergency) 1 ‑ įspėjimas (Alert) 2 ‑ kritinė situacija (Critical) 3 ‑ klaida (Error) 4 ‑ perspėjimas  (Warning)* 5 ‑ pranešimas (Notice) 6 ‑ informacinis pranešimas (Informational) 7 ‑ derinimas (Debug) Nurodoma prioriteto lygio riba pranešimams ir įvykiams registruoti. Nuotoliniame sisteminiame žurnale neregistruoti įvykiai Išjungta * Įjungta Visi įvykiai, nepriklausomai nuo jų svarbumo lygio, siunčiami į nuotolinį serverį. Administratoriaus el. pašto adresas Administratoriui el. paštu siunčiamas pranešimas apie registruotus įvykius. El. paštu išsiųsti įspėjimą, kad žurnalas išvalytas Išjungta * Įjungta Pašalinus žurnalo įrašą, administratoriui el. paštu išsiunčiamas pranešimas. El. paštu išsiųsti įspėjimą, kad žurnalas suglaustas Išjungta * Įjungta Administratoriui el. paštu siunčiamas pranešimas, kai žurnalas tampa užpildytas ir seniausi įrašai pradedami keisti naujais. Elgsena žurnalui esant užpildytam Seniausius įrašus suglausti * Žurnalą išsiųsti el. paštu, po to visus įrašus pašalinti Žurnalui užpildžius paskirtąją atmintį, išsprendžiamos žurnalo saugojimo problemos. El. paštu išsiųsti įspėjimą apie % užpildymą Išjungta * Įjungta Žurnalui užpildžius paskirtąją atmintį, administratoriui el. paštu išsiunčiamas pranešimas. Įspėjamasis % užpildymo lygis 1–99 (90*) El. paštu išsiųsti įspėjimą, kad žurnalas eksportuotas Išjungta * Įjungta Eksportavus žurnalą, administratoriui el. paštu išsiunčiamas pranešimas. El. paštu išsiųsti įspėjimą, kad žurnalo nustatymai pakeisti Išjungta * Įjungta Nustačius  Įjungti auditą , administratoriui el. paštu išsiunčiamas pranešimas. Žurnalo eilučių skirtukai LF (\\n)  (eilutės patraukimas)* CR (\\r) (grįžimas į eilutės pradžią) CRLF (\\r\\n) (grįžimas į eilutės pradžią ir eilutės patraukimas) Nurodoma, kokia bus kiekvienos eilutės pabaiga žurnalo faile. Skaitmeniniu būdu pasirašyti eksportuojamus žurnalus Išjungta * Įjungta Kiekviename eksportuojamo žurnalo faile pridedamas skaitmeninis parašas. Išvalyti žurnalą Pašalinami visi audito žurnalai. Eksportuoti žurnalą Sisteminis žurnalas (RFC 5424) Sisteminis žurnalas (RFC 3164) CSV Saugumo žurnalas eksportuojamas į atmintuką. meniu Saugumo audito žurnalas"},{"UUID":"2805dd02-0b6c-4140-b62b-c33f7cd535fc","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Prisijungimo apribojimai Meniu  Prisijungimo","descFull":"Prisijungimo apribojimai Meniu  Prisijungimo apribojimai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Nepavykę prisijungimai 1–10 (3*) Nurodomas nepavykusių bandymų prisijungti skaičius, iki naudotojas užblokuojamas. Laiko tarpas bandant prisijungti nepavykus 1–60 min. (5*) Nurodomas laiko tarpas tarp nepavykusių bandymų prisijungti, iki naudotojas užblokuojamas. Blokavimo trukmė 1–60 min. (5*) Nurodoma blokavimo trukmė. Skirtasis interneto sąsajos laikas 1–120 min. (10*) Nurodomas nuotolinio prisijungimo pauzės trukmė, iki naudotojas automatiškai atjungiamas. meniu Prisijungimo apribojimai"},{"UUID":"6af53e8e-7c96-44ec-828d-c591a22b4f9e","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Konfidencialaus spausdinimo sąranka Meniu ","descFull":"Konfidencialaus spausdinimo sąranka Meniu  Konfidencialaus spausdinimo sąranka  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Maksimalus neteisingo PIN kodo įvedimų skaičius 2–10 Nustatoma neteisingo PIN kodo įvedimų skaičiaus riba. Pasiekus maksimalų skaičių su to naudotojo vardu susijusios spausdinimo užduotys yra pašalinamos. Konfidencialių užduočių galiojimo laikas Išjungta * 1 valanda 4 valandos 24 valandos 1 savaitė Nustatomas atskiras kiekvienos užlaikomos užduoties galiojimo laikas, kol ji automatiškai pašalinama iš spausdintuvo atminties ar standžiojo disko. Užlaikoma užduotis gali būti  Konfidenciali ,  Kartotina ,  Atidėta  arba  Tikrintina . Kartotinų užduočių galiojimo laikas Išjungta * 1 valanda 4 valandos 24 valandos 1 savaitė Nustatomas spausdinimo užduoties, kurią norima pakartoti, galiojimo laikas. Tikrintinų užduočių galiojimo laikas Išjungta * 1 valanda 4 valandos 24 valandos 1 savaitė Nustatomas užduoties kopijos spausdinimo galiojimo laikas, kad būtų galima patikrinti jos kokybę prieš spausdinant likusias kopijas. Atidėtų užduočių galiojimo laikas Išjungta * 1 valanda 4 valandos 24 valandos 1 savaitė Nustatomas galiojimo laikas užduotims, kurias norima išsaugoti spausdintuve, kad būtų galima atspausdinti vėliau. Reikalauti, kad visos užduotys būtų užlaikomos Išjungta * Įjungta Nustatoma, kad spausdintuvas užlaikytų visas spausdinimo užduotis. Išlaikyti besidubliuojančius dokumentus Išjungta * Įjungta Nustatoma, kad spausdintuvas visus dokumentus išlaikytų tuo pačiu failo pavadinimu. meniu Konfidencialaus spausdinimo sąranka"},{"UUID":"f6a7c9e3-389e-4925-94ed-3a0c3c7aba43","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Disko užšifravimas Šis meniu rodomas","descFull":"Disko užšifravimas Šis meniu rodomas tik tada, kai yra įrengtas standusis diskas arba išmoningasis atminties įrenginys. Meniu  Disko užšifravimas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Standusis diskas Rodoma standžiojo disko šifravimo būsena. Išmoningasis atminties įrenginys Rodoma išmoningojo atminties disko (ISD) šifravimo būsena. Įdiegus standųjį diską, ISD automatiškai išjungiamas. meniu Disko užšifravimas"},{"UUID":"4835c35b-ca2e-4976-90a7-d719020828bd","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Išvalyti laikinuosius duomenų failus Meniu","descFull":"Išvalyti laikinuosius duomenų failus Meniu Išvalyti laikinuosius duomenų failus elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Saugoma įrenginio atmintyje Išjungta * Įjungta Pašalinami visi spausdintuvo atmintyje saugomi failai. Saugoma standžiajame diske Išvalyti 1 kartu * Išvalyti 3 kartais Išvalyti 7 kartais Pašalinami visi spausdintuvo standžiajame diske saugomi failai. Šis meniu elementas rodomas tik tada, kai spausdintuve yra įrengtas standusis diskas. meniu Išvalyti laikinuosius duomenų failus"},{"UUID":"a2b6cbaa-0a06-4af4-be89-72b7b09d693e","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Sprendimų LDAP nustatymai Meniu ","descFull":"Sprendimų LDAP nustatymai Meniu  Sprendimų LDAP nustatymai  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Sekti LDAP persiuntimus Išjungta * Įjungta Skirtinguose srities serveriuose ieškoma prisijungusio naudotojo paskyros. LDAP liudijimų patikra Taip Ne * Įgalinama LDAP liudijimų patikra. meniu Sprendimų LDAP nustatymai"},{"UUID":"68a92dc9-cfd3-45af-b1a6-3a21c33484f2","title":"Saugumas","link":"login-methods-subgroup.html","desc":"Įvairūs Meniu  Įvairūs ","descFull":"Įvairūs Meniu  Įvairūs  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Žvaigždutė (*) šalia vertės nurodo gamyklinį numatytąjį nustatymą. Apsaugotos funkcijos Rodyti * Slėpti Rodomos visos funkcijos, kurias funkcijų prieigos kontrolė (FAC) saugo nepriklausomai nuo naudotojo turimo apsaugos leidimo. Meniu elementas  Slėpti  rodo tik FAC apsaugotas funkcijas, prie kurių naudotojas turi prieigą. Leidimas spausdinti Išjungta * Įjungta Prieš spausdinant naudotojui leidžiama prisijungti. Numatytieji leidimo spausdinti prisijungimo duomenys Naudotojo vardas / slaptažodis * Naudotojo vardas Meniu elementui  Leidimas spausdinti  nustatomas numatytasis prisijungimo vardas. Apsaugos nustatymo iš naujo trumpiklis Įgalinti prieigą „Svečias“ * Jokio poveikio Nurodoma naudotojo prieiga prie spausdintuvo. Nustačius  Įgalinti prieigą „Svečias“  prieiga prie bet kurio spausdintuvo aspekto suteikiama kiekvienam. Nustačius  Jokio poveikio  prieiga prie spausdintuvo gali būti neįmanoma nepateikus reikiamos saugos informacijos. Naudotojo duomenims naudoti išmoningąjį atminties įrenginį Išjungta Įjungta * Išmoningasis atminties įrenginys įgalinamas saugoti naudotojo duomenis. Šis meniu elementas būna išjungtas, kai yra įdėtas standusis diskas. Minimalus slaptažodžio ilgis 0–32 (0*) Nurodomas slaptažodžio ilgis. Įgalinti slaptažodžio / PIN kodo rodymą Išjungta * Įjungta Rodomas slaptažodis arba asmeninio identifikavimo numeris. meniu Įvairūs"},{"UUID":"45ded003-b549-4641-af85-a2835e3ec0e3","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Meniu nustatymų puslapis Meniu ","descFull":"Meniu nustatymų puslapis Meniu  Meniu nustatymų puslapis  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Meniu nustatymų puslapis Atspausdinama ataskaita su visais spausdintuvo meniu. meniu Meniu nustatymų puslapis"},{"UUID":"b138e22d-490f-458e-a569-2fa0ddfea2d3","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Įrenginys Įrenginys Meniu  Įrenginys","descFull":"Įrenginys Įrenginys Meniu  Įrenginys  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Įrenginio informacija Atspausdinama ataskaita, kurioje pateikiama informacija apie spausdintuvą. Įrenginio statistika Atspausdinama ataskaita apie spausdintuvo naudojimą ir eksploatacinių medžiagų būseną. Profilių sąrašas Atspausdinamas spausdintuve saugomų profilių sąrašas. Įrenginio informacijos ataskaita Atspausdinama diagnostikos priemonė spausdinimo problemoms spręsti. Kad turinys nebūtų nukirptas, ataskaitą spausdinkite ant „Letter“ arba A4 formato popieriaus. meniu Įrenginys"},{"UUID":"64a7673c-37e3-4680-b93c-63ddeb3da865","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Spausdinti Meniu „Spausdinti“ elementai ir","descFull":"Spausdinti Meniu „Spausdinti“ elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Spausdinimo šriftai PCL šriftai PS šriftai Spausdinami pavyzdžiai ir informacija apie šriftus, kurie yra prieinami kiekviena spausdintuvo kalba. Demonstracinė spausdinimo versija Demonstracinis puslapis Spausdinamas puslapis, kuriame parodytos spausdintuvo galimybės ir palaikomi sprendimai. Spausdinimo katalogas Spausdinami ištekliai, kurie saugomi atmintuke arba spausdintuvo standžiajame diske. Šis meniu elementas rodomas tik tada, kai yra įdėtas atmintukas arba įrengtas spausdintuvo standusis diskas. meniu Spausdinti"},{"UUID":"16b3c1df-e6f3-426d-8c45-b64090468c75","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Sparčiosios nuorodos Meniu  Sparčiosios","descFull":"Sparčiosios nuorodos Meniu  Sparčiosios nuorodos  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Visos sparčiosios nuorodos Atspausdinama ataskaita, kurioje išvardintos spausdintuve saugomos sparčiosios nuorodos. Meniu elementas  Fakso numerių sparčiosios nuorodos  rodomas tik tada, kai yra įrengtas faksas. Fakso numerių sparčiosios nuorodos Kopijavimo sparčiosios nuorodos El. pašto sparčiosios nuorodos FTP sparčiosios nuorodos Tinklo aplanko sparčiosios nuorodos meniu Sparčiosios nuorodos"},{"UUID":"54751b23-6288-49aa-ade0-2afbfd815cc2","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Faksas Šis meniu rodomas tik","descFull":"Faksas Šis meniu rodomas tik tada, kai yra sukonfigūruotas faksas, o meniu elementas  Įgalinti užduočių žurnalą  yra nustatytas į  Įjungta . Meniu  Faksas  elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Fakso užduočių žurnalas Atspausdinama ataskaita apie paskutines atliktas 200 fakso užduočių. Fakso skambučių žurnalas Atspausdinama ataskaita apie paskutinius 100 nepavykusių, gautų ir blokuotų skambučių. meniu Faksas"},{"UUID":"0aa9b7c8-4be9-499e-81cd-f7596bf97677","title":"Ataskaitos","link":"menu-settings-page-topic.html","desc":"Tinklas Meniu  Tinklas ","descFull":"Tinklas Meniu  Tinklas  elementas ir jo paaiškinimas Meniu elementas Paaiškinimas Tinklo sąrankos puslapis Atspausdinamas puslapis, kuriame rodomi konfigūruojami spausdintuvo tinklo ir belaidžio ryšio nustatymai. Šis meniu elementas rodomas tik tinklo spausdintuvuose arba spausdintuvuose, prijungtuose prie spausdinimo serverių. Klientai, prisijungę naudojant „Wi‑Fi Direct“ Atspausdinamas puslapis, kuriame rodomas įrenginių, prijungtų prie spausdintuvo naudojant „Wi-Fi Direct“, sąrašas. Šis meniu elementas rodomas tik tada, kai parinktis  Įgalinti „Wi‑Fi Direct“  nustatyta į  Įjungta . meniu Tinklas"},{"UUID":"6040b57e-0c75-4d15-b121-da6b75edc72c","title":"Kaip naudoti spausdintuvo meniu","link":"troubleshooting-menu-topic.html","desc":"Trikčių šalinimas Meniu „Trikčių šalinimas“","descFull":"Trikčių šalinimas Meniu „Trikčių šalinimas“ elementai ir jų paaiškinimai Meniu elementas Paaiškinimas Spausdinimo kokybės testavimo puslapiai Atspausdinami pavyzdiniai puslapiai spausdinimo kokybės defektų nustatymui ir taisymui. Skaitytuvo valymas Atspausdinami nurodymai, kaip valyti skaitytuvą. meniu Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai Skaitytuvo valymas"},{"UUID":"7391f1db-7c7d-48bf-87e4-8766da1b068c","title":"Kaip naudoti spausdintuvo meniu","link":"printing-menu-settings-page-topic.html","desc":"Meniu nustatymų puslapio  spausdinimas","descFull":"Meniu nustatymų puslapio  spausdinimas Pradžios ekrane palieskite  Nustatymai Ataskaitos  Meniu nustatymų puslapis . spausdinimas Meniu nustatymų puslapis Meniu nustatymų puslapis spausdinimas spausdintuvo meniu"},{"UUID":"5aecbbfa-a0e4-45a0-bac8-f2194e5a8725","title":"Spausdintuvo priežiūra","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Dalių ir eksploatacinių medžiagų būsenos","descFull":"Dalių ir eksploatacinių medžiagų būsenos tikrinimas Pradžios ekrane palieskite  Būsena / eksploatacinės medžiagos . Pasirinkite dalis arba eksploatacines medžiagas, kurias norite patikrinti. Šį nustatymą galima pasiekti ir palietus viršutinę pradžios ekrano dalį. dalių ir eksploatacinių medžiagų būsenos tikrinimas eksploatacinių medžiagų būsena tikrinimas dalių būsena tikrinimas"},{"UUID":"863a34cc-4c89-4bd8-a0b0-67a0a15b37ee","title":"Spausdintuvo priežiūra","link":"configuring-supply-notifications-topic.html","desc":"Pranešimų dėl eksploatacinių medžiagų konfigūravimas","descFull":"Pranešimų dėl eksploatacinių medžiagų konfigūravimas Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Įrenginys Pranešimai . Meniu „Eksploatacinės medžiagos“ spustelėkite  Tinkinti pranešimai dėl eksploatacinių medžiagų . Pasirinkite pranešimą kiekvienai eksploatacinei medžiagai. Vykdykite pakeitimus. pranešimai dėl eksploatacinių medžiagų konfigūravimas pranešimų dėl eksploatacinių medžiagų konfigūravimas"},{"UUID":"ced5ff3d-4a1a-42be-9515-2dc1c2d5c34d","title":"Spausdintuvo priežiūra","link":"setting-up-e-mail-alert-topic.html","desc":"Įspėjimų el. paštu nustatymas Sukonfigūruokite","descFull":"Įspėjimų el. paštu nustatymas Sukonfigūruokite spausdintuvą, kad jis siųstų įspėjimus elektroniniu paštu, kai reikia pakeisti popierių, įdėti jo daugiau arba kai jis užstringa. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Spausdintuvo pradžios ekrane peržiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Nustatymai Įrenginys Pranešimai Įspėjimų el. paštu sąranka  ir sukonfigūruokite nustatymus. Jei reikia daugiau informacijos apie SMTP nustatymus, kreipkitės į el. pašto paslaugų teikėją. Vykdykite pakeitimus. Spustelėkite  Nustatyti el. pašto adresų sąrašus ir įspėjimus , tada sukonfigūruokite nustatymus. Vykdykite pakeitimus. įspėjimai el. paštu nustatymas įspėjimų el. paštu nustatymas"},{"UUID":"981309e6-5c5b-42dd-ad4b-0256c0cab1c5","title":"Spausdintuvo priežiūra","link":"viewing-reports-topic.html","desc":"Ataskaitų peržiūra Pradžios ekrane palieskite","descFull":"Ataskaitų peržiūra Pradžios ekrane palieskite  Nustatymai Ataskaitos . Pasirinkite norimą peržiūrėti ataskaitą. ataskaitų peržiūra ataskaitos spausdintuvo būsena ataskaitos spausdintuvo naudojimas"},{"UUID":"96077d5d-4343-49ec-a4e5-41c1a8f6a5a7","title":"Dalių ir eksploatacinių reikmenų užsakymas","link":"ordering-parts-and-supplies-group.html","desc":"Jei eksploatacinius reikmenis užsakote JAV,","descFull":"Jei eksploatacinius reikmenis užsakote JAV, kreipkitės į „Lexmark“ tel. 1-800-539-6275, kad sužinotumėte apie „Lexmark“ įgaliotuosius eksploatacinių reikmenų prekybos atstovus jūsų vietovėje. Jei užsakote kitose šalyse arba regionuose, apsilankykite interneto svetainėje  www.lexmark.com  arba kreipkitės į vietą, kurioje įsigijote spausdintuvą. Norėdami užsakyti eksploatacinių reikmenų, kreipkitės į vietą, kurioje pirkote spausdintuvą. Visų spausdintuvo eksploatacinių reikmenų naudojimo trukmė apskaičiuojama darant prielaidą, kad spausdinama ant popieriaus laiškams „Letter“ arba A4 formato paprasto popieriaus. Nepalaikant optimalaus spausdintuvo veikimo arba nepakeitus jo dalių ir eksploatacinių reikmenų, spausdintuvas gali sugesti. Originalios dalys ir eksploataciniai reikmenys"},{"UUID":"8bc4b694-f304-457d-98a4-21080eeb5881","title":"Dalių ir eksploatacinių reikmenų užsakymas","link":"ordering-parts-and-supplies-group.html","desc":"Originalių „Lexmark“ dalių ir eksploatacinių","descFull":"Originalių „Lexmark“ dalių ir eksploatacinių reikmenų naudojimas „Lexmark“ spausdintuvas geriausiai veikia, jei jame naudojamos originalios „Lexmark“ dalys ir eksploataciniai reikmenys. Trečiųjų šalių eksploatacinių reikmenų ar dalių naudojimas gali pakenkti spausdintuvo ir jo vaizdo gavimo komponentų efektyvumui, patikimumui arba naudojimo trukmei. Tai gali turėti neigiamos įtakos garantijos taikymui. Jei spausdintuvas sugenda naudojant trečiųjų šalių dalis ir eksploatacinius reikmenis, garantija netaikoma. Visi gyvavimo ciklo indikatoriai yra skirti veikti naudojant „Lexmark“ dalis ir eksploatacinius reikmenis, todėl naudojant trečiųjų šalių dalis ir eksploatacinius reikmenis rezultatai gali būti neprognozuojami. Naudojant vaizdo gavimo komponentus ilgiau nei numatyta jų naudojimo trukmė, „Lexmark“ spausdintuvas arba jo komponentai gali sugesti. Eksploatacinius reikmenis ir dalis, kurioms netaikomos Grąžinimo programos sutarties sąlygos, galima nustatyti iš naujo ir atnaujinti. Tačiau gamintojo garantija netaikoma žalai, kurią sukėlė neoriginalūs eksploataciniai reikmenys ar dalys. Iš naujo nustačius skaitiklius eksploataciniam reikmeniui ar daliai, kurie nebuvo tinkamai atnaujinti, galima pakenkti spausdintuvui. Iš naujo nustačius eksploatacinio reikmens ar dalies skaitiklį, spausdintuve gali būti rodoma klaida, reiškianti, kad jame yra iš naujo nustatytas elementas. originalių „Lexmark“ dalių ir eksploatacinių reikmenų naudojimas originalios „Lexmark“ dalys ir eksploataciniai reikmenys"},{"UUID":"910de3b0-3157-4f1d-a487-fe150a62e544","title":"Dalių ir eksploatacinių reikmenų užsakymas","link":"ordering-parts-and-supplies-group.html","desc":"Dažų kasetės užsakymas Kasetės išeiga","descFull":"Dažų kasetės užsakymas Kasetės išeiga yra apskaičiuota pagal ISO/IEC 19798 standartą. Jei ilgą laiką labai mažai spausdinama, tai gali neigiamai paveikti realią išeigą. Norėdami užsakyti dažų kasečių, kreipkitės į vietą, kurioje pirkote spausdintuvą. „Lexmark“ CX930, CX931 dažų kasetės Gaminys Visame pasaulyje Dažų kasetės Žydra 85D0HC0 Purpurinė 85D0HM0 Geltona 85D0HY0 Juoda 85D0HK0 5K dažų kasetės Žydra 85D00C0 Purpurinė 85D00M0 Geltona 85D00Y0 Juoda 85D00K0 „Lexmark“ XC9325, XC9335 dažų kasetės Gaminys Visame pasaulyje Žydra 24B7519 Purpurinė 24B7520 Geltona 24B7521 Juoda 24B7522 eksploatacinių reikmenų užsakymas dažų kasetė dažų kasetė užsakymas"},{"UUID":"f4e6cea3-d5ce-4eee-a989-f8a523bbce5c","title":"Dalių ir eksploatacinių reikmenų užsakymas","link":"ordering-parts-and-supplies-group.html","desc":"Fotolaidininko bloko užsakymas Norėdami užsakyti","descFull":"Fotolaidininko bloko užsakymas Norėdami užsakyti fotolaidininko bloką, kreipkitės į vietą, kurioje pirkote spausdintuvą. Fotolaidininko blokai ir jų dalių numeriai Gaminys Visame pasaulyje Fotolaidininko blokas 85D0P00 Fotolaidininko blokas 3 pakuotėje 85D0Q00 eksploatacinių reikmenų užsakymas fotolaidininko blokas fotolaidininko blokas užsakymas"},{"UUID":"e442ab78-8e3a-4eb3-a3e8-29bd37f632ff","title":"Dalių ir eksploatacinių reikmenų užsakymas","link":"ordering-parts-and-supplies-group.html","desc":"Dažų atliekų konteinerio užsakymas Norėdami","descFull":"Dažų atliekų konteinerio užsakymas Norėdami užsakyti dažų atliekų konteinerį, kreipkitės į vietą, kurioje pirkote spausdintuvą. Dažų atliekų konteineris ir jo dalies numeris Gaminys Dalies numeris Dažų atliekų konteineris 85D0W00 eksploatacinių reikmenų užsakymas dažų atliekų konteineris dažų atliekų konteineris užsakymas"},{"UUID":"ae39b4aa-f121-4696-a6c0-88d29f7f3621","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Dažų kasetės keitimas Atidarykite priekines","descFull":"Dažų kasetės keitimas Atidarykite priekines dureles. Išimkite panaudotą dažų kasetę. Išpakuokite naują dažų kasetę. Pakratykite kasetę, kad paskirstytumėte dažus. Įdėkite naują dažų kasetę. Atblokuokite dažų atliekų konteinerį. Išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Įdėkite spausdinimo galvutės valytuvą atgal į vietą. Kiškite dažų atliekų konteinerį į spausdintuvą, kol pasigirs  spragtelėjimas . Užblokuokite dažų atliekų konteinerį. Uždarykite dureles. dažų kasetė keitimas eksploatacinių reikmenų keitimas dažų kasetė"},{"UUID":"657d613a-a191-47d5-824b-77b757a5a975","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Dažų atliekų konteinerio keitimas Atidarykite","descFull":"Dažų atliekų konteinerio keitimas Atidarykite priekines dureles. Atblokuokite dažų atliekų konteinerį. Išimkite panaudotą dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Įdėkite spausdinimo galvutės valytuvą atgal į vietą. Išpakuokite naują dažų atliekų konteinerį. Kiškite naują dažų atliekų konteinerį į spausdintuvą, kol pasigirs  spragtelėjimas . Užblokuokite dažų atliekų konteinerį. Uždarykite dureles. eksploatacinių reikmenų keitimas dažų atliekų konteineris dažų atliekų konteineris keitimas"},{"UUID":"d33e0f8d-bf48-4e4d-ad46-a834dcabc9b4","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Fotolaidininko bloko keitimas Atidarykite priekines","descFull":"Fotolaidininko bloko keitimas Atidarykite priekines dureles. Atblokuokite dažų atliekų konteinerį. Išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Atblokuokite panaudotą fotolaidininko bloką. Siekdami išvengti dažų užteršimo, nelieskite fotolaidininko bloko galo. Išimkite panaudotą fotolaidininko bloką. Išpakuokite naują fotolaidininko bloką. Nelaikykite fotolaidininko bloko tiesioginėje šviesoje ilgiau nei vieną minutę. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įdėkite naują fotolaidininko bloką, tada užfiksuokite apatinę dalį. Nuimkite pakavimo medžiagą ir užfiksuokite viršutinę dalį. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Įdėkite valytuvą atgal į vietą. Kiškite dažų atliekų konteinerį į spausdintuvą, kol pasigirs  spragtelėjimas . Užblokuokite dažų atliekų konteinerį. Uždarykite dureles. fotolaidininko blokas keitimas fotolaidininko bloko keitimas"},{"UUID":"69cfbb00-7f6f-4843-ac0b-d6370c6c354c","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"520 lapų dėklo įdėklo keitimas","descFull":"520 lapų dėklo įdėklo keitimas 520 lapų dėklo įdėklo keitimas Išimkite panaudotą dėklo įdėklą. Išpakuokite papildomą dėklo įdėklą ir nuimkite visas pakuotės medžiagas. Įdėkite naują dėklo įdėklą. dalių keitimas 520 lapų dėklo įdėklas 520 lapų dėklo įdėklas keitimas"},{"UUID":"a8708df2-b25d-4d44-baf4-44aa59469438","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Kaitintuvo keitimas Išjunkite spausdintuvą. Atidarykite","descFull":"Kaitintuvo keitimas Išjunkite spausdintuvą. Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atblokuokite panaudotą kaitintuvą. Išimkite panaudotą kaitintuvą. Išpakuokite naują kaitintuvą. Įdėkite naują kaitintuvą. Užfiksuokite naują kaitintuvą. Uždarykite dureles. Įjunkite spausdintuvą. kaitintuvas keitimas dalių keitimas kaitintuvas"},{"UUID":"435371ff-e2d7-4780-acb1-61dd931ed580","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Popieriaus perdavimo veleno keitimas Išjunkite","descFull":"Popieriaus perdavimo veleno keitimas Išjunkite spausdintuvą. Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Išimkite panaudotą popieriaus perdavimo veleną. Išpakuokite naują popieriaus perdavimo veleną. Kiškite naują popieriaus perdavimo veleną į spausdintuvą, kol pasigirs  spragtelėjimas . Uždarykite A dureles, po to – priekines dureles. Įjunkite spausdintuvą. dalių keitimas popieriaus perdavimo velenas popieriaus perdavimo velenas keitimas"},{"UUID":"af81865a-a5db-4644-961a-ec8d76a01958","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Perdavimo modulio keitimas Išjunkite spausdintuvą.","descFull":"Perdavimo modulio keitimas Išjunkite spausdintuvą. Atblokuokite dažų atliekų konteinerį. Išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atblokuokite ir ištraukite panaudotą perdavimo modulį. Išimkite panaudotą perdavimo modulį. Išpakuokite naują perdavimo modulį. Nelieskite perdavimo diržo. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Kiškite naują perdavimo modulį, kol pasigirs  spragtelėjimas . Užfiksuokite naują perdavimo modulį, tada uždarykite A dureles. Kiškite dažų atliekų konteinerį į spausdintuvą, kol pasigirs  spragtelėjimas . Užblokuokite dažų atliekų konteinerį. Įjunkite spausdintuvą. eksploatacinių reikmenų keitimas perdavimo modulis perdavimo modulis keitimas"},{"UUID":"96064451-391e-49fc-8034-eb00bc698d0e","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Pakeiskite dėklo velenėlių komplektą. Pakeiskite","descFull":"Pakeiskite dėklo velenėlių komplektą. Pakeiskite dėklo velenėlių komplektą. Išjunkite spausdintuvą. Išimkite standartinį dėklą. Išimkite panaudotą dėklo velenėlių komplektą. Prieš pasiekdami arba liesdami vidines spausdintuvo sritis, palieskite bet kurią neapsaugotą spausdintuvo metalinio korpuso vietą, kad išvengtumėte gedimų dėl elektrostatinės iškrovos. Išpakuokite naują dėklo velenėlių komplektą. Kiškite naują dėklo velenėlių komplektą į spausdintuvą, kol pasigirs  spragtelėjimas . Įdėkite dėklą. Įjunkite spausdintuvą. dėklo velenėlių komplektas keitimas dalių keitimas dėklo velenėlių komplektas"},{"UUID":"ac5c1d0c-b6da-4710-afee-e5f215d40ab0","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"ADT velenėlių komplekto keitimas Išjunkite","descFull":"ADT velenėlių komplekto keitimas Išjunkite spausdintuvą. Atidarykite viršutinį ADT dangtį. s Nuimkite skyriklio velenėlio dangtelį. Išimkite panaudotą skyriklio velenėlį. Išpakuokite naują skyriklio velenėlį. Įdėkite naują skyriklio velenėlį. Kiškite skyriklio velenėlio dangtelį, kol pasigirs  spragtelėjimas . Išimkite panaudotą skyriklio velenėlių bloką. Išpakuokite naują skyriklio velenėlių bloką. Kiškite naują skyriklio velenėlio bloką, kol pasigirs  spragtelėjimas . Uždarykite viršutinį ADT dangtį. Įjunkite spausdintuvą. ADT velenėlių komplektas keitimas dalių keitimas ADT velenėlių komplektas skyriklio velenėlis keitimas skyriklio velenėlių blokas keitimas"},{"UUID":"44cc545d-7652-4f29-9b8c-027baeece688","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Spausdinimo galvutės valytuvo keitimas Atidarykite","descFull":"Spausdinimo galvutės valytuvo keitimas Atidarykite priekines dureles. Nuimkite panaudotą spausdinimo galvutės valytuvą. Išpakuokite naują spausdinimo galvutės valytuvą. Įdėkite naują spausdinimo galvutės valytuvą. Uždarykite dureles. dalių keitimas spausdinimo galvutės valytuvas spausdinimo galvutės valytuvas keitimas"},{"UUID":"97cf4844-8a2f-4fc1-a6c7-a3158a81a59b","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"2000 lapų dėklo velenėlių komplekto","descFull":"2000 lapų dėklo velenėlių komplekto keitimas 2000 lapų dėklo velenėlių komplekto keitimas Išjunkite spausdintuvą. Pastumkite dėklą į kairę. Atidarykite J dureles, tada atidarykite velenėlių komplekto dangtį. Suraskite ir išimkite panaudotą velenėlių komplektą. Išpakuokite naują velenėlių komplektą. Įdėkite naują velenėlių komplektą. Uždarykite velenėlių komplekto dangtį, tada uždarykite J dureles. Pastumkite dėklą atgal į vietą. Įjunkite spausdintuvą. 2000 lapų dėklo velenėlių rinkinys keitimas dalių keitimas 2000 lapų dėklo velenėlių rinkinys"},{"UUID":"135606b6-5b9d-4e18-8e63-01cad0deeb16","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"ADT popieriaus skyriklio velenėlio dangčio","descFull":"ADT popieriaus skyriklio velenėlio dangčio keitimas ADT popieriaus skyriklio velenėlio dangčio keitimas Atidarykite viršutinį ADT dangtį. Nuimkite panaudoto skyriklio velenėlio dangtelį. Išpakuokite naują skyriklio velenėlio dangtelį. Kiškite naują skyriklio velenėlio dangtelį, kol pasigirs  spragtelėjimas . Uždarykite viršutinį ADT dangtį. ADT popieriaus skyriklio velenėlio dangtis keitimas dalių keitimas ADT popieriaus skyriklio velenėlio dangtis"},{"UUID":"8145a365-ea73-4856-bad2-c46253e46d2c","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Apatinės galinės jungties dangtelio keitimas","descFull":"Apatinės galinės jungties dangtelio keitimas Apatinės galinės jungties dangtelio keitimas Nuimkite panaudotą apatinės galinės jungties dangtelį. Išpakuokite naują apatinės galinės jungties dangtelį. Kiškite naują apatinės galinės jungties dangtelį, kol pasigirs  spragtelėjimas . dalių keitimas apatinis galinės jungties dangtelis apatinis galinės jungties dangtelis keitimas"},{"UUID":"df997323-126d-4fca-bc6e-50d74788588f","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"ADT popieriaus dėtuvės stabdiklio keitimas","descFull":"ADT popieriaus dėtuvės stabdiklio keitimas Išimkite panaudotą ADT dėtuvės popieriaus stabdiklį. Išpakuokite naują ADT dėtuvės popieriaus stabdiklį. Įdėkite naują ADT dėtuvės popieriaus stabdiklį. dalių keitimas ADT dėtuvės popieriaus stabdiklis ADT dėtuvės popieriaus stabdiklis keitimas"},{"UUID":"6580b1a6-d7e3-4540-bec1-42b960c4dd4e","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Eksploatacijos skaitiklio nustatymas iš naujo","descFull":"Eksploatacijos skaitiklio nustatymas iš naujo Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Eksploatacinių reikmenų naudojimas ir skaitikliai . Palieskite  Iš naujo nustatyti techninės priežiūros skaitiklį . eksploatacijos skaitiklis nustatymas iš naujo eksploatacijos skaitiklio nustatymas iš naujo"},{"UUID":"7865c9dc-6fa4-4946-9e6e-ec0eabb7f792","title":"Dalių ir eksploatacinių reikmenų keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Eksploatacinių reikmenų naudojimo skaitiklių nustatymas","descFull":"Eksploatacinių reikmenų naudojimo skaitiklių nustatymas iš naujo Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Eksploatacinių medžiagų naudojimas ir skaitikliai . Pasirinkite skaitiklį, kurį norite nustatyti iš naujo. Eksploatacinius reikmenis ir dalis, kurioms netaikomos Grąžinimo programos sutarties sąlygos, galima nustatyti iš naujo ir atnaujinti. Tačiau gamintojo garantija neapima jokios žalos, kurią sukėlė neoriginalūs eksploataciniai reikmenys ar dalys. Iš naujo nustačius skaitiklius eksploataciniam reikmeniui ar daliai, kurie nebuvo tinkamai perdaryti, spausdintuvas gali sugesti. Iš naujo nustačius eksploatacinio reikmens ar dalies skaitiklį, spausdintuvas gali rodyti klaidą, nurodančią iš naujo nustatyto elemento buvimą. Eksploatacinius reikmenis ir dalis, kurioms netaikomos Panaudojimo ir grąžinimo programos sutarties sąlygos, galima nustatyti iš naujo ir atnaujinti. Tačiau gamintojo garantija neapima jokios žalos, kurią sukėlė neoriginalūs eksploataciniai reikmenys ar dalys. Iš naujo nustačius skaitiklius eksploataciniam reikmeniui ar daliai, kurie nebuvo tinkamai perdaryti, spausdintuvas gali sugesti. Iš naujo nustačius eksploatacinio reikmens ar dalies skaitiklį, spausdintuvas gali rodyti klaidą, nurodančią iš naujo nustatyto elemento buvimą. eksploatacinių reikmenų naudojimo skaitikliai nustatymas iš naujo eksploatacinių reikmenų naudojimo skaitiklių nustatymas iš naujo"},{"UUID":"44062273-07cf-460e-97fe-3c60ca1f1119","title":"Sąsagėlių kasetės keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Sąsagėlių kasetės keitimas segiklyje Atidarykite","descFull":"Sąsagėlių kasetės keitimas segiklyje Atidarykite apipavidalinimo įtaiso dureles. Išimkite sąsagėlių kasetės apkabą. Ištraukite tuščią sąsagėlių kasetę. Išpakuokite naują sąsagėlių kasetę. Kiškite naują sąsagėlių kasetę į laikiklį, kol ji  užsifiksuos . Kiškite sąsagėlių kasetės apkabą, kol ji  užsifiksuos . Uždarykite dureles. eksploatacinių reikmenų keitimas sąsagėlių kasetė sąsagėlių kasetė keitimas"},{"UUID":"d2168455-f399-48b3-9707-a715ed992b68","title":"Sąsagėlių kasetės keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Sąsagėlių kasetės keitimas sąsagėlių, skylmušos","descFull":"Sąsagėlių kasetės keitimas sąsagėlių, skylmušos įtaise Atidarykite apipavidalinimo įtaiso dureles. Išimkite sąsagėlių kasetės apkabą. Ištraukite tuščią sąsagėlių kasetę. Išpakuokite naują sąsagėlių kasetę. Kiškite naują sąsagėlių kasetę, kol ji  užsifiksuos . Įdėkite sąsagėlių kasetės apkabą. Uždarykite dureles. eksploatacinių reikmenų keitimas sąsagėlių kasetė sąsagėlių kasetė keitimas"},{"UUID":"c00e6e7a-2217-47ec-9cc6-8d598e84417b","title":"Sąsagėlių kasetės keitimas","link":"replacing-toner-cartridge-topic.html","desc":"Standartinės sąsagėlių kasetės apkabos keitimas","descFull":"Standartinės sąsagėlių kasetės apkabos keitimas Standartinės sąsagėlių kasetės apkabos keitimas Atidarykite apipavidalinimo įtaiso dureles. Išimkite panaudotą sąsagėlių kasetės apkabą. Išimkite sąsagėlių kasetę. Išpakuokite naują sąsagėlių kasetės apkabą. Kiškite sąsagėlių kasetę į naują sąsagėlių kasetės apkabą, kol ji  užsifiksuos . Kiškite naują sąsagėlių kasetės apkabą, kol ji  užsifiksuos . Uždarykite apipavidalinimo įtaiso dureles. dalių keitimas sąsagėlių kasetės laikiklis sąsagėlių kasetės laikiklis keitimas"},{"UUID":"d37dee89-0de0-49bb-9c95-fea0b3871a57","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Spausdintuvo valymas Norėdami išvengti elektros","descFull":"Spausdintuvo valymas Norėdami išvengti elektros smūgio pavojaus valant spausdintuvo išorę, prieš pradėdami valyti ištraukite maitinimo laidą iš elektros lizdo ir atjunkite visus spausdintuvo laidus. Šį darbą atlikite kas du mėnesius. Jei spausdintuvas sugadinamas netinkamai jį prižiūrint, garantija netaikoma. Išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Išimkite popierių iš standartinės dėtuvės ir daugiafunkcio tiektuvo. Minkštu šepečiu arba dulkių siurbliu aplink spausdintuvą pašalinkite visas dulkes, pūkelius ir popieriaus gabalėlius. Spausdintuvo išorę nuvalykite drėgnu, minkštu audiniu be pūkelių. Nenaudokite buitinių valiklių ar ploviklių, kad nepažeistumėte spausdintuvo paviršiaus. Įsitikinkite, kad nuvalius visos spausdintuvo sritys lieka sausos. Įkiškite maitinimo laidą į elektros lizdą ir įjunkite spausdintuvą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia gaminio ir lengvai pasiekiamas. spausdintuvo valymas valymas spausdintuvo vidus valymas spausdintuvo išorė"},{"UUID":"203f1023-74af-4b21-a34a-51997d5f0a1a","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Jutiklinio ekrano valymas Norėdami išvengti","descFull":"Jutiklinio ekrano valymas Norėdami išvengti elektros smūgio pavojaus valant spausdintuvo išorę, prieš pradėdami valyti ištraukite maitinimo laidą iš elektros lizdo ir atjunkite visus spausdintuvo laidus. Išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Drėgnu, minkštu, pūkelių neturinčiu audiniu nuvalykite jutiklinį ekraną. Nenaudokite buitinių valiklių ar ploviklių, kad nepažeistumėte jutiklinio ekrano. Įsitikinkite, kad nuvalius jutiklinis ekranas būtų sausas. Įkiškite maitinimo laidą į elektros lizdą ir įjunkite spausdintuvą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia gaminio ir lengvai pasiekiamas. jutiklinis ekranas valymas jutiklinio ekrano valymas"},{"UUID":"131cdd04-1005-4212-b988-fd0001d17787","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Skenerio valymas Atidarykite skenerio dangtį.","descFull":"Skenerio valymas Atidarykite skenerio dangtį. Drėgnu, minkštu, pūkelių neturinčiu audiniu nuvalykite šias vietas: ADT stiklo tarpiklį Skenerio stiklo tarpiklį ADT stiklą Skaitytuvo stiklą Uždarykite skenerio dangtį. skeneris valymas spausdinimo kokybė skenerio valymas skenerio valymas"},{"UUID":"9ca2e220-58f6-4738-8ee1-3c1e6f86e672","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Spausdinimo galvučių lęšių valymas Spausdinimo","descFull":"Spausdinimo galvučių lęšių valymas Spausdinimo galvučių lęšių valymas Atidarykite priekines dureles. Atblokuokite dažų atliekų konteinerį. Išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Įdėkite spausdinimo galvutės valytuvą atgal į vietą. Kiškite dažų atliekų konteinerį į spausdintuvą, kol pasigirs  spragtelėjimas . Užblokuokite dažų atliekų konteinerį. Uždarykite priekines dureles. spausdinimo galvučių lęšiai valymas spausdinimo galvučių lęšių valymas"},{"UUID":"402d331c-0bb1-405c-99f5-a7985989e75b","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Dėklo velenėlių komplekto valymas Išjunkite","descFull":"Dėklo velenėlių komplekto valymas Išjunkite spausdintuvą. Išimkite standartinį dėklą. Išimkite dėklo velenėlių komplektą. Prieš pasiekdami arba liesdami vidines spausdintuvo sritis, palieskite bet kurią neapsaugotą spausdintuvo metalinio korpuso vietą, kad išvengtumėte gedimų dėl elektrostatinės iškrovos. Užpilkite vandens ant minkšto, nepūkuoto audinio ir nuvalykite teikimo velenėlius. Kiškite velenėlių komplektą, kol pasigirs  spragtelėjimas . Įdėkite dėklą. Įjunkite spausdintuvą. dėklo velenėlių komplektas valymas dėklo velenėlių komplekto valymas"},{"UUID":"c919ac6c-7bf7-41e4-b3ae-7b999c09b25f","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"ADT velenėlių komplekto valymas Išjunkite","descFull":"ADT velenėlių komplekto valymas Išjunkite spausdintuvą. Atidarykite viršutinį ADT dangtį. Nuimkite skyriklio velenėlio dangtelį. Nuimkite skyriklio velenėlį. Užpilkite vandens ant minkšto, nepūkuoto audinio ir nuvalykite velenėlių komplektą. Įdėkite skyriklio velenėlį. Kiškite skyriklio velenėlio dangtelį, kol pasigirs  spragtelėjimas . Išimkite skyriklio velenėlių bloką. Užpilkite vandens ant minkšto, nepūkuoto audinio ir nuvalykite velenėlių komplektą. Kiškite skyriklio velenėlių bloką, kol pasigirs  spragtelėjimas . Uždarykite viršutinį ADT dangtį. Įjunkite spausdintuvą. ADT velenėlių komplektas valymas ADT velenėlių komplekto valymas"},{"UUID":"6a017c79-9586-4a19-9a08-cd75504efefb","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"2000 lapų dėklo velenėlių komplekto","descFull":"2000 lapų dėklo velenėlių komplekto valymas Išjunkite spausdintuvą. Pastumkite dėklą į kairę. Atidarykite J dureles, tada atidarykite velenėlių komplekto dangtį. Raskite ir nuimkite dėklo velenėlių komplektą. Užpilkite vandens ant minkšto, nepūkuoto audinio ir nuvalykite velenėlių komplektą. Įdėkite velenėlių komplektą. Uždarykite velenėlių komplekto dangtį, tada uždarykite J dureles. Pastumkite dėklą atgal į vietą. Įjunkite spausdintuvą. 2000 lapų dėklo tiekimo velenėliai valymas 2000 lapų dėklo tiekimo velenėlių valymas"},{"UUID":"1a31bf62-4c5c-46ca-8d8a-8ff8a4b202c0","title":"Spausdintuvo dalių valymas","link":"cleaning-printer-topic.html","desc":"Skylmušos dėžutės ištuštinimas Pakelkite popieriaus","descFull":"Skylmušos dėžutės ištuštinimas Pakelkite popieriaus gabenimo dangtį F. Išimkite ir ištuštinkite skylmušos dėžutę. Įdėkite skylmušos dėžutę. Uždarykite dangtį. skylmušos dėžutė ištuštinimas skylmušos dėžutės ištuštinimas"},{"UUID":"9f3cea1b-d030-48c9-b2db-69f4c44bad79","title":"Elektros energijos ir popieriaus taupymas","link":"configuring-power-save-mode-settings-topic.html","desc":"Energijos taupymo režimo nustatymų konfigūravimas","descFull":"Energijos taupymo režimo nustatymų konfigūravimas miego režimas Pradžios ekrane palieskite  Nustatymai Įrenginys Energijos sąnaudų valdymas Skirtieji laikai Miego režimas . Nurodykite spausdintuvo neveikos laiką prieš jam pereinant į  Miego režimą . užmigdymo režimas Pradžios ekrane palieskite  Nustatymai Įrenginys Energijos sąnaudų valdymas Skirtieji laikai Užmigdymo režimas . Pasirinkite spausdintuvo neveikos laiką prieš jam pereinant į užmigdymo režimą. Norėdami, kad veiktų nustatymas  Užmigdymo skirtasis laikas , parinktį  Užmigdymo skirtasis laikas prisijungiant  nustatykite į  Užmigdyti . Spausdintuvui veikiant  Užmigdymo  režimu įtaisytasis interneto serveris (EWS) būna išjungtas. miego režimas konfigūravimas užmigdymo režimas konfigūravimas aplinkos apsaugos nustatymai energijos taupymo režimai konfigūravimas"},{"UUID":"fdc7b9e9-0dd2-4a39-b843-336e264ce7f9","title":"Elektros energijos ir popieriaus taupymas","link":"configuring-power-save-mode-settings-topic.html","desc":"Ekrano skaisčio koregavimas Pradžios ekrane","descFull":"Ekrano skaisčio koregavimas Pradžios ekrane palieskite  Nustatymai Įrenginys Nuostatos . Meniu  Ekrano skaistis  pakoreguokite nustatymą. ekrano skaistis koregavimas skaisčio reguliavimas, koregavimas ekrano"},{"UUID":"b15d30a1-233d-493d-9248-973778251b1a","title":"Elektros energijos ir popieriaus taupymas","link":"configuring-power-save-mode-settings-topic.html","desc":"Eksploatacinių medžiagų taupymas Spausdinkite ant","descFull":"Eksploatacinių medžiagų taupymas Spausdinkite ant abiejų popieriaus pusių. Numatytasis nustatymas spausdinimo tvarkyklėje – abipusis spausdinimas. Spausdinkite keletą puslapių ant vieno popieriaus lapo. Naudokitės peržiūros funkcija, kad pažiūrėtumėte, kaip dokumentas atrodo prieš jį spausdinant. Atspausdinkite vieną dokumento kopiją, kad patikrintumėte, ar jo turinys ir formatas yra tinkami. eksploatacinių medžiagų taupymas eksploatacinės medžiagos taupymas"},{"UUID":"59f9a3ae-1a97-4f10-8bd3-b32dcd060173","title":"Spausdintuvo priežiūra","link":"moving-printer-topic.html","desc":"Spausdintuvo perkėlimas į kitą vietą","descFull":"Spausdintuvo perkėlimas į kitą vietą Spausdintuvo perkėlimas į kitą vietą Jei spausdintuvo svoris yra didesnis nei 20 kg (44 sv.), norint jį saugiai pakelti gali prireikti dviejų ar daugiau žmonių. Norėdami išvengti gaisro ar elektros smūgio pavojaus, naudokite tik kartu su šiuo gaminiu pateiktą maitinimo laidą arba gamintojo leistą pakaitinį laidą. Norėdami perkelti spausdintuvą, laikykitės šių nurodymų, kad būtų išvengta sužalojimų ar spausdintuvo sugadinimo: Įsitikinkite, kad visos durelės ir dėklai yra uždaryti. Išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Atjunkite visus spausdintuvo laidus ir kabelius. Jei prie spausdintuvo yra pritvirtinta atskirų pastatomų papildomų dėklų arba išvesčių įtaisų, prieš perkeldami spausdintuvą juos atskirkite. Jei spausdintuvas su ratukais, atsargiai nuridenkite jį į naują vietą. Būkite atsargūs ridendami per slenksčius ir grindų tarpus. Jei spausdintuvas ne su ratukais, bet yra sukonfigūruotas su papildomai pasirenkamais dėklais arba išvesčių įtaisais, pašalinkite papildomus išvesčių įtaisus ir nukelkite spausdintuvą nuo dėklų. Nebandykite tuo pačiu metu kelti ir spausdintuvo, ir papildomų įtaisų. Keldami spausdintuvą visada naudokitės ant jo esančiomis rankenomis. Į spausdintuvo perkėlimui naudojamo vežimėlio paviršių turi remtis visi spausdintuvo lietimosi taškai. Į pasirinktos aparatinės įrangos perkėlimui naudojamo vežimėlio paviršių įranga turi remtis visu dydžiu. Laikykite spausdintuvą vertikalioje padėtyje. Venkite staigių nedarnių judesių. Statydami spausdintuvą įsitikinkite, kad jūsų pirštai ne po spausdintuvu. Įsitikinkite, kad aplink spausdintuvą yra pakankamai erdvės. Jei spausdintuvas sugadinamas netinkamai jį perkeliant, garantija netaikoma. spausdintuvo perkėlimas"},{"UUID":"6ae97471-4961-49da-8c69-3ba6be843c1a","title":"Spausdintuvo priežiūra","link":"shipping-printer-topic.html","desc":"Spausdintuvo transportavimas Norėdami sužinoti, kaip","descFull":"Spausdintuvo transportavimas Norėdami sužinoti, kaip transportuoti, apsilankykite adresu  http://support.lexmark.com  arba kreipkitės į klientų aptarnavimo skyrių. Transportuodami spausdintuvą naudokite originalią pakuotę arba susisiekite su pirkimo vieta, kurioje įsigijote spausdintuvą. spausdintuvas transportavimas spausdintuvo transportavimas"},{"UUID":"cf89228e-1e83-495c-ab42-9620f7ac2d4d","title":"Trikties šalinimas","link":"print-quality-problems-topic.html","desc":"Spausdinimo kokybės problemos Raskite paveikslėlį,","descFull":"Spausdinimo kokybės problemos Raskite paveikslėlį, kuris yra panašus į jūsų spausdinimo kokybės problemą, ir spustelėję žemiau esančią nuorodą perskaitykite problemos sprendimo veiksmus."},{"UUID":"d1dae2d7-762f-4a3f-ab3a-9d5ba2c85bfd","title":"Trikties šalinimas","link":"printer-error-codes-topic.html","desc":"Spausdintuvo klaidų kodai Klaidų kodai","descFull":"Spausdintuvo klaidų kodai Klaidų kodai ir kaip jas išspręsti Klaidų kodai koks klaidos pranešimas; Sprendimas 2.01 Reikalingas keitimas / papildymas. Palieskite  Atšaukti užduotį  ir užsisakykite trūkstamą dalį. Norėdami gauti daugiau informacijos, žr.  . 3.01 Standartinė surinkimo dėžė pilna. Pašalinkite iš dėžės popierių ir palieskite  Tęsti . 3.21, 3.22, 3.23, 3.24 Ištraukite popierių už dėklo nr. [x]. Išimkite nurodytą dėklą. Pašalinkite visus šioje srityje užstrigusius popieriaus lapus.  Įdėkite dėklą. 7.13, 7.23, 7.33, 7.43, 7.53 Įdėkite dėklą nr. [x] Pamėginkite atlikti kurį nors iš šių veiksmų: Išimkite nurodytą dėklą. Atšaukite šią spausdinimo užduotį. 8.01 Uždarykite priekines dureles. Priekines dureles laikykite uždarytas, nebent atliekate techninę priežiūrą. 8.02, 8.03, 8.04, 8.05 Uždarykite [x] dureles. Nurodytas dureles laikykite uždarytas, nebent atliekate techninę priežiūrą. 8.06 Pridėkite dėklą nr. 5. Paslinkite dėklą į kairę, o atgal į vietą. 8.07 Uždarykite popieriaus gabenimo dangtį F. Laikykite popieriaus gabenimo dangtį F uždarytą, nebent atliekate techninę priežiūrą. 8.08 Uždarykite priekines sąsagėlių segiklio dureles. Priekines segiklio dureles laikykite uždarytas, nebent atliekate techninę priežiūrą. 8.09 Uždarykite sąsagėlių segiklio ir skylmušos įtaiso viršutinį dangtelį. Viršutines segiklio dureles laikykite uždarytas, nebent atliekate techninę priežiūrą. 9.00 Spausdintuvas turėjo būti paleistas iš naujo. Paskutinė užduotis gali būti nebaigta. Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . 11.11, 11.21, 11.31, 11.41, 11.51 Įdėkite [type] tipo ir [size] dydžio [source]. Į nurodytą dėklą įdėkite popierių. Norėdami gauti daugiau informacijos, žr.  . 11.12, 11.22, 11.32, 11.42, 11.52 Į [šaltinis] įdėkite [rūšis] [formatas] [orientacija]. 11.81, 11.91 Į daugiafunkcį tiektuvą įdėkite [rūšis] [formatas]. Į daugiafunkcį tiektuvą įdėkite popierių. Norėdami gauti daugiau informacijos, žr.  . 11.82, 11.92 Į daugiafunkcį tiektuvą įdėkite [rūšis] [formatas] [orientacija]. 12.11, 12.21, 12.31, 12.41, 12.51 Pakeiskite [šaltinis] į [rūšis] [formatas]. Ištraukite nurodytą dėklą, išimkite popierių ir įdėkite tinkamos rūšies ir formato popierių. Norėdami gauti daugiau informacijos, žr.  . 12.12, 12.22, 12.32, 12.42, 12.52 Pakeiskite [šaltinis] į [rūšis] [formatas] [orientacija]. 12.91 Pakeiskite daugiafunkcį tiektuvą į [rūšis] [formatas]. Išimkite popierių ir įdėkite tinkamos rūšies ir formato popierių. Norėdami gauti daugiau informacijos, žr.  . 12.92 Pakeiskite daugiafunkcį tiektuvą į [rūšis] [formatas] [orientacija]. 31.00 Įdėkite skylmušos dėžutę. Atidarykite popieriaus gabenimo dangtį F. Išimkite skylmušos dėžutę. Įdėkite skylmušos dėžutę. 31.35 Įdėkite trūkstamą arba nereaguojantį dažų atliekų konteinerį. Atidarykite priekines dureles. Atfiksuokite ir išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Įdėkite dažų atliekų konteinerį ir užsifiksuokite. Uždarykite priekines dureles. 31.40, 31.41, 31.42, 31.43 Įdėkite trūkstamą arba nereaguojančią [spalva] dažų kasetę. Atidarykite priekines dureles. Išimkite kasetę. Įdėkite kasetę Uždarykite priekines dureles. 31.60, 31.61, 31.62, 31.63 Sumontuokite trūkstamą arba pakeiskite neveikiantį [color] spalvos fotolaidininką. Atidarykite priekines dureles. Atfiksuokite ir išimkite dažų atliekų konteinerį. Konteinerį pastatykite vertikalioje padėtyje, kad neišbyrėtų dažai. Atfiksuokite ir išimkite fotolaidininko bloką. Įdėkite naują fotolaidininko bloką ir užfiksuokite. Įdėkite dažų atliekų konteinerį ir užsifiksuokite. Uždarykite priekines dureles. 32.40, 31.41, 31.42, 31.43 Pakeiskite netinkamą [spalva] dažų kasetę. Žr.  . 32.60, 32.61, 32.62, 32.63 Pakeiskite nesuderinamą [color] fotolaidininką. Žr.  . 34.00 Per trumpas popieriaus lapas. Nustatykite į dėklą įdėto popieriaus lapo formatą. Pradžios ekrane palieskite  Nustatymai Popierius Dėklas Konfigūracija Popieriaus formatas / tipas . 34.10, 34.20, 34.30, 34.40, 34.50 Patikrinkite [source], sureguliuokite kreiptuvus ir padėtį. Ištraukite nurodytą dėklą ir įsitikinkite, kad popierius įdėtas tinkamai. Norėdami gauti daugiau informacijos, žr.  . 34.90 Patikrinkite daugiafunkcį tiektuvą, sureguliuokite kreiptuvus ir padėtį. Įsitikinkite, kad popierius įdėtas tinkamai. Norėdami gauti daugiau informacijos, žr.  . 37.10 Nepakanka atminties užduočiai sudėstyti. Pamėginkite atlikti kurį nors iš šių veiksmų: Norėdami atspausdinti saugomos spausdinimo užduoties dalį ir pradėti dėstyti likusią spausdinimo užduotį, palieskite  Tęsti . Atšaukite šią spausdinimo užduotį. 37.30 Nepakanka atminties, kai kurios užlaikomos užduotys buvo pašalintos. Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . 38.10 Atmintis užpildyta. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Atšaukite šią spausdinimo užduotį. Įdiekite daugiau spausdintuvo atminties. Sumažinkite spausdinimo užduoties puslapių skaičių. 39.10 Sudėtingas puslapis, kai kurie duomenys galėjo nebūti išspausdinti. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Atšaukite šią spausdinimo užduotį. Įdiekite daugiau spausdintuvo atminties. Prieš vėl siųsdami spausdinti, sumažinkite spausdinimo užduoties sudėtingumą ir dydį. Sumažinkite spausdinimo užduoties puslapių skaičių. Sumažinkite atsisiųstų šriftų skaičių ir dydį. Spausdinimo užduotyje pašalinkite visus nereikalingus šriftus ar makrokomandas. Sumažinkite spausdinimo užduoties grafikos elementų skaičių. 51 Aptiktas sugadintas atmintukas. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Pakeiskite atmintuką. Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Atšaukite šią spausdinimo užduotį. 52 Atmintuke ištekliams nepakanka laisvos vietos. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Iš atmintuko pašalinkite šriftus, makrokomandas ir kitus duomenis. Įdėkite standųjį diską. Norėdami gauti daugiau informacijos, žr.  . Atsisiųsti šriftai ir makrokomandos, kurie anksčiau nebuvo išsaugoti atmintuke, pašalinami. 55.1 Klaida nuskaitant USB atmintuką. Išimkite USB atmintuką. Jei norite tęsti, išimkite atmintuką. 55.2 Klaida nuskaitant USB šakotuvą. Išimkite šakotuvą. Jei norite tęsti, išimkite USB šakotuvą. 55.3 Išjunkite ir pakeiskite režimą. 61 Išimkite sugedusį diską. Pakeiskite sugadintą atminties įrenginį. 62 Diskas užpildytas. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Iš standžiojo disko pašalinkite jame laikomus šriftus, makrokomandas ir kitus duomenis. Įdėkite standųjį diską. Norėdami gauti daugiau informacijos, žr.  . 63 Suformatuokite diską. Suformatavus dabar, iš atminties įrenginio bus išvalyta visa informacija. Jei atminties raktą norite suformatuoti, atlikite šiuos veiksmus: Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija priežiūra Nenaudojamus duomenis išvalyti . Palieskite parinktį  Apvalyti visą standžiajame diske esančią informaciją , po to palieskite  IŠVALYTI . 71.01 Nenustatytas faksimilinio ryšio stoties pavadinimas. Kreipkitės į sistemos administratorių. Žr.  . 71.02 Nenustatytas faksimilinio ryšio stoties numeris. Kreipkitės į sistemos administratorių. 71.03 Jokia analoginio telefono ryšio linija neprijungta prie modemo, faksas yra išjungtas. Patikrinkite ryšį ir liniją, ar yra signalas. Norėdami gauti daugiau informacijos, žr.  . 71.06 Nepavyko prisijungti prie HTTPS fakso serverio. Ryšys su HTTPS fakso serveriu atjungtas. Patikrinkite spausdintuvo interneto ryšį. 71.07 Spausdintuvas nėra užregistruotas HTTPS fakso serveryje. Įsitikinkite, kad spausdintuvas pridėtas prie HTTPS fakso serverio portalo įrenginių sąrašo. Kreipkitės į sistemos administratorių. 71.11 Fakso atskyrimas. Fakso atskyrimas neveikia. Kreipkitės į sistemos administratorių. 71.12 Atmintis užpildyta, nepavyksta atspausdinti faksogramų. Palieskite  Spausdinti viską , kad atspausdintumėte tiek faksogramų, kiek išsaugota. 71.13 Atmintis užpildyta. Nepavyksta išsiųsti faksogramų. Pamėginkite atlikti kurį nors iš šių veiksmų: Tęskite ir bandykite vėl išsiųsti faksogramą. Po vieną puslapį nuskenuokite originalų dokumentą, surinkite fakso numerį ir išsiųskite. 71.40 Netinkamai nustatytas spausdintuvo laikas. Nustatykite spausdintuvo laiką. Pradžios ekrane palieskite  Nustatymai Įrenginys Nuostatos Data ir laikas Konfigūruoti . 72.01 Nenustatytas el. pašto SMTP serveris. Kreipkitės į sistemos administratorių.  Pamėginkite atlikti kurį nors iš šių veiksmų: Nustatykite el. pašto funkciją. Norėdami gauti daugiau informacijos, žr.  . Pasyvinkite klaidos pranešimą. Norėdami gauti daugiau informacijos, žr.  . 72.02 Žiniatinklio serveris nenustatytas. Kreipkitės į sistemos administratorių. Kreipkitės į sistemos administratorių. 72.04 Nenustatytas fakso serverio nustatymas „Formatuoti“. Kreipkitės į sistemos administratorių. Pamėginkite atlikti kurį nors iš šių veiksmų: Pradžios ekrane palieskite  Nustatymai Faksas Fakso serverio sąranka Bendrieji fakso nustatymai .  Sukonfigūruokite nustatymą  „Formatuoti“ . Kreipkitės į sistemos administratorių. 80.21 Baigiasi eksploatacijos komplekto galiojimo laikas Norėdami pašalinti pranešimą, palieskite  Tęsti . 80.31 Pakeiskite eksploatacijos komplektą. Žr.  . 81.31 Baigėsi rekomenduojama velenėlių naudojimo trukmė; pakeiskite velenėlių rinkinį. Žr.  . 82.22 Dažų atliekų konteineris beveik pilnas. Norėdami pašalinti pranešimą, palieskite  Tęsti . 82.42 Pakeiskite dažų atliekų konteinerį. Žr.  . 83.20 Nebėra arba baigiasi sąsagėlės Pamėginkite atlikti kurį nors iš šių veiksmų: Išimkite ir vėl įdėkite sąsagėlių kasetę. Pakeiskite sąsagėlių kasetę. Norėdami gauti daugiau informacijos, žr.  . 83.30 Nebėra sąsagėlių arba jos paduodamos netinkamai 84.01 [Color] spalvos fotolaidininko blokas – beveik žemas lygis. Norėdami pašalinti pranešimą, palieskite  Tęsti . 84.11 [Color] spalvos fotolaidininko blokas – žemas lygis. 84.21 [Color] spalvos fotolaidininko blokas – labai žemas lygis. 84.31 Rekomenduojamas [Color] spalvos fotolaidininko bloko naudojimo laikas baigėsi; pakeiskite jį. Žr.  . 86.23 Neužilgo reikės atlikti skenerio techninės priežiūros darbus. Norėdami pašalinti pranešimą, palieskite  Tęsti . 86.33 Baigėsi rekomenduojama ADF rinkinio naudojimo trukmė; pakeiskite jį. Žr.  . 87.20 Skylamušos dėžutė beveik užsipildė. Norėdami pašalinti pranešimą, palieskite  Tęsti . 87.30 Ištuštinkite skylmušos dėžutę. Atidarykite popieriaus gabenimo dangtį F.  Išimkite ir ištuštinkite skylmušos dėžutę. Įdėkite skylmušos dėžutę. Uždarykite dangtį. 88.00[x] Beveik baigiasi [spalva] dažų kasetė. Norėdami pašalinti pranešimą, palieskite  Tęsti . 88.10[x] Baigiasi [spalva] dažų kasetė. 88.20[x] Visiškai baigiasi [spalva] dažų kasetė. 88.30[x], 88.40[x] Pakeiskite [color] spalvos dažų kasetę. Žr.  . 200.03, 240.06 Popieriaus strigtis, [strigties antraštė]. Žr.  . 200.16[x], 241.16a Popieriaus strigtis, [strigties antraštė]. Žr.  . 200.26[x], 200.36[x], 200.46[x], 200.56a, 202.95[x], 242.26, 242.33, 242.43, 243.33, 243.36, 243.43, 244.43, 244.46 Popieriaus strigtis, [strigties antraštė]. Žr.  . 200.56a, 245.53[x], 245.56 Popieriaus strigtis, [strigties antraštė]. Žr.  . 200.95, 201.96, 202.93, 202.94, 221.93, 221.95, 232.93, 240.25, 240.35, 240.55 Popieriaus strigtis, [strigties antraštė]. Žr.  . 280.06 Iš naujo įdėkite originalus į ADT ir iš naujo paleiskite užduotį. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Išimkite ir vėl įdėkite dokumentą į ADT. Nuskaitykite ant skaitytuvo stiklo padėtą dokumentą. Baikite užduotį nenuskenavę likusių puslapių. Atšaukite užduotį. 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95,\t281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13,\t283.15, 283.91, 283.93, 283.95, 284.11, 284.13, 284.15, 284.91, 284.93,\t284.95, 288.10,\t288.90, 295.01, 680.10 Skenerio strigtis. Žr.  . 280.13Q, 280.15Q, 295.01Q, 680.20Q Išimkite užstrigusius originalus. Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Išimkite ir vėl įdėkite dokumentą į ADT. Nuskaitykite ant skaitytuvo stiklo padėtą dokumentą. Baikite užduotį nenuskenavę likusių puslapių. Atšaukite užduotį. 280.13K, 280.15K, 680.20K, 680.40K, 295.01K,  Dar kartą įdėkite originalus ir pradėkite iš naujo. Pamėginkite atlikti kurį nors iš šių veiksmų: Išimkite ir vėl įdėkite dokumentą į ADT arba ant skaitytuvo stiklo. Atšaukite užduotį. 420.11a, 420.13a, 420.15a, 420.15b, 420.54a, 420.54b, 425.13a Popieriaus strigtis, [strigties antraštė]. Žr.  . 400,13, 400.13b, 420.13b, 420.15b, 420.54c, 450.23b, 450.91b, 451.33b, 454.23b, 454.25b, 457.25b Popieriaus strigtis, [strigties antraštė]. Žr.  . 457.35b Popieriaus strigtis, [strigties antraštė]. Jei sumontavote sąsagėlių segiklį, žr.  . Jei sumontavote sąsagėlių segiklį ir skylamušą, žr.  . klaidų kodai klaidų pranešimai"},{"UUID":"325ac46e-9c5c-40f9-91fc-3030012b0c8d","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Tušti arba balti lapai Prieš","descFull":"Tušti arba balti lapai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas  Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar spausdintuve naudojama originali ir tinkama „Lexmark“ dažų kasetė. Patikrinkite, ar spausdintuve naudojama originali ir tinkama dažų kasetė. Jei dažų kasetė netinkama, įdėkite tinkamą. Atspausdinkite dokumentą. Ar spausdintuvas spausdina tuščius arba baltus lapus? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spausdintuvas spausdina tuščius arba baltus lapus? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė tušti puslapiai trikčių šalinimas, spausdinimo kokybė balti puslapiai spausdinimo kokybės trikčių šalinimas balti puslapiai spausdinimo kokybės trikčių šalinimas juodi puslapiai tušti puslapiai balti puslapiai"},{"UUID":"db0f2254-dc97-4a4a-8d26-a63583145df2","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Spausdinama per tamsiai Prieš spręsdami","descFull":"Spausdinama per tamsiai Prieš spręsdami problemą, išspausdinkite kokybiškus pavyzdinius puslapius, kad nustatytumėte trūkstamą spalvą. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas  Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinimas Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Atspausdinkite dokumentą. Ar spausdinama per tamsiai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos sumažinkite dažų tamsumą „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Nustatymus galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Dažų tamsumas . Atspausdinkite dokumentą. Ar spausdinama per tamsiai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymai atitinka į dėklą įdėto popieriaus nustatymus. Nustatymus galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spausdinama per tamsiai? Eikite į 6 veiksmą. Įsitikinkite, kad popieriaus paviršius nėra reljefiškas arba šiurkštus. Ar spausdinate ant reljefiško arba šiurkštaus popieriaus? Eikite į 6 veiksmą. Popierių reljefišku arba šiurkščiu paviršiumi pakeiskite paprastu. Atspausdinkite dokumentą. Ar spausdinama per tamsiai? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Atspausdinkite dokumentą. Ar spausdinama per tamsiai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spausdinama per tamsiai spausdinimo kokybės trikčių šalinimas spausdinama per tamsiai spausdinama per tamsiai"},{"UUID":"a9b8a274-7a22-4d30-ae8b-2078c395d6d4","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Sudvejinti vaizdai Prieš spręsdami problemą,","descFull":"Sudvejinti vaizdai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Į dėklą įdėkite tinkamos rūšies ir svorio popierių. Atspausdinkite dokumentą. Ar spaudiniuose matomi sudvejinti vaizdai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka į dėklą įdėto popieriaus nustatymą. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spaudiniuose matomi sudvejinti vaizdai? Problema išspręsta. Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinimas Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Atspausdinkite dokumentą. Ar spaudiniuose matomi sudvejinti vaizdai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spaudiniuose matomi sudvejinti vaizdai spausdinimo kokybės trikčių šalinimas spaudiniuose matomi sudvejinti vaizdai sudvejinti vaizdai"},{"UUID":"f402ab67-eed1-4095-9927-5c3e4ca4dbe2","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Pilkas arba spalvotas fonas Prieš","descFull":"Pilkas arba spalvotas fonas Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos padidinkite dažų tamsumą „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Dažų tamsumas . Atspausdinkite dokumentą. Ar spaudiniuose matyti pilkas arba spalvotas fonas? Problema išspręsta. Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinimas Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Atspausdinkite dokumentą. Ar spaudiniuose matyti pilkas arba spalvotas fonas? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spaudiniuose matyti pilkas arba spalvotas fonas? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė pilkas arba spalvotas fonas spausdinimo kokybės trikčių šalinimas pilkas arba spalvotas fonas pilkas fonas spaudinyje spalvotas fonas spaudinyje"},{"UUID":"02f2f5a1-a654-4222-92f8-f34dfd43e778","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Neteisingos paraštės Veiksmai sprendžiant šią","descFull":"Neteisingos paraštės Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Perkelkite popieriaus kreiptuvus dėkle į įdėtam popieriui tinkamą padėtį. Atspausdinkite dokumentą. Ar paraštės teisingos? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus formatą nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar paraštės teisingos? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . neteisingos paraštės spausdinimo trikčių šalinimas neteisingos paraštės trikčių šalinimas, spausdinimas neteisingos paraštės"},{"UUID":"60072ca6-bf35-4891-ba21-a292558bfb39","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Spausdinama per šviesiai Prieš spręsdami","descFull":"Spausdinama per šviesiai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinimas Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos padidinkite dažų tamsumą „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Dažų tamsumas . Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Išjunkite funkciją  Spalvų taupymas . Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Spalvų taupymas . Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Patikrinkite, ar popieriaus paviršius nėra reljefiškas arba šiurkštus. Ar spausdinate ant reljefiško arba šiurkštaus popieriaus? Eikite į 7 veiksmą. Popierių reljefišku arba šiurkščiu paviršiumi pakeiskite paprastu. Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Atspausdinkite dokumentą. Ar spausdinama per šviesiai? Problema išspręsta. Išimkite ir vėl įdėkite dažų atliekų konteinerį. Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinimas Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Ar spausdinama per šviesiai? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Spausdinama per šviesiai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spausdinama per šviesiai spausdinimo kokybės trikčių šalinimas spausdinama per šviesiai spausdinama per šviesiai"},{"UUID":"1d44d0ce-8278-4848-aa19-033ea78865cc","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Trūksta spalvų Prieš spręsdami problemą,","descFull":"Trūksta spalvų Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Išimkite trūkstamos spalvos fotolaidininko bloką. Saugokite fotolaidininko bloką nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įdėkite fotolaidininko bloką. Išimkite trūkstamos spalvos dažų kasetę. Įdėkite trūkstamos spalvos dažų kasetę. Atspausdinkite dokumentą. Spaudiniuose trūksta kai kurių spalvų? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė trūksta spalvų spausdinimo kokybės trikčių šalinimas trūksta spalvų trūksta spalvų"},{"UUID":"7c62fd33-ab84-4195-ac78-c0405d900f25","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Spausdinama taškuotai Prieš spręsdami problemą,","descFull":"Spausdinama taškuotai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar išbirę dažai neužteršė spausdintuvo. Ar spausdintuve nėra išbirusių dažų? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Patikrinkite, ar popieriaus formatas ir rūšis atitinka įdėto popieriaus nustatymus. Įsitikinkite, kad popieriaus paviršius nėra reljefiškas arba šiurkštus. Ar nustatymai atitinka? Eikite į 4 veiksmą. Priklausomai nuo savo operacinės sistemos popieriaus formatą ir rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymai atitinka į dėklą įdėto popieriaus nustatymus. Nustatymus galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spausdinama taškuotai? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Atspausdinkite dokumentą. Ar spausdinama taškuotai? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spausdinama taškuotai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spausdinama taškuotai spausdinimo kokybės trikčių šalinimas spausdinama taškuotai spausdinama taškuotai taškeliai atspausdintame puslapyje"},{"UUID":"cc5a77b8-1474-41ce-8625-bf2ffd34a17d","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Popierius užsiriečia Veiksmai sprendžiant šią","descFull":"Popierius užsiriečia Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Perkelkite kreiptuvus dėkle į įdėtam popieriui tinkamą padėtį. Atspausdinkite dokumentą. Ar popierius užsirietęs? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar popierius užsirietęs? Problema išspręsta. Spausdinkite ant kitos popieriaus pusės. Popierių išimkite, apverskite ir vėl įdėkite. Atspausdinkite dokumentą. Ar popierius užsirietęs? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Atspausdinkite dokumentą. Ar popierius užsirietęs? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė popierius užsiriečia spausdinimo kokybės trikčių šalinimas popierius užsiriečia"},{"UUID":"3983a530-1356-4fda-9381-232bc2744cf8","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Spausdinama kreivai arba iškreiptai Prieš","descFull":"Spausdinama kreivai arba iškreiptai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Ištraukite dėklą. Išimkite ten esantį popierių ir įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Perkelkite popieriaus kreiptuvus dėkle į įdėtam popieriui tinkamą padėtį. Įdėkite dėklą. Atspausdinkite dokumentą. Ar spausdinama kreivai arba iškreiptai? Problema išspręsta. Įsitikinkite, kad spausdinate ant palaikomo popieriaus. Atspausdinkite dokumentą. Ar spausdinama kreivai arba iškreiptai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spausdinama sukreivintai spausdinimo kokybės trikčių šalinimas spausdinama sukreivintai trikčių šalinimas, spausdinimo kokybė spausdinama kreivai spausdinimo kokybės trikčių šalinimas spausdinama kreivai spausdinama kreivai spausdinama sukreivintai"},{"UUID":"c271d78c-e7d3-4cb0-a57b-41b8a4de30df","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Vientisi spalvoti arba nespalvoti atvaizdai","descFull":"Vientisi spalvoti arba nespalvoti atvaizdai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spausdintuvas spausdina vientisus spalvotus arba juodus puslapius? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė vientisi spalvoti arba nespalvoti atvaizdai spausdinimo kokybės trikčių šalinimas vientisi spalvoti arba nespalvoti atvaizdai grynoji spalva nespalvoti vaizdai"},{"UUID":"837ca55b-9bb2-411a-b7ce-83a09efe01bc","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Nukirptas tekstas arba atvaizdai Prieš","descFull":"Nukirptas tekstas arba atvaizdai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Perkelkite popieriaus kreiptuvus dėkle į įdėtam popieriui tinkamą padėtį. Atspausdinkite dokumentą. Tekstas arba vaizdas nukirptas? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus formatą nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka į dėklą įdėto popieriaus nustatymą. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Tekstas arba vaizdas nukirptas? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Tekstas arba vaizdas nukirptas? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė nukirptas tekstas arba atvaizdai spausdinimo kokybės trikčių šalinimas nukirptas tekstas arba atvaizdai nukirptas tekstas spaudiniuose nukirpti vaizdai spaudiniuose"},{"UUID":"04100c3a-91f9-4416-a48b-8e789d4c7bfd","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Dažai lengvai nusitrina Prieš spręsdami","descFull":"Dažai lengvai nusitrina Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Dažai vis tiek nusitrina? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė lengvai nusitrina dažai spausdinimo kokybės trikčių šalinimas lengvai nusitrina dažai lengvai nusitrina dažai"},{"UUID":"4057574a-19d5-4e61-83f4-6244ef21f2fe","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Netolygus spausdinimo tankis Prieš spręsdami","descFull":"Netolygus spausdinimo tankis Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Pakeiskite fotolaidininko blokus ir atspausdinkite dokumentą. Ar spausdinimo tankis netolygus? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė netolygus spausdinimo tankis spausdinimo kokybės trikčių šalinimas netolygus spausdinimo tankis netolygus spausdinimo tankis"},{"UUID":"fa0c60b3-812e-4d4a-baeb-632f9dbfe608","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Horizontalios tamsios linijos Prieš spręsdami","descFull":"Horizontalios tamsios linijos Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Jei spaudiniuose vis tiek matomos horizontalios tamsios linijos, žr. temą „Pasikartojantys defektai“. Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Iki naudodami, popierių laikykite originalioje pakuotėje. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė horizontalios tamsios linijos spausdinimo kokybės trikčių šalinimas horizontalios tamsios linijos horizontalios tamsios linijos"},{"UUID":"a6408cba-3db0-4374-b692-08dfafcfc0a5","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Vertikalios tamsios linijos Prieš spręsdami","descFull":"Vertikalios tamsios linijos Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka į dėklą įdėto popieriaus nustatymą. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios tamsios linijos? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Iki naudodami, popierių laikykite originalioje pakuotėje. Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios tamsios linijos? Problema išspręsta. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios tamsios linijos? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė spaudiniuose matomos vertikalios tamsios linijos spausdinimo kokybės trikčių šalinimas spaudiniuose matomos vertikalios tamsios linijos spaudiniuose matomos vertikalios tamsios linijos"},{"UUID":"c53946d6-742a-4db8-a858-06a18fc9155a","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Horizontalios baltos linijos Prieš spręsdami","descFull":"Horizontalios baltos linijos Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Jei spaudiniuose vis tiek matomos horizontalios baltos linijos, žr. temą „Pasikartojantys defektai“. Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka į dėklą įdėto popieriaus nustatymą. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spaudiniuose matomos horizontalios baltos linijos? Problema išspręsta. Į nurodytą popieriaus šaltinį įdėkite rekomenduojamos rūšies popierių. Atspausdinkite dokumentą. Ar spaudiniuose matomos horizontalios baltos linijos? Problema išspręsta. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spaudiniuose matomos horizontalios baltos linijos? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė horizontalios baltos linijos spausdinimo kokybės trikčių šalinimas horizontalios baltos linijos horizontalios baltos linijos"},{"UUID":"b5621bf2-e94e-4530-aec9-d70d08e85f0d","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Vertikalios baltos linijos Prieš spręsdami","descFull":"Vertikalios baltos linijos Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka į dėklą įdėto popieriaus nustatymą. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios baltos linijos? Problema išspręsta. Patikrinkite, ar naudojate rekomenduojamos rūšies popierių. Į nurodytą popieriaus šaltinį įdėkite rekomenduojamos rūšies popierių. Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios baltos linijos? Problema išspręsta. Nuimkite spausdinimo galvutės valytuvą ir išvalykite spausdinimo galvutės lęšius. Atspausdinkite dokumentą. Spaudiniuose matomos tamsios horizontalios linijos? Problema išspręsta. Išimkite fotolaidininko blokus. Saugokite fotolaidininko blokus nuo tiesioginės šviesos. Dėl ilgo buvimo šviesoje gali kilti spausdinimo kokybės problemų. Nelieskite fotolaidininko būgno. Tai gali turėti neigiamos įtakos būsimų spausdinimo užduočių kokybei. Įstatykite fotolaidininko blokus. Atspausdinkite dokumentą. Ar spaudiniuose matomos vertikalios baltos linijos? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimo kokybė vertikalios baltos linijos spausdinimo kokybės trikčių šalinimas vertikalios baltos linijos vertikalios baltos linijos"},{"UUID":"e47079a9-8060-4ab0-8228-a86e0551b442","title":"Prasta spausdinimo kokybė","link":"solving-printing-problems.html","desc":"Pasikartojantys defektai Prieš spręsdami problemą,","descFull":"Pasikartojantys defektai Prieš spręsdami problemą, atsispausdinkite spausdinimo kokybės testavimo puslapius. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Naudodamiesi puslapiu „Eksploatacijos defektų liniuotė“, atitinkamame spalvotame lape išmatuokite atstumą tarp pasikartojančių defektų. Pakeiskite eksploatacinę medžiagą, kuri atitinka matavimą atitinkamame spalvotame lape. Fotolaidininko blokas 94,5 mm (3,72 col.) 38 mm (1,5 col.). Ryškalo blokas 28,7 mm (1,13 col.) Atspausdinkite spausdinimo kokybės testavimo puslapius. Ar matomi defektai? Įsidėmėję atstumą kreipkitės į  klientų aptarnavimo skyrių  arba savo aptarnavimo atstovą. Įsidėmėję atstumą kreipkitės į  techninės pagalbos skyrių  arba „Dell“ spausdintuvų prekybos atstovą. Problema išspręsta. Naudodamiesi puslapiu „Eksploatacijos defektų liniuotė“, atitinkamame spalvotame lape išmatuokite atstumą tarp pasikartojančių defektų. Pakeiskite eksploatacinę medžiagą, kuri atitinka matavimą atitinkamame spalvotame lape. Antras perdavimo velenas 56,5 mm (2,22 col.) Kaitintuvas 95,1 mm (3,74 col.) 82,5 mm (3,25 col.) Perdavimo diržas 56,8 mm (2,24 col.) 19,1 mm (0,75 col.) 31,7 mm (1,25 col.) 70,9 mm (2,79 col.) 41,0 mm (1,61 col.) Atspausdinkite spausdinimo kokybės testavimo puslapius. Ar matomi defektai? Įsidėmėję atstumą kreipkitės į  klientų aptarnavimo skyrių  arba savo aptarnavimo atstovą. Įsidėmėję atstumą kreipkitės į  techninės pagalbos skyrių  arba „Dell“ spausdintuvų prekybos atstovą. Problema išspręsta. spausdinimo kokybės trikčių šalinimas pasikartojantys spausdinimo defektai trikčių šalinimas, spausdinimo kokybė pasikartojantys spausdinimo defektai pasikartojantys spausdinimo defektai"},{"UUID":"5b92a6ce-ed77-4819-9370-66efe7380c7a","title":"Spausdinimo problemos","link":"solving-printing-problems.html","desc":"Spausdinimo užduotys nespausdinamos Veiksmai sprendžiant","descFull":"Spausdinimo užduotys nespausdinamos Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Dokumente, kurį bandote atspausdinti, atidarykite dialogo langą „Spausdinimas“ ir patikrinkite, ar pasirinkote tinkamą spausdintuvą. Atspausdinkite dokumentą. Ar dokumentas spausdinamas? Problema išspręsta. Patikrinkite, ar spausdintuvas įjungtas. Imkitės veiksmų, susijusių su visais ekrane rodomais klaidų pranešimais. Atspausdinkite dokumentą. Ar dokumentas spausdinamas? Problema išspręsta. Patikrinkite, ar veikia prievadai ir ar tvirtai prijungti laidai prie kompiuterio ir spausdintuvo. Norėdami gauti daugiau informacijos, žr sąrankos dokumentaciją, kurią gavote kartu su spausdintuvu. Atspausdinkite dokumentą. Ar dokumentas spausdinamas? Problema išspręsta. Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Atspausdinkite dokumentą. Ar dokumentas spausdinamas? Problema išspręsta. Pašalinkite ir vėl įdiekite spausdinimo tvarkyklę. Atspausdinkite dokumentą. Ar dokumentas spausdinamas? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . trikčių šalinimas, spausdinimas nespausdinamos spausdinimo užduotys spausdinimo trikčių šalinimas nespausdinamos spausdinimo užduotys nespausdinamos spausdinimo užduotys"},{"UUID":"a7d9ff33-a364-483c-894c-777bd4cf5ef9","title":"Spausdinimo problemos","link":"solving-printing-problems.html","desc":"Nespausdinami konfidencialūs ir kiti turimi","descFull":"Nespausdinami konfidencialūs ir kiti turimi dokumentai Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Valdymo skydelyje patikrinkite, ar dokumentai rodomi sąraše  Turimos užduotys . Jei dokumentų sąraše nėra, juos atspausdinkite naudodamiesi parinktimis Spausdinti ir laikyti. Atspausdinkite dokumentus. Ar dokumentai spausdinami? Problema išspręsta. Spausdinimo užduotyje gali būti formatavimo klaida ar neteisingi duomenys. Pašalinkite spausdinimo užduotį ir išsiųskite ją dar kartą. Jei norite spausdinti PDF failus,sukurkite naują failą ir atspausdinkite dokumentus. Ar dokumentai spausdinami? Problema išspręsta. Jei spausdinate iš interneto, spausdintuvas keleto užduočių pavadinimus gali nuskaityti kaip besidubliuojančius. „Windows“ naudotojams Atidarykite dialogo langą „Spausdinimo parinktys“. Ąselėje „Spausdinti ir laikyti“ spustelėkite  Naudoti „Spausdinti ir laikyti“ , po to spustelėkite  Laikyti pasikartojančius dokumentus . Įveskite PIN kodą ir išsaugokite pakeitimus. Išsiųskite spausdinimo užduotį. „Macintosh“ naudotojams Kiekvieną užduotį išsaugokite ir pavadinkite skirtingai. Atskirai išsiųskite užduotį. Ar dokumentai spausdinami? Problema išspręsta. Pašalinkite keletą turimų užduočių, kad atlaisvintumėte vietos spausdintuvo atmintyje. Atspausdinkite dokumentus. Ar dokumentai spausdinami? Problema išspręsta. Spausdintuve pridėkite atminties. Atspausdinkite dokumentus. Ar dokumentai spausdinami? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, spausdinimas nespausdinami konfidencialūs ir kiti turimi dokumentai spausdinimo trikčių šalinimas nespausdinami konfidencialūs ir kiti turimi dokumentai nespausdinami konfidencialūs dokumentai nespausdinami turimi dokumentai"},{"UUID":"06720d39-0cd0-4be4-b1af-b93b0354271c","title":"Spausdinimo problemos","link":"solving-printing-problems.html","desc":"Užduotis spausdinama ne iš to","descFull":"Užduotis spausdinama ne iš to dėklo arba ne ant to popieriaus Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar spausdinate ant tinkamo popieriaus. Atspausdinkite dokumentą. Ar dokumentas atspausdintas ant tinkamo popieriaus? Įdėkite tinkamo formato ir rūšies popierių. Priklausomai nuo savo operacinės sistemos popieriaus formatą ir rūšį  nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Nustatymus galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Įsitikinkite, kad nustatymai atitinka įdėto popieriaus nustatymus. Atspausdinkite dokumentą. Ar dokumentas atspausdintas ant tinkamo popieriaus? Problema išspręsta. Patikrinkite, ar dėklai susieti. Norėdami gauti daugiau informacijos, žr.  . Atspausdinkite dokumentą. Ar dokumentas atspausdintas iš tinkamo dėklo? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . spausdinimo trikčių šalinimas užduotis spausdinama ne iš to dėklo spausdinimo trikčių šalinimas užduotis spausdinama ne ant to popieriaus trikčių šalinimas, spausdinimas užduotis spausdinama ne iš to dėklo trikčių šalinimas, spausdinimas užduotis spausdinama ne ant to popieriaus užduotis spausdinama ne iš to dėklo užduotis spausdinama ne ant to popieriaus"},{"UUID":"b03905e3-e696-4536-aece-25361e230bb3","title":"Spausdinimo problemos","link":"solving-printing-problems.html","desc":"Spausdinama per lėtai Veiksmai sprendžiant","descFull":"Spausdinama per lėtai Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad spausdintuvo laidas tvirtai prijungtas prie spausdintuvo ir kompiuterio, spausdinimo serverio, papildomos įrangos arba kito tinklo įrenginio. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Įsitikinkite, kad spausdintuve nėra nustatytas  Tylusis režimas . Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Įrenginio veiksenos Tylusis režimas . Atspausdinkite dokumentą. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Priklausomai nuo jūsų operacinės sistemos spausdinimo skiriamąją gebą nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Nustatykite  2400 tšk./col. vaizdo Q  skiriamąją gebą. Atspausdinkite dokumentą. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Priklausomai nuo savo operacinės sistemos popieriaus rūšį nurodykite „Spausdinimo parinktyse“ arba dialogo lange „Spausdinti“. Įsitikinkite, kad nustatymas atitinka įdėto popieriaus nustatymus. Nustatymą galima pakeisti ir spausdintuvo valdymo skydelyje. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Ant sunkesnio popieriaus spausdinama lėčiau. Lėčiau gali būti spausdinama ir ant popieriaus, kuris yra siauresnis nei „Letter“, A4 ar „Legal“. Atspausdinkite dokumentą. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Įsitikinkite, kad spausdintuvo nustatymai popieriaus tekstūrai ir svoriui tinka įdėtam popieriui. Pradžios ekrane palieskite  Nustatymai Popierius Laikmenų konfigūracija Laikmenų rūšys . Ant šiurkščios tekstūros ir didelio svorio popieriaus gali būti spausdinama lėčiau. Atspausdinkite dokumentą. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Pašalinkite turimas užduotis. Ar spausdintuvas spausdina per lėtai? Problema išspręsta. Įsitikinkite, kad spausdintuvas neperkaista. Po ilgos spausdinimo užduoties leiskite spausdintuvui atvėsti. Laikykitės spausdintuvo laikymui rekomenduojamos aplinkos temperatūros. Norėdami gauti daugiau informacijos, žr.  . Atspausdinkite dokumentą. Ar spausdintuvas spausdina per lėtai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. spausdinimo trikčių šalinimas spausdinama per lėtai trikčių šalinimas, spausdinimas spausdinama per lėtai spausdinama per lėtai"},{"UUID":"1da048a2-96a8-496c-b1c4-3b5e2e9efd3f","title":"Trikties šalinimas","link":"trb-printer-not-responding-topic.html","desc":"Spausdintuvas nereaguoja Veiksmai sprendžiant šią","descFull":"Spausdintuvas nereaguoja Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar maitinimo laidas įjungtas į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Ar spausdintuvas reaguoja? Problema išspręsta. Patikrinkite, ar elektros lizdas nėra išjungtas jungikliu arba pertraukikliu. Ar elektros lizdas nėra išjungtas jungikliu arba pertraukikliu? Įjunkite jungiklį arba iš naujo nustatykite pertraukiklį. Patikrinkite, ar spausdintuvas įjungtas. Ar spausdintuvas įjungtas? Įjunkite spausdintuvą. Patikrinkite, ar spausdintuvas neveikia miego arba užmigdymo režimu. Ar spausdintuvas veikia miego arba užmigdymo režimu? Paspauskite įjungimo mygtuką, kad pažadintumėte spausdintuvą. Patikrinkite, ar spausdintuvą ir kompiuterį jungiantys laidai įkišti į tinkamus prievadus. Ar laidai įkišti į tinkamus prievadus? Įkiškite laidus į tinkamus prievadus. Išjunkite spausdintuvą, įdėkite papildomą aparatinę įrangą ir vėl jį įjunkite. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su papildoma įranga. Ar spausdintuvas reaguoja? Problema išspręsta. Įdiekite tinkamą spausdinimo tvarkyklę. Ar spausdintuvas reaguoja? Problema išspręsta. Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Ar spausdintuvas reaguoja? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių. Kreipkitės į  techninės pagalbos skyrių. . trikčių šalinimas spausdintuvas nereaguoja spausdintuvas nereaguoja"},{"UUID":"6f2ab3f6-f17a-4bd8-a9c9-18bef80ea940","title":"Trikties šalinimas","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Nepavyksta nuskaityti atmintuko Veiksmai sprendžiant","descFull":"Nepavyksta nuskaityti atmintuko Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar spausdintuvas tuo metu neatlieka kitos spausdinimo, kopijavimo, nuskaitymo ar faksogramos siuntimo užduoties. Ar spausdintuvas pasiruošęs? Eikite į 3 veiksmą. Palaukite, kol spausdintuvas baigs apdoroti kitą užduotį. Išimkite ir vėl įkiškite atmintuką. Ar spausdintuvas atpažįsta atmintuką? Problema išspręsta. Patikrinkite, ar atmintukas įkištas į priekinį USB lizdą. Atmintukas neveiks, jei jis įkištas į galinį USB lizdą. Ar atmintukas įkištas į tinkamą lizdą? Eikite į 5 veiksmą. Įkiškite atmintuką į tinkamą lizdą. Ar spausdintuvas atpažįsta atmintuką? Problema išspręsta. Patikrinkite, ar atmintukas yra palaikomas. Norėdami gauti daugiau informacijos, žr.  . Ar atmintukas palaikomas? Eikite į 7 veiksmą. Įkiškite palaikomą atmintuką. Ar spausdintuvas atpažįsta atmintuką? Problema išspręsta. Išimkite ir vėl įkiškite atmintuką. Ar spausdintuvas atpažįsta atmintuką? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . nepavyksta nuskaityti atmintuko trikčių šalinimas, spausdinimas spausdinimo trikčių šalinimas nepavyksta nuskaityti atmintuko"},{"UUID":"e320815d-9fc8-4380-92b9-1d9a1fc2e83d","title":"Trikties šalinimas","link":"enabling-usb-port-topic.html","desc":"USB jungties įgalinimas Pradžios ekrane","descFull":"USB jungties įgalinimas Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai USB Įgalinti USB jungtį . USB jungtis įgalinimas USB jungties įgalinimas"},{"UUID":"12aa36f7-34dd-4fa6-84a1-31541280cdfe","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Kaip išvengti strigčių Tinkamai įdėkite","descFull":"Kaip išvengti strigčių Tinkamai įdėkite popierių Įsitikinkite, kad popierius dėkle guli lygiai. Tinkamas ir netinkamas popieriaus įdėjimas Tinkamas popieriaus įdėjimas Netinkamas popieriaus įdėjimas Nedėkite popieriaus ir neišimkite dėklo spausdintuvui spausdinant. Nedėkite per daug popieriaus. Įsitikinkite, kad popieriaus pluoštas yra žemiau maksimalaus popieriaus užpildymo indikatoriaus. Nestumkite popieriaus į dėklą. Dėkite popierių, kaip parodyta iliustracijoje. Įsitikinkite, kad popieriaus kreiptuvai yra nustatyti teisingai ir ne per stipriai spaudžia popierių ar vokus. Įdėję popieriaus tvirtai įstumkite dėklą į spausdintuvą. Naudokite rekomenduojamą popierių Naudokite tik rekomenduojamą popierių arba specialiąsias laikmenas. Nedėkite susiraukšlėjusio, sulenkto, drėgno, sulankstyto arba užsirietusio popieriaus. Prieš dėdami popierių, jį palankstykite, pavėduokite ir sulyginkite lapų kraštus. Nenaudokite ranka nukirpto ar patrumpinto popieriaus. Tame pačiame dėkle nedėkite skirtingų formatų, svorių ar rūšių popieriaus. Įsitikinkite, kad kompiuteryje ar spausdintuvo valdymo skydelyje popieriaus formatas ir rūšis yra tinkamai nustatyti. Popierių laikykite laikydamiesi gamintojo rekomendacijų. popieriaus strigtys kaip išvengti strigtys, popierius kaip išvengti kaip išvengti popieriaus strigčių"},{"UUID":"4cd849c7-1e0b-4081-918d-6b54cd5e8b86","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Strigčių vietų nustatymas Kai funkcijos","descFull":"Strigčių vietų nustatymas Kai funkcijos  Strigčių pagelbiklis  nustatymas –  Įjungta , pašalinus užstrigusį puslapį spausdintuvas išleidžia tuščius puslapius arba puslapius su daliniais spaudiniais. Patikrinkite, ar tarp spaudinių nėra tuščių lapų. Kai funkcijos  Atkūrimas po strigčių  nustatymas –  Įjungta  arba  Automatiškai , užstrigusius lapus spausdintuvas atspausdina iš naujo. Strigčių vietos Strigčių vietos 1 Daugiafunkcis tiektuvas 2 A durelės 3 Automatinis dokumentų tiektuvas 4 Standartinė dėtuvė 5 Horizontalaus perkėlimo blokas 6 Sąsagėlių segimo, skylmušos įtaisas 7 Standartinis dėklas 8 2000 lapų dėklas 9 Sąsagėlių segiklis 10 Papildomi dėklai popieriaus strigtys vietos nustatymas strigčių vietos nustatymas"},{"UUID":"61c2e887-3ddb-488e-8224-d3cd37c54674","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis standartiniame dėkle Atidarykite","descFull":"Popieriaus strigtis standartiniame dėkle Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Ištraukite standartinį dėklą. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Įdėkite dėklą, tada uždarykite A dureles. strigties šalinimas standartiniame dėkle popieriaus strigties šalinimas standartiniame dėkle popieriaus strigtis standartiniame dėkle"},{"UUID":"068775f4-f161-4841-af73-59b953b7f252","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis papildomuose dėkluose Atidarykite","descFull":"Popieriaus strigtis papildomuose dėkluose Atidarykite B dureles. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite dureles. Ištraukite papildomą 520 lapų dėklą arba 2000 lapų sudvejintą dėklą. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Sudvejintuose dėkluose ištraukite C rankeną, tada atidarykite vidinį dangtį. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite dangtį ir įdėkite C rankeną. Įdėkite dėklą. strigties šalinimas B durelėse strigties šalinimas 520 lapų dėkle strigties šalinimas 2000 lapų sudvejintame dėkle popieriaus strigties šalinimas B durelėse popieriaus strigties šalinimas 520 lapų dėkle popieriaus strigties šalinimas 2000 lapų sudvejintame dėkle popieriaus strigtis B durelėse popieriaus strigtis 520 lapų dėkle popieriaus strigtis 2000 lapų sudvejintame dėkle popieriaus strigtis papildomuose dėkluose strigties šalinimas papildomuose dėkluose popieriaus strigties šalinimas papildomuose dėkluose"},{"UUID":"43320a38-2e88-497f-845d-6a6d24940723","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis daugiafunkciame tiektuve Išimkite","descFull":"Popieriaus strigtis daugiafunkciame tiektuve Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. strigties šalinimas daugiafunkciame tiektuve popieriaus strigties šalinimas daugiafunkciame tiektuve popieriaus strigtis daugiafunkciame tiektuve"},{"UUID":"ee34a9a6-40d4-40b9-8751-2535eef85da9","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis 2000 lapų dėkle","descFull":"Popieriaus strigtis 2000 lapų dėkle Pastumkite dėklą į kairę. Atidarykite J dureles ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite dureles ir įstumkite dėklą atgal į vietą. Ištraukite dėklo įdėklą ir išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Pastumkite dėklo įdėklą atgal į vietą. strigties šalinimas 2000 lapų dėkle popieriaus strigties šalinimas 2000 lapų dėkle popieriaus strigtis 2000 lapų dėkle"},{"UUID":"9870d80a-7aa2-4fc9-819b-bb1eec70789e","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis A durelėse Popieriaus","descFull":"Popieriaus strigtis A durelėse Popieriaus strigtis A durelėse Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Pašalinkite popierių, įstrigusį bet kurioje iš šių sričių: Įsitikinkite, kad pašalinote visas popieriaus daleles. Kaitintuvo srityje Dvipusio spausdinimo įrenginys C durelės Uždarykite A dureles. strigties šalinimas A durelėse strigties šalinimas dvipusio spausdinimo įrenginyje strigties šalinimas C durelėse strigties šalinimas kaitintuvo srityje popieriaus strigties šalinimas kaitintuvo srityje popieriaus strigties šalinimas C durelėse popieriaus strigties šalinimas dvipusio spausdinimo įrenginyje popieriaus strigties šalinimas A durelėse popieriaus strigtis A durelėse popieriaus strigtis dvipusio spausdinimo įrenginyje popieriaus strigtis kaitintuvo srityje popieriaus strigtis C durelėse"},{"UUID":"3343c5d1-06bc-46c1-b042-545ca18c59ad","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis standartinėje dėtuvėje Atidarykite","descFull":"Popieriaus strigtis standartinėje dėtuvėje Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atidarykite C dureles ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite C dureles, po to – A dureles. Iš standartinės dėtuvės išimtas įstrigęs popierius. Įsitikinkite, kad pašalinote visas popieriaus daleles. strigties šalinimas standartinėje dėtuvėje popieriaus strigties šalinimas standartinė dėtuvė popieriaus strigtis standartinėje dėtuvėje"},{"UUID":"365a5783-4889-4776-9c80-794ff1420e1c","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis automatiniame dokumentų tiektuve","descFull":"Popieriaus strigtis automatiniame dokumentų tiektuve Visus dokumentų originalus išimkite iš ADT dėklo. Atidarykite ADT dangtį. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite ADT dangtį. strigties šalinimas automatiniame dokumentų tiektuve popieriaus strigtis automatiniame dokumentų tiektuve popieriaus strigties šalinimas automatiniame dokumentų tiektuve"},{"UUID":"f1720624-4ac4-4953-98a1-e823f4b0b5c5","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis sąsagėlių segiklyje Atidarykite","descFull":"Popieriaus strigtis sąsagėlių segiklyje Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atidarykite A1 dureles ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite A1 dureles, po to – A dureles. Atidarykite apipavidalinimo įtaiso viršutinį dangtį ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite dangtį. Atidarykite apipavidalinimo įtaiso viršutinį dangtį, pasukite rankenėlę ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite dangtį. Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atidarykite C dureles ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite C dureles, po to – A dureles. strigties šalinimas sąsagėlių segiklyje popieriaus strigties šalinimas sąsagėlių segiklyje popieriaus strigtis sąsagėlių segiklyje"},{"UUID":"665853fd-5ef9-4791-968e-2dd35577e557","title":"Strigčių šalinimas","link":"avoiding-jams-topic.html","desc":"Popieriaus strigtis sąsagėlių, skylmušos įtaise","descFull":"Popieriaus strigtis sąsagėlių, skylmušos įtaise Atidarykite A dureles. Spausdintuvo vidus gali būti karštas. Norėdami sumažinti pavojų susižaloti nuo karšto komponento, prieš liesdami leiskite paviršiui atvėsti. Atidarykite A1 dureles ir pašalinkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite A1 dureles, po to – A dureles. Pakelkite popieriaus perdavimo dangtį F, tada išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite popieriaus gabenimo dangtį. Patraukite sąsagėlių segimo ir skylmušos įtaiso svirtį ir pakelkite dangtį. Išimkite užstrigusį popierių. Įsitikinkite, kad pašalinote visas popieriaus daleles. Uždarykite baigiamojo įtaiso dureles. strigties šalinimas sąsagėlių segimo, skylmušos įtaise popieriaus strigties šalinimas sąsagėlių segimo, skylmušos įtaise popieriaus strigtis sąsagėlių, skylmušos įtaise"},{"UUID":"d0d77567-e58c-485d-b076-bceb58e430b9","title":"Tinklo ryšio problemos","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nepavyksta atidaryti įtaisytojo interneto serverio","descFull":"Nepavyksta atidaryti įtaisytojo interneto serverio (EWS) Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar spausdintuvas įjungtas. Prisijunkite prie spausdintuvo įtaisytojo interneto serverio (EWS). Ar galite atidaryti EWS? Problema išspręsta. Įsitikinkite, kad spausdintuvo IP adresas yra teisingas. IP adresą pasižiūrėkite pradžios ekrane. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Prisijunkite prie EWS. Ar galite atidaryti EWS? Problema išspręsta. Įsitikinkite, kad įdiegėte palaikomą naršyklę: „Internet Explorer“ 11 ar naujesnę versiją; „Microsoft Edge“ „Safari“ 6 ar naujesnę versiją; Google Chrome  32 ar naujesnę versiją; „Mozilla Firefox“ 24 ar naujesnę versiją. Prisijunkite prie EWS. Ar galite atidaryti EWS? Problema išspręsta. Patikrinkite, ar veikia tinklo ryšys. Jei ryšys neveikia, susisiekite su administratoriumi. Prisijunkite prie EWS. Ar galite atidaryti EWS? Problema išspręsta. Įsitikinkite, kad laidai yra tvirtai prijungti prie spausdintuvo ir spausdinimo serverio. Norėdami gauti daugiau informacijos, žr. dokumentaciją, kurią gavote kartu su spausdinimo serveriu. Prisijunkite prie EWS. Ar galite atidaryti EWS? Problema išspręsta. Patikrinkite, ar išjungti įgaliotieji interneto serveriai. Jei serveriai išjungti, susisiekite su administratoriumi. Prisijunkite prie EWS. Ar galite atidaryti EWS? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . nepavyksta atidaryti įtaisytojo interneto serverio (EWS) trikčių šalinimas nepavyksta atidaryti įtaisytojo interneto serverio (EWS)"},{"UUID":"ae397f11-46ba-444d-940f-7b3afb174a19","title":"Tinklo ryšio problemos","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nepavyksta prijungti spausdintuvo prie „Wi-Fi“","descFull":"Nepavyksta prijungti spausdintuvo prie „Wi-Fi“ tinklo Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar elementas  Aktyvus adapteris  yra nustatytas į  Automatiškai . Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Trumpa tinklo informacija Aktyvus adapteris Automatiškai . Ar spausdintuvas gali prisijungti prie „Wi-Fi“ tinklo? Problema išspręsta. Patikrinkite, ar pasirinktas tinkamas „Wi‑Fi“ tinklas. Kai kurie maršrutų parinktuvai gali bendrinti numatytąjį SSID. Ar jungiatės prie tinkamo „Wi‑Fi“ tinklo? Eikite į 4 veiksmą. Prisijunkite prie tinkamo „Wi‑Fi“ tinklo. Norėdami gauti daugiau informacijos, žr.  . Ar spausdintuvas gali prisijungti prie „Wi-Fi“ tinklo? Problema išspręsta. Patikrinkite belaidžio ryšio saugumo režimą. Pradžios ekrane palieskite  Nustatymai Tinklas / prievadai Belaidis ryšys Belaidžio ryšio saugumo režimas . Ar pasirinktas tinkamas belaidžio ryšio saugumo režimas? Eikite į 6 veiksmą. Pasirinkite tinkamą belaidžio ryšio saugumo režimą. Ar spausdintuvas gali prisijungti prie „Wi-Fi“ tinklo? Problema išspręsta. Įsitikinkite, kad įvedėte teisingą tinklo slaptažodį. Atkreipkite dėmesį į slaptažodžio tarpus, skaičius ir didžiąsias raides. Ar spausdintuvas gali prisijungti prie „Wi-Fi“ tinklo? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . nepavyksta prijungti spausdintuvo prie „Wi‑Fi“ trikčių šalinimas nepavyksta prijungti spausdintuvo prie „Wi‑Fi“"},{"UUID":"a9aa5e00-7a6a-45d7-8998-75c2798d109e","title":"Papildomos aparatinės įrangos problemos","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nepavyksta aptikti papildomo vidinio įtaiso","descFull":"Nepavyksta aptikti papildomo vidinio įtaiso Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Ar spausdintuvas aptinka papildomą vidinį įtaisą? Problema išspręsta. Atsispausdinkite meniu nustatymų puslapį ir patikrinkite, ar papildomas vidinis įtaisas yra įdiegtų funkcijų sąraše. Ar papildomas vidinis įtaisas yra sąraše? Eikite į 4 veiksmą. Patikrinkite, ar papildomas vidinis įtaisas yra tinkamai įrengtas valdiklių plokštėje. Išjunkite spausdintuvą ir ištraukite maitinimo laidą iš elektros lizdo. Įsitikinkite, kad papildomas vidinis įtaisas yra įkištas į tinkamą valdiklių plokštės jungtį. Įkiškite maitinimo laidą į elektros lizdą ir įjunkite spausdintuvą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia gaminio ir lengvai pasiekiamas. Ar spausdintuvas aptinka papildomą vidinį įtaisą? Problema išspręsta. Patikrinkite, ar papildomą vidinį įtaisą galima rasti spausdinimo tvarkyklėje. Jei reikia, spausdinimo tvarkyklėje rankiniu būdu pridėkite papildomą vidinį įtaisą, kad jis būtų prieinamas spausdinimo užduotims. Norėdami gauti daugiau informacijos, žr.  . Atspausdinkite dokumentą. Ar spausdintuvas aptinka papildomą vidinį įtaisą? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, papildoma spausdintuvo įranga nepavyksta aptikti papildomo vidinio įtaiso papildomos spausdintuvo įrangos trikčių šalinimas nepavyksta aptikti papildomo vidinio įtaiso neaptiktas papildomas vidinis įtaisas"},{"UUID":"537656db-f832-420d-9f73-571a1da6d9e7","title":"Papildomos aparatinės įrangos problemos","link":"trb-cannot-detect-internal-option-topic.html","desc":"Aptiktas sugadintas atmintukas Pabandykite atlikti","descFull":"Aptiktas sugadintas atmintukas Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Pakeiskite sugadintą išmoningąjį atminties įrenginį. Norėdami ignoruoti pranešimą ir tęsti spausdinimą, pradžios ekrane palieskite  Tęsti . Atšaukite šią spausdinimo užduotį. spausdintuvo pranešimai Aptiktas sugadintas atmintukas sugedęs išmoningasis atminties įrenginys"},{"UUID":"c8cfff06-c760-42a5-bce5-6a98f85c9d0c","title":"Papildomos aparatinės įrangos problemos","link":"trb-cannot-detect-internal-option-topic.html","desc":"Atmintuke ištekliams nepakanka laisvos vietos","descFull":"Atmintuke ištekliams nepakanka laisvos vietos Pabandykite atlikti vieną ar daugiau iš šių veiksmų: Jei norite pašalinti pranešimą ir tęsti spausdinimą, palieskite  Tęsti . Iš atmintuko pašalinkite šriftus, makrokomandas ir kitus duomenis. Įdėkite standųjį diską. Atsisiųsti šriftai ir makrokomandos, kurie anksčiau nebuvo išsaugoti atmintuke, pašalinami. spausdintuvo pranešimai Atmintuke ištekliams nepakanka laisvos vietos Atmintuke ištekliams nepakanka laisvos vietos"},{"UUID":"85ffdb2f-a289-42a8-b18b-64b4e1bf097e","title":"Problemos, susijusios su eksploataciniais reikmenimis","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Trūkstama arba nereaguojanti dažų kasetė","descFull":"Trūkstama arba nereaguojanti dažų kasetė Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atidarykite priekines dureles. Išimkite ir vėl įdėkite dažų kasetę. Ar dažų kasetės nėra arba ji nereaguoja? Problema išspręsta. Patikrinkite, ar spausdintuve naudojama originali ir tinkama „Lexmark“ dažų kasetė. Patikrinkite, ar spausdintuve naudojama originali ir tinkama dažų kasetė. Jei dažų kasetė netinkama, įdėkite tinkamą. Ar dažų kasetės nėra arba ji nereaguoja? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, reikmenys trūkstama arba nereaguojanti dažų kasetė trūkstama arba nereaguojanti dažų kasetė reikmenys trikčių šalinimui trūkstama arba nereaguojanti dažų kasetė"},{"UUID":"8569af59-63c8-484e-a946-3978ebc15349","title":"Problemos, susijusios su eksploataciniais reikmenimis","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Ne „Lexmark“ eksploatacinis reikmuo Ne","descFull":"Ne „Lexmark“ eksploatacinis reikmuo Ne „Dell“ eksploatacinis reikmuo Ne spausdintuvo gamintojo eksploatacinis reikmuo Spausdintuvas aptiko jame įdėtą ne „Lexmark“ eksploatacinį reikmenį arba dalį. Spausdintuvas aptiko jame įdėtą ne „Dell“ eksploatacinį reikmenį arba dalį. Spausdintuvas aptiko jame įdėtą neatpažįstamą eksploatacinį reikmenį arba dalį. „Lexmark“ spausdintuvas geriausiai veikia, jei jame naudojami originalūs „Lexmark“ eksploataciniai reikmenys ir dalys. Trečiųjų šalių eksploatacinių reikmenų ar dalių naudojimas gali pakenkti spausdintuvo ir jo vaizdo gavimo komponentų efektyvumui, patikimumui arba naudojimo trukmei. „Dell“ spausdintuvas geriausiai veikia, jei jame naudojami originalūs „Dell“ eksploataciniai reikmenys ir dalys. Trečiųjų šalių eksploatacinių reikmenų ar dalių naudojimas gali pakenkti spausdintuvo ir jo vaizdo gavimo komponentų efektyvumui, patikimumui arba naudojimo trukmei. Jūsų spausdintuvas geriausiai veikia jame naudojant spausdintuvo gamintojo pagamintus originalius eksploatacinius reikmenis ir dalis. Trečiųjų šalių eksploatacinių reikmenų ar dalių naudojimas gali pakenkti spausdintuvo ir jo vaizdo gavimo komponentų efektyvumui, patikimumui arba naudojimo trukmei. Visi gyvavimo ciklo indikatoriai yra skirti veikti naudojant „Lexmark“ eksploatacinius reikmenis ir dalis, todėl naudojant trečiųjų šalių eksploatacinius reikmenis ar dalis rezultatai gali būti neprognozuojami. Naudojant vaizdo gavimo komponentus ilgiau nei numatyta jų naudojimo trukmė, „Lexmark“ spausdintuvas ar susiję komponentai gali sugesti. Visi gyvavimo ciklo indikatoriai yra skirti veikti naudojant „Dell“ eksploatacinius reikmenis ir dalis, todėl naudojant trečiųjų šalių eksploatacinius reikmenis ar dalis rezultatai gali būti neprognozuojami. Naudojant vaizdo gavimo komponentus ilgiau nei numatyta jų naudojimo trukmė „Dell“ spausdintuvas ar susiję komponentai gali sugesti. Visi gyvavimo ciklo indikatoriai yra skirti veikti naudojant spausdintuvo gamintojo eksploatacinius reikmenis ir dalis, todėl naudojant trečiųjų šalių eksploatacinius reikmenis ar dalis rezultatai gali būti neprognozuojami. Naudojant vaizdo gavimo komponentus ilgiau nei numatyta jų naudojimo trukmė, spausdintuvas ar susiję komponentai gali sugesti. Trečiųjų šalių eksploatacinių reikmenų ar dalių naudojimas gali turėti neigiamos įtakos garantijos taikymui. Jei spausdintuvas sugenda naudojant trečiųjų šalių eksploatacinius reikmenis ar dalis, garantija gali būti netaikoma. Jei prisiimate visą riziką ir spausdintuve toliau norite naudoti neoriginalius eksploatacinius reikmenis ar dalis, spausdintuvo ekrane dviem pirštais palieskite ir 15 sekundžių palaikykite nuspaudę klaidos pranešimą. Pasirodžius patvirtinimo dialogo langui, palieskite  Tęsti . Jei nenorite prisiimti šios rizikos, pašalinkite trečiųjų šalių eksploatacinį reikmenį arba dalį iš savo spausdintuvo ir įdėkite originalų „Lexmark“ eksploatacinį reikmenį arba dalį. Norėdami gauti daugiau informacijos, žr.  . Jei nenorite prisiimti šios rizikos, pašalinkite trečiųjų šalių eksploatacinį reikmenį arba dalį iš savo spausdintuvo ir įdėkite originalų „Dell“ eksploatacinį reikmenį arba dalį. Jei nenorite prisiimti šios rizikos, išimkite iš spausdintuvo trečiųjų šalių eksploatacinį reikmenį arba dalį ir įdėkite originalų spausdintuvo gamintojo eksploatacinį reikmenį ar dalį. Jei išvalius klaidos pranešimą spausdintuvas nespausdina, iš naujo nustatykite eksploatacinių reikmenų naudojimo skaitiklį. Pradžios ekrane palieskite  Nustatymai Įrenginys Eksploatacija Meniu „Konfigūracija“ Eksploatacinių reikmenų naudojimas ir skaitikliai . Pažymėkite dalį arba eksploatacinį reikmenį, kurį norite nustatyti iš naujo, ir palieskite  Pradėti . Perskaitykite įspėjamąjį pranešimą ir palieskite  Tęsti . Norėdami išvalyti klaidos pranešimą, dviem pirštais 15 sekundžių lieskite ekraną. Jei eksploatacinių reikmenų naudojimo skaitiklių nepavyksta nustatyti iš naujo, eksploatacinį reikmenį grąžinkite į pirkimo vietą. spausdintuvo pranešimai Ne „Lexmark“ eksploatacinis reikmuo Ne „Lexmark“ eksploatacinis reikmuo spausdintuvo pranešimai Ne „Dell“ eksploatacinis reikmuo Ne „Dell“ eksploatacinis reikmuo spausdintuvo pranešimai Ne spausdintuvo gamintojo eksploatacinis reikmuo Ne spausdintuvo gamintojo eksploatacinis reikmuo nustatymas iš naujo eksploatacinių reikmenų naudojimo skaitikliai eksploatacinių reikmenų naudojimo skaitikliai nustatymas iš naujo eksploatacinių reikmenų naudojimo skaitiklių nustatymas iš naujo"},{"UUID":"5089a276-c1e5-4202-810f-be7e90d36315","title":"Popieriaus tiekimo problemos","link":"trb-envelope-seals-when-printing-topic.html","desc":"Spausdinant vokas užsiklijuoja Veiksmai sprendžiant","descFull":"Spausdinant vokas užsiklijuoja Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Naudokite voką, kuris buvo laikomas sausoje aplinkoje. Spausdinant ant vokų, į kuriuos įsigėrę daug drėgmės, jų atlankai gali užsiklijuoti. Išsiųskite spausdinimo užduotį. Ar spausdinant voką jis užsiklijuoja? Problema išspręsta. Patikrinkite, ar popieriaus rūšis yra Vokai. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Išsiųskite spausdinimo užduotį. Ar spausdinant voką jis užsiklijuoja? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimas spausdinant vokas užsiklijuoja spausdinimo trikčių šalinimas spausdinant vokas užsiklijuoja spausdinant vokas užsiklijuoja"},{"UUID":"8b773c27-b964-4022-879e-9ae8a5ff9e49","title":"Popieriaus tiekimo problemos","link":"trb-envelope-seals-when-printing-topic.html","desc":"Spausdinimas sudėstant neveikia Veiksmai sprendžiant","descFull":"Spausdinimas sudėstant neveikia Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Pradžios ekrane palieskite  Nustatymai Spausdinti Išdėstymas Sudėstyti . Palieskite  Įjungta [1,2,1,2,1,2] . Atspausdinkite dokumentą. Ar dokumentas tinkamai sudėstomas? Problema išspręsta. Dokumente, kurį bandote atspausdinti, atidarykite dialogo langą „Spausdinti“ ir pasirinkite  Sudėstyti . Atspausdinkite dokumentą. Ar dokumentas tinkamai sudėstomas? Problema išspręsta. Sumažinkite spausdintinų puslapių skaičių. Atspausdinkite dokumentą. Ar puslapiai sudėstyti tinkamai? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . spausdinimo trikčių šalinimas spausdinimas sudėstant neveikia trikčių šalinimas, spausdinimas spausdinimas sudėstant neveikia spausdinimas sudėstant neveikia"},{"UUID":"8103371f-6a88-4804-a0bd-a0445dfaf65c","title":"Popieriaus tiekimo problemos","link":"trb-envelope-seals-when-printing-topic.html","desc":"Dėklų susiejimas neveikia Veiksmai sprendžiant","descFull":"Dėklų susiejimas neveikia Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar dėkluose yra tokio paties formato ir rūšies popierius. Patikrinkite, ar tinkamai nustatyti popieriaus kreiptuvai. Atspausdinkite dokumentą. Ar dėklai tinkamai susieti? Problema išspręsta. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Popieriaus formato ir rūšies nustatymai turi atitikti į susietus dėklus įdėto popieriaus formatą ir rūšį. Atspausdinkite dokumentą. Ar dėklai tinkamai susieti? Problema išspręsta. Patikrinkite, ar parinktis  Dėklų susiejimas  yra nustatyta kaip  Automatinis . Norėdami gauti daugiau informacijos, žr.  . Atspausdinkite dokumentą. Ar dėklai tinkamai susieti? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, spausdinimas dėklų susiejimas neveikia spausdinimo trikčių šalinimas dėklų susiejimas neveikia"},{"UUID":"ef96a398-dd1d-45ca-bf00-14870b326d4a","title":"Popieriaus tiekimo problemos","link":"trb-envelope-seals-when-printing-topic.html","desc":"Popierius dažnai stringa Veiksmai sprendžiant","descFull":"Popierius dažnai stringa Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Išimkite dėklą. Patikrinkite, ar tinkamai įdėtas popierius. Įsitikinkite, kad nustatyta tinkama popieriaus kreiptuvų padėtis. Įsitikinkite, kad popieriaus pluoštas yra žemiau maksimalaus popieriaus užpildymo indikatoriaus. Būtinai spausdinkite ant rekomenduojamo formato ir rūšies popieriaus. Įdėkite dėklą. Atspausdinkite dokumentą. Ar dažnai pasitaiko popieriaus strigčių? Problema išspręsta. Pradžios ekrane palieskite  Nustatymai Popierius Dėklų konfigūracija Popieriaus formatas / rūšis . Nustatykite tinkamą popieriaus formatą ir rūšį. Atspausdinkite dokumentą. Ar dažnai pasitaiko popieriaus strigčių? Problema išspręsta. Įdėkite popierių iš naujos pakuotės. Esant didelei drėgmei popierius ją sugeria. Kol nesate pasiruošę popieriaus naudoti, laikykite jį originalioje pakuotėje. Atspausdinkite dokumentą. Ar dažnai pasitaiko popieriaus strigčių? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spausdinimas popierius dažnai stringa spausdinimo trikčių šalinimas popierius dažnai stringa popierius dažnai stringa"},{"UUID":"bdf1fe29-9183-44f1-9b1c-2df860f8270c","title":"Popieriaus tiekimo problemos","link":"trb-envelope-seals-when-printing-topic.html","desc":"Užstrigę lapai neatspausdinami iš naujo","descFull":"Užstrigę lapai neatspausdinami iš naujo Veiksmas sprendžiant šią problemą Veiksmas Taip Ne Pradžios ekrane palieskite  Nustatymai Įrenginys Pranešimai Turinio atkūrimas po strigčių šalinimo . Meniu „Atkūrimas po strigčių“ palieskite  Įjungta  arba  Automatiškai . Atspausdinkite dokumentą. Ar užstrigę puslapiai atspausdinami iš naujo? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, spausdinimas užstrigę puslapiai neatspausdinami iš naujo užstrigę puslapiai neatspausdinami iš naujo"},{"UUID":"981902a0-1ba9-4f6c-aae3-a14e7e6858fa","title":"Problemos siunčiant el. paštu","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Pranešimo apie „SMTP serveris neįdiegtas“","descFull":"Pranešimo apie „SMTP serveris neįdiegtas“ klaidą išjungimas Pradžios ekrane palieskite  Nustatymai El. paštas El. pašto sąranka Išjungti „SMTP serveris neįdiegtas“ klaidą Įjungta . Norėdami išvengti klaidos pasikartojimo, atlikite vieną ar kelis iš šių veiksmų: Atnaujinkite spausdintuvo programinę aparatinę įrangą. Norėdami gauti daugiau informacijos, žr.  . Sukonfigūruokite el. pašto SMTP nustatymus. Norėdami gauti daugiau informacijos, žr.  . „SMTP serveris neįdiegtas“ klaida išjungimas trikčių šalinimas „SMTP serveris neįdiegtas“ klaida „SMTP serveris neįdiegtas“ klaidos išjungimas"},{"UUID":"a3e80253-5fe4-4730-8eae-c10941b6c47a","title":"Problemos siunčiant el. paštu","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nepavyksta išsiųsti el. laiškų Veiksmai","descFull":"Nepavyksta išsiųsti el. laiškų Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad el. pašto SMTP nustatymai yra tinkamai sukonfigūruoti. Norėdami gauti daugiau informacijos, žr.  . Ar galite išsiųsti el. laišką? Problema išspręsta. Įsitikinkite, kad naudojate teisingą slaptažodį. Priklausomai nuo jūsų el. pašto paslaugų teikėjo, naudokite paskyros slaptažodį, programos slaptažodį arba tapatumo nustatymo slaptažodį. Norėdami gauti daugiau informacijos, žr.  . Ar galite išsiųsti el. laišką? Problema išspręsta. Įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo, o tinklas yra prijungtas prie interneto. Ar galite išsiųsti el. laišką? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . el. pašto trikčių šalinimas nepavyksta išsiųsti el. laiškų trikčių šalinimas, el. paštas nepavyksta išsiųsti el. laiškų nepavyksta išsiųsti el. laiškų"},{"UUID":"07c33ab9-4c7a-47bd-9861-dfc5be318943","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Nerodomas siuntėjo identifikavimo numeris Šios","descFull":"Nerodomas siuntėjo identifikavimo numeris Šios instrukcijos taikomos tik spausdintuvams, kuriuose palaikomas analoginis faksimilinis ryšys. Norėdami gauti daugiau informacijos žr. skirsnį  Fakso nustatymas spausdintuve . Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įgalinkite siuntėjo identifikavimo numerį. Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų gavimo nustatymai Administratoriaus valdymas Įgalinti siuntėjo identifikavimą . Ar rodomas siuntėjo identifikavimo numeris? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, faksas nerodomas siuntėjo identifikavimo numeris fakso trikčių šalinimas nerodomas siuntėjo identifikavimo numeris nerodomas siuntėjo identifikavimo numeris"},{"UUID":"044083b4-66d1-4c4f-8f0d-a0cbc8418852","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Nepavyksta išsiųsti arba priimti faksogramų","descFull":"Nepavyksta išsiųsti arba priimti faksogramų naudojant analoginį faksimilinį ryšį Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Imkitės veiksmų, susijusių su visais ekrane rodomais klaidų pranešimais. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Patikrinkite, ar tvirtai prijungtos šių įrenginių laidų jungtys: telefono; ragelio; atsakiklio. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Patikrinkite, ar girdimas rinkimo signalas. Paskambinkite fakso numeriu, kad patikrintumėte, ar jis tinkamai veikia. Jei naudojatės girdimo rinkimo signalo (On Hook Dial) funkcija, įjunkite garsį, kad patikrintumėte, ar išgirsite rinkimo signalą. Ar girdite rinkimo signalą? Eikite į 5 veiksmą. Patikrinkite sieninį telefono lizdą. Įjunkite analoginės telefono linijos laidą tiesiai į sieninį lizdą. Paklausykite, ar girdimas rinkimo signalas. Jei negirdite rinkimo signalo, naudokite kitą telefono laidą. Jei vis tiek negirdite rinkimo signalo, analoginės telefono linijos laidą įjunkite į kitą sieninį lizdą. Jei išgirsite rinkimo signalą, spausdintuvą prijunkite prie to sieninio lizdo. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Patikrinkite, ar spausdintuvas prijungtas prie analoginės telefono linijos paslaugos arba tinkamos skaitmeninės jungties. Jei naudojate skaitmeninio visuminių paslaugų tinklo (Integrated Services for Digital Network, ISDN) telefono ryšio paslaugą, prisijunkite prie ISDN terminalo adapterio analoginės telefono linijos prievado. Norėdami gauti daugiau informacijos, kreipkitės į ISDN paslaugos teikėją. Jei naudojatės skaitmenine abonento linija (DSL), prisijunkite prie DSL filtro arba maršruto parinktuvo, kuris palaiko analoginio ryšio naudojimą. Norėdami gauti daugiau informacijos, kreipkitės į DSL paslaugos teikėją. Jei naudojatės privataus telefonų tinklo (PBX) telefono ryšio paslauga, įsitikinkite, kad jungiatės prie analoginio ryšio jungties PBX tinkle. Jei nei vieno iš išvardintųjų nėra, apsvarstykite galimybę įrengti analoginę telefono liniją, skirtą fakso aparatui. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Laikinai atjunkite kitą įrangą ir išjunkite kitas telefono paslaugas. Išjunkite tarp spausdintuvo ir telefono linijos esančią kitą įrangą (pvz., atsakiklius, kompiuterius, modemus ar telefono linijos dalytuvus). Išjunkite skambučio laukimo ir balso pašto funkcijas. Norėdami gauti daugiau informacijos, kreipkitės į telefono ryšio įmonę. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Vienu metu nuskaitykite vieną dokumento originalo puslapį. Surinkite fakso numerį. Nuskenuokite dokumentą. Ar galite išsiųsti arba priimti faksogramą? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas nepavyksta išsiųsti arba priimti faksogramų naudojant analoginį faksimilinį ryšį trikčių šalinimas, faksas nepavyksta išsiųsti arba priimti faksogramų naudojant analoginį faksimilinį ryšį nepavyksta išsiųsti arba priimti faksogramų naudojant analoginį faksimilinį ryšį"},{"UUID":"3282930a-15b1-4241-b6a9-561a6bdca776","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Galima priimti, bet nepavyksta išsiųsti","descFull":"Galima priimti, bet nepavyksta išsiųsti faksogramų naudojant analoginį faksimilinį ryšį Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Dokumento originalą tinkamai įdėkite į ADT dėklą arba padėkite ant skenerio stiklo. Ar galite siųsti faksogramas? Problema išspręsta. Tinkamai įdiekite sparčiosios nuorodos numerį. Patikrinkite, ar sparčiosios nuorodos numeris nustatytas telefono numeriui, kurį norite rinkti. Telefono numerį surinkite ranka. Ar galite siųsti faksogramas? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Tinkamai įdiekite sparčiosios nuorodos numerį. Patikrinkite, ar sparčiosios nuorodos numeris nustatytas telefono numeriui, kurį norite rinkti. Telefono numerį surinkite ranka. Ar galite siųsti faksogramas? Problema išspręsta. Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas nepavyksta išsiųsti faksogramų naudojant analoginį faksimilinį ryšį trikčių šalinimas, faksas nepavyksta išsiųsti faksogramų naudojant analoginį faksimilinį ryšį"},{"UUID":"a12501f6-6b83-46e7-ad72-eef610f12f3b","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Galima išsiųsti, bet nepavyksta priimti","descFull":"Galima išsiųsti, bet nepavyksta priimti faksogramų naudojant analoginį faksimilinį ryšį Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad popieriaus šaltinis netuščias. Ar galite gauti faksogramas? Problema išspręsta. Patikrinkite skambėjimo skaičiavimo delsos nustatymus. Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Faksogramų gavimo nustatymai Skambėjimai prieš atsiliepiant . Ar galite gauti faksogramas? Problema išspręsta. Jei spausdintuvas spausdina tuščius lapus, žr.  . Ar galite gauti faksogramas? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas galima išsiųsti, bet nepavyksta priimti faksogramų naudojant analoginį faksimilinį ryšį trikčių šalinimas, faksas galima išsiųsti, bet nepavyksta priimti faksogramų naudojant analoginį faksimilinį ryšį nepavyksta priimti faksogramų naudojant analoginį faksimilinį ryšį"},{"UUID":"d8273e80-e916-4d94-9f3f-2ab20ccb06d0","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Nepavyksta nustatyti „etherFAX“ Veiksmai sprendžiant","descFull":"Nepavyksta nustatyti „etherFAX“ Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite spausdintuvo jungtis. Atsispausdinkite  Tinklo sąrankos puslapį . Pradžios ekrane palieskite  Nustatymai Ataskaitos Tinklas Tinklo sąrankos puslapis . Patikrinkite tinklo būseną. Ar spausdintuvas prijungtas prie tinklo? Eikite į 3 veiksmą. Įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo, o tinklas yra prijungtas prie interneto. Ar galite nustatyti „etherFAX“? Problema išspręsta. Įsitikinkite, kad „etherFAX“ nustatytas tinkamai. Norėdami gauti daugiau informacijos, žr.  . Ar galite nustatyti „etherFAX“? Problema išspręsta. Eikite adresu  https://www.etherfax.net/lexmark . fakso trikčių šalinimas nepavyksta nustatyti „etherFAX“ trikčių šalinimas, faksas nepavyksta nustatyti „etherFAX“"},{"UUID":"06f7e476-eb97-4871-8948-813f0610946f","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Nepavyksta išsiųsti arba priimti faksogramų","descFull":"Nepavyksta išsiųsti arba priimti faksogramų naudojant „etherFAX“ Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad spausdintuvas yra prijungtas prie tinklo, o tinklas yra prijungtas prie interneto. Ar galite išsiųsti arba priimti faksogramas naudodamiesi „etherFAX“? Problema išspręsta. Įsitikinkite, kad „etherFAX“ nustatytas tinkamai. Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka Bendrieji fakso nustatymai . Įsitikinkite, kad įvedėte teisingą fakso numerį. Patikrinkite, ar parinktis  Faksogramų siuntimas  yra nustatyta kaip  „etherFAX“ . Šis meniu rodomas tik tada, kai galimas daugiau nei vienas faksogramų transportas. Jei spausdintuve įdiegta tik „etherFAX“, jis sukonfigūruojamas automatiškai. Ar galite išsiųsti arba priimti faksogramas naudodamiesi „etherFAX“? Problema išspręsta. Didelės apimties dokumentus padalinkite į mažesnio dydžio failus. Ar galite išsiųsti arba priimti faksogramas naudodamiesi „etherFAX“? Problema išspręsta. Eikite adresu  https://www.etherfax.net/lexmark . fakso trikčių šalinimas nepavyksta išsiųsti arba priimti faksogramų naudojant „etherFAX“ trikčių šalinimas, faksas nepavyksta išsiųsti arba priimti faksogramų naudojant „etherFAX“ nepavyksta išsiųsti arba priimti faksogramų naudojant „etherFAX“"},{"UUID":"cf7bfc09-4f0b-4f7d-8caf-6f92ca614f98","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Bloga faksogramų spausdinimo kokybė Veiksmai","descFull":"Bloga faksogramų spausdinimo kokybė Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad nėra spausdinimo kokybės defektų. Pradžios ekrane palieskite  Nustatymai Trikčių šalinimas Spausdinimo kokybės testavimo puslapiai . Ištaisykite bet kokius spausdinimo kokybės defektus. Norėdami gauti daugiau informacijos, žr.  . Ar faksogramos spausdinimo kokybė patenkinama? Problema išspręsta. Jei naudojate analoginį faksimilinį ryšį, sumažinkite gaunamos faksogramos perdavimo greitį. Pradžios ekrane palieskite  Nustatymai Faksas Faksimilinio ryšio sąranka  Faksogramų priėmimo nustatymai Administratoriaus valdikliai . Meniu „Maksimali sparta“ pasirinkite mažesnę perdavimo spartą. Ar faksogramos spausdinimo kokybė patenkinama? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas prasta spausdinimo kokybė prasta faksogramų spausdinimo kokybė trikčių šalinimas, faksas prasta spausdinimo kokybė"},{"UUID":"e06a3238-29a7-4e1c-90d0-312d4770effe","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"Trūksta informacijos faksogramos antraštiniame lape","descFull":"Trūksta informacijos faksogramos antraštiniame lape Veiksmai sprendžiant šią problemą Veiksmas Ne Taip Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Išsiųskite arba gaukite faksogramą. Ar trūksta informacijos faksogramos antraštiniame lape? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas trūksta informacijos faksogramos antraštiniame lape trikčių šalinimas, faksas trūksta informacijos faksogramos antraštiniame lape trūksta informacijos faksogramos antraštiniame lape"},{"UUID":"f6d720ab-8205-43a1-8121-74ee70b4b6fe","title":"Problemos siunčiant faksu","link":"trb-caller-id-not-shown-topic.html","desc":"nepavyksta išsiųsti faksogramos antraštinio lapo","descFull":"nepavyksta išsiųsti faksogramos antraštinio lapo iš kompiuterio Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad spausdinimo tvarkyklė yra atnaujinta. Norėdami gauti daugiau informacijos, žr.  . Išsiųskite faksogramą. Ar galite išsiųsti faksogramos antraštinį lapą? Problema išspręsta. Dokumente, kurį bandote išsiųsti faksu, atidarykite dialogo langą  Spausdinti . Pasirinkę spausdintuvą, spustelėkite  Savybės ,  Nuostatos ,  Parinktys  arba  Sąranka . Spustelėkite  Faksas  ir išvalykite nustatymą  Prieš siunčiant faksogramą visada rodyti nustatymus . Išsiųskite faksogramą. Ar galite išsiųsti faksogramos antraštinį lapą? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . fakso trikčių šalinimas nepavyksta išsiųsti faksogramos antraštinio lapo iš kompiuterio trikčių šalinimas, faksas nepavyksta išsiųsti faksogramos antraštinio lapo iš kompiuterio nepavyksta išsiųsti faksogramos antraštinio lapo iš kompiuterio"},{"UUID":"e5f6e49a-1c25-482a-a4e1-c30f97a31fe3","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nepavyksta nuskenuoti į kompiuterį Veiksmai","descFull":"Nepavyksta nuskenuoti į kompiuterį Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atlikite kopijavimo užduotį. Ar pavyko atlikti kopijavimo užduotį? Eikite į 3 veiksmą. Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Nuskenuokite dokumentą. Ar galite nuskenuoti dokumentą į kompiuterį? Problema išspręsta. Patikrinkite spausdintuvo jungtis. Atsispausdinkite  Tinklo sąrankos puslapį . Pradžios ekrane palieskite  Nustatymai Ataskaitos Tinklas Tinklo sąrankos puslapis . Patikrinkite tinklo būseną. Ar spausdintuvas prijungtas prie tinklo? Eikite į 5 veiksmą. Prijunkite spausdintuvą prie tinklo. Nuskenuokite dokumentą. Ar galite nuskenuoti dokumentą į kompiuterį? Problema išspręsta. Įsitikinkite, kad spausdintuvas ir kompiuteris yra prijungti prie to paties tinklo. Nuskenuokite dokumentą. Ar galite nuskenuoti dokumentą į kompiuterį? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . skenavimo trikčių šalinimas nepavyksta nuskenuoti į kompiuterį trikčių šalinimas, skenavimas nepavyksta nuskenuoti į kompiuterį nepavyksta nuskenuoti į kompiuterį"},{"UUID":"af672fa1-1b11-42e0-a39b-4194f90679fb","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nepavyksta nuskenuoti į tinklo aplanką","descFull":"Nepavyksta nuskenuoti į tinklo aplanką Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Sukurkite tinklo aplanko sparčiąją nuorodą. Nuskenuokite dokumentą naudodami sparčiąją nuorodą. Norėdami gauti daugiau informacijos, žr.  . Ar galite nuskenuoti dokumentą ir išsaugoti jį tinklo aplanke? Problema išspręsta. Įsitikinkite, kad tinklo aplanko kelias ir formatas yra teisingi. Pavyzdžiui,  // server_hostname /foldername/path , kai  server_hostname  yra visas srities (FQDN) vardas arba IP adresas. Ar tinklo aplanko kelias ir formatas teisingi? Eikite į 4 veiksmą. Įsitikinkite, kad turite rašymo teisę tinklo aplanke. Ar galite nuskenuoti dokumentą ir išsaugoti jį tinklo aplanke? Problema išspręsta. Atnaujinkite tinklo aplanko sparčiąją nuorodą. Atidarykite interneto naršyklę ir adreso lauke įveskite spausdintuvo IP adresą. Pradžios ekrane pasižiūrėkite spausdintuvo IP adresą. IP adresas rodomas kaip keturi taškais atskirtų skaičių rinkiniai, pavyzdžiui, 123.123.123.123. Jei naudojate įgaliotąjį serverį, laikinai jį išjunkite, kad galėtumėte tinkamai įkelti tinklalapį. Spustelėkite  Sparčiosios nuorodos  ir pasirinkite sparčiąją nuorodą. Jei jūsų sparčiosios nuorodos yra keleto tipų, pasirinkite  Tinklo aplankas . Lauke  Bendrasis kelias  įveskite tinklo aplanko kelią. Jei jūsų bendrasis kelias yra  \\\\server_hostname\\foldername\\path , įveskite  //server_hostname/foldername/path . Įvesdami bendrąjį kelią įsitikinkite, kad naudojate dešininius brūkšnius. Meniu  Tapatumo nustatymas  pasirinkite tapatumo nustatymo būdą. Jei meniu elementas  Tapatumo nustatymas  yra nustatytas kaip „ Naudoti priskirtąjį naudotojo vardą ir slaptažodį “, laukuose  Naudotojo vardas  ir  Slaptažodis  įveskite savo prisijungimo duomenis. Spustelėkite  Išsaugoti . Ar galite nuskenuoti dokumentą ir išsaugoti jį tinklo aplanke? Problema išspręsta. Įsitikinkite, kad spausdintuvas ir tinklo aplankas yra prijungti prie to paties tinklo. Ar galite nuskenuoti dokumentą ir išsaugoti jį tinklo aplanke? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . nepavyksta nuskenuoti į tinklo aplanką trikčių šalinimas, skenavimas nepavyksta nuskenuoti į tinklo aplanką skenavimo trikčių šalinimas nepavyksta nuskenuoti į tinklo aplanką"},{"UUID":"d059ef96-df0f-467c-92d3-4071aa2a4ee2","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Iš dalies atspausdintos dokumento arba","descFull":"Iš dalies atspausdintos dokumento arba nuotraukos kopijos Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įsitikinkite, kad dokumentas ar nuotrauka yra padėti gerąja puse viršutiniame kairiajame skaitytuvo stiklo kampe. Nukopijuokite dokumentą arba nuotrauką. Ar dokumentas arba nuotrauka nukopijuoti tinkamai? Problema išspręsta. Nustatykite popieriaus formatą pagal į dėklą įdėtą popierių. Nukopijuokite dokumentą arba nuotrauką. Ar dokumentas arba nuotrauka nukopijuoti tinkamai? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Nustatykite popieriaus formatą pagal į dėklą įdėtą popierių. Nukopijuokite dokumentą arba nuotrauką. Ar dokumentas arba nuotrauka nukopijuoti tinkamai? Problema išspręsta. Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, kopijavimas iš dalies atspausdintos dokumentų arba nuotraukų kopijos kopijavimo trikčių šalinimas iš dalies atspausdintos dokumentų arba nuotraukų kopijos trikčių šalinimas, nuskaitymas iš dalies atspausdintos dokumentų arba nuotraukų kopijos nuskaitymo trikčių šalinimas iš dalies atspausdintos dokumentų arba nuotraukų kopijos"},{"UUID":"8d53c596-854f-4086-9d73-0e4b2a43cc52","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Prasta kopijavimo kokybė Veiksmai sprendžiant","descFull":"Prasta kopijavimo kokybė Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Nuvalykite skaitytuvo ir ADT stiklą drėgnu, minkštu, pūkelių nepaliekančiu audiniu. Jei spausdintuve yra antras ADT stiklas, esantis ADT viduje, jį taip pat nuvalykite. Norėdami gauti daugiau informacijos, žr.  . Įsitikinkite, kad dokumentas ar nuotrauka yra padėti gerąja puse viršutiniame kairiajame skaitytuvo stiklo kampe. Nukopijuokite dokumentą arba nuotrauką. Ar kopijų kokybė patenkinama? Problema išspręsta. Patikrinkite dokumento arba nuotraukos originalo kokybę. Pakoreguokite nuskaitymo kokybės nustatymus. Nukopijuokite dokumentą arba nuotrauką. Ar kopijų kokybė patenkinama? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Patikrinkite dokumento arba nuotraukos originalo kokybę. Pakoreguokite nuskaitymo kokybės nustatymus. Nukopijuokite dokumentą arba nuotrauką. Ar kopijų kokybė patenkinama? Problema išspręsta. Kreipkitės į  techninės pagalbos skyrių . kopijavimo trikčių šalinimas prasta kopijavimo kokybė trikčių šalinimas, kopijavimas prasta kopijavimo kokybė nuskaitymo trikčių šalinimas prasta kopijavimo kokybė trikčių šalinimas, nuskaitymas prasta kopijavimo kokybė"},{"UUID":"58fb4605-ca14-48c7-88b2-0a8000f16f0d","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Vertikalūs tamsūs dryžiai spaudiniuose nuskaitant","descFull":"Vertikalūs tamsūs dryžiai spaudiniuose nuskaitant iš ADT Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atidarykite skaitytuvo dangtį. Drėgnu, minkštu, neturinčiu pūkelių audiniu nuvalykite ADT stiklą ir ADT stiklo tarpiklį. Uždarykite skaitytuvo dangtį. Nuskaitykite dokumentą. Ar nuskaitytuose dokumentuose matomi vertikalūs dryžiai? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, nuskaitymas vertikalūs tamsūs dryžiai spaudiniuose nuskaitant iš ADT nuskaitymo trikčių šalinimas vertikalūs tamsūs dryžiai spaudiniuose nuskaitant iš ADT vertikalūs tamsūs dryžiai spaudiniuose nuskaitant iš ADT nuskaitymo kokybės problema"},{"UUID":"49898960-0f9c-464e-b2cd-2f78299922fc","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nelygus vaizdas arba tekstas skenuojant","descFull":"Nelygus vaizdas arba tekstas skenuojant iš ADT Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Įdėkite į ADT 50 lapų švaraus, lygaus popieriaus. Lygus popierius padeda nuvalyti arba pašalinti dulkes ir kitas apnašas nuo ADT popieriaus tiekimo velenėlių. Pradžios ekrane palieskite  . Į ADT įdėkite dokumento originalą. Nuskenuokite dokumentą. Ar išvedinyje matyti nelygūs vaizdai arba tekstas? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, skenavimas nelygus vaizdas skenuojant iš ADT trikčių šalinimas, skenavimas nelygus tekstas skenuojant iš ADT skenavimo trikčių šalinimas nelygus vaizdas skenuojant iš ADT skenavimo trikčių šalinimas nelygus tekstas skenuojant iš ADT nelygus vaizdas skenavimas iš ADT nelygus tekstas skenavimas iš ADT skenavimas iš ADT nelygus vaizdas skenavimas iš ADT nelygus tekstas"},{"UUID":"a5cad861-dbb7-441d-998b-4d9acd79f966","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nepavyko atlikti nuskaitymo užduoties Veiksmai","descFull":"Nepavyko atlikti nuskaitymo užduoties Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite laidų jungtis. Įsitikinkite, kad eterneto arba USB laidas tvirtai prijungtas prie kompiuterio ir spausdintuvo. Iš naujo išsiųskite nuskaitymo užduotį. Ar pavyko atlikti nuskaitymo užduotį? Problema išspręsta. Patikrinkite failą, kurį norite nuskaityti. Patikrinkite, ar paskirties aplanke nėra failo tokiu pačiu pavadinimu. Įsitikinkite, kad dokumentas ar nuotrauka, kuriuos norite nuskaityti, nėra atidaryti kitoje programoje. Iš naujo išsiųskite nuskaitymo užduotį. Ar pavyko atlikti nuskaitymo užduotį? Problema išspręsta. Įsitikinkite, kad paskirties vietos konfigūracijos nustatymuose yra pažymėtas žymimasis langelis  Papildyti laiko žyma  arba  Pakeisti esamą failą . Iš naujo išsiųskite nuskaitymo užduotį. Ar pavyko atlikti nuskaitymo užduotį? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Įsitikinkite, kad paskirties vietos konfigūracijos nustatymuose yra pažymėtas žymimasis langelis  Papildyti laiko žyma  arba  Pakeisti esamą failą . Iš naujo išsiųskite nuskaitymo užduotį. Ar pavyko atlikti nuskaitymo užduotį? Problema išspręsta. Kreipkitės į  techninės pagalbos skyrių . nuskaitymo trikčių šalinimas nepavyko atlikti nuskaitymo užduoties trikčių šalinimas, nuskaitymas nepavyko atlikti nuskaitymo užduoties"},{"UUID":"282da5be-adc3-4619-9d23-4970b9258eb2","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nepavyksta uždaryti skaitytuvo Veiksmas sprendžiant","descFull":"Nepavyksta uždaryti skaitytuvo Veiksmas sprendžiant šią problemą Veiksmas Taip Ne Pašalinkite kliuvinius, dėl kurių neužsidaro skaitytuvo dangtis. Ar skaitytuvo dangtis užsidaro tinkamai? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, kopijavimas nepavyksta uždaryti skaitytuvo trikčių šalinimas, nuskaitymas nepavyksta uždaryti skaitytuvo nepavyksta uždaryti skaitytuvo"},{"UUID":"9589267f-f46d-4d79-bf94-3cf7c7c6f3f5","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nuskaitymas trunka per ilgai arba","descFull":"Nuskaitymas trunka per ilgai arba sustabdo kompiuterį Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Uždarykite visas programas, kurios trukdo nuskaityti. Ar nuskaitymas trunka per ilgai arba sustabdo kompiuterį? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. nuskaitymo trikčių šalinimas nuskaitymas trunka per ilgai nuskaitymo trikčių šalinimas nuskaitymas sustabdo kompiuterį"},{"UUID":"7f3738dd-bebb-4cf6-834c-035a610c47cd","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skaitytuvas nereaguoja Veiksmai sprendžiant šią","descFull":"Skaitytuvas nereaguoja Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Patikrinkite, ar maitinimo laidas tinkamai prijungtas prie spausdintuvo ir įjungtas į elektros lizdą. Norėdami išvengti gaisro ar elektros smūgio pavojaus, prijunkite maitinimo laidą prie tinkamos nominaliosios srovės ir tinkamai įžeminto elektros lizdo, kuris yra šalia įrenginio ir lengvai pasiekiamas. Nukopijuokite arba nuskaitykite dokumentą. Ar skaitytuvas reaguoja? Problema išspręsta. Patikrinkite, ar spausdintuvas įjungtas. Imkitės veiksmų, susijusių su visais ekrane rodomais klaidų pranešimais. Nukopijuokite arba nuskaitykite dokumentą. Ar skaitytuvas reaguoja? Problema išspręsta. Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Nukopijuokite arba nuskaitykite dokumentą. Ar skaitytuvas reaguoja? Problema išspręsta. Kreipkitės į  klientų aptarnavimo skyrių . Išjunkite spausdintuvą, palaukite apie 10 sekundžių ir vėl jį įjunkite. Nukopijuokite arba nuskaitykite dokumentą. Ar skaitytuvas reaguoja? Problema išspręsta. Kreipkitės į  techninės pagalbos skyrių . trikčių šalinimas, kopijavimas skaitytuvas nereaguoja kopijavimo trikčių šalinimas skaitytuvas nereaguoja trikčių šalinimas, nuskaitymas skaitytuvas nereaguoja nuskaitymo trikčių šalinimas skaitytuvas nereaguoja"},{"UUID":"f513bd3b-4183-48ed-95c6-85d563512c12","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skaitytuvo registracijos koregavimas Pradžios ekrane","descFull":"Skaitytuvo registracijos koregavimas Pradžios ekrane palieskite  Nustatymai Įrenginys Techninė priežiūra Meniu „Konfigūracija“ Skaitytuvo konfigūracija Neautomatinė skaitytuvo registracija . Meniu „Greitasis spausdinimo testas“ palieskite  Pradėti . Padėkite greitojo spausdinimo testo puslapį ant skaitytuvo stiklo ir palieskite  Skaitytuvo registracija . Meniu „Greitasis kopijavimo testas“ palieskite  Pradėti . Palyginkite greitojo kopijavimo testo puslapį su dokumento originalu. Jei testo puslapio ir dokumento originalo paraštės skiriasi, pakoreguokite kairiąją ir viršutinę paraštes. Kartokite   ir  , kol greitojo kopijavimo testo puslapis atitiks dokumento originalą. koregavimas skaitytuvo registracija"},{"UUID":"c3c1751b-7f65-4efa-977a-c10174c0764f","title":"Skenavimo problemos","link":"trb-cannot-scan-to-computer-topic.html","desc":"ADT registracijos koregavimas Pradžios ekrane","descFull":"ADT registracijos koregavimas Pradžios ekrane palieskite  Nustatymai Įrenginys Techninė priežiūra Meniu „Konfigūracija“ Skaitytuvo konfigūracija Neautomatinė skaitytuvo registracija . Meniu „Greitasis spausdinimo testas“ palieskite  Pradėti . Į ADT dėklą įdėkite greitojo spausdinimo testo puslapį. Palieskite  Priekinė ADT registracija  arba  Galinė ADT registracija . Norėdami sulygiuoti priekinę ADT registraciją, testo puslapį į ADT dėklą įdėkite gerąja puse aukštyn, pirma įdėdami trumpąjį kraštą. Norėdami sulygiuoti galinę ADT registraciją, testo puslapį į ADT dėklą įdėkite gerąja puse žemyn, pirma įdėdami trumpąjį kraštą. Meniu „Greitasis kopijavimo testas“ palieskite  Pradėti . Palyginkite greitojo kopijavimo testo puslapį su dokumento originalu. Jei testo puslapio ir dokumento originalo paraštės skiriasi, pakoreguokite horizontaliąją lygiuotę ir viršutinę paraštę. Kartokite   ir  , kol greitojo kopijavimo testo puslapis atitiks dokumento originalą. ADT registracija koregavimas ADT registracijos koregavimas"},{"UUID":"97ad7c1a-3941-4d1a-92d6-9f689c9a514d","title":"Spalvų kokybės problemos","link":"modifying-colors-in-printed-output-topic.html","desc":"Spalvų keitimas spausdintuose išvediniuose Pradžios","descFull":"Spalvų keitimas spausdintuose išvediniuose Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Išplėstinis vaizdo gavimas Spalvų korekcija . Meniu  Spalvų korekcija  palieskite  Neautomatinė Spalvų korekcijos turinys . Pasirinkite atitinkamą spalvų konvertavimo nustatymą. Meniu „Neautomatinė spalvų korekcija“ objekto tipai ir jų spalvų konvertavimo lentelės Objekto tipas Spalvų konvertavimo lentelės RGB (RŽM) spalvų vaizdas RGB (RŽM) spalvų tekstas RGB (RŽM) spalvų grafika Vivid  – gaunamos ryškesnės, sodresnės spalvos; šis nustatymas gali būti taikomas visiems įeinantiems spalvotiems formatams. sRGB Display  – gaunami spaudiniai, kurių spalvos yra artimos kompiuterio monitoriuje matomoms spalvoms. Juodos spalvos dažų naudojimas yra optimizuotas nuotraukoms spausdinti. Display‑True Black  – gaunami spaudiniai, kurių spalvos yra artimos kompiuterio monitoriuje matomoms spalvoms. Esant šiam nustatymui, siekiant gauti visų atspalvių neutralią pilką spalvą naudojami tik juodi dažai. sRGB Vivid  –  sRGB Display  spalvų korekcijai suteikiamas didesnis spalvų grynis. Juodos spalvos dažų naudojimas yra optimizuotas verslo grafikai spausdinti. Išjungta CMYK (ŽPGJ) spalvų vaizdas CMYK (ŽPGJ) spalvų tekstas CMYK (ŽPGJ) spalvų grafika JAV CMYK (ŽPGJ)  – taikoma spalvų korekcija, kuri prilygsta SWOP (interneto ofsetinių leidinių specifikacijų) spalvotiems spaudiniams. Euro CMYK  – taikoma spalvų korekcija, kuri prilygsta „Euroscale“ spalvotiems spaudiniams. Vivid CMYK  – padidinamas spalvų korekcijos nustatymo  JAV CMYK (ŽPGJ)  spalvų grynis. Išjungta spalvinių išvesčių modifikavimas neautomatinė spalvų korekcija spalvų korekcija"},{"UUID":"baa5c2aa-40b9-4dd3-afc4-26733ffde3ae","title":"Spalvų kokybės problemos","link":"modifying-colors-in-printed-output-topic.html","desc":"DUK apie spalvotą spausdinimą Kas","descFull":"DUK apie spalvotą spausdinimą Kas yra RGB (RŽM) spalvų modelis? RGB (RŽM) spalvų modelis – tai spalvų apibūdinimo metodas nurodant raudonos, žalios arba mėlynos spalvos proporciją, kuri naudojama tam tikrai spalvai gauti. Įvairiomis proporcijomis sumaišius raudoną, žalią ir mėlyną spalvas gaunama didelė gamtoje sutinkamų spalvų gama. Kompiuterių ekranuose, skaitytuvuose ir skaitmeniniuose fotoaparatuose spalvos rodomos naudojant šį metodą. Kas yra CMYK (ŽPGJ) spalvų modelis? CMYK (ŽPGJ) spalvų modelis – tai spalvų apibūdinimo metodas nurodant žydros, purpurinės, geltonos ir juodos spalvos proporciją, kuri naudojama tam tikrai spalvai gauti. Spausdinant įvairių proporcijų žydros, purpurinės, geltonos ir juodos spalvos rašalu arba dažais gaunama plati gamtoje sutinkamų spalvų gama. Tokiu būdu gaunamos spalvos spausdinimo presuose, rašaliniuose ir spalviniuose lazeriniuose spausdintuvuose. Kaip bus spausdinama dokumente nurodyta spalva? Dokumento spalvai nurodyti ir keisti naudojant RGB (RŽM) arba CMYK (ŽPGJ) spalvų derinius naudojamos programinės įrangos programos. Norėdami gauti daugiau informacijos, žr. programų žinyno temas. Kaip spausdintuvas žino, kokia spalva spausdinti? Spausdinant dokumentą, informacija apie kiekvieno objekto tipą ir spalvą pateikiama spausdintuvui ir perduodama per spalvų konvertavimo lenteles. Spalva paverčiama atitinkamomis žydros, purpurinės, geltonos ir juodos spalvos dažų, naudojamų norint gauti norimą spalvą, proporcijomis. Objekto informacija apsprendžia, kokios spalvų konvertavimo lentelės bus taikomos. Pavyzdžiui, tekstui galima taikyti vienos rūšies spalvų konvertavimo lentelę, o nuotraukoms – kitą. Kas yra rankinė spalvų korekcija? Rankinei spalvų korekcija esant įjungtai, spausdintuve objektams apdoroti naudojamos naudotojo pasirinktos spalvų konvertavimo lentelės. Rankinės spalvų korekcijos nustatymai yra skirti konkrečiam spausdinamo objekto tipui (tekstui, grafikai arba paveikslams). Be to, programoje konkrečiai nurodoma ir objekto spalva (RGB (RŽM) arba CMYK (ŽPGJ) derinys). Jei norite rankiniu būdu pritaikyti kitą spalvų konvertavimo lentelę, žr.  . Jei programoje nėra nurodytos spalvos su RGB ar CMYK deriniais, rankinė spalvų korekcija neturi prasmės. Ji nėra veiksminga, ir kai spalvų priderinimą reguliuoja programinės įrangos programa arba kompiuterio operacinė sistema. Nustačius automatinę spalvų korekciją, dažniausiai dokumentams sukuriamos pageidaujamos spalvos. Kaip galėčiau atitaikyti tam tikrą spalvą (pavyzdžiui, įmonės logotipą)? Spausdintuvo meniu „Kokybė“ yra devynių tipų spalvų šablonų rinkiniai. Šiuos rinkinius galima rasti ir įtaisytojo tinklo serverio (EWS) puslapyje „Spalvų šablonai“. Pasirinkus bet kurį spalvų šablono rinkinį generuojami kelių puslapių spaudiniai, kuriuos sudaro šimtai spalvotų langelių. Priklausomai nuo pasirinktos lentelės kiekviename langelyje būna arba CMYK ŽPGJ), arba RGB (RŽM) spalvų derinys. Nustatyta kiekvieno langelio spalva gaunama langelyje pažymėtam CMYK (ŽPGJ) arba RGB (RŽM) deriniui pereinant per pasirinktą spalvų konvertavimo lentelę. Išanalizavę spalvų šablonų rinkinius galite nustatyti, kurio langelio spalva labiausiai atitinka derinamą spalvą. Tada langelyje pažymėtas spalvų derinys gali būti naudojamas objekto spalvai programoje pakeisti. Norėdami gauti daugiau informacijos, žr. programų žinyno temas. Rankinė spalvų korekcija gali būti reikalinga norint pasirinktą spalvų konvertavimo lentelę panaudoti konkrečiam objektui. Kokį spalvų šablono rinkinį, kuris bus naudojamas konkrečiai spalvų atitikimo problemai, pasirinkti, priklauso nuo šių dalykų: naudojamo spalvų korekcijos nustatymo (automatinė, išjungta ar rankinė); spausdinamo objekto tipo (tekstas, grafika ar paveikslai); kaip programoje nurodoma objekto spalva (RGB (RŽM) ar CMYK (ŽPGJ) derinys). Jei programoje nėra nurodytos spalvos su RGB (RŽM) ar CMYK (ŽPGJ) deriniais, naudoti spalvų šablonų puslapių nėra prasmės. Be to, kai kuriose programose nurodyti RGB (RŽM) arba CMYK (ŽPGJ) spalvų deriniai koreguojami naudojant spalvų valdymą. Tokiais atvejais atspausdinta spalva nebūtinai tiksliai atitiks spalvų šablonų puslapiuose pateiktą spalvą. trikčių šalinimas DUK apie spalvotą spausdinimą DUK apie spalvotą spausdinimą"},{"UUID":"7ad0da82-0c1a-4cef-94a5-43e47a5b2939","title":"Spalvų kokybės problemos","link":"modifying-colors-in-printed-output-topic.html","desc":"Spaudinyje matomas atspalvis Veiksmai sprendžiant","descFull":"Spaudinyje matomas atspalvis Veiksmai sprendžiant šią problemą Veiksmas Taip Ne Atlikite  Spalvų priderinimą . Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Išplėstinis vaizdo gavimas Spalvų priderinimas . Atspausdinkite dokumentą. Ar spaudinyje matomas atspalvis? Problema išspręsta. Atlikite  Spalvų subalansavimą . Pradžios ekrane palieskite  Nustatymai Spausdinti Kokybė Išplėstinis vaizdo gavimas Spalvų subalansavimas . Pakoreguokite nustatymus. Atspausdinkite dokumentą. Ar spaudinyje matomas atspalvis? Kreipkitės į  klientų aptarnavimo skyrių . Kreipkitės į  techninės pagalbos skyrių . Problema išspręsta. trikčių šalinimas, spalvų kokybė spaudinyje matomas atspalvis spalvų kokybė, trikčių šalinimas spaudinyje matomas atspalvis spaudinyje matomas atspalvis"},{"UUID":"49993153-5033-4517-9c71-3c5b8f764747","title":"Trikties šalinimas","link":"trb-contacting-customer-support-topic.html","desc":"Kreipimasis į klientų aptarnavimo skyrių","descFull":"Kreipimasis į klientų aptarnavimo skyrių Prieš kreipdamiesi į klientų aptarnavimo skyrių įsitikinkite, kad žinote šią informaciją: kokia spausdintuvo problema; koks klaidos pranešimas; koks spausdintuvo modelio tipas ir serijos numeris. Eikite adresu  http://support.lexmark.com , kad gautumėte pagalbą elektroniniu paštu ar pokalbio metu arba kad bibliotekoje galėtumėte peržiūrėti vadovus, pagalbinius dokumentus, tvarkykles ir kitas siuntas. Galima ir techninė pagalba telefonu. JAV arba Kanadoje skambinkite tel. 1-800-539-6275. Jei esate kitose šalyse ar regionuose, apsilankykite adresu  http://support.lexmark.com . Nuvykite į vietą, kurioje pirkote spausdintuvą. kreipimasis į klientų aptarnavimo skyrių klientų aptarnavimo skyrius kreipimasis į"},{"UUID":"abe1cb70-8336-4875-80e6-d3c7121af7ee","title":"Trikties šalinimas","link":"troubleshooting-chapter.html","desc":"Kreipimasis į techninės pagalbos skyrių","descFull":"Kreipimasis į techninės pagalbos skyrių Kreipdamiesi į techninės pagalbos skyrių apibūdinkite savo problemą, pranešimą spausdintuvo ekrane ir trikčių šalinimo veiksmus, kurių jau buvo imtasi. Pažiūrėkite etiketę viršutinio priekinio dangčio viduje arba galinėje spausdintuvo pusėje ir pasižymėkite šiuos dalykus: spausdintuvo modelį, techninės priežiūros kortelę ir skubaus aptarnavimo kodą. Norėdami sužinoti daugiau, apsilankykite adresu  www.dell.com/support . trikčių šalinimas kreipimasis į techninės pagalbos skyrių kreipimasis į techninės pagalbos skyrių"},{"UUID":"1277c671-a72a-4fe4-901c-da5507bde50d","title":"Perdirbimas ir šalinimas","link":"recycling-lexmark-products-topic.html","desc":"Perdirbami „Lexmark“ gaminiai Norėdami grąžinti","descFull":"Perdirbami „Lexmark“ gaminiai Norėdami grąžinti „Lexmark“ gaminius perdirbimui: Eikite adresu  www.lexmark.com/recycle . Pasirinkite gaminį, kurį norite atiduoti perdirbti. „Lexmark“ surinkimo ir perdirbimo programoje neišvardinti spausdintuvų priedai ir aparatinė įranga gali būti perdirbama kreipiantis į vietos perdirbimo centrą. perdirbimas „Lexmark“ gaminiai"},{"UUID":"ae3ecb53-c0f9-4d06-bcb7-c332a2b216f4","title":"Perdirbimas ir šalinimas","link":"recycling-lexmark-packaging-topic.html","desc":"Perdirbamos „Lexmark“ pakuotės „Lexmark“ nuolat","descFull":"Perdirbamos „Lexmark“ pakuotės „Lexmark“ nuolat siekia mažinti pakuotes. Mažesnės pakuotės padeda užtikrinti, kad „Lexmark“ spausdintuvai bus gabenami efektyviausiu ir aplinką tausojančiu būdu bei reiks šalinti mažiau pakuočių. Dėl tokio efektyvumo atsiranda mažiau šiltnamio efektą sukeliančių dujų, taupoma energija ir gamtos ištekliai. Kai kuriose šalyse arba regionuose „Lexmark“ taip pat užtikrina pakuočių komponentų perdirbimą. Norėdami gauti daugiau informacijos, eikite į  www.lexmark.com/recycle  ir pasirinkite savo šalį arba regioną. Informacija apie esamas pakuočių perdirbimo programas yra pridėta prie informacijos apie gaminio perdirbimą. „Lexmark“ kartoninės dėžės yra 100 % perdirbamos, kur veikia gofruotų pakavimo gaminių perdirbimo įmonės. Jūsų teritorijoje tokių įmonių gali nebūti. „Lexmark“ pakuotėse naudojamas putplastis yra perdirbamas, kur veikia putplasčio perdirbimo įmonės. Jūsų teritorijoje tokių įmonių gali nebūti.  Kai „Lexmark“ grąžinate kasetę, galite pakartotinai panaudoti kasetės dėžę. „Lexmark“ perdirba dėžę. perdirbimas „Lexmark“ pakuotės"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX930, CX931, XC9325, XC9335 daugiafunkciai spausdintuvai"}},[_vm._v("\n    CX930, CX931, XC9325, XC9335 daugiafunkciai spausdintuvai\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_lt","title":"Saugos informacija"}},[_vm._v("\n    Saugos informacija\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Sutartiniai žymenys"}},[_vm._v("\n     Sutartiniai žymenys\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Parei&scaron;kimai dėl gaminio"}},[_vm._v("\n     Pareiškimai dėl gaminio\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_lt","title":"Žinios apie spausdintuvą"}},[_vm._v("\n    Žinios apie spausdintuvą\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e170"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_lt","title":"Informacijos apie spausdintuvą paie&scaron;ka"}},[_vm._v("\n     Informacijos apie spausdintuvą paieška\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_lt","title":"Spausdintuvo serijos numerio paie&scaron;ka"}},[_vm._v("\n     Spausdintuvo serijos numerio paieška\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_lt","title":"Spausdintuvo konfigūracijos"}},[_vm._v("\n     Spausdintuvo konfigūracijos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_lt","title":"Valdymo skydelio naudojimas"}},[_vm._v("\n     Valdymo skydelio naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_lt","title":"Kaip suprasti indikatoriaus lemputės spalvas"}},[_vm._v("\n     Kaip suprasti indikatoriaus lemputės spalvas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e562","title":"Popieriaus parinkimas"}},[_vm._v("\n     Popieriaus parinkimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_lt","title":"Nustatymas, įrengimas ir konfigūravimas"}},[_vm._v("\n    Nustatymas, įrengimas ir konfigūravimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e3851"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_lt","title":"Vietos spausdintuvui parinkimas"}},[_vm._v("\n     Vietos spausdintuvui parinkimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_lt","title":"Laidų ir kabelių prijungimas"}},[_vm._v("\n     Laidų ir kabelių prijungimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e4039","title":"Pradžios ekrano programų diegimas ir naudojimas"}},[_vm._v("\n     Pradžios ekrano programų diegimas ir naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e4691","title":"Prieinamumo funkcijų nustatymas ir naudojimas"}},[_vm._v("\n     Prieinamumo funkcijų nustatymas ir naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e4994","title":"Fakso nustatymas spausdintuve"}},[_vm._v("\n     Fakso nustatymas spausdintuve\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_lt","title":"El. pa&scaron;to SMTP nustatymų konfigūravimas"}},[_vm._v("\n     El. pašto SMTP nustatymų konfigūravimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#d0e6870","title":"Popieriaus ir specialiųjų laikmenų įdėjimas"}},[_vm._v("\n     Popieriaus ir specialiųjų laikmenų įdėjimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e7265","title":"Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas"}},[_vm._v("\n     Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-envelope-tray-topic.html#d0e7547","title":"Papildomos aparatinės įrangos įrengimas"}},[_vm._v("\n     Papildomos aparatinės įrangos įrengimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"networking-intro-topic.html#d0e8219","title":"Prijungimas prie tinklo"}},[_vm._v("\n     Prijungimas prie tinklo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-serial-printing-topic.html#setting-up-serial-printing_lt","title":"Spausdinimo per nuoseklųjį prievadą diegimas (tik &bdquo;Windows&ldquo;)"}},[_vm._v("\n     Spausdinimo per nuoseklųjį prievadą diegimas (tik „Windows“)\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_lt","title":"Spausdintuvo apsaugojimas"}},[_vm._v("\n    Spausdintuvo apsaugojimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8616"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_lt","title":"Saugos lizdo vietos nustatymas"}},[_vm._v("\n     Saugos lizdo vietos nustatymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_lt","title":"Spausdintuvo atminties i&scaron;valymas"}},[_vm._v("\n     Spausdintuvo atminties išvalymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_lt","title":"Spausdintuvo atminties įrenginio i&scaron;valymas"}},[_vm._v("\n     Spausdintuvo atminties įrenginio išvalymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_lt","title":"Gamyklinių numatytųjų nustatymų atkūrimas"}},[_vm._v("\n     Gamyklinių numatytųjų nustatymų atkūrimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_lt","title":"Parei&scaron;kimas dėl nei&scaron;liekamosios atminties įtaisų"}},[_vm._v("\n     Pareiškimas dėl neišliekamosios atminties įtaisų\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_lt","title":"Spausdinimas"}},[_vm._v("\n    Spausdinimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8809"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_lt","title":"Spausdinimas i&scaron; kompiuterio"}},[_vm._v("\n     Spausdinimas iš kompiuterio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e8835","title":"Spausdinimas i&scaron; mobiliojo prietaiso"}},[_vm._v("\n     Spausdinimas iš mobiliojo prietaiso\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_lt","title":"Spausdinimas i&scaron; atmintuko"}},[_vm._v("\n     Spausdinimas iš atmintuko\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_lt","title":"Palaikomi atmintukai ir failų tipai"}},[_vm._v("\n     Palaikomi atmintukai ir failų tipai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_lt","title":"Konfidencialių užduočių konfigūravimas"}},[_vm._v("\n     Konfidencialių užduočių konfigūravimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_lt","title":"Konfidencialių ir kitų turimų užduočių spausdinimas"}},[_vm._v("\n     Konfidencialių ir kitų turimų užduočių spausdinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_lt","title":"&Scaron;riftų pavyzdžių sąra&scaron;o spausdinimas"}},[_vm._v("\n     Šriftų pavyzdžių sąrašo spausdinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_lt","title":"Katalogo sąra&scaron;o spausdinimas"}},[_vm._v("\n     Katalogo sąrašo spausdinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_lt","title":"Skiriamųjų lapų dėjimas tarp kopijų"}},[_vm._v("\n     Skiriamųjų lapų dėjimas tarp kopijų\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-printed-sheets-topic.html#stapling-printed-sheets_lt","title":"Spausdintų lapų susegimas"}},[_vm._v("\n     Spausdintų lapų susegimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_lt","title":"Skylmu&scaron;a spausdintuose lapuose"}},[_vm._v("\n     Skylmuša spausdintuose lapuose\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_lt","title":"Komplektavimo grupavimo naudojimas spausdintiems lapams"}},[_vm._v("\n     Komplektavimo grupavimo naudojimas spausdintiems lapams\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_lt","title":"Spausdinimo užduoties at&scaron;aukimas"}},[_vm._v("\n     Spausdinimo užduoties atšaukimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_lt","title":"Dažų tamsumo koregavimas"}},[_vm._v("\n     Dažų tamsumo koregavimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying-chapter.html#copying-chapter_lt","title":"Kopijavimas"}},[_vm._v("\n    Kopijavimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9600"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_lt","title":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas"}},[_vm._v("\n     Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_lt","title":"Kopijų darymas"}},[_vm._v("\n     Kopijų darymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_lt","title":"Nuotraukų kopijavimas"}},[_vm._v("\n     Nuotraukų kopijavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_lt","title":"Kopijavimas ant firminių blankų"}},[_vm._v("\n     Kopijavimas ant firminių blankų\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_lt","title":"Kopijavimas ant abiejų popieriaus pusių"}},[_vm._v("\n     Kopijavimas ant abiejų popieriaus pusių\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_lt","title":"Kopijų mažinimas arba didinimas"}},[_vm._v("\n     Kopijų mažinimas arba didinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_lt","title":"Kopijų sudėstymas"}},[_vm._v("\n     Kopijų sudėstymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_lt","title":"Skiriamųjų lapų dėjimas tarp kopijų"}},[_vm._v("\n     Skiriamųjų lapų dėjimas tarp kopijų\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_lt","title":"Kelių puslapių kopijavimas viename lape"}},[_vm._v("\n     Kelių puslapių kopijavimas viename lape\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_lt","title":"Kortelių kopijavimas"}},[_vm._v("\n     Kortelių kopijavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-copies-topic.html#stapling-copies_lt","title":"kopijų susegimas"}},[_vm._v("\n     kopijų susegimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-copies-topic.html#punching-holes-copies_lt","title":"Skylmu&scaron;a kopijoms"}},[_vm._v("\n     Skylmuša kopijoms\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-copies-topic.html#using-offset-stacking-copies_lt","title":"Komplektavimo grupavimo naudojimas kopijoms"}},[_vm._v("\n     Komplektavimo grupavimo naudojimas kopijoms\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_lt","title":"Sparčiosios kopijavimo nuorodos kūrimas"}},[_vm._v("\n     Sparčiosios kopijavimo nuorodos kūrimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_lt","title":"El. pa&scaron;tas"}},[_vm._v("\n    El. paštas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9979"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_lt","title":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas"}},[_vm._v("\n     Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_lt","title":"Elektroninio lai&scaron;ko siuntimas"}},[_vm._v("\n     Elektroninio laiško siuntimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_lt","title":"El. pa&scaron;to sparčiosios nuorodos kūrimas"}},[_vm._v("\n     El. pašto sparčiosios nuorodos kūrimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faxing-chapter.html#faxing-chapter_lt","title":"Faksas"}},[_vm._v("\n    Faksas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10073"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_lt","title":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas"}},[_vm._v("\n     Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_lt","title":"Faksogramos siuntimas"}},[_vm._v("\n     Faksogramos siuntimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_lt","title":"Faksogramos siuntimo planavimas"}},[_vm._v("\n     Faksogramos siuntimo planavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_lt","title":"Faksogramų paskirties vietos sparčiosios nuorodos kūrimas"}},[_vm._v("\n     Faksogramų paskirties vietos sparčiosios nuorodos kūrimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_lt","title":"Faksogramos skiriamosios gebos keitimas"}},[_vm._v("\n     Faksogramos skiriamosios gebos keitimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_lt","title":"Faksogramos tamsumo koregavimas"}},[_vm._v("\n     Faksogramos tamsumo koregavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_lt","title":"Faksogramų žurnalo spausdinimas"}},[_vm._v("\n     Faksogramų žurnalo spausdinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_lt","title":"Brukalo faksogramų blokavimas"}},[_vm._v("\n     Brukalo faksogramų blokavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_lt","title":"Faksogramų užlaikymas"}},[_vm._v("\n     Faksogramų užlaikymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_lt","title":"Faksogramos persiuntimas"}},[_vm._v("\n     Faksogramos persiuntimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"ftp-chapter.html#ftp-chapter_lt","title":"Skenavimas"}},[_vm._v("\n    Skenavimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10437"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_lt","title":"Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas"}},[_vm._v("\n     Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_lt","title":"Skenavimas į kompiuterį"}},[_vm._v("\n     Skenavimas į kompiuterį\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_lt","title":"Nuskaitymas į FTP serverį"}},[_vm._v("\n     Nuskaitymas į FTP serverį\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_lt","title":"Sparčiosios FTP nuorodos kūrimas"}},[_vm._v("\n     Sparčiosios FTP nuorodos kūrimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_lt","title":"Nuskaitymas į tinklo aplanką"}},[_vm._v("\n     Nuskaitymas į tinklo aplanką\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_lt","title":"Tinklo aplanko sparčiosios nuorodos kūrimas"}},[_vm._v("\n     Tinklo aplanko sparčiosios nuorodos kūrimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_lt","title":"Skenavimas į atmintuką"}},[_vm._v("\n     Skenavimas į atmintuką\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_lt","title":"Kaip naudoti spausdintuvo meniu"}},[_vm._v("\n    Kaip naudoti spausdintuvo meniu\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10739"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menus-map-mfp_lt","title":"Meniu planas"}},[_vm._v("\n     Meniu planas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e11102","title":"Įrenginys"}},[_vm._v("\n     Įrenginys\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e13477","title":"Spausdinimas"}},[_vm._v("\n     Spausdinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e14883","title":"Popierius"}},[_vm._v("\n     Popierius\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e15252","title":"Kopijavimas"}},[_vm._v("\n     Kopijavimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e15913","title":"Faksas"}},[_vm._v("\n     Faksas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e18318","title":"El. pa&scaron;tas"}},[_vm._v("\n     El. paštas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e19368","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e19953","title":"USB atmintukas"}},[_vm._v("\n     USB atmintukas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e20811","title":"Tinklas / prievadai"}},[_vm._v("\n     Tinklas / prievadai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e23002","title":"Debesų paslaugos"}},[_vm._v("\n     Debesų paslaugos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e23059","title":"Saugumas"}},[_vm._v("\n     Saugumas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e24248","title":"Ataskaitos"}},[_vm._v("\n     Ataskaitos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_lt","title":"Trikčių &scaron;alinimas"}},[_vm._v("\n     Trikčių šalinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_lt","title":"Meniu nustatymų puslapio spausdinimas"}},[_vm._v("\n     Meniu nustatymų puslapio spausdinimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_lt","title":"Spausdintuvo priežiūra"}},[_vm._v("\n    Spausdintuvo priežiūra\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e24588"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_lt","title":"Dalių ir eksploatacinių medžiagų būsenos tikrinimas"}},[_vm._v("\n     Dalių ir eksploatacinių medžiagų būsenos tikrinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_lt","title":"Prane&scaron;imų dėl eksploatacinių medžiagų konfigūravimas"}},[_vm._v("\n     Pranešimų dėl eksploatacinių medžiagų konfigūravimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_lt","title":"Įspėjimų el. pa&scaron;tu nustatymas"}},[_vm._v("\n     Įspėjimų el. paštu nustatymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_lt","title":"Ataskaitų peržiūra"}},[_vm._v("\n     Ataskaitų peržiūra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-supplies-group_lt","title":"Dalių ir eksploatacinių reikmenų užsakymas"}},[_vm._v("\n     Dalių ir eksploatacinių reikmenų užsakymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e24897","title":"Dalių ir eksploatacinių reikmenų keitimas"}},[_vm._v("\n     Dalių ir eksploatacinių reikmenų keitimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e25567","title":"Spausdintuvo dalių valymas"}},[_vm._v("\n     Spausdintuvo dalių valymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e25835","title":"Elektros energijos ir popieriaus taupymas"}},[_vm._v("\n     Elektros energijos ir popieriaus taupymas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_lt","title":"Spausdintuvo perkėlimas į kitą vietą"}},[_vm._v("\n     Spausdintuvo perkėlimas į kitą vietą\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_lt","title":"Spausdintuvo transportavimas"}},[_vm._v("\n     Spausdintuvo transportavimas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_lt","title":"Trikties &scaron;alinimas"}},[_vm._v("\n    Trikties šalinimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e25989"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_lt","title":"Spausdinimo kokybės problemos"}},[_vm._v("\n     Spausdinimo kokybės problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_lt","title":"Spausdintuvo klaidų kodai"}},[_vm._v("\n     Spausdintuvo klaidų kodai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_lt","title":"Spausdinimo problemos"}},[_vm._v("\n     Spausdinimo problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_lt","title":"Spausdintuvas nereaguoja"}},[_vm._v("\n     Spausdintuvas nereaguoja\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_lt","title":"Nepavyksta nuskaityti atmintuko"}},[_vm._v("\n     Nepavyksta nuskaityti atmintuko\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_lt","title":"USB jungties įgalinimas"}},[_vm._v("\n     USB jungties įgalinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"avoiding-jams-topic.html#d0e29525","title":"Strigčių &scaron;alinimas"}},[_vm._v("\n     Strigčių šalinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e30035","title":"Tinklo ry&scaron;io problemos"}},[_vm._v("\n     Tinklo ryšio problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e30263","title":"Papildomos aparatinės įrangos problemos"}},[_vm._v("\n     Papildomos aparatinės įrangos problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e30389","title":"Problemos, susijusios su eksploataciniais reikmenimis"}},[_vm._v("\n     Problemos, susijusios su eksploataciniais reikmenimis\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e30494","title":"Popieriaus tiekimo problemos"}},[_vm._v("\n     Popieriaus tiekimo problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e30860","title":"Problemos siunčiant el. pa&scaron;tu"}},[_vm._v("\n     Problemos siunčiant el. paštu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e30954","title":"Problemos siunčiant faksu"}},[_vm._v("\n     Problemos siunčiant faksu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e31599","title":"Skenavimo problemos"}},[_vm._v("\n     Skenavimo problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e32373","title":"Spalvų kokybės problemos"}},[_vm._v("\n     Spalvų kokybės problemos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_lt","title":"Kreipimasis į klientų aptarnavimo skyrių"}},[_vm._v("\n     Kreipimasis į klientų aptarnavimo skyrių\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_lt","title":"Perdirbimas ir &scaron;alinimas"}},[_vm._v("\n    Perdirbimas ir šalinimas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32623"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_lt","title":"Perdirbami &bdquo;Lexmark&ldquo; gaminiai"}},[_vm._v("\n     Perdirbami „Lexmark“ gaminiai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_lt","title":"Perdirbamos &bdquo;Lexmark&ldquo; pakuotės"}},[_vm._v("\n     Perdirbamos „Lexmark“ pakuotės\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_lt","title":"Prane&scaron;imai"}},[_vm._v("\n    Pranešimai\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32658"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32661","title":"Gaminio informacija"}},[_vm._v("\n     Gaminio informacija\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32678","title":"Prane&scaron;imas apie leidimą"}},[_vm._v("\n     Pranešimas apie leidimą\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_lt","title":"Prekių ženklai"}},[_vm._v("\n     Prekių ženklai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_lt","title":"Licencijavimo prane&scaron;imai"}},[_vm._v("\n     Licencijavimo pranešimai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_lt","title":"Triuk&scaron;mo lygiai"}},[_vm._v("\n     Triukšmo lygiai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_lt","title":"Direktyva dėl elektros ir elektroninės įrangos atliekų (EEIĄ direktyva)"}},[_vm._v("\n     Direktyva dėl elektros ir elektroninės įrangos atliekų (EEIĄ direktyva)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32783","title":"Pakartotinai įkraunama ličio jonų baterija"}},[_vm._v("\n     Pakartotinai įkraunama ličio jonų baterija\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_lt","title":"Reglamentas (ES) 2023/1542"}},[_vm._v("\n     Reglamentas (ES) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32821","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_lt","title":"Gaminio &scaron;alinimas"}},[_vm._v("\n     Gaminio šalinimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_lt","title":"&bdquo;Lexmark&ldquo; kasečių grąžinimas pakartotiniam naudojimui arba perdirbimui"}},[_vm._v("\n     „Lexmark“ kasečių grąžinimas pakartotiniam naudojimui arba perdirbimui\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_lt","title":"Prane&scaron;imas dėl statinio elektros krūvio poveikio"}},[_vm._v("\n     Pranešimas dėl statinio elektros krūvio poveikio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_lt","title":"&bdquo;ENERGY STAR&ldquo;"}},[_vm._v("\n     „ENERGY STAR“\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_lt","title":"Temperatūros duomenys"}},[_vm._v("\n     Temperatūros duomenys\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_lt","title":"Elektros energijos suvartojimas"}},[_vm._v("\n     Elektros energijos suvartojimas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_lt","title":"Reglamentiniai prane&scaron;imai dėl galinių telekomunikacijų įrenginių"}},[_vm._v("\n     Reglamentiniai pranešimai dėl galinių telekomunikacijų įrenginių\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_lt","title":"Atitiktis Europos Bendrijos (EB) direktyvoms"}},[_vm._v("\n     Atitiktis Europos Bendrijos (EB) direktyvoms\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_lt","title":"Prane&scaron;imas dėl radijo trukdžių"}},[_vm._v("\n     Pranešimas dėl radijo trukdžių\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js